// Lesson 2 - Head and Neck Anatomy
// Complete file with all 16 topics (8 subjects, each with Part 1 and Part 2)
// Total: 1,478 unique questions


export const questions = {
  "0. TMJ (Part 1)": [    {
      id: 11000,
      question: "What type of articulation is the temporomandibular joint?",
      options: [
        "Bilateral articulation between temporal bone and mandible",
        "Unilateral articulation between temporal and mandible",
        "Single fused joint in the midline",
        "Articulation between maxilla and mandible",
      ],
      correct: "A"
    },
    {
      id: 11001,
      question: "The blood supply to the TMJ is remembered by which mnemonic?",
      options: [
        "PATT (pharyngeal, auricular, temporal, tympanic)",
        "MAT (masseteric, auricular, temporal)",
        "TAP (temporal, auricular, pharyngeal)",
        "PAT (pharyngeal, auricular, tympanic)",
      ],
      correct: "A"
    },
    {
      id: 11002,
      question: "The nerve supply to the TMJ is remembered by which mnemonic?",
      options: [
        "MAT (masseteric, auriculotemporal, temporal)",
        "PATT (pharyngeal, auricular, temporal, tympanic)",
        "TAM (temporal, auricular, masseteric)",
        "ATM (auriculotemporal, temporal, masseteric)",
      ],
      correct: "A"
    },
    {
      id: 11003,
      question: "What is the most anterior part of the temporal bone associated with the TMJ?",
      options: [
        "Articular eminence",
        "Mandibular fossa",
        "Posterior tubercle",
        "Mandibular condyle",
      ],
      correct: "B"
    },
    {
      id: 11004,
      question: "What material is the articular disc composed of?",
      options: [
        "Dense collagen tissue",
        "Elastic cartilage",
        "Hyaline cartilage",
        "Loose connective tissue",
      ],
      correct: "A"
    },
    {
      id: 11005,
      question: "What is the function of synovial fluid in the TMJ?",
      options: [
        "Allows surfaces to rub over one another without irritation",
        "Provides nutrients to the disc",
        "Cushions the joint during impact",
        "Maintains disc shape",
      ],
      correct: "A"
    },
    {
      id: 11006,
      question: "Where does the TMJ capsule attach?",
      options: [
        "Medially and laterally to both the mandibular condyle and temporal bone",
        "Only to the temporal bone",
        "Only to the mandibular condyle",
        "To the articular disc only",
      ],
      correct: "A"
    },
    {
      id: 11007,
      question: "What mnemonic helps remember the sphenomandibular ligament location?",
      options: [
        "M.I.G. (Middle Inside Groove)",
        "MAT",
        "PATT",
        "SML",
      ],
      correct: "A"
    },
    {
      id: 11008,
      question: "What is the relationship between arteries and veins in the circulatory system?",
      options: [
        "Arteries carry blood away; veins bring it back",
        "Arteries supply only; veins have no function",
        "Both carry the same type of blood",
        "They don't interact",
      ],
      correct: "A"
    },
    {
      id: 11009,
      question: "Which muscles are responsible for depression of the mandible during mastication?",
      options: [
        "Hyoid muscles",
        "Muscles of mastication",
        "Facial muscles",
        "Neck muscles",
      ],
      correct: "A"
    },
    {
      id: 11010,
      question: "During mastication, where is the condyle positioned on the side with food?",
      options: [
        "In contact with the mandibular fossa",
        "Forward on the articular eminence",
        "Between the fossa and eminence",
        "Beyond the articular eminence",
      ],
      correct: "A"
    },
    {
      id: 11011,
      question: "To fill the space on the non-chewing side during mastication, what structure is pulled forward?",
      options: [
        "The thicker part of the articular disc",
        "The condyle only",
        "The mandibular fossa",
        "The temporal bone",
      ],
      correct: "A"
    },
    {
      id: 11012,
      question: "What visual sign can be observed when standing in front of a client with popping and clicking?",
      options: [
        "A notable shift of the mandibular midline to one side during opening",
        "Asymmetrical facial features",
        "Swelling of the joint",
        "Redness around the TMJ",
      ],
      correct: "A"
    },
    {
      id: 11013,
      question: "What do veins carry?",
      options: [
        "Deoxygenated blood away from body systems back to the heart",
        "Oxygenated blood from the heart",
        "Oxygenated blood to the heart",
        "Arterial blood",
      ],
      correct: "A"
    },
    {
      id: 11014,
      question: "Where does most of the blood and nerve supply enter the TMJ?",
      options: [
        "Through the retrodiscal pad",
        "Through the anterior capsule",
        "Through the lateral capsule",
        "Through the articular disc",
      ],
      correct: "A"
    },
    {
      id: 11015,
      question: "What proportion of blood supplied to the head comes through the common carotid arteries?",
      options: [
        "All of it",
        "Half of it",
        "Most of it",
        "A small portion",
      ],
      correct: "A"
    },
    {
      id: 11016,
      question: "Do veins generally follow the same pathways as arteries?",
      options: [
        "Yes, generally follow the same pathways",
        "No, completely different pathways",
        "Only in the head",
        "Only in the neck",
      ],
      correct: "A"
    },
    {
      id: 11017,
      question: "What is an alternative name sometimes used for the lingual and facial arteries when they branch together?",
      options: [
        "Linguofacial trunk",
        "Linguomaxillary trunk",
        "Faciomaxillary trunk",
        "Cervicofacial trunk",
      ],
      correct: "A"
    },
    {
      id: 11018,
      question: "How does fibromyalgia affect the TMJ?",
      options: [
        "Heightened nerve sensitivity can extend to the TMJ",
        "It doesn't affect TMJ",
        "It only affects disc position",
        "It causes bone fusion",
      ],
      correct: "A"
    },
    {
      id: 11019,
      question: "What type of blood do arteries carry?",
      options: [
        "Oxygenated blood from the heart to body systems",
        "Deoxygenated blood from the heart",
        "Deoxygenated blood to the heart",
        "Mixed blood",
      ],
      correct: "A"
    },
    {
      id: 11020,
      question: "What does \"cephalic\" mean in the term brachiocephalic artery?",
      options: [
        "Head",
        "Neck",
        "Arm",
        "Chest",
      ],
      correct: "A"
    },
    {
      id: 11021,
      question: "Where does the maxillary artery enter after passing through the infratemporal fossa?",
      options: [
        "Pterygopalatine fossa",
        "Oral cavity",
        "Nasal cavity",
        "Temporal fossa",
      ],
      correct: "A"
    },
    {
      id: 11022,
      question: "What does the descending palatine artery extend through?",
      options: [
        "Pterygopalatine canal",
        "Infraorbital canal",
        "Incisive canal",
        "Mandibular canal",
      ],
      correct: "A"
    },
    {
      id: 11023,
      question: "What is another name for the pterygopalatine artery?",
      options: [
        "Sphenopalatine artery",
        "Infraorbital artery",
        "Descending palatine artery",
        "Greater palatine artery",
      ],
      correct: "A"
    },
    {
      id: 11024,
      question: "Where does the anterior superior alveolar artery travel?",
      options: [
        "Down the bone in front of the maxillary sinus",
        "Through the mandibular canal",
        "Along the hard palate",
        "Through the nasal cavity",
      ],
      correct: "A"
    },
    {
      id: 11025,
      question: "The nerve supply to the TMJ includes branches of which cranial nerve division?",
      options: [
        "V1 (ophthalmic)",
        "V2 (maxillary)",
        "V3 (mandibular)",
        "VII (facial)",
      ],
      correct: "C"
    },
    {
      id: 11026,
      question: "What is the posterior tubercle in relation to the TMJ?",
      options: [
        "The most anterior part of the temporal bone",
        "The process of the mandible",
        "The most posterior part of the temporal bone associated with TMJ",
        "The articular disc attachment",
      ],
      correct: "C"
    },
    {
      id: 11027,
      question: "Why is the upper surface of the articular disc concavoconvex?",
      options: [
        "To match the mandibular condyle shape",
        "To match the mandibular fossa and articular eminence",
        "To accommodate the synovial fluid",
        "To attach to the lateral pterygoid muscle",
      ],
      correct: "B"
    },
    {
      id: 11028,
      question: "What are the compartments above and below the articular disc called?",
      options: [
        "Joint spaces",
        "Articular cavities",
        "Capsular spaces",
        "Synovial cavities",
      ],
      correct: "D"
    },
    {
      id: 11029,
      question: "Which region of the articular disc is the thickest?",
      options: [
        "Anterior region",
        "Intermediate region",
        "Lateral region",
        "Posterior region",
      ],
      correct: "D"
    },
    {
      id: 11030,
      question: "Which region of the articular disc is the thinnest?",
      options: [
        "Anterior region",
        "Intermediate region",
        "Posterior region",
        "Medial region",
      ],
      correct: "B"
    },
    {
      id: 11031,
      question: "Where does the anterior region of the articular disc attach?",
      options: [
        "To the mandibular fossa",
        "To the superior head of the lateral pterygoid muscle",
        "To the inferior head of the lateral pterygoid muscle",
        "To the posterior tubercle",
      ],
      correct: "B"
    },
    {
      id: 11032,
      question: "How many ligaments are associated with the TMJ protection?",
      options: [
        "One within the capsule only",
        "Two outside the capsule only",
        "Three within the capsule",
        "One within and two outside the capsule",
      ],
      correct: "D"
    },
    {
      id: 11033,
      question: "Where is the temporomandibular ligament located?",
      options: [
        "Outside the TMJ capsule",
        "Within the TMJ capsule",
        "Posterior to the capsule",
        "Anterior to the capsule",
      ],
      correct: "B"
    },
    {
      id: 11034,
      question: "Where does the sphenomandibular ligament attach on the mandible?",
      options: [
        "Angle of the mandible",
        "Lateral side of the condyle",
        "Coronoid process",
        "Medial side near the mylohyoid groove",
      ],
      correct: "D"
    },
    {
      id: 11035,
      question: "What is the primary function of the temporomandibular ligament?",
      options: [
        "Limits jaw opening",
        "Prevents backward movement of the condyle",
        "Supports jaw like a sling",
        "Allows forward movement",
      ],
      correct: "B"
    },
    {
      id: 11036,
      question: "What is the primary function of the stylomandibular ligament?",
      options: [
        "Prevents backward movement",
        "Supports jaw like a sling",
        "Limits jaw opening",
        "Prevents lateral movement",
      ],
      correct: "C"
    },
    {
      id: 11037,
      question: "What is the primary function of the sphenomandibular ligament?",
      options: [
        "Limits jaw opening",
        "Prevents backward movement",
        "Prevents forward movement",
        "Supports jaw like a sling",
      ],
      correct: "D"
    },
    {
      id: 11038,
      question: "What secretes synovial fluid in the TMJ?",
      options: [
        "Fibrous capsule cells",
        "Articular disc cells",
        "Condylar cartilage cells",
        "Specific epithelial cells",
      ],
      correct: "D"
    },
    {
      id: 11039,
      question: "What type of tissue makes up the retrodiscal pad?",
      options: [
        "Dense fibrous tissue",
        "Elastic tissue",
        "Connective tissue",
        "Cartilaginous tissue",
      ],
      correct: "C"
    },
    {
      id: 11040,
      question: "What is the location of the elastic and collagenous laminae?",
      options: [
        "Anterior to the TMJ",
        "Lateral to the TMJ",
        "Superior to the TMJ",
        "Posterior to the TMJ",
      ],
      correct: "D"
    },
    {
      id: 11041,
      question: "What muscle is responsible for pulling the disc and mandible forward?",
      options: [
        "Masseter muscle",
        "Temporalis muscle",
        "Medial pterygoid muscle",
        "Lateral pterygoid muscle",
      ],
      correct: "D"
    },
    {
      id: 11042,
      question: "How many types of movement are involved in normal TMJ function?",
      options: [
        "One type",
        "Two types",
        "Three types",
        "Four types",
      ],
      correct: "B"
    },
    {
      id: 11043,
      question: "What are the two types of normal TMJ movement?",
      options: [
        "Lateral and medial",
        "Flexion and extension",
        "Rotational and gliding",
        "Abduction and adduction",
      ],
      correct: "C"
    },
    {
      id: 11044,
      question: "During the first millimeters of teeth separation, which type of movement occurs?",
      options: [
        "Rotational movement",
        "Gliding movement",
        "Lateral movement",
        "Sliding movement",
      ],
      correct: "A"
    },
    {
      id: 11045,
      question: "During initial rotation, what lubricates the condyle's movement against the articular disc?",
      options: [
        "Superior synovial cavity",
        "Inferior synovial cavity",
        "Joint capsule fluid",
        "Blood plasma",
      ],
      correct: "B"
    },
    {
      id: 11046,
      question: "During initial rotation, what prevents the articular disc from rotating forward with the condyle?",
      options: [
        "The collagenous lamina",
        "The joint capsule",
        "The lateral pterygoid muscle",
        "The elastic lamina",
      ],
      correct: "D"
    },
    {
      id: 11047,
      question: "What is the primary function of the elastic lamina during initial jaw opening?",
      options: [
        "To pull the disc forward",
        "To lubricate the joint",
        "To stabilize the condyle",
        "To hold the articular disc more posteriorly",
      ],
      correct: "D"
    },
    {
      id: 11048,
      question: "As the teeth come farther apart during opening, which movement begins in addition to rotation?",
      options: [
        "Gliding movement",
        "Lateral movement",
        "Posterior movement",
        "Medial movement",
      ],
      correct: "A"
    },
    {
      id: 11049,
      question: "Which muscle is responsible for pulling both the condyle and disc forward during jaw opening?",
      options: [
        "Masseter muscle",
        "Temporalis muscle",
        "Medial pterygoid muscle",
        "Superior head of the lateral pterygoid muscle",
      ],
      correct: "D"
    },
    {
      id: 11050,
      question: "How far does the condyle move during full opening?",
      options: [
        "To the posterior tubercle",
        "To about the crest of the articular eminence",
        "Into the mandibular fossa",
        "Beyond the articular eminence",
      ],
      correct: "B"
    },
    {
      id: 11051,
      question: "When the jaw begins to close, which muscle controls the movement back to centric relation?",
      options: [
        "Masseter muscle",
        "Superior head of the lateral pterygoid muscle",
        "Temporalis muscle",
        "Inferior head of the lateral pterygoid muscle",
      ],
      correct: "B"
    },
    {
      id: 11052,
      question: "What balances the posterior pull of the elastic lamina during jaw closing?",
      options: [
        "The joint capsule",
        "The temporalis muscle",
        "Controlled release of lateral pterygoid contraction",
        "The masseter muscle",
      ],
      correct: "C"
    },
    {
      id: 11053,
      question: "What is the function of the collagenous lamina during jaw movement?",
      options: [
        "To lubricate the joint",
        "To initiate jaw opening",
        "To rotate the condyle",
        "To control the anterior pull of the lateral pterygoid muscle",
      ],
      correct: "D"
    },
    {
      id: 11054,
      question: "The collagenous lamina prevents the disc from being pulled too far in which direction?",
      options: [
        "Posteriorly",
        "Laterally",
        "Medially",
        "Forward",
      ],
      correct: "D"
    },
    {
      id: 11055,
      question: "During mastication, what causes lateral excursion of the mandible?",
      options: [
        "Both lateral pterygoid muscles contracting equally",
        "The masseter muscle contracting",
        "The temporalis muscle contracting bilaterally",
        "One lateral pterygoid muscle pulling forward more than the other",
      ],
      correct: "D"
    },
    {
      id: 11056,
      question: "On the side opposite to the food during mastication, what space is created?",
      options: [
        "No space is created",
        "A large space in the fossa",
        "A small space between the condyle and mandibular fossa",
        "A space in the inferior synovial cavity",
      ],
      correct: "C"
    },
    {
      id: 11057,
      question: "Which muscle pulls the condyle posteriorly during the biting phase of mastication?",
      options: [
        "Lateral pterygoid muscle",
        "Masseter muscle",
        "Medial pterygoid muscle",
        "Temporal muscle",
      ],
      correct: "D"
    },
    {
      id: 11058,
      question: "What action is created between tooth surfaces during mastication as the temporal muscle contracts?",
      options: [
        "Sliding action",
        "Crushing action",
        "Tearing action",
        "Grinding action",
      ],
      correct: "D"
    },
    {
      id: 11059,
      question: "During the biting phase, what happens to the superior head of the lateral pterygoid muscle?",
      options: [
        "It contracts strongly",
        "It remains contracted",
        "It spasms",
        "It slowly relaxes",
      ],
      correct: "D"
    },
    {
      id: 11060,
      question: "What force brings the condyle back to its resting closed position during jaw closing?",
      options: [
        "Gravity",
        "Temporalis muscle only",
        "Masseter muscle contraction",
        "Controlled posterior force from the elastic lamina",
      ],
      correct: "D"
    },
    {
      id: 11061,
      question: "Popping and clicking may occur when the articular disc is pulled too far in which direction?",
      options: [
        "Posteriorly",
        "Forward",
        "Laterally",
        "Medially",
      ],
      correct: "B"
    },
    {
      id: 11062,
      question: "When popping occurs, where does the thick part of the disc move?",
      options: [
        "Backward into the fossa",
        "Under the condyle",
        "Into the inferior synovial cavity",
        "Over the articular eminence",
      ],
      correct: "D"
    },
    {
      id: 11063,
      question: "Besides disc displacement, what other conditions can cause TMJ noises?",
      options: [
        "Muscle spasm only",
        "Bone fractures",
        "Ligament tears only",
        "Adhesions of synovial membranes, arthritis, or disc perforations",
      ],
      correct: "D"
    },
    {
      id: 11064,
      question: "What is an audible sign of popping and clicking?",
      options: [
        "Continuous grinding sound",
        "Crackling during rest",
        "Whistling sound",
        "A noise when opening and/or closing the mouth",
      ],
      correct: "D"
    },
    {
      id: 11065,
      question: "What may be felt during palpation of the TMJ with popping and clicking?",
      options: [
        "Smooth continuous movement",
        "No movement",
        "Excessive heat",
        "A jumping movement during opening",
      ],
      correct: "D"
    },
    {
      id: 11066,
      question: "Which treatment is commonly used for popping and clicking?",
      options: [
        "Antibiotics",
        "Immediate surgery",
        "Tooth extraction",
        "Use of a splint (nightguard)",
      ],
      correct: "D"
    },
    {
      id: 11067,
      question: "In disc derangement, where is the articular disc positioned?",
      options: [
        "Permanently displaced backward",
        "Permanently displaced forward",
        "Permanently displaced laterally",
        "In normal position",
      ],
      correct: "B"
    },
    {
      id: 11068,
      question: "What structures may tear in disc derangement?",
      options: [
        "Only the joint capsule",
        "Posterior laminae and disc attachments to the condyle",
        "Only the muscles",
        "Only the ligaments",
      ],
      correct: "B"
    },
    {
      id: 11069,
      question: "Why is disc derangement usually very painful?",
      options: [
        "The disc itself has many nerves",
        "The structures behind the disc have full nerve supply, unlike the disc itself",
        "The condyle is fractured",
        "The temporal bone is damaged",
      ],
      correct: "B"
    },
    {
      id: 11070,
      question: "What is a common successful treatment for disc derangement?",
      options: [
        "Antibiotics",
        "Ice therapy only",
        "Surgical treatment",
        "Rest only",
      ],
      correct: "C"
    },
    {
      id: 11071,
      question: "In subluxation, where does the condyle move during opening?",
      options: [
        "Stays in the fossa",
        "Moves slightly forward",
        "Slides too far forward and passes over the height of the articular eminence",
        "Moves backward",
      ],
      correct: "C"
    },
    {
      id: 11072,
      question: "Why is it difficult for the condyle to return in subluxation?",
      options: [
        "The disc is torn",
        "Muscles are pulling up as well as back on the condyle",
        "The joint is frozen",
        "There is no muscle function",
      ],
      correct: "B"
    },
    {
      id: 11073,
      question: "What anatomical factors influence the likelihood of subluxation?",
      options: [
        "Tooth position only",
        "Muscle strength only",
        "Height of articular eminence, depth of mandibular fossa, and position of joint capsule",
        "Disc thickness only",
      ],
      correct: "C"
    },
    {
      id: 11074,
      question: "What is the primary sign of subluxation?",
      options: [
        "Excessive jaw movement",
        "The client is not able to close the mouth after it has been opened widely",
        "Continuous pain at rest",
        "Bleeding from the joint",
      ],
      correct: "B"
    },
    {
      id: 11075,
      question: "Where should thumbs be placed when treating subluxation?",
      options: [
        "On the chin",
        "On the forehead",
        "On the anterior teeth",
        "On the occlusal surfaces of the posterior teeth",
      ],
      correct: "D"
    },
    {
      id: 11076,
      question: "What direction of pressure is applied first when reducing subluxation?",
      options: [
        "Upward",
        "Downward",
        "Forward",
        "Lateral",
      ],
      correct: "B"
    },
    {
      id: 11077,
      question: "After reducing subluxation, what post-operative instruction should be given?",
      options: [
        "Open wide frequently",
        "Chew lots of gum",
        "DO NOT open wide",
        "Stretch the jaw when yawning",
      ],
      correct: "C"
    },
    {
      id: 11078,
      question: "What can be done for repeated subluxation occurrences?",
      options: [
        "No treatment available",
        "Medication only",
        "Surgery to re-contour the anatomical features of TMJ",
        "Extraction of teeth",
      ],
      correct: "C"
    },
    {
      id: 11079,
      question: "What is bruxism?",
      options: [
        "TMJ dislocation",
        "The habitual grinding of teeth outside of normal function",
        "Jaw fracture",
        "Excessive jaw opening",
      ],
      correct: "B"
    },
    {
      id: 11080,
      question: "When does bruxism most commonly occur?",
      options: [
        "During eating",
        "During talking",
        "During sleep",
        "During exercise",
      ],
      correct: "C"
    },
    {
      id: 11081,
      question: "What is the primary source of pain in bruxism?",
      options: [
        "Bone fractures",
        "Disc perforation",
        "Tiring of the muscles of mastication",
        "Ligament tears",
      ],
      correct: "C"
    },
    {
      id: 11082,
      question: "What dental sign is characteristic of bruxism?",
      options: [
        "Missing teeth",
        "Signs of excessive wear on the occlusal surfaces of teeth",
        "Tooth mobility",
        "Gum recession only",
      ],
      correct: "B"
    },
    {
      id: 11083,
      question: "What is abfraction?",
      options: [
        "Tooth fracture",
        "A type of tooth wear associated with bruxism",
        "Gum disease",
        "Tooth decay",
      ],
      correct: "B"
    },
    {
      id: 11084,
      question: "What is a common treatment for bruxism to protect teeth?",
      options: [
        "Tooth extraction",
        "Root canal",
        "Fabrication of nightguard",
        "Crown placement",
      ],
      correct: "C"
    },
    {
      id: 11085,
      question: "What medication may be prescribed for bruxism?",
      options: [
        "Antibiotics",
        "Painkillers only",
        "Tranquilizers to relieve tension",
        "Steroids",
      ],
      correct: "C"
    },
    {
      id: 11086,
      question: "What is referred pain in relation to TMJ?",
      options: [
        "Pain that spreads to teeth",
        "Pain interpreted from the TMJ but actually coming from another area",
        "Pain from tooth decay",
        "Pain from sinus infection",
      ],
      correct: "B"
    },
    {
      id: 11087,
      question: "What areas can cause referred pain to the TMJ?",
      options: [
        "Only the teeth",
        "Only the muscles of mastication",
        "Auricular region, spasm of neck muscles or muscles of mastication",
        "Only the eyes",
      ],
      correct: "C"
    },
    {
      id: 11088,
      question: "In referred pain, what is found on palpation of the TMJ?",
      options: [
        "Severe tenderness",
        "Swelling",
        "No pain on palpation",
        "Crepitus",
      ],
      correct: "C"
    },
    {
      id: 11089,
      question: "What do radiographs show in cases of referred pain to TMJ?",
      options: [
        "Severe bone damage",
        "Disc displacement",
        "Normal results",
        "Fractures",
      ],
      correct: "C"
    },
    {
      id: 11090,
      question: "What treatment targets the muscles surrounding the TMJ in referred pain?",
      options: [
        "Surgery",
        "Tooth extraction",
        "Muscle relaxants and physical therapy",
        "Antibiotics",
      ],
      correct: "C"
    },
    {
      id: 11091,
      question: "What is the theory linking malocclusion to TMJ pain?",
      options: [
        "Teeth are too large",
        "Muscles of mastication are not in proper position and may tire or spasm",
        "Bone structure is abnormal",
        "Disc is damaged",
      ],
      correct: "B"
    },
    {
      id: 11092,
      question: "What can cause changes to occlusion that may lead to TMJ problems?",
      options: [
        "Aging only",
        "Dental wear or other dental treatments",
        "Diet only",
        "Breathing patterns",
      ],
      correct: "B"
    },
    {
      id: 11093,
      question: "How might dentists treat malocclusion-related TMJ pain?",
      options: [
        "Extract all teeth",
        "No treatment available",
        "Correct occlusion by building up worn-down surfaces",
        "Only prescribe medication",
      ],
      correct: "C"
    },
    {
      id: 11094,
      question: "What do both trismus and ankylosis have in common?",
      options: [
        "They both cause excessive movement",
        "They both limit the client's opening and/or overall mobility of TMJ",
        "They both cause bleeding",
        "They both are painless",
      ],
      correct: "B"
    },
    {
      id: 11095,
      question: "What is trismus?",
      options: [
        "Excessive jaw opening",
        "Fusion of bones",
        "Fibrosis, spasm or contraction of masticatory muscles causing jaw to become \"locked\"",
        "Disc perforation",
      ],
      correct: "C"
    },
    {
      id: 11096,
      question: "What is ankylosis?",
      options: [
        "Muscle spasm",
        "When the mandible becomes fused to the temporal bone by bony or fibrous tissue",
        "Disc displacement",
        "Ligament tear",
      ],
      correct: "B"
    },
    {
      id: 11097,
      question: "What is the primary treatment for ankylosis?",
      options: [
        "Medication only",
        "Physical therapy only",
        "Surgical",
        "No treatment needed",
      ],
      correct: "C"
    },
    {
      id: 11098,
      question: "Can arthritis affect the TMJ?",
      options: [
        "No, never",
        "Only in elderly patients",
        "Yes, since TMJ is such a high-stress joint",
        "Only if there is trauma",
      ],
      correct: "C"
    },
    {
      id: 11099,
      question: "What may arthritis cause in the TMJ?",
      options: [
        "Increased mobility",
        "Excessive wear of the articular disc and synovial cavities",
        "No changes",
        "Tooth loss only",
      ],
      correct: "B"
    },
    {
      id: 11100,
      question: "What is fibromyalgia?",
      options: [
        "A bacterial infection",
        "A viral disease",
        "An idiopathic syndrome causing general heightened nerve sensitivity throughout the body",
        "A fungal infection",
      ],
      correct: "C"
    },
    {
      id: 11101,
      question: "What sensation might arthritis cause in TMJ movements?",
      options: [
        "Smoother movements",
        "No change in sensation",
        "Movements feel less \"smooth\" and potentially painful",
        "Increased flexibility",
      ],
      correct: "C"
    },
    {
      id: 11102,
      question: "During jaw closing, what two forces work together to control condyle movement?",
      options: [
        "Gravity and muscle contraction",
        "Controlled release of lateral pterygoid contraction and posterior pull of elastic lamina",
        "Masseter and temporalis only",
        "Disc and capsule tension",
      ],
      correct: "B"
    },
    {
      id: 11103,
      question: "What prevents excessive anterior displacement of the disc during jaw opening?",
      options: [
        "Superior synovial cavity",
        "Inferior synovial cavity",
        "Collagenous lamina",
        "Joint capsule alone",
      ],
      correct: "C"
    },
  ],
  "0. TMJ (Part 2)": [
    {
      id: 11500,
      question: "The temporomandibular joint is best described as which type of articulation?",
      options: [
        "A bilateral joint between temporal and mandibular bones",
        "A unilateral joint between sphenoid and mandible",
        "A fixed suture between cranial bones only",
        "A cartilaginous joint with limited movement capability"
      ],
      correct: "A"
    },
    {
      id: 11501,
      question: "What is the blood supply to the TMJ? (Remember: PATT)",
      options: [
        "Posterior auricular, anterior tibial, temporal, tympanic arteries",
        "Pharyngeal, auricular, temporal, tympanic arteries (ascending pharyngeal, superficial temporal, deep auricular, anterior tympanic)",
        "Pulmonary, aortic, temporal, thyroid arteries supply",
        "Palatine, alveolar, transverse facial, temporal arteries"
      ],
      correct: "B"
    },
    {
      id: 11502,
      question: "Which nerves provide innervation to the TMJ? (Remember: MAT)",
      options: [
        "Mandibular, alveolar, and trigeminal nerve branches",
        "Maxillary, auricular, and temporal nerve branches",
        "Masseteric, auriculotemporal, and deep temporal nerves (all V3 branches)",
        "Mental, anterior palatine, and trigeminal branches"
      ],
      correct: "C"
    },
    {
      id: 11503,
      question: "The articular eminence is located on which bone?",
      options: [
        "The anterior portion of the mandible near condyle",
        "The posterior aspect of the sphenoid bone",
        "The most anterior part of temporal bone associated with TMJ",
        "The lateral surface of the zygomatic bone"
      ],
      correct: "C"
    },
    {
      id: 11504,
      question: "What is the mandibular fossa?",
      options: [
        "The concavity in temporal bone where mandibular condyle sits",
        "The depression on mandible where temporal bone articulates",
        "The opening in sphenoid bone for nerve passage",
        "The space between maxilla and mandible for muscles"
      ],
      correct: "A"
    },
    {
      id: 11505,
      question: "The posterior tubercle (posterior temporal) is described as:",
      options: [
        "The anterior boundary of the mandibular fossa region",
        "The attachment site for the articular disc anteriorly",
        "The most posterior part of temporal bone associated with TMJ",
        "The inferior projection of the mandibular condyle bone"
      ],
      correct: "C"
    },
    {
      id: 11506,
      question: "What is the shape of the articular disc\'s upper surface?",
      options: [
        "Uniformly flat to match the mandibular fossa",
        "Completely convex to fit over the condyle",
        "Concavoconvex to match mandibular fossa and articular eminence",
        "Cylindrical to allow rotational movement only"
      ],
      correct: "C"
    },
    {
      id: 11507,
      question: "The lower surface of the articular disc is:",
      options: [
        "Flat to provide stability during movement",
        "Convex to match the temporal bone",
        "Concave to match the shape of the condyle",
        "Irregular to increase surface area contact"
      ],
      correct: "C"
    },
    {
      id: 11508,
      question: "Which region of the articular disc is the thickest?",
      options: [
        "The anterior region where it attaches to lateral pterygoid",
        "The intermediate region between anterior and posterior",
        "The posterior region at the back of the disc",
        "All regions have equal thickness throughout the disc"
      ],
      correct: "C"
    },
    {
      id: 11509,
      question: "Which region of the articular disc is the thinnest?",
      options: [
        "The posterior region for flexibility during movement",
        "The anterior region to allow muscle attachment",
        "The intermediate region between anterior and posterior portions",
        "The lateral edges to accommodate condyle movement"
      ],
      correct: "C"
    },
    {
      id: 11510,
      question: "Where does the anterior portion of the articular disc attach?",
      options: [
        "To the posterior aspect of the mandibular condyle",
        "To the superior head of lateral pterygoid muscle",
        "To the inferior head of lateral pterygoid muscle",
        "To the temporomandibular ligament within the capsule"
      ],
      correct: "B"
    },
    {
      id: 11511,
      question: "What structure surrounds the entire TMJ?",
      options: [
        "Dense fibrous tissue forming the TMJ capsule",
        "Loose connective tissue with elastic fibers",
        "Synovial membrane without fibrous reinforcement",
        "Cartilaginous tissue connecting temporal to mandible"
      ],
      correct: "A"
    },
    {
      id: 11512,
      question: "The temporomandibular ligament runs from:",
      options: [
        "Styloid process to the medial mandible surface",
        "Sphenoid spine to the mylohyoid groove area",
        "Articular eminence to lateral side of condyle",
        "Posterior tubercle to the angle of mandible"
      ],
      correct: "C"
    },
    {
      id: 11513,
      question: "Where is the temporomandibular ligament located?",
      options: [
        "Outside the capsule on the medial side",
        "Within the TMJ capsule as reinforcement",
        "Posterior to the capsule near styloid process",
        "Anterior to the capsule near sphenoid bone"
      ],
      correct: "B"
    },
    {
      id: 11514,
      question: "The stylomandibular ligament runs from:",
      options: [
        "Styloid process to the angle of mandible medially",
        "Sphenoid bone to the mylohyoid groove region",
        "Temporal bone to the lateral condyle surface",
        "Articular eminence to the coronoid process anteriorly"
      ],
      correct: "A"
    },
    {
      id: 11515,
      question: "The sphenomandibular ligament attaches to which landmark? (Remember: M.I.G.)",
      options: [
        "Lateral surface of mandible near the sigmoid notch",
        "Medial side of mandible near mylohyoid groove",
        "Anterior border of mandible at mental foramen",
        "Posterior mandible at the angle and ramus junction"
      ],
      correct: "B"
    },
    {
      id: 11516,
      question: "What is the primary function of the temporomandibular ligament?",
      options: [
        "It limits excessive jaw opening during function",
        "It prevents backward movement of the condyle",
        "It supports the jaw like a sling structure",
        "It controls lateral excursion during chewing"
      ],
      correct: "B"
    },
    {
      id: 11517,
      question: "What is the function of the stylomandibular ligament?",
      options: [
        "Prevents backward movement of mandibular condyle",
        "Limits jaw opening to protect joint structures",
        "Supports jaw like a sling during movements",
        "Controls rotation during initial mouth opening"
      ],
      correct: "B"
    },
    {
      id: 11518,
      question: "What is the function of the sphenomandibular ligament?",
      options: [
        "Limits jaw opening to prevent dislocation",
        "Prevents posterior displacement of the condyle",
        "Supports the jaw like a sling structure",
        "Controls forward translation during opening"
      ],
      correct: "C"
    },
    {
      id: 11519,
      question: "What are the synovial cavities in the TMJ?",
      options: [
        "Spaces filled with blood for nutrient supply",
        "Sac-like cavities above and below articular disc",
        "Chambers containing air for shock absorption",
        "Channels for nerve and blood vessel passage"
      ],
      correct: "B"
    },
    {
      id: 11520,
      question: "What is the function of synovial fluid?",
      options: [
        "To provide nutrients to the articular cartilage directly",
        "To lubricate TMJ movements and reduce friction",
        "To cushion impact during forceful biting actions",
        "To transmit proprioceptive signals during movement"
      ],
      correct: "B"
    },
    {
      id: 11521,
      question: "The superior synovial cavity is located:",
      options: [
        "Between the articular disc and mandibular condyle",
        "Between temporal bone and articular disc superior surface",
        "Within the retrodiscal pad posterior to disc",
        "Between the capsule and lateral pterygoid muscle"
      ],
      correct: "B"
    },
    {
      id: 11522,
      question: "The inferior synovial cavity is located:",
      options: [
        "Between articular disc and temporal bone above",
        "Within the mandibular fossa and capsule space",
        "Between articular disc and mandibular condyle below",
        "Between retrodiscal tissue and posterior capsule"
      ],
      correct: "C"
    },
    {
      id: 11523,
      question: "What is the retrodiscal pad?",
      options: [
        "Anterior extension of disc attaching to muscle",
        "Connective tissue extending from posterior disc end",
        "Lateral attachment of disc to joint capsule",
        "Superior attachment connecting disc to temporal bone"
      ],
      correct: "B"
    },
    {
      id: 11524,
      question: "What is significant about the retrodiscal pad?",
      options: [
        "It contains most TMJ blood and nerve supply",
        "It provides primary attachment for lateral pterygoid",
        "It secretes the majority of synovial fluid",
        "It prevents anterior displacement of the disc"
      ],
      correct: "A"
    },
    {
      id: 11525,
      question: "The superior retrodiscal lamina contains:",
      options: [
        "Collagenous fibers for strength and support",
        "Elastic fibers to assist normal TMJ movement",
        "Dense fibrous tissue for capsule attachment",
        "Synovial cells for fluid production"
      ],
      correct: "B"
    },
    {
      id: 11526,
      question: "The inferior retrodiscal lamina contains:",
      options: [
        "Elastic fibers allowing disc displacement anteriorly",
        "Synovial tissue producing lubricating fluid",
        "Collagenous fibers assisting normal TMJ movement",
        "Adipose tissue for shock absorption"
      ],
      correct: "C"
    },
    {
      id: 11527,
      question: "What is the function of the superior elastic lamina?",
      options: [
        "Pulls the disc anteriorly during opening",
        "Holds disc posteriorly during condyle rotation",
        "Prevents excessive forward disc displacement",
        "Limits downward movement of the condyle"
      ],
      correct: "B"
    },
    {
      id: 11528,
      question: "What is the function of the inferior collagenous lamina?",
      options: [
        "Allows elastic stretch during wide opening",
        "Produces synovial fluid for lubrication",
        "Controls anterior pull of lateral pterygoid muscle",
        "Provides attachment for temporalis muscle"
      ],
      correct: "C"
    },
    {
      id: 11529,
      question: "What are the two components of normal TMJ movement?",
      options: [
        "Elevation and depression of the mandible",
        "Rotational and gliding movements",
        "Lateral and medial excursion",
        "Protrusion and retrusion"
      ],
      correct: "B"
    },
    {
      id: 11530,
      question: "During the first millimeters of mouth opening:",
      options: [
        "Gliding movement occurs down articular eminence",
        "Lateral pterygoid muscle contracts to pull disc forward",
        "Rotational movement of condyle against disc occurs",
        "Condyle moves posteriorly into mandibular fossa"
      ],
      correct: "C"
    },
    {
      id: 11531,
      question: "Which synovial cavity lubricates the rotational movement?",
      options: [
        "The superior synovial cavity between temporal and disc",
        "The inferior synovial cavity between disc and condyle",
        "Both cavities equally during rotation",
        "Neither cavity is involved in rotation"
      ],
      correct: "B"
    },
    {
      id: 11532,
      question: "During initial rotation, what prevents the disc from rotating forward?",
      options: [
        "The superior head of lateral pterygoid muscle contraction",
        "The inferior head of lateral pterygoid muscle tension",
        "The elastic lamina holding disc more posteriorly",
        "The collagenous lamina preventing anterior displacement"
      ],
      correct: "C"
    },
    {
      id: 11533,
      question: "As the teeth separate further during opening:",
      options: [
        "Only rotational movement continues throughout",
        "Rotation stops and gliding becomes the sole movement",
        "Rotation continues and gliding movement begins",
        "Both movements stop and lateral excursion begins"
      ],
      correct: "C"
    },
    {
      id: 11534,
      question: "Which muscle pulls the condyle and disc forward during opening?",
      options: [
        "The inferior head of lateral pterygoid muscle",
        "The superior head of lateral pterygoid muscle",
        "The anterior fibers of temporalis muscle",
        "The deep masseter muscle fibers"
      ],
      correct: "B"
    },
    {
      id: 11535,
      question: "During gliding, the condyle and disc move to:",
      options: [
        "The posterior slope of the articular eminence",
        "About the crest of the articular eminence",
        "The posterior tubercle of temporal bone",
        "The deepest part of mandibular fossa"
      ],
      correct: "B"
    },
    {
      id: 11536,
      question: "During jaw closing, which structure controls condyle movement back?",
      options: [
        "Superior lateral pterygoid controls its release balancing elastic lamina",
        "Inferior lateral pterygoid actively pulls condyle posteriorly",
        "Temporalis muscle pulls condyle directly backward",
        "Masseter muscle guides condyle into fossa"
      ],
      correct: "A"
    },
    {
      id: 11537,
      question: "Which muscles are responsible for jaw depression during mastication?",
      options: [
        "The lateral pterygoid muscles bilaterally",
        "The temporalis muscles working together",
        "The hyoid muscles and suprahyoid group",
        "The masseter and medial pterygoid muscles"
      ],
      correct: "C"
    },
    {
      id: 11538,
      question: "During mastication, which lateral pterygoid contracts more?",
      options: [
        "Both contract equally for balanced movement",
        "The one on the same side as food",
        "The one on opposite side from food",
        "Neither contracts during mastication"
      ],
      correct: "C"
    },
    {
      id: 11539,
      question: "During biting on food, where is the condyle positioned?",
      options: [
        "Forward on articular eminence on food side",
        "In contact with fossa on same side as food",
        "Posterior to fossa on opposite side",
        "Equally positioned bilaterally in both fossae"
      ],
      correct: "B"
    },
    {
      id: 11540,
      question: "On the non-chewing side during mastication:",
      options: [
        "The condyle remains in contact with fossa",
        "A small space exists between condyle and fossa",
        "The condyle moves anteriorly past eminence",
        "The disc becomes completely compressed"
      ],
      correct: "B"
    },
    {
      id: 11541,
      question: "To fill the space on the non-chewing side:",
      options: [
        "Inferior lateral pterygoid pulls condyle forward",
        "Superior lateral pterygoid pulls thicker disc portion forward",
        "Temporalis muscle pulls condyle laterally",
        "Masseter muscle elevates the condyle superiorly"
      ],
      correct: "B"
    },
    {
      id: 11542,
      question: "Which muscle contracts to bring mandible to centric occlusion?",
      options: [
        "The lateral pterygoid muscle bilaterally",
        "The digastric muscle during elevation",
        "The temporal muscle pulling condyle posteriorly",
        "The medial pterygoid muscle on chewing side"
      ],
      correct: "C"
    },
    {
      id: 11543,
      question: "The grinding action during mastication is created by:",
      options: [
        "Lateral pterygoid protruding mandible forward",
        "Temporal muscle pulling condyle posteriorly during closure",
        "Masseter elevating mandible vertically only",
        "Medial pterygoid moving mandible laterally"
      ],
      correct: "B"
    },
    {
      id: 11544,
      question: "As temporal muscle contracts during mastication:",
      options: [
        "Lateral pterygoid also increases contraction",
        "Lateral pterygoid maintains constant contraction level",
        "Superior lateral pterygoid slowly relaxes",
        "Inferior lateral pterygoid begins to contract"
      ],
      correct: "C"
    },
    {
      id: 11545,
      question: "What allows controlled posterior force during closing?",
      options: [
        "Masseter muscle active contraction",
        "Elastic lamina as lateral pterygoid relaxes",
        "Collagenous lamina pulling disc backward",
        "Temporalis muscle gradual release"
      ],
      correct: "B"
    },
    {
      id: 11546,
      question: "Popping and clicking may occur when:",
      options: [
        "The condyle moves too far posteriorly",
        "The disc is pulled too far forward during opening",
        "The temporal muscle contracts excessively",
        "The mandibular fossa becomes too shallow"
      ],
      correct: "B"
    },
    {
      id: 11547,
      question: "When the disc \"pops\" forward, it moves over which structure?",
      options: [
        "The posterior tubercle of temporal bone",
        "The mandibular condyle head",
        "The articular eminence anteriorly",
        "The lateral pole of condyle"
      ],
      correct: "C"
    },
    {
      id: 11548,
      question: "Besides disc displacement, what else can cause TMJ noises?",
      options: [
        "Normal muscle contraction during function",
        "Adhesions of synovial membranes or arthritis",
        "Proper alignment of teeth during closure",
        "Healthy retrodiscal tissue elasticity"
      ],
      correct: "B"
    },
    {
      id: 11549,
      question: "A sign of popping and clicking includes:",
      options: [
        "Silent smooth opening without any sounds",
        "Audible noise when opening and/or closing mouth",
        "Constant pain without any joint sounds",
        "Inability to open mouth beyond few millimeters"
      ],
      correct: "B"
    },
    {
      id: 11550,
      question: "When palpating TMJ with popping/clicking, you may feel:",
      options: [
        "Smooth continuous movement throughout opening",
        "Complete lack of any condyle movement",
        "Jumping movement during opening",
        "Excessive posterior movement of condyle"
      ],
      correct: "C"
    },
    {
      id: 11551,
      question: "During opening with disc displacement, the mandibular midline:",
      options: [
        "Remains perfectly centered throughout movement",
        "Shifts notably to one side during opening",
        "Moves posteriorly toward the throat",
        "Elevates superiorly toward the nose"
      ],
      correct: "B"
    },
    {
      id: 11552,
      question: "Treatment for popping and clicking may include:",
      options: [
        "Immediate surgical intervention as first option",
        "Ultrasound, physical therapy, and splint use",
        "Complete immobilization of jaw for healing",
        "Extraction of posterior teeth to reduce stress"
      ],
      correct: "B"
    },
    {
      id: 11553,
      question: "Permanent disc displacement forward may damage:",
      options: [
        "The anterior band of articular disc only",
        "Posterior laminae and disc-condyle attachments",
        "The superior head of lateral pterygoid muscle",
        "The temporomandibular ligament within capsule"
      ],
      correct: "B"
    },
    {
      id: 11554,
      question: "Why is disc derangement often very painful?",
      options: [
        "The articular disc itself has extensive nerve supply",
        "Structures behind disc have full nerve supply unlike disc",
        "The mandibular condyle becomes fractured",
        "The temporal bone develops stress fractures"
      ],
      correct: "B"
    },
    {
      id: 11555,
      question: "Treatment for disc derangement may include:",
      options: [
        "Immediate physical therapy with no other options",
        "Only conservative management without surgery",
        "Surgical treatment which is usually successful",
        "Complete jaw immobilization for six months"
      ],
      correct: "C"
    },
    {
      id: 11556,
      question: "Subluxation occurs when:",
      options: [
        "Condyle moves too far posteriorly into fossa",
        "Condyle slides too far forward over articular eminence",
        "Disc becomes trapped behind the condyle",
        "Temporal bone fractures during opening"
      ],
      correct: "B"
    },
    {
      id: 11557,
      question: "During subluxation, why is closing difficult?",
      options: [
        "Disc blocks condyle from returning",
        "Muscles pull up and back, difficult to slide over eminence",
        "Lateral pterygoid remains in spasm",
        "Capsule tears preventing any movement"
      ],
      correct: "B"
    },
    {
      id: 11558,
      question: "Factors affecting subluxation likelihood include:",
      options: [
        "Strength of masticatory muscles only",
        "Number of posterior teeth present",
        "Height of eminence, depth of fossa, capsule position",
        "Condition of anterior teeth and occlusion"
      ],
      correct: "C"
    },
    {
      id: 11559,
      question: "The main sign of subluxation is:",
      options: [
        "Severe pain during normal chewing function",
        "Clicking sound during wide opening",
        "Inability to close mouth after wide opening",
        "Constant jaw deviation to one side"
      ],
      correct: "C"
    },
    {
      id: 11560,
      question: "Immediate treatment for subluxation involves:",
      options: [
        "Referring patient immediately to oral surgeon",
        "Placing thumbs on posterior teeth, pressing down and back",
        "Having patient bite forcefully on cotton rolls",
        "Applying ice and waiting for spontaneous reduction"
      ],
      correct: "B"
    },
    {
      id: 11561,
      question: "After subluxation reduction, post-operative instructions include:",
      options: [
        "Chewing gum regularly to strengthen muscles",
        "Opening wide during yawning for exercise",
        "NOT opening wide, chewing lots of gum, or stretching jaw",
        "Immediately returning to all normal activities"
      ],
      correct: "C"
    },
    {
      id: 11562,
      question: "Repeated subluxation can be treated by:",
      options: [
        "Wearing a nightguard indefinitely",
        "Surgery to re-contour anatomical TMJ features",
        "Physical therapy alone without other intervention",
        "Muscle relaxants taken daily for prevention"
      ],
      correct: "B"
    },
    {
      id: 11563,
      question: "Bruxism is defined as:",
      options: [
        "Normal grinding during functional chewing",
        "Habitual grinding of teeth outside normal function",
        "Clicking sounds during mouth opening",
        "Inability to bring teeth together properly"
      ],
      correct: "B"
    },
    {
      id: 11564,
      question: "When does bruxism most commonly occur?",
      options: [
        "During normal daytime function and eating",
        "Only during stressful situations while awake",
        "During sleep more commonly than awake",
        "Equally during both sleep and waking hours"
      ],
      correct: "C"
    },
    {
      id: 11565,
      question: "Most bruxism pain comes from:",
      options: [
        "Fractures of the mandibular condyle",
        "Perforation of the articular disc",
        "Tiring of muscles of mastication",
        "Dislocation of temporal bone"
      ],
      correct: "C"
    },
    {
      id: 11566,
      question: "Signs and symptoms of bruxism include:",
      options: [
        "Inability to open mouth in morning",
        "Excessive wear on occlusal tooth surfaces",
        "Clicking sounds during all movements",
        "Complete lack of any TMJ tenderness"
      ],
      correct: "B"
    },
    {
      id: 11567,
      question: "What is abfraction?",
      options: [
        "Fracture of the mandibular condyle",
        "Non-carious cervical tooth lesions from stress",
        "Complete tooth avulsion from socket",
        "Fracture of articular eminence"
      ],
      correct: "B"
    },
    {
      id: 11568,
      question: "Treatment for bruxism includes:",
      options: [
        "Immediate surgical correction of occlusion",
        "Extraction of worn teeth and replacement",
        "Fabrication of nightguard and possibly tranquilizers",
        "Complete immobilization of jaw during sleep"
      ],
      correct: "C"
    },
    {
      id: 11569,
      question: "Referred pain in TMJ region may originate from:",
      options: [
        "Only the TMJ structures themselves",
        "Auricular region, neck muscles, or masticatory muscles",
        "Exclusively from dental caries in molars",
        "Only from maxillary sinus infections"
      ],
      correct: "B"
    },
    {
      id: 11570,
      question: "Signs of referred pain to TMJ include:",
      options: [
        "Severe pain on TMJ palpation",
        "Abnormal findings on radiographs",
        "Complaints of TMJ pain but no palpation pain",
        "Visible swelling over joint area"
      ],
      correct: "C"
    },
    {
      id: 11571,
      question: "Treatment for referred pain may include:",
      options: [
        "TMJ surgery to correct structural problems",
        "Extraction of all posterior teeth",
        "Muscle relaxants and physical therapy",
        "Antibiotics for infection treatment"
      ],
      correct: "C"
    },
    {
      id: 11572,
      question: "The theory linking malocclusion to TMJ pain suggests:",
      options: [
        "Tooth color affects muscle function",
        "Improper occlusion causes improper muscle positioning",
        "Number of teeth determines pain level",
        "Tooth size affects condyle movement"
      ],
      correct: "B"
    },
    {
      id: 11573,
      question: "Dental treatment for malocclusion-related TMJ pain may involve:",
      options: [
        "Extracting all teeth and replacing with dentures",
        "Orthodontic treatment in all cases",
        "Building up worn-down tooth surfaces",
        "Removing all occlusal contacts completely"
      ],
      correct: "C"
    },
    {
      id: 11574,
      question: "What is trismus?",
      options: [
        "Normal range of mandibular movement",
        "Excessive mobility of TMJ during function",
        "Fibrosis or spasm causing jaw to become \"locked\"",
        "Inflammation of retrodiscal tissue only"
      ],
      correct: "C"
    },
    {
      id: 11575,
      question: "What is ankylosis?",
      options: [
        "Normal fusion of mandibular symphysis",
        "Muscle spasm limiting mouth opening",
        "Mandible fused to temporal bone by bony/fibrous tissue",
        "Clicking sound during TMJ movement"
      ],
      correct: "C"
    },
    {
      id: 11576,
      question: "The main sign of both trismus and ankylosis is:",
      options: [
        "Excessive jaw mobility and dislocation",
        "Painless normal range of motion",
        "Movement becomes challenging or mandible immobile",
        "Clicking sounds during all movements"
      ],
      correct: "C"
    },
    {
      id: 11577,
      question: "Treatment for trismus varies depending on:",
      options: [
        "Patient age and gender only",
        "Cause and severity of condition",
        "Number of teeth present",
        "Patient occupation and lifestyle"
      ],
      correct: "B"
    },
    {
      id: 11578,
      question: "Treatment for ankylosis typically requires:",
      options: [
        "Physical therapy and muscle relaxants",
        "Nightguard and occlusal adjustment",
        "Surgical intervention",
        "Antibiotics and anti-inflammatory medications"
      ],
      correct: "C"
    },
    {
      id: 11579,
      question: "How does arthritis affect the TMJ?",
      options: [
        "It strengthens the articular disc",
        "It causes excessive wear of disc and synovial cavities",
        "It improves smoothness of movements",
        "It has no effect on TMJ structures"
      ],
      correct: "B"
    },
    {
      id: 11580,
      question: "Fibromyalgia is characterized by:",
      options: [
        "Localized pain only in TMJ",
        "Reduced nerve sensitivity throughout body",
        "General heightened nerve sensitivity throughout body",
        "Complete loss of sensation in joints"
      ],
      correct: "C"
    },
    {
      id: 11581,
      question: "Why is TMJ particularly affected by arthritis?",
      options: [
        "It is rarely used during daily activities",
        "It has minimal stress compared to other joints",
        "It is a high-stress joint used frequently",
        "It has more blood supply than other joints"
      ],
      correct: "C"
    },
    {
      id: 11582,
      question: "Fibromyalgia affecting TMJ is described as:",
      options: [
        "Bacterial infection requiring antibiotics",
        "Idiopathic syndrome causing heightened nerve sensitivity",
        "Congenital malformation of joint structures",
        "Traumatic injury from external force"
      ],
      correct: "B"
    }
  
  ],
  "1. Bones of the skull (Part 1)": [    { id: 11100, question: "Which term refers to the immovable fibrous joints between skull bones?", options: ["Canal", "Eminence", "Suture", "Condyle"], correct: 2 },
    { id: 11101, question: "Which anatomical direction means \"toward the head\" in the transverse plane?", options: ["Inferior", "Lateral", "Superior", "Posterior"], correct: 2 },
    { id: 11102, question: "Which bone is not part of the neurocranium?", options: ["Ethmoid", "Parietal", "Maxilla", "Occipital"], correct: 2 },
    { id: 11103, question: "The TMJ is formed by the mandibular condyle and which bone?", options: ["Sphenoid", "Temporal", "Zygomatic", "Frontal"], correct: 1 },
    { id: 11104, question: "Which of the following is a single facial bone?", options: ["Nasal", "Lacrimal", "Inferior nasal concha", "Vomer"], correct: 3 },
    { id: 11105, question: "Which suture joins the frontal and parietal bones?", options: ["Lambdoidal", "Coronal", "Squamosal", "Sagittal"], correct: 1 },
    { id: 11106, question: "The sagittal suture is also known as the ____ suture.", options: ["Interparietal", "Parietooccipital", "Frontoparietal", "Palatomaxillary"], correct: 0 },
    { id: 11107, question: "Which sinus is located within the body of the sphenoid bone, inferior to the pituitary gland?", options: ["Ethmoid sinus", "Maxillary sinus", "Frontal sinus", "Sphenoid sinus"], correct: 3 },
    { id: 11108, question: "Which paranasal sinus is typically the largest?", options: ["Ethmoid", "Maxillary", "Sphenoid", "Frontal"], correct: 1 },
    { id: 11109, question: "Which sinus infection most commonly produces pressure above the eyes?", options: ["Ethmoid", "Sphenoid", "Frontal", "Maxillary"], correct: 2 },
    { id: 11110, question: "Which structure is radiolucent on imaging?", options: ["Nasal septum", "Inferior nasal conchae", "Vomer", "Nasal cavity"], correct: 3 },
    { id: 11111, question: "Which bones articulate with the ethmoid bone?", options: ["Frontal", "Maxillae", "Lacrimal", "All of the above"], correct: 3 },
    { id: 11112, question: "The transverse palatine suture connects which two bones?", options: ["Palatine & Maxilla", "Maxilla & Maxilla", "Palatine & Vomer", "Maxilla & Zygomatic"], correct: 0 },
    { id: 11113, question: "Which sinus drains into the superior meatus?", options: ["Anterior ethmoid cells", "Middle ethmoid cells", "Posterior ethmoid cells", "Maxillary sinus"], correct: 2 },
    { id: 11114, question: "Why is the maxillary sinus prone to drainage problems?", options: ["The opening is often located high within the cavity", "It has the thickest mucosa", "It lacks cilia", "It drains directly into the frontal sinus"], correct: 0 },
    { id: 11115, question: "The inferior portion of the nasal septum is formed by the:", options: ["Ethmoid", "Vomer", "Lacrimal", "Palatine"], correct: 1 },
    { id: 11116, question: "Which of the following bones contributes to the medial wall of the orbit?", options: ["Zygomatic", "Temporal", "Lacrimal", "Occipital"], correct: 2 },
    { id: 11117, question: "The suture located between the two maxillae at the anterior midline is the:", options: ["Median palatine suture", "Lambdoidal suture", "Intermaxillary suture", "Incisive suture"], correct: 2 },
    { id: 11118, question: "Which sinus drains into the superior meatus?", options: ["Frontal sinus", "Anterior ethmoid air cells", "Middle ethmoid air cells", "Posterior ethmoid air cells"], correct: 3 },
    { id: 11119, question: "Which bone forms the lateral wall and part of the floor of the orbit?", options: ["Zygomatic", "Nasal", "Mandible", "Vomer"], correct: 0 },
    { id: 11120, question: "Which of the following is paired?", options: ["Vomer", "Mandible", "Inferior nasal conchae", "Sphenoid"], correct: 2 },
    { id: 11121, question: "The lambdoidal suture is also known as the:", options: ["Frontoparietal suture", "Palatomaxillary suture", "Interparietal suture", "Parietooccipital suture"], correct: 3 },
    { id: 11122, question: "The frontal sinuses drain into which region?", options: ["Superior meatus", "Hiatus semilunaris (anterior portion)", "Sphenoethmoidal recess", "Middle meatus (posterior portion)"], correct: 1 },
    { id: 11123, question: "Which bone forms the majority of the posterior–inferior skull?", options: ["Temporal", "Occipital", "Parietal", "Sphenoid"], correct: 1 },
    { id: 11124, question: "Which term refers to a shallow depression in bone?", options: ["Process", "Fossa", "Eminence", "Foramen"], correct: 1 },
    { id: 11125, question: "The nasal conchae function primarily to:", options: ["Form the nasal septum", "Increase surface area for warming and humidifying air", "Support the lacrimal apparatus", "Form the orbital floor"], correct: 1 },
    { id: 11126, question: "Which structure is part of the viscerocranium?", options: ["Occipital", "Temporal", "Ethmoid", "Maxillae"], correct: 3 },
    { id: 11127, question: "Which bone forms the anterior portion of the hard palate?", options: ["Palatine bones", "Maxillae", "Vomer", "Sphenoid"], correct: 1 },
    { id: 11128, question: "The medial and lateral pterygoid plates are part of which bone?", options: ["Temporal", "Sphenoid", "Maxilla", "Zygomatic"], correct: 1 },
    { id: 11129, question: "The lacrimal bones articulate with all of the following EXCEPT:", options: ["Frontal", "Ethmoid", "Maxilla", "Sphenoid"], correct: 3 },
    { id: 11130, question: "The occipital bone articulates with which of the following?", options: ["Parietal", "Sphenoid", "Temporal", "All of the above"], correct: 3 },
    { id: 11131, question: "Which sinus is most difficult to palpate during extraoral examination?", options: ["Frontal", "Maxillary", "Sphenoid", "Middle ethmoid"], correct: 2 },
    { id: 11132, question: "Which term describes a rounded projection that forms an articulation with another bone?", options: ["Protuberance", "Condyle", "Fissure", "Eminence"], correct: 1 },
    { id: 11133, question: "The median palatine suture is located:", options: ["Between the two maxillae anteriorly", "Between the palatine processes forming the hard palate", "Between the maxilla and palatine bones", "Between the maxilla and vomer"], correct: 1 },
    { id: 11134, question: "Infection of the ethmoid sinuses typically causes:", options: ["Pain in the forehead", "Deep midline head pressure", "Congestion/aching within the nasal cavity", "Pain near the maxillary molars"], correct: 2 },
    { id: 11135, question: "Which anatomical plane divides the body into anterior and posterior portions?", options: ["Sagittal plane", "Horizontal plane", "Coronal plane", "Median plane"], correct: 2 },
    { id: 11136, question: "A structure located closer to the midline of the body is described as:", options: ["Lateral", "Inferior", "Medial", "Posterior"], correct: 2 },
    { id: 11137, question: "The term \"eminence\" refers to:", options: ["A long tube-like passage", "A shallow depression", "A raised area above surrounding bone", "A blunt projection"], correct: 2 },
    { id: 11138, question: "The squamosal suture is unusual because:", options: ["It fuses first after birth", "It involves temporal bone overlapping the parietal bone", "It connects the frontal and parietal bones", "It lies at the midline of the skull"], correct: 1 },
    { id: 11139, question: "The sphenoccipital synchondrosis normally disappears by approximately:", options: ["Age 12", "Age 18", "Age 25", "Age 30"], correct: 1 },
    { id: 11140, question: "The incisive suture is typically found:", options: ["Between the two palatine bones posteriorly", "At the canine-to-canine region of the maxilla in children", "At the midline of the palatine processes", "Between the maxilla and vomer"], correct: 1 },
    { id: 11141, question: "The lacrimal bone contributes to which region of the skull?", options: ["Lateral orbital wall", "Medial orbital wall", "Inferior orbital rim", "Posterior skull base"], correct: 1 },
    { id: 11142, question: "The palatine bones contribute to all of the following EXCEPT:", options: ["Posterior hard palate", "Floor of the orbit", "Lateral nasal cavity wall", "Nasal septum"], correct: 3 },
    { id: 11143, question: "Which sinus drains into the highest and most posterior part of the nasal cavity?", options: ["Frontal sinus", "Maxillary sinus", "Ethmoid air cells", "Sphenoid sinus"], correct: 3 },
    { id: 11144, question: "Which air cells drain into the ethmoid bulla and hiatus semilunaris?", options: ["Posterior ethmoid air cells", "Middle ethmoid air cells", "Maxillary air cells", "Frontal air cells"], correct: 1 },
    { id: 11145, question: "A radiopaque structure seen superior to the maxilla on an X-ray is most likely the:", options: ["Nasal cavity", "Vomer", "Maxillary sinus", "Hiatus semilunaris"], correct: 1 },
    { id: 11146, question: "Maxillary sinus drainage can be problematic because:", options: ["The opening is at the inferior portion", "The opening is at the middle or top of the sinus", "The sinus has no mucosa", "It drains into the frontal sinus"], correct: 1 },
    { id: 11147, question: "Periapical infections of maxillary molars may spread into the sinus because:", options: ["The sinus is separated by a thick bone wall", "The sinus sits far above all root tips", "Some roots protrude into or near the sinus cavity", "The sinus drains directly into the oral cavity"], correct: 2 },
    { id: 11148, question: "Which bone forms the superior portion of the nasal septum?", options: ["Maxilla", "Ethmoid", "Vomer", "Palatine"], correct: 1 },
    { id: 11149, question: "The middle nasal concha is part of which bone?", options: ["Inferior nasal concha", "Maxilla", "Ethmoid", "Lacrimal"], correct: 2 },
    { id: 11150, question: "The ethmoid bone forms part of all the following EXCEPT:", options: ["The nasal septum", "The medial orbital wall", "The inferior orbital rim", "The cranial base"], correct: 2 },
    { id: 11151, question: "The temporal bone includes all of the following parts EXCEPT:", options: ["Petrous part", "Squamous part", "Mastoid process", "Coronoid process"], correct: 3 },
    { id: 11152, question: "Which of the following contributes to the floor of the orbit?", options: ["Maxilla", "Nasal bone", "Parietal bone", "Occipital bone"], correct: 0 },
    { id: 11153, question: "The foramen located at the midline of the anterior palate is the:", options: ["Greater palatine foramen", "Incisive foramen", "Mental foramen", "Infraorbital foramen"], correct: 1 },
    { id: 11154, question: "The inferior nasal conchae are classified as:", options: ["Cranial bones", "Ossicles", "Viscerocranium bones", "Mandibular processes"], correct: 2 },
    { id: 11155, question: "The sphenoid bone can best be visualized from which view?", options: ["Superior", "Anterior only", "Internal or inferior view", "Posterior only"], correct: 2 },
    { id: 11156, question: "The occipital bone is best seen from which view?", options: ["Anterior view", "Lateral view", "Inferior and posterior views", "Orbit view"], correct: 2 },
    { id: 11157, question: "Which structure passes olfactory nerves from the nasal cavity to the brain?", options: ["Crista galli", "Cribriform plate", "Perpendicular plate", "Palatine process"], correct: 1 },
    { id: 11158, question: "The posterior ethmoid air cells drain into the:", options: ["Superior meatus", "Middle meatus", "Inferior meatus", "Hiatus semilunaris"], correct: 0 },
    { id: 11159, question: "The parietal bones articulate with all of the following EXCEPT:", options: ["Frontal", "Temporal", "Occipital", "Maxilla"], correct: 3 },
    { id: 11160, question: "Which bone forms the majority of the bridge of the nose?", options: ["Maxilla", "Nasal bone", "Vomer", "Lacrimal"], correct: 1 },
    { id: 11161, question: "A fissure is defined as:", options: ["A round opening", "A long tube-like canal", "A natural groove or cleft", "A raised bony prominence"], correct: 2 },
    { id: 11162, question: "The lacrimal gland drains tears into the nasal cavity because tears pass through the:", options: ["Lacrimal foramen", "Lacrimal canal", "Nasolacrimal duct", "Orbitonasal fissure"], correct: 2 },
    { id: 11163, question: "The maxillary sinuses span from the canine region posteriorly to the:", options: ["Second premolar", "First molar", "Second molar", "Third molar"], correct: 3 },
    { id: 11164, question: "The middle nasal concha belongs to the:", options: ["Inferior nasal conchae", "Ethmoid bone", "Maxilla", "Zygomatic bone"], correct: 1 },
    { id: 11165, question: "Which bone forms the majority of the lateral wall of the nasal cavity?", options: ["Maxilla", "Ethmoid", "Lacrimal", "Inferior nasal concha"], correct: 0 },
    { id: 11166, question: "The mandibular ramus is best visualized from which skull view?", options: ["Superior view", "Lateral view", "Inferior view", "Anterior view"], correct: 1 },
    { id: 11167, question: "Which bone contains the crista galli?", options: ["Sphenoid", "Temporal", "Ethmoid", "Occipital"], correct: 2 },
    { id: 11168, question: "The perpendicular plate contributes to which structure?", options: ["Hard palate", "Nasal septum", "Nasolacrimal canal", "Zygomatic arch"], correct: 1 },
    { id: 11169, question: "The mandible articulates with the temporal bone at the:", options: ["Coronoid process", "Mental protuberance", "Condylar process", "Mylohyoid line"], correct: 2 },
    { id: 11170, question: "Which bone contributes to the posterior portion of the orbit?", options: ["Maxilla", "Palatine", "Nasal", "Vomer"], correct: 1 },
    { id: 11171, question: "Which structure is found in the ethmoid bone and contains numerous small foramina?", options: ["Stylomastoid foramen", "Cribriform plate", "Infraorbital canal", "Mandibular foramen"], correct: 1 },
    { id: 11172, question: "Which suture connects the parietal bones to the occipital bone?", options: ["Lambdoidal suture", "Coronal suture", "Sagittal suture", "Squamosal suture"], correct: 0 },
    { id: 11173, question: "Which sinus lies just below the orbital floor and is closely related to maxillary posterior teeth?", options: ["Ethmoid sinus", "Maxillary sinus", "Frontal sinus", "Sphenoid sinus"], correct: 1 },
    { id: 11174, question: "Which structure is radiopaque on a panoramic radiograph?", options: ["Nasal cavity", "Nasal septum", "Frontal sinuses", "Airway"], correct: 1 },
    { id: 11175, question: "The superior nasal concha belongs to which bone?", options: ["Maxilla", "Palatine", "Ethmoid", "Inferior nasal concha"], correct: 2 },
    { id: 11176, question: "The lacrimal bone articulates with all the following EXCEPT:", options: ["Maxilla", "Ethmoid", "Nasal", "Frontal"], correct: 2 },
    { id: 11177, question: "The sphenoid bone articulates with which cranial bone?", options: ["Occipital", "Parietal", "Temporal", "All of the above"], correct: 3 },
    { id: 11178, question: "The cranial bone forming the largest portion of the posterior skull is the:", options: ["Temporal bone", "Occipital bone", "Sphenoid bone", "Frontal bone"], correct: 1 },
    { id: 11179, question: "Tears drain into the nasal cavity through which opening?", options: ["Inferior meatus", "Middle meatus", "Superior meatus", "Sphenoethmoidal recess"], correct: 0 },
    { id: 11180, question: "The middle meatus receives drainage from all the following EXCEPT:", options: ["Maxillary sinus", "Frontal sinus", "Anterior ethmoid air cells", "Posterior ethmoid air cells"], correct: 3 },
    { id: 11181, question: "The structure that warms, filters, and humidifies inspired air is the:", options: ["Palatine tonsil", "Nasal conchae", "Vomer", "Mandible"], correct: 1 },
    { id: 11182, question: "The zygomatic bone articulates with all the following EXCEPT:", options: ["Maxilla", "Frontal", "Temporal", "Nasal"], correct: 3 },
    { id: 11183, question: "Which structure is part of the neurocranium?", options: ["Nasal bone", "Zygomatic bone", "Temporal bone", "Maxilla"], correct: 2 },
    { id: 11184, question: "Which facial bone forms the posterior portion of the hard palate?", options: ["Maxilla", "Palatine", "Vomer", "Lacrimal"], correct: 1 }
  ],
  "1. Bones of the skull (Part 2)": [
    {
      id: 11600,
      question: "Which term describes a short tube-like opening or passage through bone?",
      options: [
        "Suture",
        "Foramen",
        "Fissure",
        "Canal"
      ],
      correct: "B"
    },
    {
      id: 11601,
      question: "A long tube-like opening or channel through bone is called a:",
      options: [
        "Foramen",
        "Canal",
        "Fossa",
        "Process"
      ],
      correct: "B"
    },
    {
      id: 11602,
      question: "What is an eminence in anatomical terms?",
      options: [
        "A shallow depression in bone",
        "An area raised above the bone surface",
        "A groove between two structures",
        "A projection forming joint articulation"
      ],
      correct: "B"
    },
    {
      id: 11603,
      question: "Which structure is described as a shallow depression or hollow in bone?",
      options: [
        "Condyle",
        "Process",
        "Fossa",
        "Eminence"
      ],
      correct: "C"
    },
    {
      id: 11604,
      question: "A rounded protuberance of bone forming articulation with another bone is called a:",
      options: [
        "Process",
        "Condyle",
        "Fissure",
        "Foramen"
      ],
      correct: "B"
    },
    {
      id: 11605,
      question: "What term describes a groove or natural division between two structures?",
      options: [
        "Suture",
        "Canal",
        "Fissure",
        "Foramen"
      ],
      correct: "C"
    },
    {
      id: 11606,
      question: "A projection or outgrowth of bone tissue is known as a:",
      options: [
        "Fossa",
        "Condyle",
        "Process",
        "Eminence"
      ],
      correct: "C"
    },
    {
      id: 11607,
      question: "Which term means occurring on only one side of the body?",
      options: [
        "Bilateral",
        "Ipsilateral",
        "Medial",
        "Unilateral"
      ],
      correct: "D"
    },
    {
      id: 11608,
      question: "When a structure occurs on both sides of the body symmetrically, it is described as:",
      options: [
        "Unilateral",
        "Bilateral",
        "Ipsilateral",
        "Contralateral"
      ],
      correct: "B"
    },
    {
      id: 11609,
      question: "Ipsilateral refers to structures occurring:",
      options: [
        "On opposite sides of the body",
        "On the same side of the body",
        "On both sides of the body",
        "At the midline of the body"
      ],
      correct: "B"
    },
    {
      id: 11610,
      question: "How many bones make up the neurocranium (bones surrounding the brain)?",
      options: [
        "6 bones",
        "8 bones",
        "14 bones",
        "22 bones"
      ],
      correct: "B"
    },
    {
      id: 11611,
      question: "How many bones comprise the viscerocranium (bones of the face)?",
      options: [
        "8 bones",
        "10 bones",
        "14 bones",
        "16 bones"
      ],
      correct: "C"
    },
    {
      id: 11612,
      question: "Which mnemonic can help remember the neurocranium bones?",
      options: [
        "LIMP",
        "N.V.M.Z",
        "S-T-E-P-O-F",
        "B.A.R"
      ],
      correct: "C"
    },
    {
      id: 11613,
      question: "The frontal bone extends from the roof of the orbit to:",
      options: [
        "The back of the skull",
        "The top of the skull",
        "The base of the skull",
        "The side of the skull"
      ],
      correct: "B"
    },
    {
      id: 11614,
      question: "Which bones does the frontal bone articulate with?",
      options: [
        "Only parietal and temporal bones",
        "Only sphenoid and ethmoid bones",
        "Nasal, maxillae, zygomatic, sphenoid, parietal, ethmoid, and lacrimal",
        "All cranial bones except occipital"
      ],
      correct: "C"
    },
    {
      id: 11615,
      question: "The sphenoid bone is often described as shaped like a:",
      options: [
        "Triangle",
        "Rectangle",
        "Butterfly",
        "Pyramid"
      ],
      correct: "C"
    },
    {
      id: 11616,
      question: "Which bone articulates with ALL other cranial bones?",
      options: [
        "Frontal bone",
        "Sphenoid bone",
        "Temporal bone",
        "Ethmoid bone"
      ],
      correct: "B"
    },
    {
      id: 11617,
      question: "The sphenoid bone forms which portion of the orbit?",
      options: [
        "The anterior portion",
        "The superior portion",
        "The posterior portion",
        "The inferior portion"
      ],
      correct: "C"
    },
    {
      id: 11618,
      question: "The ethmoid bone forms the superior portion of which structure?",
      options: [
        "The hard palate",
        "The nasal septum",
        "The orbital floor",
        "The zygomatic arch"
      ],
      correct: "B"
    },
    {
      id: 11619,
      question: "Which bone is best visualized from inferior or internal views?",
      options: [
        "Frontal bone",
        "Parietal bone",
        "Sphenoid bone",
        "Nasal bone"
      ],
      correct: "C"
    },
    {
      id: 11620,
      question: "The occipital bone is located:",
      options: [
        "Anterior and superior to temporal bones",
        "Posterior and inferior to parietal bones",
        "Lateral to the frontal bone",
        "Superior to the parietal bones"
      ],
      correct: "B"
    },
    {
      id: 11621,
      question: "Which bones does the occipital bone articulate with?",
      options: [
        "Frontal, parietal, and ethmoid",
        "Temporal, parietal, and sphenoid",
        "All neurocranium bones",
        "Only temporal and parietal bones"
      ],
      correct: "B"
    },
    {
      id: 11622,
      question: "How many parts does the temporal bone have?",
      options: [
        "Two parts",
        "Three parts",
        "Four parts",
        "Six parts"
      ],
      correct: "D"
    },
    {
      id: 11623,
      question: "The mnemonic \"Some People Try Zooming Mostly South\" helps remember:",
      options: [
        "The facial bones",
        "The sutures of the skull",
        "The parts of the temporal bone",
        "The paranasal sinuses"
      ],
      correct: "C"
    },
    {
      id: 11624,
      question: "Which part of the temporal bone contains the ear structures?",
      options: [
        "Squamous part",
        "Petrous part",
        "Tympanic part",
        "Mastoid process"
      ],
      correct: "B"
    },
    {
      id: 11625,
      question: "The zygomatic process is part of which bone?",
      options: [
        "Frontal bone",
        "Sphenoid bone",
        "Temporal bone",
        "Parietal bone"
      ],
      correct: "C"
    },
    {
      id: 11626,
      question: "The parietal bones are best visualized from which views?",
      options: [
        "Anterior and posterior views",
        "Lateral and superior views",
        "Inferior and internal views",
        "Anterior and lateral views"
      ],
      correct: "B"
    },
    {
      id: 11627,
      question: "How many parietal bones are there?",
      options: [
        "One single bone",
        "Two paired bones",
        "Three bones",
        "Four bones"
      ],
      correct: "B"
    },
    {
      id: 11628,
      question: "Which bones does the parietal bone articulate with?",
      options: [
        "Only frontal and occipital bones",
        "Frontal, sphenoid, temporal, occipital, and opposite parietal",
        "All cranial bones",
        "Only temporal and occipital bones"
      ],
      correct: "B"
    },
    {
      id: 11629,
      question: "The mnemonic for facial bones \"My Mouth\'s Palate Never Liked Zucchini In Vinegar\" represents:",
      options: [
        "The order of bone development",
        "The size of the bones",
        "The names of the 14 facial bones",
        "The articulations of facial bones"
      ],
      correct: "C"
    },
    {
      id: 11630,
      question: "Which facial bone is the only mobile bone of the head and neck?",
      options: [
        "Maxilla",
        "Mandible",
        "Palatine",
        "Zygomatic"
      ],
      correct: "B"
    },
    {
      id: 11631,
      question: "The mandible has how many main parts?",
      options: [
        "Two parts",
        "Three parts",
        "Four parts",
        "Five parts"
      ],
      correct: "B"
    },
    {
      id: 11632,
      question: "What does the mandible articulate with to form the TMJ?",
      options: [
        "The maxilla",
        "The sphenoid bone",
        "The temporal bone",
        "The zygomatic bone"
      ],
      correct: "C"
    },
    {
      id: 11633,
      question: "The vomer forms which portion of the nasal septum?",
      options: [
        "The superior portion",
        "The anterior portion",
        "The inferior portion",
        "The lateral portion"
      ],
      correct: "C"
    },
    {
      id: 11634,
      question: "Which bones does the vomer articulate with?",
      options: [
        "Only maxillae and palatine bones",
        "Sphenoid, ethmoid, maxillae, and palatine",
        "All facial bones",
        "Only ethmoid and sphenoid bones"
      ],
      correct: "B"
    },
    {
      id: 11635,
      question: "The nasal bones form which structure?",
      options: [
        "The nasal septum",
        "The bridge of the nose",
        "The nasal cavity floor",
        "The lateral walls of the nose"
      ],
      correct: "B"
    },
    {
      id: 11636,
      question: "Which bones are described as very small and fragile, forming the medial corner of the orbit?",
      options: [
        "Nasal bones",
        "Palatine bones",
        "Lacrimal bones",
        "Inferior nasal conchae"
      ],
      correct: "C"
    },
    {
      id: 11637,
      question: "The lacrimal bones articulate with which structures?",
      options: [
        "Only frontal and maxillae",
        "Frontal, ethmoid, maxillae, and inferior nasal conchae",
        "All facial bones",
        "Only ethmoid and nasal bones"
      ],
      correct: "B"
    },
    {
      id: 11638,
      question: "Which bone is commonly known as the \"cheek bone\"?",
      options: [
        "Maxilla",
        "Lacrimal",
        "Palatine",
        "Zygomatic"
      ],
      correct: "D"
    },
    {
      id: 11639,
      question: "The zygomatic bone forms part of which structures?",
      options: [
        "Only the lateral wall of the orbit",
        "The floor and lateral wall of the orbit",
        "Only the cheek prominence",
        "The nasal cavity walls"
      ],
      correct: "B"
    },
    {
      id: 11640,
      question: "The inferior nasal conchae are part of how many \"nasal turbinates\"?",
      options: [
        "Two turbinates",
        "Three turbinates",
        "Four turbinates",
        "Five turbinates"
      ],
      correct: "B"
    },
    {
      id: 11641,
      question: "What is the function of nasal turbinates?",
      options: [
        "To support the nasal bones",
        "To warm, cleanse, and add moisture to air",
        "To form the nasal septum",
        "To drain the sinuses"
      ],
      correct: "B"
    },
    {
      id: 11642,
      question: "Which bones form the posterior portion of the hard palate?",
      options: [
        "Maxillae",
        "Palatine bones",
        "Vomer",
        "Sphenoid"
      ],
      correct: "B"
    },
    {
      id: 11643,
      question: "The palatine bones contribute to which structures?",
      options: [
        "Only the hard palate",
        "Hard palate, nasal cavity, and orbit floor",
        "Only the nasal cavity",
        "Only the orbit floor"
      ],
      correct: "B"
    },
    {
      id: 11644,
      question: "The maxillae form which portion of the hard palate?",
      options: [
        "The posterior portion",
        "The lateral portions",
        "The anterior portion",
        "The entire hard palate"
      ],
      correct: "C"
    },
    {
      id: 11645,
      question: "Which facial bone articulates with the most other bones?",
      options: [
        "Mandible",
        "Vomer",
        "Maxilla",
        "Zygomatic"
      ],
      correct: "C"
    },
    {
      id: 11646,
      question: "What are sutures?",
      options: [
        "Muscle attachments on bone",
        "Fibrous joints between skull bones",
        "Openings for blood vessels",
        "Depressions in skull bones"
      ],
      correct: "B"
    },
    {
      id: 11647,
      question: "When do skull sutures fully fuse together?",
      options: [
        "At birth",
        "During childhood",
        "By age 18",
        "In adulthood"
      ],
      correct: "D"
    },
    {
      id: 11648,
      question: "The coronal suture is also called the:",
      options: [
        "Interparietal suture",
        "Parietooccipital suture",
        "Frontoparietal suture",
        "Temporoparietal suture"
      ],
      correct: "C"
    },
    {
      id: 11649,
      question: "Which suture marks where the frontal and parietal bones meet?",
      options: [
        "Sagittal suture",
        "Lambdoidal suture",
        "Squamosal suture",
        "Coronal suture"
      ],
      correct: "D"
    },
    {
      id: 11650,
      question: "The lambdoidal suture is also known as the:",
      options: [
        "Frontoparietal suture",
        "Parietooccipital suture",
        "Interparietal suture",
        "Temporoparietal suture"
      ],
      correct: "B"
    },
    {
      id: 11651,
      question: "Where do the parietal and occipital bones meet?",
      options: [
        "At the coronal suture",
        "At the sagittal suture",
        "At the lambdoidal suture",
        "At the squamosal suture"
      ],
      correct: "C"
    },
    {
      id: 11652,
      question: "What is unique about the squamosal suture?",
      options: [
        "It fuses by age 18",
        "The bones overlap instead of meeting edge-to-edge",
        "It is the longest suture",
        "It only appears in adults"
      ],
      correct: "B"
    },
    {
      id: 11653,
      question: "The squamosal suture is located between which bones?",
      options: [
        "Frontal and parietal bones",
        "Parietal and occipital bones",
        "Temporal and parietal bones",
        "Sphenoid and temporal bones"
      ],
      correct: "C"
    },
    {
      id: 11654,
      question: "The sagittal suture is also called the:",
      options: [
        "Frontoparietal suture",
        "Interparietal suture",
        "Median suture",
        "Coronal suture"
      ],
      correct: "B"
    },
    {
      id: 11655,
      question: "Which suture runs along the midline at the top of the skull?",
      options: [
        "Coronal suture",
        "Lambdoidal suture",
        "Sagittal suture",
        "Squamosal suture"
      ],
      correct: "C"
    },
    {
      id: 11656,
      question: "The intermaxillary suture is located:",
      options: [
        "At the back of the hard palate",
        "Inferior to the nasal cavity at the midline",
        "Between the maxilla and palatine bones",
        "Between the two palatine bones"
      ],
      correct: "B"
    },
    {
      id: 11657,
      question: "Which suture is also called the median palatine suture?",
      options: [
        "The suture between maxillae on the hard palate",
        "The suture between palatine bones",
        "The suture between maxilla and palatine",
        "The intermaxillary suture"
      ],
      correct: "A"
    },
    {
      id: 11658,
      question: "The transverse palatine suture is also known as the:",
      options: [
        "Median palatine suture",
        "Intermaxillary suture",
        "Palatomaxillary suture",
        "Incisive suture"
      ],
      correct: "C"
    },
    {
      id: 11659,
      question: "Where is the transverse palatine suture located?",
      options: [
        "Between the two maxillae",
        "Between maxilla and palatine bones on the hard palate",
        "Between the two palatine bones",
        "Anterior to the nasal cavity"
      ],
      correct: "B"
    },
    {
      id: 11660,
      question: "The incisive suture runs from:",
      options: [
        "Incisor to incisor",
        "Canine to canine",
        "Premolar to premolar",
        "Molar to molar"
      ],
      correct: "B"
    },
    {
      id: 11661,
      question: "Which suture is rarely present in adults?",
      options: [
        "Coronal suture",
        "Sagittal suture",
        "Incisive suture",
        "Lambdoidal suture"
      ],
      correct: "C"
    },
    {
      id: 11662,
      question: "The sphenoccipital synchondrosis disappears by what age?",
      options: [
        "10 years old",
        "18 years old",
        "25 years old",
        "30 years old"
      ],
      correct: "B"
    },
    {
      id: 11663,
      question: "What are paranasal sinuses?",
      options: [
        "Solid bone structures",
        "Connected hollow cavities in the skull",
        "Muscle attachments",
        "Blood vessel channels"
      ],
      correct: "B"
    },
    {
      id: 11664,
      question: "Paranasal sinuses are generally lined by:",
      options: [
        "Bone tissue",
        "Cartilage",
        "Mucosa",
        "Fibrous tissue"
      ],
      correct: "C"
    },
    {
      id: 11665,
      question: "How do sinuses drain into the nasal cavity?",
      options: [
        "Through blood vessels",
        "Through the cribriform plate",
        "Through an opening called the ostium",
        "Through the nasal conchae"
      ],
      correct: "C"
    },
    {
      id: 11666,
      question: "What structures move mucus through the nasal canal?",
      options: [
        "Blood flow",
        "Small hairs called cilia",
        "Muscle contractions",
        "Gravity alone"
      ],
      correct: "B"
    },
    {
      id: 11667,
      question: "How many paranasal sinuses are there?",
      options: [
        "Two sinuses",
        "Three sinuses",
        "Four sinuses",
        "Six sinuses"
      ],
      correct: "C"
    },
    {
      id: 11668,
      question: "Which is a function of paranasal sinuses?",
      options: [
        "To strengthen the skull",
        "To lighten the skull",
        "To protect the brain",
        "To support facial muscles"
      ],
      correct: "B"
    },
    {
      id: 11669,
      question: "Sinuses improve which human function?",
      options: [
        "Vision",
        "Hearing",
        "Voice quality",
        "Taste"
      ],
      correct: "C"
    },
    {
      id: 11670,
      question: "The frontal sinuses are located:",
      options: [
        "Behind the sphenoid bone",
        "Just above the orbital cavity",
        "Within the maxillae",
        "In the ethmoid bone"
      ],
      correct: "B"
    },
    {
      id: 11671,
      question: "Which characteristic of frontal sinuses varies greatly from person to person?",
      options: [
        "Their location",
        "Their function",
        "Their size",
        "Their drainage pathway"
      ],
      correct: "C"
    },
    {
      id: 11672,
      question: "Frontal sinus infections typically cause pain:",
      options: [
        "Deep in the midline of the head",
        "Just above the eye",
        "In the cheek area",
        "At the back of the head"
      ],
      correct: "B"
    },
    {
      id: 11673,
      question: "Where do the frontal sinuses drain?",
      options: [
        "Into the superior meatus",
        "Into the sphenoid sinus",
        "Into the anterior hiatus semilunaris",
        "Into the maxillary sinus"
      ],
      correct: "C"
    },
    {
      id: 11674,
      question: "The sphenoid sinuses are located:",
      options: [
        "Above the frontal bone",
        "In the body of the sphenoid bone",
        "Within the maxillae",
        "In the ethmoid bone"
      ],
      correct: "B"
    },
    {
      id: 11675,
      question: "Sphenoid sinuses are located just below which structure?",
      options: [
        "The orbital cavity",
        "The frontal sinus",
        "The pituitary fossa",
        "The nasal bones"
      ],
      correct: "C"
    },
    {
      id: 11676,
      question: "What is the average size of sphenoid sinuses?",
      options: [
        "1cm x 1cm x 1cm",
        "2cm x 2cm x 2cm",
        "3cm x 3cm x 3cm",
        "4cm x 4cm x 4cm"
      ],
      correct: "B"
    },
    {
      id: 11677,
      question: "Where do the sphenoid sinuses drain?",
      options: [
        "Into the anterior nasal cavity",
        "Into the hiatus semilunaris",
        "Into the highest and most posterior part of the nasal cavity",
        "Into the maxillary sinus"
      ],
      correct: "C"
    },
    {
      id: 11678,
      question: "Why are sphenoid sinus infections difficult to identify?",
      options: [
        "They cause no symptoms",
        "They cause pressure deep in the midline of the head",
        "They only affect children",
        "They don\'t show on radiographs"
      ],
      correct: "B"
    },
    {
      id: 11679,
      question: "Can sphenoid sinuses be palpated during extraoral examination?",
      options: [
        "Yes, easily palpated",
        "Only in thin patients",
        "Only when infected",
        "No, unable to be palpated"
      ],
      correct: "D"
    },
    {
      id: 11680,
      question: "How are ethmoid sinuses structurally different from other sinuses?",
      options: [
        "They are solid bone",
        "They are single large cavities",
        "They consist of numerous small compartments",
        "They have no drainage pathway"
      ],
      correct: "C"
    },
    {
      id: 11681,
      question: "The ethmoid sinuses are also called:",
      options: [
        "Ethmoid cavities",
        "Ethmoid air cells",
        "Ethmoid chambers",
        "Ethmoid spaces"
      ],
      correct: "B"
    },
    {
      id: 11682,
      question: "How many divisions do the ethmoid sinuses have?",
      options: [
        "Two divisions",
        "Three divisions",
        "Four divisions",
        "Five divisions"
      ],
      correct: "B"
    },
    {
      id: 11683,
      question: "The anterior ethmoid sinuses are located in the base of which structure?",
      options: [
        "The superior nasal concha",
        "The middle nasal concha",
        "The inferior nasal concha",
        "The nasal septum"
      ],
      correct: "B"
    },
    {
      id: 11684,
      question: "Where do the posterior ethmoid sinuses drain?",
      options: [
        "Into the hiatus semilunaris",
        "Into the ethmoid bulla",
        "Into the superior meatus",
        "Into the middle meatus"
      ],
      correct: "C"
    },
    {
      id: 11685,
      question: "Why are ethmoid sinus infections difficult to treat?",
      options: [
        "They are too large",
        "They consist of small compartments",
        "They have no drainage",
        "Antibiotics cannot reach them"
      ],
      correct: "B"
    },
    {
      id: 11686,
      question: "Which is the largest of the paranasal sinuses?",
      options: [
        "Frontal sinus",
        "Sphenoid sinus",
        "Ethmoid sinus",
        "Maxillary sinus"
      ],
      correct: "D"
    },
    {
      id: 11687,
      question: "The maxillary sinus spans from which teeth posteriorly?",
      options: [
        "From the incisor to the first molar",
        "From the canine to the third molar",
        "From the first premolar to the second molar",
        "From the lateral incisor to the canine"
      ],
      correct: "B"
    },
    {
      id: 11688,
      question: "The maxillary sinus extends superiorly to:",
      options: [
        "The nasal bones",
        "The frontal sinus",
        "The floor of the orbital cavity",
        "The zygomatic bone"
      ],
      correct: "C"
    },
    {
      id: 11689,
      question: "Where do the maxillary sinuses drain?",
      options: [
        "Into the anterior hiatus semilunaris",
        "Into the posterior end of the hiatus semilunaris",
        "Into the superior meatus",
        "Into the sphenoid sinus"
      ],
      correct: "B"
    },
    {
      id: 11690,
      question: "Why can maxillary sinus drainage be problematic?",
      options: [
        "The opening is too small",
        "The opening can be near the middle or top of the cavity",
        "There is no drainage pathway",
        "The opening is always blocked"
      ],
      correct: "B"
    },
    {
      id: 11691,
      question: "What can happen if the maxillary sinus opening is sealed by edema?",
      options: [
        "The sinus empties completely",
        "Microorganisms can be trapped, worsening infection",
        "The sinus shrinks",
        "Nothing problematic occurs"
      ],
      correct: "B"
    },
    {
      id: 11692,
      question: "Why might maxillary teeth and sinuses create diagnostic confusion?",
      options: [
        "They look similar on radiographs",
        "They are supplied by the same nerves",
        "They are the same size",
        "They are located far apart"
      ],
      correct: "B"
    },
    {
      id: 11693,
      question: "What dental procedure could potentially perforate the maxillary sinus wall?",
      options: [
        "Filling a cavity",
        "Extracting maxillary molars",
        "Cleaning teeth",
        "Taking radiographs"
      ],
      correct: "B"
    },
    {
      id: 11694,
      question: "What is especially important when planning dental implants near the maxillary sinus?",
      options: [
        "Using local anesthesia",
        "Checking the patient\'s age",
        "Performing due diligence",
        "Avoiding radiographs"
      ],
      correct: "C"
    },
    {
      id: 11695,
      question: "Which plane divides the body into left and right portions?",
      options: [
        "Transverse plane",
        "Coronal plane",
        "Sagittal plane",
        "Horizontal plane"
      ],
      correct: "C"
    },
    {
      id: 11696,
      question: "The transverse plane divides the body into:",
      options: [
        "Left and right",
        "Front and back",
        "Upper and lower",
        "Medial and lateral"
      ],
      correct: "C"
    },
    {
      id: 11697,
      question: "The coronal plane is also known as the:",
      options: [
        "Sagittal plane",
        "Frontal plane",
        "Transverse plane",
        "Median plane"
      ],
      correct: "B"
    },
    {
      id: 11698,
      question: "Which term means \"toward the front surface of the body\"?",
      options: [
        "Posterior",
        "Superior",
        "Anterior",
        "Inferior"
      ],
      correct: "C"
    },
    {
      id: 11699,
      question: "\"Posterior\" means:",
      options: [
        "Toward the front",
        "Toward the rear surface",
        "Toward the feet",
        "Toward the head"
      ],
      correct: "B"
    },
    {
      id: 11700,
      question: "Which term means \"toward the head or above\"?",
      options: [
        "Inferior",
        "Anterior",
        "Posterior",
        "Superior"
      ],
      correct: "D"
    },
    {
      id: 11701,
      question: "\"Inferior\" means:",
      options: [
        "Toward the head",
        "Toward the midline",
        "Toward the feet or below",
        "Away from the midline"
      ],
      correct: "C"
    },
    {
      id: 11702,
      question: "Which term means \"toward the midline of the body\"?",
      options: [
        "Lateral",
        "Medial",
        "Superior",
        "Anterior"
      ],
      correct: "B"
    },
    {
      id: 11703,
      question: "\"Lateral\" means:",
      options: [
        "Toward the midline",
        "Away from the midline",
        "Toward the feet",
        "Toward the head"
      ],
      correct: "B"
    },
    {
      id: 11704,
      question: "The nose is ________ to the ear.",
      options: [
        "Posterior",
        "Lateral",
        "Anterior",
        "Superior"
      ],
      correct: "C"
    },
    {
      id: 11705,
      question: "The knee is ________ to the hip.",
      options: [
        "Superior",
        "Medial",
        "Lateral",
        "Inferior"
      ],
      correct: "D"
    },
    {
      id: 11706,
      question: "The shoulder is ________ to the sternum.",
      options: [
        "Medial",
        "Lateral",
        "Inferior",
        "Posterior"
      ],
      correct: "B"
    }
  
  ],
  "2. Landmarks on bones (Part 1)": [    { id: 11200, question: "The temporomandibular joint is formed by the articulation between the mandible and the:", options: ["Occipital bone", "Temporal bone", "Sphenoid bone", "Zygomatic bone"], correct: 1 },
    { id: 11201, question: "Which structure forms the posterior boundary of the mandibular fossa?", options: ["Articular eminence", "Postglenoid tubercle", "Styloid process", "Mastoid process"], correct: 1 },
    { id: 11202, question: "The articular eminence is a key structure for which movement?", options: ["Condylar rotation", "Anterior translation of the condyle", "Lateral deviation", "Jaw depression only"], correct: 1 },
    { id: 11203, question: "The articular disc of the TMJ is avascular in which zone?", options: ["Posterior band", "Anterior band", "Central (intermediate) zone", "Retrodiscal tissue"], correct: 2 },
    { id: 11204, question: "The upper synovial cavity is located between which two structures?", options: ["Condylar head and disc", "Temporal bone and disc", "Articular eminence and condylar head", "Retrodiscal tissues and disc"], correct: 1 },
    { id: 11205, question: "The lower synovial cavity allows for:", options: ["Translation", "Rotation", "Lateral deviation", "Condylar guidance"], correct: 1 },
    { id: 11206, question: "Which of the following correctly describes the articular disc shape?", options: ["Uniformly thick", "Thicker anteriorly and posteriorly with thin intermediate zone", "Thickest at the intermediate zone", "Completely avascular"], correct: 1 },
    { id: 11207, question: "What is the primary function of the retrodiscal pad?", options: ["Provide lubrication", "Attach to the lateral pterygoid", "Provide shock absorption and blood supply", "Produce synovial fluid"], correct: 2 },
    { id: 11208, question: "Which ligament prevents excessive forward movement of the mandible?", options: ["Sphenomandibular ligament", "Stylomandibular ligament", "Temporomandibular ligament", "Posterior ligament"], correct: 2 },
    { id: 11209, question: "The superior head of the lateral pterygoid muscle attaches primarily to:", options: ["Condylar neck", "Anterior disc margin", "Articular eminence", "Coronoid process"], correct: 1 },
    { id: 11210, question: "The inferior head of the lateral pterygoid muscle primarily inserts on the:", options: ["Articular disc", "Condylar neck", "Coronoid process", "Temporal bone"], correct: 1 },
    { id: 11211, question: "Which collagenous lamina provides strength to the retrodiscal area?", options: ["Upper lamina only", "Lower lamina only", "Both upper and lower laminae", "Central lamina"], correct: 2 },
    { id: 11212, question: "The TMJ capsule attaches superiorly to the:", options: ["Condylar neck", "Articular eminence", "Temporal bone around the mandibular fossa", "Coronoid process"], correct: 2 },
    { id: 11213, question: "The TMJ capsule attaches inferiorly to the:", options: ["Condylar head", "Condylar neck", "Coronoid process", "Ramus"], correct: 1 },
    { id: 11214, question: "Which artery is a primary blood supplier to the TMJ?", options: ["Facial artery", "Maxillary artery", "Superficial temporal artery", "Buccal artery"], correct: 2 },
    { id: 11215, question: "The nerve supply to the TMJ is primarily from branches of which division?", options: ["V1 (Ophthalmic)", "V2 (Maxillary)", "V3 (Mandibular)", "VII (Facial)"], correct: 2 },
    { id: 11216, question: "Which nerve specifically innervates the TMJ?", options: ["Lingual nerve", "Inferior alveolar nerve", "Auriculotemporal nerve", "Buccal nerve"], correct: 2 },
    { id: 11217, question: "The upper elastic lamina of the retrodiscal tissues attaches posteriorly to the:", options: ["Posterior band of the disc", "Temporal bone", "Articular eminence", "Condylar head"], correct: 1 },
    { id: 11218, question: "The lower elastic lamina attaches to the:", options: ["Articular eminence", "Posterior neck of the condyle", "Anterior band of the disc", "Temporal bone"], correct: 1 },
    { id: 11219, question: "Which statement is true regarding the lateral pterygoid muscle?", options: ["Only the inferior head attaches to the disc", "Only the superior head attaches to the disc", "Both heads attach to the disc equally", "Neither head attaches to the disc"], correct: 1 },
    { id: 11220, question: "During jaw opening, the condyle performs which combined movement?", options: ["Only rotation", "Only translation", "Rotation followed by translation", "Translation followed by rotation"], correct: 2 },
    { id: 11221, question: "The intermediate zone of the disc serves which function?", options: ["Absorption of forces during function", "Attachment site for muscles", "Blood supply to the disc", "Producing synovial fluid"], correct: 0 },
    { id: 11222, question: "Which structural element prevents posterior disc displacement during function?", options: ["Lateral pterygoid muscle alone", "Temporomandibular ligament", "Retrodiscal tissues and elastic laminae", "Articular eminence"], correct: 2 },
    { id: 11223, question: "The posterior band is thicker than the intermediate zone to:", options: ["Allow for better translation", "Resist compressive forces", "Attach to the lateral pterygoid", "Produce synovial fluid"], correct: 1 },
    { id: 11224, question: "Synovial fluid within the TMJ serves which primary purpose?", options: ["Provide structural support", "Lubricate articular surfaces", "Provide nerve supply", "Act as a cushion"], correct: 1 },
    { id: 11225, question: "Which structure provides blood and nerve supply to the posterior disc region?", options: ["Anterior band", "Intermediate zone", "Retrodiscal pad", "Lateral pterygoid muscle"], correct: 2 },
    { id: 11226, question: "The articular surfaces of the TMJ are covered by:", options: ["Hyaline cartilage", "Fibrocartilage", "Elastic cartilage", "No cartilage"], correct: 1 },
    { id: 11227, question: "The stylomandibular ligament primarily functions to:", options: ["Limit anterior translation", "Limit excessive jaw opening", "Support the disc", "Attach muscles to bone"], correct: 1 },
    { id: 11228, question: "The sphenomandibular ligament attaches superiorly to the:", options: ["Sphenoid bone", "Temporal bone", "Zygomatic arch", "Mandibular fossa"], correct: 0 },
    { id: 11229, question: "The sphenomandibular ligament attaches inferiorly to the:", options: ["Angle of the mandible", "Lingula of the mandible", "Condylar neck", "Coronoid process"], correct: 1 },
    { id: 11230, question: "The lateral pterygoid muscle plays a role in:", options: ["Disc stabilization", "Posterior disc retraction", "Preventing rotation", "Tightening the TMJ capsule only"], correct: 0 },
    { id: 11231, question: "Which structure forms the concavity in which the mandibular condyle sits?", options: ["Articular eminence", "Mandibular fossa", "Posterior tubercle", "Retrodiscal pad"], correct: 1 },
    { id: 11232, question: "The articular disc is primarily composed of:", options: ["Hyaline cartilage", "Dense collagen tissue", "Elastic cartilage", "Fibro-osseous tissue"], correct: 1 },
    { id: 11233, question: "The thinnest region of the articular disc is the:", options: ["Posterior band", "Intermediate zone", "Anterior band", "Retrodiscal area"], correct: 1 },
    { id: 11234, question: "Which ligament is located within the TMJ capsule?", options: ["Stylomandibular ligament", "Sphenomandibular ligament", "Temporomandibular ligament", "Zygomaticomandibular ligament"], correct: 2 },
    { id: 11235, question: "The sphenomandibular ligament attaches to the mandible near the:", options: ["Coronoid process", "Mylohyoid groove", "Condylar neck", "Retromolar triangle"], correct: 1 },
    { id: 11236, question: "Which structure contains most of the TMJ's blood and nerve supply?", options: ["Anterior band of disc", "Intermediate zone", "Retrodiscal pad", "Lower synovial cavity"], correct: 2 },
    { id: 11237, question: "The superior head of the lateral pterygoid attaches to the:", options: ["Neck of the condyle", "Posterior disc region", "Anterior disc region", "Articular eminence"], correct: 2 },
    { id: 11238, question: "The superior synovial cavity primarily allows:", options: ["Rotational movement", "Compression of the disc", "Translational movement", "Retrodiscal tension"], correct: 2 },
    { id: 11239, question: "Which arterial group supplies the TMJ?", options: ["Maxillary, facial, lingual", "Ascending pharyngeal, superficial temporal, deep auricular", "Inferior alveolar, posterior superior alveolar, buccal", "Occipital, facial, transverse facial"], correct: 1 },
    { id: 11240, question: "The stylomandibular ligament helps:", options: ["Prevent backward movement", "Limit excessive jaw opening", "Support the mandible like a sling", "Control condylar rotation"], correct: 1 },
    { id: 11241, question: "The lower collagenous lamina provides:", options: ["Elastic recoil", "Vascular supply", "Strength and stability", "Synovial secretion"], correct: 2 },
    { id: 11242, question: "The posterior tubercle prevents:", options: ["Forward displacement", "Lateral deviation", "Posterior displacement", "Superior compression"], correct: 2 },
    { id: 11243, question: "Which nerve branch innervates the TMJ?", options: ["Masseteric nerve", "Auriculotemporal nerve", "Inferior alveolar nerve", "Buccal nerve"], correct: 1 },
    { id: 11244, question: "The inferior synovial cavity allows which type of movement?", options: ["Sliding", "Rotation", "Retraction", "Deviation"], correct: 1 },
    { id: 11245, question: "The articular eminence is located:", options: ["Posterior to the mandibular fossa", "On the anterior portion of the temporal bone", "On the lateral side of the mandible", "On the medial surface of the sphenoid"], correct: 1 },
    { id: 11246, question: "The mandibular condyle articulates with which part of the temporal bone?", options: ["Zygomatic process", "Mandibular fossa", "Styloid process", "Temporal crest"], correct: 1 },
    { id: 11247, question: "Which region of the articular disc is slightly thicker than the intermediate zone?", options: ["Posterior band", "Anterior band", "Lateral band", "Retrodiscal area"], correct: 1 },
    { id: 11248, question: "The TMJ capsule is composed primarily of:", options: ["Loose elastic tissue", "Thick fibrous tissue", "Fibrocartilage", "Compact bone"], correct: 1 },
    { id: 11249, question: "The temporomandibular ligament runs from the articular eminence to the:", options: ["Medial side of the condyle", "Lateral side of the condyle", "Posterior tubercle", "Coronoid process"], correct: 1 },
    { id: 11250, question: "The function of the stylomandibular ligament is to:", options: ["Prevent posterior displacement", "Limit excessive jaw opening", "Stabilize the disc", "Direct condylar rotation"], correct: 1 },
    { id: 11251, question: "The sphenomandibular ligament originates from the:", options: ["Sphenoid spine", "Styloid process", "Zygomatic arch", "Temporal crest"], correct: 0 },
    { id: 11252, question: "Synovial cavities are located:", options: ["Only above the disc", "Only below the disc", "Above and below the disc", "At the retrodiscal pad only"], correct: 2 },
    { id: 11253, question: "Synovial fluid provides:", options: ["Elastic support", "Lubrication and nutrition", "Muscle attachment points", "Joint stabilization"], correct: 1 },
    { id: 11254, question: "The upper elastic lamina attaches posteriorly to the:", options: ["Articular eminence", "Posterior tubercle", "Squamous temporal bone", "Retrodiscal tissues"], correct: 3 },
    { id: 11255, question: "The retrodiscal pad contains:", options: ["Only collagen", "Elastic fibers", "Vascular and nerve tissue", "Hyaline cartilage"], correct: 2 },
    { id: 11256, question: "The inferior head of the lateral pterygoid inserts on the:", options: ["Neck of the condyle", "Coronoid process", "Retrodiscal tissue", "Anterior disc"], correct: 0 },
    { id: 11257, question: "Which movement occurs first when opening the mouth?", options: ["Translation", "Rotation (hinge movement)", "Lateral excursion", "Protrusion"], correct: 1 },
    { id: 11258, question: "The superior synovial cavity is located between the disc and the:", options: ["Condylar head", "Mandibular notch", "Temporal bone", "Inferior pterygoid fibers"], correct: 2 },
    { id: 11259, question: "The posterior band of the disc functions to:", options: ["Stabilize the condyle anteriorly", "Resist excessive posterior movement", "Provide attachment to the lateral pterygoid", "Produce synovial fluid"], correct: 1 },
    { id: 11260, question: "Which artery supplies the TMJ region?", options: ["Deep auricular artery", "Posterior superior alveolar artery", "Lingual artery", "Submental artery"], correct: 0 },
    { id: 11261, question: "The temporomandibular joint is formed by the articulation between the mandible and the:", options: ["Occipital bone", "Temporal bone", "Sphenoid bone", "Zygomatic bone"], correct: 1 },
    { id: 11262, question: "The TMJ receives blood supply from all of the following arteries EXCEPT:", options: ["Ascending pharyngeal artery", "Superficial temporal artery", "Deep auricular artery", "Posterior alveolar artery"], correct: 3 },
    { id: 11263, question: "The nerve supply to the TMJ includes branches of which cranial nerve division?", options: ["V1", "V2", "V3", "VII"], correct: 2 },
    { id: 11264, question: "The articular eminence is located on which bone?", options: ["Mandible", "Sphenoid", "Temporal bone", "Zygomatic bone"], correct: 2 },
    { id: 11265, question: "The articular disc is primarily composed of:", options: ["Elastic cartilage", "Dense collagenous tissue", "Hyaline cartilage", "Fibrocartilage only"], correct: 1 },
    { id: 11266, question: "The upper surface of the articular disc is described as:", options: ["Flat", "Convex only", "Concave only", "Concavoconvex"], correct: 3 },
    { id: 11267, question: "The region of the disc that is thinnest is the:", options: ["Posterior band", "Intermediate zone", "Anterior band", "Retrodiscal pad"], correct: 1 },
    { id: 11268, question: "The anterior portion of the articular disc attaches to the:", options: ["Inferior head of the lateral pterygoid muscle", "Superior head of the lateral pterygoid muscle", "Medial pterygoid muscle", "Temporalis muscle"], correct: 1 },
    { id: 11269, question: "The TMJ capsule surrounds:", options: ["Only the temporal bone", "Only the mandibular condyle", "The entire TMJ", "Only the synovial cavities"], correct: 2 }
  ],
  "2. Landmarks on bones (Part 2)": [
    {
      id: 11700,
      question: "The supraorbital foramen is located on which bone?",
      options: [
        "Temporal bone",
        "Frontal bone",
        "Sphenoid bone",
        "Ethmoid bone"
      ],
      correct: "B"
    },
    {
      id: 11701,
      question: "What structure does the supraorbital foramen provide passage for?",
      options: [
        "Optic nerve and ophthalmic artery",
        "Blood and nerve supply to the forehead",
        "Middle meningeal artery",
        "Maxillary nerve"
      ],
      correct: "B"
    },
    {
      id: 11702,
      question: "Which process of the frontal bone forms the superior and lateral portion of the orbit?",
      options: [
        "Palatine process",
        "Alveolar process",
        "Zygomatic process",
        "Frontal process"
      ],
      correct: "C"
    },
    {
      id: 11703,
      question: "The anterior cranial fossa of the frontal bone houses which structure?",
      options: [
        "Cerebellum",
        "Brain stem",
        "Frontal lobe of the brain",
        "Pituitary gland"
      ],
      correct: "C"
    },
    {
      id: 11704,
      question: "Which wing of the sphenoid bone makes up the posterior medial portion of the orbit?",
      options: [
        "Greater wing",
        "Lesser wing",
        "Pterygoid process",
        "Zygomatic process"
      ],
      correct: "B"
    },
    {
      id: 11705,
      question: "The foramen rotundum houses which nerve?",
      options: [
        "Mandibular nerve (V3)",
        "Optic nerve",
        "Maxillary nerve (V2)",
        "Facial nerve"
      ],
      correct: "C"
    },
    {
      id: 11706,
      question: "What passes through the foramen ovale?",
      options: [
        "Maxillary nerve (V2)",
        "Mandibular nerve (V3)",
        "Optic nerve",
        "Middle meningeal artery"
      ],
      correct: "B"
    },
    {
      id: 11707,
      question: "The foramen spinosum transmits which structure?",
      options: [
        "Maxillary nerve",
        "Mandibular nerve",
        "Middle meningeal artery",
        "Internal carotid artery"
      ],
      correct: "C"
    },
    {
      id: 11708,
      question: "What is the mnemonic for remembering the three main sphenoid foramina?",
      options: [
        "MAO",
        "ROS",
        "SOT",
        "BAR"
      ],
      correct: "B"
    },
    {
      id: 11709,
      question: "The sella turcica (hypophyseal fossa) houses which gland?",
      options: [
        "Thyroid gland",
        "Adrenal gland",
        "Pituitary gland",
        "Pineal gland"
      ],
      correct: "C"
    },
    {
      id: 11710,
      question: "Which cranial nerves pass through the superior orbital fissure?",
      options: [
        "2nd, 5th, 6th",
        "3rd, 4th, 6th and ophthalmic branch of 5th",
        "7th, 9th, 10th",
        "1st, 2nd, 3rd"
      ],
      correct: "B"
    },
    {
      id: 11711,
      question: "The inferior orbital fissure is located between which bones?",
      options: [
        "Frontal and sphenoid",
        "Temporal and occipital",
        "Greater wing of sphenoid, zygoma, and maxilla",
        "Palatine and ethmoid"
      ],
      correct: "C"
    },
    {
      id: 11712,
      question: "The pterygopalatine fossa is located between which structures?",
      options: [
        "Frontal and parietal bones",
        "Maxilla and pterygoid process",
        "Temporal and occipital bones",
        "Mandible and hyoid bone"
      ],
      correct: "B"
    },
    {
      id: 11713,
      question: "What important structures branch in the pterygopalatine fossa?",
      options: [
        "Cranial nerves IX, X, XI",
        "Vertebral arteries",
        "Major nerves and vessels to oral and nasal cavities",
        "Spinal cord branches"
      ],
      correct: "C"
    },
    {
      id: 11714,
      question: "The crista galli serves as an attachment for which structure?",
      options: [
        "Temporalis muscle",
        "Falx cerebri",
        "Masseter muscle",
        "Stylohyoid ligament"
      ],
      correct: "B"
    },
    {
      id: 11715,
      question: "The cribriform plate provides passage for which nerve?",
      options: [
        "Optic nerve",
        "Facial nerve",
        "Olfactory nerve",
        "Trigeminal nerve"
      ],
      correct: "C"
    },
    {
      id: 11716,
      question: "Which structures are part of the ethmoid bone?",
      options: [
        "Inferior and middle nasal conchae",
        "Superior and middle nasal conchae",
        "All three nasal conchae",
        "Only the inferior nasal concha"
      ],
      correct: "B"
    },
    {
      id: 11717,
      question: "The foramen magnum transmits which structures?",
      options: [
        "Internal carotid artery only",
        "Spinal cord, vertebral arteries, and 11th cranial nerve",
        "Jugular vein only",
        "Optic nerve and ophthalmic artery"
      ],
      correct: "B"
    },
    {
      id: 11718,
      question: "The occipital condyles articulate with which bone?",
      options: [
        "First cervical vertebra (atlas)",
        "Temporal bone",
        "Sphenoid bone",
        "Parietal bone"
      ],
      correct: "A"
    },
    {
      id: 11719,
      question: "The hypoglossal canals transmit which nerve?",
      options: [
        "10th cranial nerve",
        "11th cranial nerve",
        "12th cranial nerve",
        "9th cranial nerve"
      ],
      correct: "C"
    },
    {
      id: 11720,
      question: "The temporal fossa is composed of how many bones?",
      options: [
        "Two bones",
        "Three bones",
        "Four bones",
        "Five bones"
      ],
      correct: "C"
    },
    {
      id: 11721,
      question: "Which bones form the temporal fossa?",
      options: [
        "Temporal and parietal only",
        "Frontal, parietal, sphenoid, and temporal",
        "Occipital, temporal, and sphenoid",
        "Maxilla, palatine, and temporal"
      ],
      correct: "B"
    },
    {
      id: 11722,
      question: "The external acoustic meatus is part of which bone?",
      options: [
        "Sphenoid bone",
        "Occipital bone",
        "Temporal bone",
        "Frontal bone"
      ],
      correct: "C"
    },
    {
      id: 11723,
      question: "The petrous portion of the temporal bone houses what?",
      options: [
        "Middle ear structures",
        "Inner ear components",
        "External ear canal",
        "Mastoid air cells only"
      ],
      correct: "B"
    },
    {
      id: 11724,
      question: "The styloid process serves as an attachment for what?",
      options: [
        "Eye muscles",
        "Muscles and ligaments of head and neck",
        "Tongue muscles only",
        "Facial expression muscles only"
      ],
      correct: "B"
    },
    {
      id: 11725,
      question: "The mandibular fossa articulates with which structure?",
      options: [
        "Temporal process of zygomatic",
        "Coronoid process",
        "Mandibular condyle",
        "Styloid process"
      ],
      correct: "C"
    },
    {
      id: 11726,
      question: "What structure is located just anterior to the mandibular fossa?",
      options: [
        "Postglenoid process",
        "Articular eminence",
        "Styloid process",
        "Mastoid process"
      ],
      correct: "B"
    },
    {
      id: 11727,
      question: "The carotid canal transmits which structure?",
      options: [
        "External carotid artery",
        "Vertebral artery",
        "Internal carotid artery",
        "Middle meningeal artery"
      ],
      correct: "C"
    },
    {
      id: 11728,
      question: "The stylomastoid foramen allows exit of which cranial nerve?",
      options: [
        "5th cranial nerve",
        "6th cranial nerve",
        "7th cranial nerve",
        "8th cranial nerve"
      ],
      correct: "C"
    },
    {
      id: 11729,
      question: "The jugular foramen is bordered by which bones?",
      options: [
        "Sphenoid and ethmoid",
        "Temporal and occipital",
        "Frontal and parietal",
        "Maxilla and palatine"
      ],
      correct: "B"
    },
    {
      id: 11730,
      question: "The mandible consists of how many main parts?",
      options: [
        "Two parts",
        "Three parts",
        "Four parts",
        "Five parts"
      ],
      correct: "B"
    },
    {
      id: 11731,
      question: "What does the acronym BAR stand for in mandibular anatomy?",
      options: [
        "Base, articulation, ridge",
        "Body, alveolar process, ramus",
        "Bone, angle, region",
        "Border, apex, root"
      ],
      correct: "B"
    },
    {
      id: 11732,
      question: "Where does mandibular growth primarily occur?",
      options: [
        "Coronoid process only",
        "Condyle only",
        "Alveolar process and body",
        "Angle only"
      ],
      correct: "C"
    },
    {
      id: 11733,
      question: "The mental foramen is located near which teeth?",
      options: [
        "Incisors",
        "Canines",
        "Premolars",
        "Molars"
      ],
      correct: "C"
    },
    {
      id: 11734,
      question: "What does the mental foramen transmit?",
      options: [
        "Inferior alveolar nerve only",
        "Mental nerve and vessels",
        "Lingual nerve",
        "Buccal nerve"
      ],
      correct: "B"
    },
    {
      id: 11735,
      question: "The mental protuberance is also known as what?",
      options: [
        "The angle of mandible",
        "The coronoid process",
        "The tip of the chin",
        "The condylar neck"
      ],
      correct: "C"
    },
    {
      id: 11736,
      question: "The external oblique line runs from which structure?",
      options: [
        "Condyle to mental foramen",
        "Anterior border of ramus where it meets the body",
        "Coronoid process to angle",
        "Lingula to mental spine"
      ],
      correct: "B"
    },
    {
      id: 11737,
      question: "The mandibular foramen allows entry of which structures?",
      options: [
        "Mental nerve and vessels",
        "Inferior alveolar nerve and vessels",
        "Lingual nerve only",
        "Mylohyoid nerve only"
      ],
      correct: "B"
    },
    {
      id: 11738,
      question: "The lingula partially covers which opening?",
      options: [
        "Mental foramen",
        "Mandibular foramen",
        "Incisive foramen",
        "Greater palatine foramen"
      ],
      correct: "B"
    },
    {
      id: 11739,
      question: "The mylohyoid groove is located where in relation to the mandibular foramen?",
      options: [
        "Above the foramen",
        "Below the foramen",
        "Anterior to the foramen",
        "Lateral to the foramen"
      ],
      correct: "B"
    },
    {
      id: 11740,
      question: "What muscle attaches to the mylohyoid line?",
      options: [
        "Masseter muscle",
        "Temporalis muscle",
        "Mylohyoid muscle",
        "Lateral pterygoid muscle"
      ],
      correct: "C"
    },
    {
      id: 11741,
      question: "The sublingual fossa houses which gland?",
      options: [
        "Parotid gland",
        "Sublingual salivary gland",
        "Submandibular gland only",
        "Thyroid gland"
      ],
      correct: "B"
    },
    {
      id: 11742,
      question: "The retromolar triangle is located where?",
      options: [
        "Anterior to the canine",
        "Between the premolars",
        "Immediately behind the third molar",
        "At the angle of mandible"
      ],
      correct: "C"
    },
    {
      id: 11743,
      question: "The mental spines serve as attachment for what?",
      options: [
        "Lip muscles",
        "Tongue muscles",
        "Facial expression muscles",
        "Mastication muscles"
      ],
      correct: "B"
    },
    {
      id: 11744,
      question: "The digastric fossa is located where?",
      options: [
        "Buccally at the angle",
        "Lingually at inferior border near midline",
        "On the coronoid process",
        "On the condylar neck"
      ],
      correct: "B"
    },
    {
      id: 11745,
      question: "The mandibular notch is located between which two processes?",
      options: [
        "Condyle and angle",
        "Coronoid and condylar processes",
        "Angle and coronoid",
        "Mental spine and lingula"
      ],
      correct: "B"
    },
    {
      id: 11746,
      question: "The coronoid process serves as attachment for which muscle?",
      options: [
        "Lateral pterygoid",
        "Medial pterygoid",
        "Temporalis",
        "Masseter"
      ],
      correct: "C"
    },
    {
      id: 11747,
      question: "The head of the condyle articulates with which structure to form the TMJ?",
      options: [
        "Articular eminence only",
        "Postglenoid process",
        "Mandibular fossa of temporal bone",
        "Zygomatic arch"
      ],
      correct: "C"
    },
    {
      id: 11748,
      question: "The condylar neck is located where?",
      options: [
        "Superior to the condyle",
        "Just inferior to the condyle",
        "At the sigmoid notch",
        "At the angle of mandible"
      ],
      correct: "B"
    },
    {
      id: 11749,
      question: "The piriform aperture is which shape?",
      options: [
        "Circular",
        "Triangular",
        "Heart or pear-shaped",
        "Square"
      ],
      correct: "C"
    },
    {
      id: 11750,
      question: "Which bone forms the bridge of the nose?",
      options: [
        "Ethmoid bone",
        "Maxilla",
        "Nasal bone",
        "Frontal bone"
      ],
      correct: "C"
    },
    {
      id: 11751,
      question: "The inferior orbital fissure is formed by the articulation of which bones?",
      options: [
        "Frontal and ethmoid",
        "Zygomatic, sphenoid, and maxilla",
        "Palatine and lacrimal",
        "Nasal and vomer"
      ],
      correct: "B"
    },
    {
      id: 11752,
      question: "The temporal process of the zygomatic bone forms what structure?",
      options: [
        "Orbit floor",
        "Zygomatic arch",
        "Infraorbital rim",
        "Nasal cavity"
      ],
      correct: "B"
    },
    {
      id: 11753,
      question: "The frontal process of the zygomatic bone forms which orbital wall?",
      options: [
        "Medial wall",
        "Superior wall",
        "Anterior lateral wall",
        "Floor"
      ],
      correct: "C"
    },
    {
      id: 11754,
      question: "The greater palatine foramen transmits what?",
      options: [
        "Lesser palatine nerve and vessels",
        "Greater palatine nerve and vessels",
        "Nasopalatine nerve",
        "Infraorbital nerve"
      ],
      correct: "B"
    },
    {
      id: 11755,
      question: "Where is the lesser palatine foramen located relative to the greater palatine foramen?",
      options: [
        "Anterior",
        "Lateral",
        "Just posterior",
        "Medial"
      ],
      correct: "C"
    },
    {
      id: 11756,
      question: "The palatine process of the maxilla forms what?",
      options: [
        "Most of the hard palate",
        "The soft palate",
        "The nasal septum",
        "The orbit floor"
      ],
      correct: "A"
    },
    {
      id: 11757,
      question: "The maxillary tuberosity is located where?",
      options: [
        "Anterior to the incisors",
        "Between the canine and premolars",
        "Posterior to the terminal molar",
        "At the midline suture"
      ],
      correct: "C"
    },
    {
      id: 11758,
      question: "What enters the maxillary tuberosity?",
      options: [
        "Infraorbital nerve",
        "Blood vessels and nerves to supply posterior teeth",
        "Nasopalatine nerve",
        "Greater palatine vessels"
      ],
      correct: "B"
    },
    {
      id: 11759,
      question: "The canine eminence is specific to which tooth?",
      options: [
        "Central incisor",
        "Lateral incisor",
        "Canine",
        "First premolar"
      ],
      correct: "C"
    },
    {
      id: 11760,
      question: "The canine fossa surrounds which structure?",
      options: [
        "Mental foramen",
        "Infraorbital foramen",
        "Canine eminence",
        "Maxillary tuberosity"
      ],
      correct: "C"
    },
    {
      id: 11761,
      question: "The infraorbital foramen transmits structures that supply which areas?",
      options: [
        "Lower lip, chin, and mandibular gingiva",
        "Upper lip, facial gingiva, lower eyelid, and side of nose",
        "Posterior teeth and palate",
        "Tongue and floor of mouth"
      ],
      correct: "B"
    },
    {
      id: 11762,
      question: "The incisive foramen is located where?",
      options: [
        "Between the central incisors posteriorly",
        "Most anterior and medial portion of palate",
        "Posterior to the molars",
        "At the junction of hard and soft palate"
      ],
      correct: "B"
    },
    {
      id: 11763,
      question: "The maxillary sinus is located in which bone?",
      options: [
        "Frontal bone",
        "Ethmoid bone",
        "Maxilla",
        "Sphenoid bone"
      ],
      correct: "C"
    },
    {
      id: 11764,
      question: "Pain from the maxillary sinus can be confused with pain from which teeth?",
      options: [
        "Mandibular molars",
        "Maxillary anterior teeth",
        "Maxillary posterior teeth",
        "Mandibular anterior teeth"
      ],
      correct: "C"
    },
    {
      id: 11765,
      question: "The TMJ is formed by the articulation of which two bones?",
      options: [
        "Maxilla and mandible",
        "Temporal and mandible",
        "Sphenoid and mandible",
        "Zygomatic and mandible"
      ],
      correct: "B"
    },
    {
      id: 11766,
      question: "The articular disc in the TMJ is located between which structures?",
      options: [
        "Condyle and coronoid process",
        "Mandibular fossa and condyle",
        "Articular eminence and postglenoid process",
        "Temporal bone and zygomatic bone"
      ],
      correct: "B"
    },
    {
      id: 11767,
      question: "What type of joint is the temporomandibular joint?",
      options: [
        "Hinge joint only",
        "Ball and socket joint",
        "Synovial joint with both hinge and gliding movements",
        "Fibrous joint"
      ],
      correct: "C"
    },
    {
      id: 11768,
      question: "The postglenoid process is located where relative to the TMJ?",
      options: [
        "Anterior to articulation point",
        "Just posterior to articulation point",
        "Superior to articulation point",
        "Inferior to articulation point"
      ],
      correct: "B"
    },
    {
      id: 11769,
      question: "How many synovial cavities does the TMJ have?",
      options: [
        "One",
        "Two",
        "Three",
        "Four"
      ],
      correct: "B"
    },
    {
      id: 11770,
      question: "The upper synovial cavity of the TMJ is associated with which movement?",
      options: [
        "Hinge movement",
        "Rotation",
        "Forward movement (protrusion)",
        "Lateral movement"
      ],
      correct: "C"
    },
    {
      id: 11771,
      question: "The lower synovial cavity of the TMJ is associated with which movement?",
      options: [
        "Forward movement",
        "Hinge movement (depression)",
        "Lateral excursion",
        "Elevation only"
      ],
      correct: "B"
    },
    {
      id: 11772,
      question: "The lateral pterygoid muscle attaches to which part of the TMJ?",
      options: [
        "Articular eminence",
        "Articular disc and condyle",
        "Postglenoid process",
        "Mandibular fossa"
      ],
      correct: "B"
    },
    {
      id: 11773,
      question: "The middle cranial fossa is formed by which bone(s)?",
      options: [
        "Frontal bone only",
        "Occipital bone only",
        "Temporal bone (part of)",
        "Parietal bones"
      ],
      correct: "C"
    },
    {
      id: 11774,
      question: "The posterior cranial fossa houses which structures?",
      options: [
        "Frontal lobe",
        "Pituitary gland",
        "Brain stem and cerebellum",
        "Optic chiasm"
      ],
      correct: "C"
    },
    {
      id: 11775,
      question: "The anterior cranial fossa, middle cranial fossa, and posterior cranial fossa are separated by which bones?",
      options: [
        "Only the ethmoid",
        "Sphenoid, temporal, and occipital",
        "Frontal and parietal",
        "Maxilla and palatine"
      ],
      correct: "B"
    },
    {
      id: 11776,
      question: "Foramen lacerum is bordered by which bones?",
      options: [
        "Frontal and ethmoid",
        "Sphenoid, temporal, and occipital",
        "Maxilla and palatine",
        "Zygomatic and temporal"
      ],
      correct: "B"
    },
    {
      id: 11777,
      question: "What is the significance of foramen lacerum?",
      options: [
        "Major artery passes through",
        "Mostly plugged with cartilage; minimal passage",
        "Largest cranial nerve exits here",
        "Spinal cord passes through"
      ],
      correct: "B"
    },
    {
      id: 11778,
      question: "The optic canal transmits which structures?",
      options: [
        "Maxillary nerve and vessels",
        "Optic nerve and ophthalmic artery",
        "Facial nerve",
        "Mandibular nerve"
      ],
      correct: "B"
    },
    {
      id: 11779,
      question: "The optic canal is located in which wing of the sphenoid?",
      options: [
        "Greater wing",
        "Lesser wing",
        "Pterygoid process",
        "Body"
      ],
      correct: "B"
    },
    {
      id: 11780,
      question: "Which bones contribute to forming the hard palate?",
      options: [
        "Maxilla only",
        "Palatine only",
        "Maxilla and palatine",
        "Vomer and ethmoid"
      ],
      correct: "C"
    },
    {
      id: 11781,
      question: "The medial pterygoid plate and lateral pterygoid plate are separated by what?",
      options: [
        "Greater palatine foramen",
        "Pterygoid fossa",
        "Infraorbital fissure",
        "Sphenopalatine foramen"
      ],
      correct: "B"
    }
  
  ],
  "3. Circulation of the Head and Neck (Part 1)": [    {
      id: 11300,
      question: "What type of blood do arteries carry?",
      options: [
        "Oxygenated blood from the heart to body systems",
        "Deoxygenated blood from the heart",
        "Deoxygenated blood to the heart",
        "Mixed blood",
      ],
      correct: "A"
    },
    {
      id: 11301,
      question: "What type of blood do veins carry?",
      options: [
        "Oxygenated blood from the heart",
        "Oxygenated blood to the heart",
        "Arterial blood",
        "Deoxygenated blood away from body systems back to the heart",
      ],
      correct: "D"
    },
    {
      id: 11302,
      question: "How many common carotid arteries are there?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 11303,
      question: "Where does the left common carotid artery originate from?",
      options: [
        "Brachiocephalic artery",
        "Subclavian artery",
        "Directly from the arch of the aorta",
        "External carotid artery",
      ],
      correct: "C"
    },
    {
      id: 11304,
      question: "Where does the right common carotid artery originate from?",
      options: [
        "Directly from the arch of the aorta",
        "Subclavian artery",
        "Internal carotid artery",
        "From the arch of the aorta through the brachiocephalic artery",
      ],
      correct: "D"
    },
    {
      id: 11305,
      question: "What does \"cephalic\" mean in the term brachiocephalic artery?",
      options: [
        "Head",
        "Neck",
        "Arm",
        "Chest",
      ],
      correct: "A"
    },
    {
      id: 11306,
      question: "Where does the common carotid artery run through?",
      options: [
        "Jugular sheath",
        "Carotid sheath",
        "Vertebral canal",
        "Pharyngeal space",
      ],
      correct: "B"
    },
    {
      id: 11307,
      question: "Near what structure does the common carotid artery split?",
      options: [
        "Hyoid bone",
        "Clavicle",
        "Larynx",
        "Mandible",
      ],
      correct: "C"
    },
    {
      id: 11308,
      question: "What are the two branches of the common carotid artery?",
      options: [
        "Superficial and deep carotid arteries",
        "Anterior and posterior carotid arteries",
        "Superior and inferior carotid arteries",
        "Internal and external carotid arteries",
      ],
      correct: "D"
    },
    {
      id: 11309,
      question: "How many branches does the internal carotid artery have in the neck?",
      options: [
        "None",
        "Two",
        "Three",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 11310,
      question: "Through what structure does the internal carotid artery enter the skull?",
      options: [
        "Jugular foramen",
        "Foramen magnum",
        "Foramen spinosum",
        "Carotid canal",
      ],
      correct: "D"
    },
    {
      id: 11311,
      question: "What structures does the internal carotid artery supply?",
      options: [
        "Face and neck only",
        "Eyes, brain, and some brain coverings",
        "Tongue and pharynx",
        "Muscles of mastication",
      ],
      correct: "B"
    },
    {
      id: 11312,
      question: "How are the branches of the external carotid artery named?",
      options: [
        "By their size",
        "By their order of branching",
        "According to the areas they supply",
        "Alphabetically",
      ],
      correct: "C"
    },
    {
      id: 11313,
      question: "Where are the branches of the external carotid artery located relative to the body surface?",
      options: [
        "Deep",
        "Within bone",
        "In the cranial cavity",
        "More superficial (nearer the surface)",
      ],
      correct: "D"
    },
    {
      id: 11314,
      question: "How many categories are the branches of the external carotid artery divided into?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 11315,
      question: "Which arteries are anterior branches of the external carotid artery?",
      options: [
        "Occipital, posterior auricular",
        "Maxillary, superficial temporal",
        "Superior thyroid, lingual, facial",
        "Ascending pharyngeal only",
      ],
      correct: "C"
    },
    {
      id: 11316,
      question: "Which artery is the medial branch of the external carotid artery?",
      options: [
        "Facial artery",
        "Lingual artery",
        "Occipital artery",
        "Ascending pharyngeal artery",
      ],
      correct: "D"
    },
    {
      id: 11317,
      question: "Which arteries are posterior branches of the external carotid artery?",
      options: [
        "Occipital, posterior auricular",
        "Facial, lingual",
        "Superior thyroid, lingual",
        "Maxillary, superficial temporal",
      ],
      correct: "A"
    },
    {
      id: 11318,
      question: "What are the two terminal branches of the external carotid artery?",
      options: [
        "Lingual and facial",
        "Maxillary and superficial temporal",
        "Occipital and posterior auricular",
        "Superior thyroid and ascending pharyngeal",
      ],
      correct: "B"
    },
    {
      id: 11319,
      question: "What does the lingual artery supply?",
      options: [
        "Face and neck",
        "Brain and eyes",
        "Tongue and floor of oral cavity",
        "Muscles of mastication",
      ],
      correct: "C"
    },
    {
      id: 11320,
      question: "At what level does the lingual artery branch from the external carotid artery?",
      options: [
        "At the level of the mandible",
        "At the level of the larynx",
        "At the level of the thyroid cartilage",
        "About even with the hyoid bone",
      ],
      correct: "D"
    },
    {
      id: 11321,
      question: "What are the three branches of the lingual artery?",
      options: [
        "Dorsal lingual, deep lingual, and sublingual",
        "Superior, middle, and inferior lingual",
        "Anterior, posterior, and lateral lingual",
        "Maxillary, mandibular, and palatine lingual",
      ],
      correct: "A"
    },
    {
      id: 11322,
      question: "What does the dorsal lingual artery supply?",
      options: [
        "Anterior part of the tongue",
        "Deep posterior part of tongue, tonsils, soft palate, and epiglottis",
        "Ventral surface of the tongue",
        "Floor of the mouth only",
      ],
      correct: "B"
    },
    {
      id: 11323,
      question: "What does the deep lingual artery supply?",
      options: [
        "Posterior part of the tongue",
        "Soft palate",
        "Deep anterior part of the tongue and deep to mucous membranes",
        "Epiglottis",
      ],
      correct: "C"
    },
    {
      id: 11324,
      question: "What does the sublingual artery supply?",
      options: [
        "Dorsal surface of the tongue",
        "Posterior tongue",
        "Soft palate",
        "Ventral surface of the tongue",
      ],
      correct: "D"
    },
    {
      id: 11325,
      question: "What does the facial artery supply?",
      options: [
        "Facial skin and muscles of facial expression",
        "Tongue and floor of mouth",
        "Muscles of mastication",
        "Brain coverings",
      ],
      correct: "A"
    },
    {
      id: 11326,
      question: "Where can the facial artery be palpated?",
      options: [
        "At the angle of the mandible",
        "Just anterior to the angle of mandible at the lower border",
        "On the zygomatic arch",
        "On the forehead",
      ],
      correct: "B"
    },
    {
      id: 11327,
      question: "What structure does the facial artery supply after branching from the external carotid?",
      options: [
        "Parotid gland",
        "Sublingual gland",
        "Submandibular salivary gland",
        "Thyroid gland",
      ],
      correct: "C"
    },
    {
      id: 11328,
      question: "What is the submental branch of the facial artery responsible for supplying?",
      options: [
        "Lips",
        "Nose",
        "Forehead",
        "Chin",
      ],
      correct: "D"
    },
    {
      id: 11329,
      question: "How many labial branches does the facial artery have?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 11330,
      question: "What do the labial branches of the facial artery supply?",
      options: [
        "Cheeks",
        "Chin",
        "Maxillary and mandibular labia (lips)",
        "Nose",
      ],
      correct: "C"
    },
    {
      id: 11331,
      question: "Where does the facial artery end?",
      options: [
        "At the medial corner of the eye",
        "At the angle of the mouth",
        "At the chin",
        "At the forehead",
      ],
      correct: "A"
    },
    {
      id: 11332,
      question: "What artery begins where the facial artery ends?",
      options: [
        "Infraorbital artery",
        "Angular artery",
        "Nasal artery",
        "Ophthalmic artery",
      ],
      correct: "B"
    },
    {
      id: 11333,
      question: "Why can the facial artery be compressed at the edge of the mandible?",
      options: [
        "To measure pulse",
        "To diagnose disease",
        "To slow facial bleeding",
        "To administer medication",
      ],
      correct: "C"
    },
    {
      id: 11334,
      question: "What is one of the two terminal branches of the external carotid artery?",
      options: [
        "Lingual artery",
        "Facial artery",
        "Occipital artery",
        "Maxillary artery",
      ],
      correct: "D"
    },
    {
      id: 11335,
      question: "What structures does the maxillary artery supply?",
      options: [
        "Muscles of mastication, teeth, oral and nasal cavities, brain coverings, and other areas",
        "Only the teeth",
        "Only facial muscles",
        "Only the tongue",
      ],
      correct: "A"
    },
    {
      id: 11336,
      question: "At what level does the maxillary artery originate from the external carotid artery?",
      options: [
        "At the level of the hyoid bone",
        "At the level of the mandibular condyle",
        "At the level of the zygomatic arch",
        "At the level of the larynx",
      ],
      correct: "B"
    },
    {
      id: 11337,
      question: "Where does the maxillary artery run after originating?",
      options: [
        "Through the parotid gland",
        "Through the oral cavity",
        "Through the infratemporal fossa",
        "Along the surface of the face",
      ],
      correct: "C"
    },
    {
      id: 11338,
      question: "What is the infratemporal fossa?",
      options: [
        "The space lateral to the zygomatic arch",
        "The space above the hard palate",
        "The space behind the maxilla",
        "The space medial to the zygomatic arch and ramus of mandible",
      ],
      correct: "D"
    },
    {
      id: 11339,
      question: "Where does the maxillary artery enter after passing through the infratemporal fossa?",
      options: [
        "Pterygopalatine fossa",
        "Oral cavity",
        "Nasal cavity",
        "Temporal fossa",
      ],
      correct: "A"
    },
    {
      id: 11340,
      question: "Where do the terminal branches of the maxillary artery emerge onto the face?",
      options: [
        "Mental foramen",
        "Infraorbital foramen",
        "Greater palatine foramen",
        "Mandibular foramen",
      ],
      correct: "B"
    },
    {
      id: 11341,
      question: "How many total branches does the maxillary artery have?",
      options: [
        "10",
        "12",
        "15",
        "20",
      ],
      correct: "C"
    },
    {
      id: 11342,
      question: "How many branches from the infratemporal fossa are studied in detail?",
      options: [
        "Four",
        "Five",
        "Seven",
        "Six",
      ],
      correct: "D"
    },
    {
      id: 11343,
      question: "How many branches from the pterygopalatine fossa are studied in detail?",
      options: [
        "Four",
        "Two",
        "Three",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 11344,
      question: "Where does the inferior alveolar artery enter?",
      options: [
        "Mental foramen",
        "Mandibular foramen",
        "Infraorbital foramen",
        "Greater palatine foramen",
      ],
      correct: "B"
    },
    {
      id: 11345,
      question: "Where does the inferior alveolar artery run after entering the mandible?",
      options: [
        "Along the surface of the mandible",
        "Through the mental foramen",
        "Through the mandibular canal",
        "Along the alveolar crest",
      ],
      correct: "C"
    },
    {
      id: 11346,
      question: "What structures does the inferior alveolar artery supply?",
      options: [
        "Only the teeth",
        "Only the gingiva",
        "Only the bone",
        "Each mandibular tooth, PDLs, and alveolar bone",
      ],
      correct: "D"
    },
    {
      id: 11347,
      question: "What is the most anterior portion of the inferior alveolar artery called?",
      options: [
        "Mental artery",
        "Incisive artery",
        "Lingual artery",
        "Buccal artery",
      ],
      correct: "B"
    },
    {
      id: 11348,
      question: "What teeth does the incisive artery supply?",
      options: [
        "Molars",
        "Premolars and canines",
        "Premolars forward",
        "All mandibular teeth",
      ],
      correct: "C"
    },
    {
      id: 11349,
      question: "Through what foramen does the mental artery exit the mandible?",
      options: [
        "Mandibular foramen",
        "Infraorbital foramen",
        "Incisive foramen",
        "Mental foramen",
      ],
      correct: "D"
    },
    {
      id: 11350,
      question: "What does the mental artery supply?",
      options: [
        "All mandibular teeth",
        "Mandibular buccal gingiva and mucosa from premolars to incisors, and mucosa of lower lip and chin",
        "Only the lower lip",
        "Only the chin",
      ],
      correct: "B"
    },
    {
      id: 11351,
      question: "How many temporal branches arise from the maxillary artery?",
      options: [
        "One",
        "Three",
        "Two",
        "Four",
      ],
      correct: "C"
    },
    {
      id: 11352,
      question: "What muscle do the temporal branches supply?",
      options: [
        "Masseter muscle",
        "Pterygoid muscles",
        "Temporal muscle",
        "Buccinator muscle",
      ],
      correct: "C"
    },
    {
      id: 11353,
      question: "What are the names of the two temporal branches?",
      options: [
        "Superior and inferior deep temporal",
        "Medial and lateral deep temporal",
        "Internal and external deep temporal",
        "Anterior and posterior deep temporal",
      ],
      correct: "D"
    },
    {
      id: 11354,
      question: "Through what structure does the masseteric artery run?",
      options: [
        "Mandibular foramen",
        "Coronoid notch",
        "Mental foramen",
        "Infraorbital foramen",
      ],
      correct: "B"
    },
    {
      id: 11355,
      question: "What muscle does the masseteric artery supply?",
      options: [
        "Temporal muscle",
        "Buccinator muscle",
        "Masseter muscle",
        "Pterygoid muscles",
      ],
      correct: "C"
    },
    {
      id: 11356,
      question: "How many pterygoid branches may there be?",
      options: [
        "Always one",
        "Always two",
        "Always three",
        "One or more",
      ],
      correct: "D"
    },
    {
      id: 11357,
      question: "What muscles do the pterygoid branches supply?",
      options: [
        "Medial and lateral pterygoid",
        "Masseter and temporal",
        "Buccinator and masseter",
        "Only medial pterygoid",
      ],
      correct: "A"
    },
    {
      id: 11358,
      question: "Through what foramen does the middle meningeal artery run?",
      options: [
        "Foramen ovale",
        "Foramen spinosum",
        "Jugular foramen",
        "Carotid canal",
      ],
      correct: "B"
    },
    {
      id: 11359,
      question: "What is the middle meningeal artery the major blood supply to?",
      options: [
        "Brain tissue",
        "Muscles of mastication",
        "Meninges of brain (connective tissue enclosing brain)",
        "Facial muscles",
      ],
      correct: "C"
    },
    {
      id: 11360,
      question: "What structures does the buccal artery supply?",
      options: [
        "Only maxillary teeth",
        "Only mandibular teeth",
        "Lips and chin",
        "Mucosa and gingiva of maxillary and mandibular posterior teeth",
      ],
      correct: "D"
    },
    {
      id: 11361,
      question: "What does the descending palatine artery extend through?",
      options: [
        "Pterygopalatine canal",
        "Infraorbital canal",
        "Incisive canal",
        "Mandibular canal",
      ],
      correct: "A"
    },
    {
      id: 11362,
      question: "Where does the descending palatine artery extend downwards to?",
      options: [
        "Soft palate",
        "Nasal cavity",
        "Hard palate",
        "Tongue",
      ],
      correct: "C"
    },
    {
      id: 11363,
      question: "What are the two branches of the descending palatine artery?",
      options: [
        "Anterior and posterior palatine",
        "Greater and lesser palatine",
        "Superior and inferior palatine",
        "Medial and lateral palatine",
      ],
      correct: "B"
    },
    {
      id: 11364,
      question: "What does the greater palatine artery supply?",
      options: [
        "Soft palate only",
        "Nasal cavity",
        "Palatal mucosa and maxillary lingual gingiva",
        "Maxillary teeth",
      ],
      correct: "C"
    },
    {
      id: 11365,
      question: "What does the lesser palatine artery supply?",
      options: [
        "Hard palate",
        "Maxillary teeth",
        "Soft palate",
        "Tongue",
      ],
      correct: "C"
    },
    {
      id: 11366,
      question: "Through what foramen does the greater palatine artery emerge?",
      options: [
        "Lesser palatine foramen",
        "Greater palatine foramen",
        "Incisive foramen",
        "Infraorbital foramen",
      ],
      correct: "B"
    },
    {
      id: 11367,
      question: "Through what foramen does the lesser palatine artery emerge?",
      options: [
        "Greater palatine foramen",
        "Incisive foramen",
        "Infraorbital foramen",
        "Lesser palatine foramen",
      ],
      correct: "D"
    },
    {
      id: 11368,
      question: "What is another name for the pterygopalatine artery?",
      options: [
        "Sphenopalatine artery",
        "Infraorbital artery",
        "Descending palatine artery",
        "Greater palatine artery",
      ],
      correct: "A"
    },
    {
      id: 11369,
      question: "Through what foramen does the sphenopalatine artery run into the nasal cavity?",
      options: [
        "Infraorbital foramen",
        "Sphenopalatine foramen",
        "Incisive foramen",
        "Greater palatine foramen",
      ],
      correct: "B"
    },
    {
      id: 11370,
      question: "What does the sphenopalatine artery primarily supply?",
      options: [
        "Hard palate",
        "Soft palate",
        "Most of the nasal cavity",
        "Maxillary sinus only",
      ],
      correct: "C"
    },
    {
      id: 11371,
      question: "Through what foramen does the sphenopalatine artery exit to join the greater palatine artery?",
      options: [
        "Sphenopalatine foramen",
        "Greater palatine foramen",
        "Infraorbital foramen",
        "Incisive foramen",
      ],
      correct: "D"
    },
    {
      id: 11372,
      question: "What is the infraorbital artery?",
      options: [
        "A branch of the facial artery",
        "The terminal end of the maxillary artery",
        "A branch of the lingual artery",
        "The first branch of the external carotid",
      ],
      correct: "B"
    },
    {
      id: 11373,
      question: "How many main branches does the infraorbital artery have?",
      options: [
        "One",
        "Three",
        "Two",
        "Four",
      ],
      correct: "C"
    },
    {
      id: 11374,
      question: "What does the middle superior alveolar artery supply?",
      options: [
        "Maxillary molars",
        "Maxillary premolars",
        "Maxillary incisors",
        "All maxillary teeth",
      ],
      correct: "B"
    },
    {
      id: 11375,
      question: "Is the middle superior alveolar artery always present?",
      options: [
        "Yes, always",
        "Only in males",
        "No, not always present",
        "Only in adults",
      ],
      correct: "C"
    },
    {
      id: 11376,
      question: "What teeth does the anterior superior alveolar artery supply?",
      options: [
        "Maxillary premolars",
        "Maxillary molars",
        "All maxillary teeth",
        "Maxillary anterior teeth",
      ],
      correct: "D"
    },
    {
      id: 11377,
      question: "Where does the anterior superior alveolar artery travel?",
      options: [
        "Down the bone in front of the maxillary sinus",
        "Through the mandibular canal",
        "Along the hard palate",
        "Through the nasal cavity",
      ],
      correct: "A"
    },
    {
      id: 11378,
      question: "What artery may the anterior superior alveolar artery join in the wall of the sinus?",
      options: [
        "Middle superior alveolar artery",
        "Posterior superior alveolar artery",
        "Infraorbital artery",
        "Descending palatine artery",
      ],
      correct: "B"
    },
    {
      id: 11379,
      question: "Through what foramen do the terminal branches of the infraorbital artery emerge onto the face?",
      options: [
        "Mental foramen",
        "Greater palatine foramen",
        "Infraorbital foramen",
        "Sphenopalatine foramen",
      ],
      correct: "C"
    },
    {
      id: 11380,
      question: "What structures do the terminal infraorbital branches supply on the face?",
      options: [
        "Only the nose",
        "Only the upper lip",
        "Only the lower eyelid",
        "Upper lip, its mucosa, maxillary labial gingiva, lower eyelid, and sides of nose",
      ],
      correct: "D"
    },
    {
      id: 11381,
      question: "Where does the posterior superior alveolar artery descend from?",
      options: [
        "Infraorbital foramen",
        "Pterygopalatine canal",
        "Mandibular foramen",
        "Pterygomaxillary fissure",
      ],
      correct: "D"
    },
    {
      id: 11382,
      question: "Where does the posterior superior alveolar artery descend onto?",
      options: [
        "Hard palate",
        "Mandibular ramus",
        "Zygomatic arch",
        "Maxillary tuberosity",
      ],
      correct: "D"
    },
    {
      id: 11383,
      question: "Where do some branches of the posterior superior alveolar artery enter the bone?",
      options: [
        "At the infraorbital foramen",
        "Behind the 3rd molar",
        "At the greater palatine foramen",
        "At the incisive foramen",
      ],
      correct: "B"
    },
    {
      id: 11384,
      question: "What do the branches of the posterior superior alveolar artery that enter bone supply?",
      options: [
        "Only the maxillary molars",
        "Only the maxillary sinus",
        "All maxillary posterior teeth and part of maxillary sinus",
        "Maxillary anterior teeth",
      ],
      correct: "C"
    },
    {
      id: 11385,
      question: "What do the branches of the posterior superior alveolar artery that don't enter bone supply?",
      options: [
        "Hard palate",
        "Nasal cavity",
        "Soft palate",
        "Posterior buccal gingiva and mucosa of maxillary posterior teeth",
      ],
      correct: "D"
    },
    {
      id: 11386,
      question: "Do veins generally follow the same pathways as arteries?",
      options: [
        "Yes, generally follow the same pathways",
        "No, completely different pathways",
        "Only in the head",
        "Only in the neck",
      ],
      correct: "A"
    },
    {
      id: 11387,
      question: "What are the veins of the head and neck called?",
      options: [
        "Carotid veins",
        "Cervical veins",
        "Cephalic veins",
        "Jugular veins",
      ],
      correct: "D"
    },
    {
      id: 11388,
      question: "What does the internal jugular vein drain?",
      options: [
        "Face only",
        "Entire brain area",
        "Neck muscles only",
        "Oral cavity only",
      ],
      correct: "B"
    },
    {
      id: 11389,
      question: "Through what structure does the internal jugular vein pass out of the skull?",
      options: [
        "Carotid canal",
        "Foramen magnum",
        "Jugular foramen",
        "Foramen spinosum",
      ],
      correct: "C"
    },
    {
      id: 11390,
      question: "What area does the external jugular vein drain?",
      options: [
        "Brain only",
        "Posterior neck only",
        "Oral cavity only",
        "Much of the area from front of ear to front of face",
      ],
      correct: "D"
    },
    {
      id: 11391,
      question: "What is an alternative name sometimes used for the lingual and facial arteries when they branch together?",
      options: [
        "Linguofacial trunk",
        "Linguomaxillary trunk",
        "Faciomaxillary trunk",
        "Cervicofacial trunk",
      ],
      correct: "A"
    },
    {
      id: 11392,
      question: "Are the left and right circulatory systems of the head and neck symmetrical?",
      options: [
        "No, completely different",
        "Yes, symmetrical except for origins of common carotid arteries",
        "Only the arterial system is symmetrical",
        "Only the venous system is symmetrical",
      ],
      correct: "B"
    },
    {
      id: 11393,
      question: "When we speak of the \"common carotid artery\" without specifying left or right, what is assumed?",
      options: [
        "We mean only the left",
        "We mean only the right",
        "We are speaking of both left and right",
        "We mean neither specifically",
      ],
      correct: "C"
    },
    {
      id: 11394,
      question: "What proportion of blood supplied to the head comes through the common carotid arteries?",
      options: [
        "All of it",
        "Half of it",
        "Most of it",
        "A small portion",
      ],
      correct: "A"
    },
    {
      id: 11395,
      question: "Which side common carotid artery has a more direct origin from the aorta?",
      options: [
        "Right",
        "Both equal",
        "Neither direct",
        "Left",
      ],
      correct: "D"
    },
    {
      id: 11396,
      question: "What is the relationship between arteries and veins in the circulatory system?",
      options: [
        "Arteries carry blood away; veins bring it back",
        "Arteries supply only; veins have no function",
        "Both carry the same type of blood",
        "They don't interact",
      ],
      correct: "A"
    },
  ],
  "3. Circulation of the Head and Neck (Part 2)": [
    {
      id: 11800,
      question: "What is the primary function of arteries in the circulatory system?",
      options: [
        "Transport de-oxygenated blood from body systems back to the heart",
        "Carry oxygenated blood from the heart to body systems and parts",
        "Store excess blood for emergency circulation needs",
        "Filter blood before it enters the heart chambers"
      ],
      correct: "B"
    },
    {
      id: 11801,
      question: "What is the primary function of veins in the circulatory system?",
      options: [
        "Distribute oxygenated blood to all body tissues and organs",
        "Regulate blood pressure throughout the cardiovascular system",
        "Carry de-oxygenated blood from body parts back to the heart",
        "Connect arteries to capillaries in tissue beds"
      ],
      correct: "C"
    },
    {
      id: 11802,
      question: "Where does the left common carotid artery originate?",
      options: [
        "From the brachiocephalic artery on the left side",
        "Directly from the arch of the aorta",
        "From the subclavian artery on the left side",
        "From the junction of the ascending and descending aorta"
      ],
      correct: "B"
    },
    {
      id: 11803,
      question: "How does the right common carotid artery differ in origin from the left?",
      options: [
        "It originates through the brachiocephalic artery before becoming the common carotid",
        "It branches directly from the ascending aorta",
        "It emerges from the left ventricle of the heart",
        "It originates from the right subclavian artery"
      ],
      correct: "A"
    },
    {
      id: 11804,
      question: "What structure contains the common carotid artery as it travels through the neck?",
      options: [
        "The vertebral canal on both sides of the neck",
        "The carotid sheath on both left and right sides",
        "The internal jugular foramen bilaterally",
        "The external carotid canal in the temporal bone"
      ],
      correct: "B"
    },
    {
      id: 11805,
      question: "At what anatomical landmark does the common carotid artery bifurcate?",
      options: [
        "At the level of the clavicle",
        "Near the larynx",
        "At the base of the skull",
        "Adjacent to the thyroid cartilage"
      ],
      correct: "B"
    },
    {
      id: 11806,
      question: "Into which two major arteries does the common carotid artery divide?",
      options: [
        "The maxillary and superficial temporal arteries",
        "The external carotid and internal carotid arteries",
        "The facial and lingual arteries bilaterally",
        "The superior and inferior thyroid arteries"
      ],
      correct: "B"
    },
    {
      id: 11807,
      question: "What is a key characteristic of the internal carotid artery in the neck?",
      options: [
        "It has numerous branches supplying neck muscles",
        "It branches extensively to supply facial structures",
        "It has no branches in the neck region",
        "It terminates at the level of the hyoid bone"
      ],
      correct: "C"
    },
    {
      id: 11808,
      question: "Through which opening does the internal carotid artery enter the skull?",
      options: [
        "Through the jugular foramen in the temporal bone",
        "Through the foramen magnum at the skull base",
        "Through the carotid canal in the skull",
        "Through the foramen spinosum in the sphenoid bone"
      ],
      correct: "C"
    },
    {
      id: 11809,
      question: "Which structures does the internal carotid artery primarily supply?",
      options: [
        "The facial muscles, tongue, and oral cavity structures",
        "The eyes, brain, and some brain coverings",
        "The thyroid gland, larynx, and pharynx",
        "The scalp, external ear, and temporal region"
      ],
      correct: "B"
    },
    {
      id: 11810,
      question: "What is the location of external carotid artery branches relative to body surface?",
      options: [
        "They are deep to bone and muscle layers",
        "They are located within the cranial cavity",
        "They are nearer the surface and more superficial",
        "They travel exclusively through bony canals"
      ],
      correct: "C"
    },
    {
      id: 11811,
      question: "Which structures do the branches of the external carotid artery supply?",
      options: [
        "Only the brain and its protective coverings",
        "The throat, tongue, face, ears, and cranium wall",
        "Exclusively the muscles of mastication and deglutition",
        "The cervical vertebrae and spinal cord"
      ],
      correct: "B"
    },
    {
      id: 11812,
      question: "How many categories divide the branches of the external carotid artery?",
      options: [
        "Two categories: superficial and deep branches only",
        "Four categories: anterior, posterior, medial, and lateral",
        "Three categories: anterior, medial, and posterior branches",
        "Five categories including terminal and intermediate branches"
      ],
      correct: "C"
    },
    {
      id: 11813,
      question: "Which arteries are anterior branches of the external carotid artery?",
      options: [
        "Occipital, posterior auricular, and ascending pharyngeal arteries",
        "Superior thyroid, lingual, and facial arteries",
        "Maxillary, superficial temporal, and middle meningeal arteries",
        "Deep temporal, masseteric, and pterygoid arteries"
      ],
      correct: "B"
    },
    {
      id: 11814,
      question: "Which artery is the medial branch of the external carotid artery?",
      options: [
        "The lingual artery supplying the tongue",
        "The facial artery crossing the mandible",
        "The ascending pharyngeal artery",
        "The occipital artery to the posterior scalp"
      ],
      correct: "C"
    },
    {
      id: 11815,
      question: "Which arteries are posterior branches of the external carotid artery?",
      options: [
        "Superior thyroid and lingual arteries posteriorly",
        "Maxillary and superficial temporal arteries",
        "Occipital and posterior auricular arteries",
        "Facial and ascending pharyngeal arteries"
      ],
      correct: "C"
    },
    {
      id: 11816,
      question: "Into which two terminal arteries does the external carotid artery divide?",
      options: [
        "The lingual and facial arteries at termination",
        "The superior thyroid and ascending pharyngeal arteries",
        "The maxillary and superficial temporal arteries",
        "The occipital and posterior auricular arteries"
      ],
      correct: "C"
    },
    {
      id: 11817,
      question: "What anatomical variation may occur with the lingual and facial arteries?",
      options: [
        "They may branch directly from the common carotid artery",
        "They occasionally branch together as the linguofacial trunk",
        "They sometimes bypass the external carotid entirely",
        "They may originate from the internal carotid artery"
      ],
      correct: "B"
    },
    {
      id: 11818,
      question: "Which primary structures does the lingual artery supply?",
      options: [
        "The facial muscles and external ear structures",
        "The thyroid gland and surrounding neck tissues",
        "The tongue and floor of the oral cavity",
        "The palate and nasal cavity mucosa"
      ],
      correct: "C"
    },
    {
      id: 11819,
      question: "At approximately what anatomical level does the lingual artery branch from the external carotid?",
      options: [
        "At the level of the mandibular angle",
        "About even with the hyoid bone",
        "Near the thyroid cartilage prominence",
        "At the base of the tongue muscle"
      ],
      correct: "B"
    },
    {
      id: 11820,
      question: "In what direction does the lingual artery travel after branching?",
      options: [
        "Posterior and superficial toward the ear region",
        "Laterally toward the angle of the mandible",
        "Anterior and deep under the tongue muscles",
        "Superior toward the base of the skull"
      ],
      correct: "C"
    },
    {
      id: 11821,
      question: "Which branch of the lingual artery supplies the deep posterior tongue?",
      options: [
        "The sublingual artery to posterior structures",
        "The deep lingual artery posteriorly",
        "The dorsal lingual artery",
        "The superior thyroid artery branch"
      ],
      correct: "C"
    },
    {
      id: 11822,
      question: "What additional structures does the dorsal lingual artery supply besides the tongue?",
      options: [
        "The floor of mouth and sublingual gland",
        "The tonsils, soft palate, and epiglottis",
        "The hard palate and nasal cavity",
        "The mandibular teeth and periodontal ligament"
      ],
      correct: "B"
    },
    {
      id: 11823,
      question: "Which lingual artery branch supplies the deep anterior part of the tongue?",
      options: [
        "The dorsal lingual artery to anterior regions",
        "The sublingual artery anteriorly",
        "The deep lingual artery deep to mucous membranes",
        "The anterior thyroid artery branch"
      ],
      correct: "C"
    },
    {
      id: 11824,
      question: "Which lingual artery branch supplies the ventral surface of the tongue?",
      options: [
        "The deep lingual artery ventrally",
        "The dorsal lingual artery to ventral areas",
        "The sublingual artery",
        "The inferior lingual branch"
      ],
      correct: "C"
    },
    {
      id: 11825,
      question: "Which primary structures does the facial artery supply blood to?",
      options: [
        "The tongue, floor of mouth, and sublingual structures",
        "The facial skin and muscles of facial expression",
        "The brain, eyes, and cranial nerve structures",
        "The teeth, periodontal ligaments, and alveolar bone"
      ],
      correct: "B"
    },
    {
      id: 11826,
      question: "What structure does the facial artery supply before crossing the mandible?",
      options: [
        "The parotid salivary gland and duct",
        "The muscles of mastication inferiorly",
        "The submandibular salivary gland",
        "The thyroid and parathyroid glands"
      ],
      correct: "C"
    },
    {
      id: 11827,
      question: "Where can the facial artery be palpated on the face?",
      options: [
        "At the temporal region anterior to the ear",
        "Just anterior to the mandibular angle",
        "At the infraorbital foramen below the eye",
        "Along the zygomatic arch laterally"
      ],
      correct: "B"
    },
    {
      id: 11828,
      question: "What is the first branch of the facial artery after crossing the mandible?",
      options: [
        "The angular artery near the eye",
        "The superior and inferior labial branches",
        "The submental branch to the chin",
        "The nasal branch to the nose"
      ],
      correct: "C"
    },
    {
      id: 11829,
      question: "Which structures do the labial branches of the facial artery supply?",
      options: [
        "The buccal mucosa and gingiva",
        "The maxillary and mandibular lips (labia)",
        "The tongue and floor of mouth",
        "The hard and soft palate"
      ],
      correct: "B"
    },
    {
      id: 11830,
      question: "Where does the facial artery terminate and what does it become?",
      options: [
        "At the angle of mouth as the labial artery",
        "At the medial eye corner as the angular artery",
        "At the nasal tip as the dorsal nasal artery",
        "At the chin as the mental artery"
      ],
      correct: "B"
    },
    {
      id: 11831,
      question: "What is the clinical significance of the facial artery at the mandibular border?",
      options: [
        "It serves as a landmark for nerve blocks",
        "It can be compressed to slow facial bleeding",
        "It indicates the location of lymph nodes",
        "It marks the insertion of facial muscles"
      ],
      correct: "B"
    },
    {
      id: 11832,
      question: "Which major structures does the maxillary artery supply?",
      options: [
        "Only the maxillary teeth and surrounding gingiva",
        "The facial skin and superficial neck structures",
        "Mastication muscles, teeth, oral/nasal cavities, brain coverings, and smaller areas",
        "Exclusively the brain and cranial nerve pathways"
      ],
      correct: "C"
    },
    {
      id: 11833,
      question: "The maxillary artery is one of which type of branches?",
      options: [
        "One of three medial branches of external carotid",
        "One of two terminal branches of external carotid",
        "One of four anterior branches of external carotid",
        "One of two posterior branches of external carotid"
      ],
      correct: "B"
    },
    {
      id: 11834,
      question: "At what anatomical level does the maxillary artery originate?",
      options: [
        "At the level of the hyoid bone",
        "Near the thyroid cartilage prominence",
        "At the level of the mandibular condyle",
        "At the angle of the mandible"
      ],
      correct: "C"
    },
    {
      id: 11835,
      question: "Through which space does the maxillary artery initially travel?",
      options: [
        "Through the pterygomaxillary fissure initially",
        "Through the infratemporal fossa medial to zygomatic arch",
        "Through the pterygopalatine fossa behind eye",
        "Through the temporal fossa above zygomatic arch"
      ],
      correct: "B"
    },
    {
      id: 11836,
      question: "Into which fossa does the maxillary artery enter after the infratemporal fossa?",
      options: [
        "Into the temporal fossa above the ear",
        "Into the pterygopalatine fossa behind and below the eye",
        "Into the orbit through the inferior orbital fissure",
        "Into the nasal cavity through ethmoid foramina"
      ],
      correct: "B"
    },
    {
      id: 11837,
      question: "Through which opening do terminal branches of the maxillary artery emerge onto the face?",
      options: [
        "Through the mental foramen on the mandible",
        "Through the supraorbital foramen above the eye",
        "Through the infraorbital foramen below the eye",
        "Through the zygomaticofacial foramen laterally"
      ],
      correct: "C"
    },
    {
      id: 11838,
      question: "How many total branches does the maxillary artery have?",
      options: [
        "Ten major branches in total",
        "Twelve branches total",
        "Fifteen branches in total",
        "Twenty branches throughout its course"
      ],
      correct: "C"
    },
    {
      id: 11839,
      question: "From which fossa do the inferior alveolar, temporal, masseteric, pterygoid, middle meningeal, and buccal arteries branch?",
      options: [
        "From the pterygopalatine fossa posteriorly",
        "From the temporal fossa superiorly",
        "From the infratemporal fossa",
        "From the submandibular fossa inferiorly"
      ],
      correct: "C"
    },
    {
      id: 11840,
      question: "Which arteries branch from the maxillary artery in the pterygopalatine fossa?",
      options: [
        "Inferior alveolar, buccal, and masseteric arteries",
        "Descending palatine, posterior superior alveolar, pterygopalatine, and infraorbital arteries",
        "Middle meningeal, temporal, and pterygoid arteries",
        "Facial, lingual, and superior thyroid arteries"
      ],
      correct: "B"
    },
    {
      id: 11841,
      question: "Through which opening does the inferior alveolar artery enter the mandible?",
      options: [
        "Through the mental foramen on the lateral surface",
        "Through the mandibular foramen on the medial surface",
        "Through the mandibular notch superiorly",
        "Through the submandibular fossa inferiorly"
      ],
      correct: "B"
    },
    {
      id: 11842,
      question: "Which structures does the inferior alveolar artery supply within the mandible?",
      options: [
        "Only the mandibular molars and their supporting bone",
        "Each mandibular tooth, their PDLs, and alveolar bone",
        "The mandibular gingiva and oral mucosa only",
        "The muscles attached to the mandible"
      ],
      correct: "B"
    },
    {
      id: 11843,
      question: "What is the name of the most anterior portion of the inferior alveolar artery?",
      options: [
        "The mental artery supplying anterior teeth",
        "The anterior alveolar artery",
        "The incisive artery from premolars forward",
        "The mandibular incisor branch"
      ],
      correct: "C"
    },
    {
      id: 11844,
      question: "Through which opening does the mental artery exit the mandible?",
      options: [
        "Through the mandibular foramen medially",
        "Through the mental foramen on the lateral surface",
        "Through the incisive canal anteriorly",
        "Through the lingual foramen on medial surface"
      ],
      correct: "B"
    },
    {
      id: 11845,
      question: "Which structures does the mental artery supply after exiting the mandible?",
      options: [
        "All mandibular teeth and periodontal structures",
        "The floor of mouth and sublingual gland",
        "Mandibular buccal gingiva and mucosa from premolars to incisors, lower lip mucosa, and chin",
        "The muscles of facial expression in lower face"
      ],
      correct: "C"
    },
    {
      id: 11846,
      question: "How many temporal artery branches arise from the maxillary artery?",
      options: [
        "One temporal artery branch only",
        "Two temporal branches",
        "Three temporal artery branches",
        "Four temporal branches bilaterally"
      ],
      correct: "B"
    },
    {
      id: 11847,
      question: "Which muscle do the temporal branches of the maxillary artery supply?",
      options: [
        "The masseter muscle of mastication",
        "The lateral pterygoid muscle",
        "The temporal muscle",
        "The medial pterygoid muscle"
      ],
      correct: "C"
    },
    {
      id: 11848,
      question: "What are the two temporal branches called?",
      options: [
        "Superior and inferior deep temporal arteries",
        "Anterior and posterior deep temporal arteries",
        "Medial and lateral temporal arteries",
        "Superficial and deep temporal arteries"
      ],
      correct: "B"
    },
    {
      id: 11849,
      question: "Through which anatomical feature does the masseteric artery travel?",
      options: [
        "Through the mandibular foramen medially",
        "Through the pterygomaxillary fissure posteriorly",
        "Through the coronoid notch laterally",
        "Through the infratemporal crest superiorly"
      ],
      correct: "C"
    },
    {
      id: 11850,
      question: "Which muscle does the masseteric artery supply?",
      options: [
        "The temporal muscle on the cranium",
        "The lateral pterygoid muscle medially",
        "The masseter muscle",
        "The medial pterygoid muscle"
      ],
      correct: "C"
    },
    {
      id: 11851,
      question: "Which muscles do the pterygoid branches supply?",
      options: [
        "The masseter and temporalis muscles",
        "The medial and lateral pterygoid muscles",
        "The muscles of facial expression",
        "The suprahyoid muscles of the neck"
      ],
      correct: "B"
    },
    {
      id: 11852,
      question: "How many pterygoid branches may arise from the maxillary artery?",
      options: [
        "Always exactly one pterygoid branch",
        "Always exactly two pterygoid branches",
        "There may be one or more pterygoid branches",
        "Always three pterygoid branches"
      ],
      correct: "C"
    },
    {
      id: 11853,
      question: "Through which foramen does the middle meningeal artery pass?",
      options: [
        "Through the foramen ovale into cranium",
        "Through the jugular foramen posteriorly",
        "Through the foramen spinosum",
        "Through the carotid canal medially"
      ],
      correct: "C"
    },
    {
      id: 11854,
      question: "What is the primary structure supplied by the middle meningeal artery?",
      options: [
        "The muscles of mastication in infratemporal fossa",
        "The meninges (connective tissue enclosing the brain)",
        "The brain tissue itself and neurons",
        "The bones of the cranial vault"
      ],
      correct: "B"
    },
    {
      id: 11855,
      question: "Which areas does the buccal artery supply?",
      options: [
        "The lips and labial mucosa exclusively",
        "The tongue and floor of mouth",
        "Mucosa and gingiva of maxillary and mandibular posterior teeth",
        "The hard and soft palate mucosa"
      ],
      correct: "C"
    },
    {
      id: 11856,
      question: "What is the descending palatine artery a branch of?",
      options: [
        "The facial artery in the face",
        "The lingual artery near the tongue",
        "The maxillary artery in pterygopalatine fossa",
        "The external carotid artery directly"
      ],
      correct: "C"
    },
    {
      id: 11857,
      question: "Through which canal does the descending palatine artery travel?",
      options: [
        "Through the incisive canal anteriorly",
        "Through the greater palatine canal",
        "Through the pterygopalatine canal",
        "Through the inferior orbital canal"
      ],
      correct: "C"
    },
    {
      id: 11858,
      question: "Into which two arteries does the descending palatine artery divide?",
      options: [
        "The ascending and descending palatine arteries",
        "The anterior and posterior palatine arteries",
        "The greater and lesser palatine arteries",
        "The medial and lateral palatine arteries"
      ],
      correct: "C"
    },
    {
      id: 11859,
      question: "Which structures does the greater palatine artery supply?",
      options: [
        "The soft palate and uvula exclusively",
        "The nasal cavity and turbinates",
        "The palatal mucosa and maxillary lingual gingiva",
        "The maxillary teeth and alveolar bone"
      ],
      correct: "C"
    },
    {
      id: 11860,
      question: "Through which foramen does the greater palatine artery emerge?",
      options: [
        "Through the lesser palatine foramen",
        "Through the incisive foramen anteriorly",
        "Through the greater palatine foramen",
        "Through the sphenopalatine foramen"
      ],
      correct: "C"
    },
    {
      id: 11861,
      question: "Which structure does the lesser palatine artery primarily supply?",
      options: [
        "The hard palate mucosa",
        "The soft palate",
        "The maxillary gingiva",
        "The nasal septum"
      ],
      correct: "B"
    },
    {
      id: 11862,
      question: "Through which foramen does the lesser palatine artery emerge?",
      options: [
        "Through the greater palatine foramen",
        "Through the incisive foramen",
        "Through the lesser palatine foramen",
        "Through the sphenopalatine foramen"
      ],
      correct: "C"
    },
    {
      id: 11863,
      question: "From which opening does the posterior superior alveolar artery descend?",
      options: [
        "From the inferior orbital fissure",
        "From the pterygomaxillary fissure",
        "From the sphenopalatine foramen",
        "From the infraorbital foramen"
      ],
      correct: "B"
    },
    {
      id: 11864,
      question: "Onto which anatomical structure does the posterior superior alveolar artery descend?",
      options: [
        "Onto the coronoid process of mandible",
        "Onto the palatine process of maxilla",
        "Onto the maxillary tuberosity",
        "Onto the zygomatic process of maxilla"
      ],
      correct: "C"
    },
    {
      id: 11865,
      question: "Where do some branches of the posterior superior alveolar artery enter bone?",
      options: [
        "Through the mental foramen anteriorly",
        "Through the infraorbital canal superiorly",
        "Behind the third molar on maxillary tuberosity",
        "Through the incisive foramen medially"
      ],
      correct: "C"
    },
    {
      id: 11866,
      question: "Which structures do the intraosseous branches of the posterior superior alveolar artery supply?",
      options: [
        "The maxillary anterior teeth exclusively",
        "All maxillary posterior teeth and part of maxillary sinus",
        "The mandibular posterior teeth and bone",
        "The hard palate and palatine bone"
      ],
      correct: "B"
    },
    {
      id: 11867,
      question: "What do the extraosseous branches of the posterior superior alveolar artery supply?",
      options: [
        "The lingual gingiva of maxillary posteriors",
        "The palatal mucosa and gingiva",
        "The posterior buccal gingiva and mucosa of maxillary posterior teeth",
        "The nasal cavity lateral wall"
      ],
      correct: "C"
    },
    {
      id: 11868,
      question: "What is another name for the pterygopalatine artery?",
      options: [
        "The descending palatine artery",
        "The greater palatine artery",
        "The sphenopalatine artery",
        "The nasopalatine artery"
      ],
      correct: "C"
    },
    {
      id: 11869,
      question: "Through which foramen does the pterygopalatine artery enter the nasal cavity?",
      options: [
        "Through the greater palatine foramen",
        "Through the incisive foramen anteriorly",
        "Through the sphenopalatine foramen",
        "Through the inferior orbital fissure"
      ],
      correct: "C"
    },
    {
      id: 11870,
      question: "Which primary structure does the pterygopalatine (sphenopalatine) artery supply?",
      options: [
        "The hard and soft palate",
        "The maxillary teeth and sinus",
        "Most of the nasal cavity",
        "The orbit and lacrimal gland"
      ],
      correct: "C"
    },
    {
      id: 11871,
      question: "Through which foramen does the pterygopalatine artery exit after supplying the nasal cavity?",
      options: [
        "Through the sphenopalatine foramen",
        "Through the greater palatine foramen",
        "Through the incisive foramen to join greater palatine artery",
        "Through the inferior orbital fissure"
      ],
      correct: "C"
    },
    {
      id: 11872,
      question: "What is the anatomical significance of the infraorbital artery?",
      options: [
        "It is the first branch of maxillary artery",
        "It is one of the posterior branches",
        "It is the terminal end of the maxillary artery",
        "It is a branch of the facial artery"
      ],
      correct: "C"
    },
    {
      id: 11873,
      question: "How many main branches does the infraorbital artery have before reaching the face?",
      options: [
        "One branch only",
        "Two branches",
        "Three branches",
        "Four branches"
      ],
      correct: "B"
    },
    {
      id: 11874,
      question: "Which teeth does the middle superior alveolar artery supply?",
      options: [
        "The maxillary molars exclusively",
        "The maxillary premolars",
        "The maxillary anterior teeth",
        "The maxillary canines only"
      ],
      correct: "B"
    },
    {
      id: 11875,
      question: "Is the middle superior alveolar artery always present?",
      options: [
        "Yes, it is always present bilaterally",
        "No, it is not always present",
        "It is only present in males",
        "It only develops after age twenty"
      ],
      correct: "B"
    },
    {
      id: 11876,
      question: "Which teeth does the anterior superior alveolar artery supply?",
      options: [
        "The maxillary posterior teeth",
        "The maxillary premolars bilaterally",
        "The maxillary anterior teeth",
        "The mandibular anterior teeth"
      ],
      correct: "C"
    },
    {
      id: 11877,
      question: "Where does the anterior superior alveolar artery travel to supply the anterior teeth?",
      options: [
        "Through the palatine bone medially",
        "Down the bone in front of the maxillary sinus",
        "Through the nasal cavity floor",
        "Along the facial surface of maxilla"
      ],
      correct: "B"
    },
    {
      id: 11878,
      question: "With which other artery may the anterior superior alveolar artery join?",
      options: [
        "With the middle superior alveolar artery",
        "With the infraorbital artery terminus",
        "With the posterior superior alveolar artery in sinus wall",
        "With the descending palatine artery"
      ],
      correct: "C"
    },
    {
      id: 11879,
      question: "Which facial structures do the terminal infraorbital branches supply after emerging from the infraorbital foramen?",
      options: [
        "The lower eyelid, nose, and chin exclusively",
        "The upper lip, its mucosa, maxillary labial gingiva, lower eyelid, and sides of nose",
        "The zygomatic region and temporal area",
        "The nasal cavity and ethmoid sinuses"
      ],
      correct: "B"
    },
    {
      id: 11880,
      question: "What is the general relationship between veins and arteries in the head and neck?",
      options: [
        "Veins follow completely different pathways than arteries",
        "Veins generally follow the same pathways as arteries",
        "Veins are superficial while arteries are always deep",
        "Veins and arteries never travel together"
      ],
      correct: "B"
    },
    {
      id: 11881,
      question: "What are the veins of the head and neck collectively called?",
      options: [
        "The carotid veins bilaterally",
        "The cervical veins of neck",
        "The jugular veins",
        "The cranial veins superiorly"
      ],
      correct: "C"
    },
    {
      id: 11882,
      question: "Which major area does the internal jugular vein drain?",
      options: [
        "The facial structures and neck muscles",
        "The thyroid and parathyroid glands",
        "The entire brain area",
        "The scalp and external ear"
      ],
      correct: "C"
    },
    {
      id: 11883,
      question: "Through which opening does the internal jugular vein pass out of the skull?",
      options: [
        "Through the carotid canal",
        "Through the foramen magnum posteriorly",
        "Through the jugular foramen",
        "Through the foramen spinosum"
      ],
      correct: "C"
    },
    {
      id: 11884,
      question: "Which anatomical area does the external jugular vein primarily drain?",
      options: [
        "The deep neck structures and larynx",
        "The brain and cranial structures",
        "Much of the area from front of ear to front of face",
        "The posterior neck and occipital region"
      ],
      correct: "C"
    }
  
  ],
  "4. Lymphatics (Part 1)": [    {
      id: 11400,
      question: "What role does the lymphatic system play in the body's defense mechanisms?",
      options: [
        "First line of defense",
        "Second line of defense",
        "Third line of defense",
        "Final line of defense",
      ],
      correct: "B"
    },
    {
      id: 11401,
      question: "The lymphatic system is composed of tiny channels interconnected by which structures?",
      options: [
        "Blood vessels",
        "Capillaries",
        "Lymph nodes",
        "Arteries",
      ],
      correct: "C"
    },
    {
      id: 11402,
      question: "How does the lymphatic system function in relation to body fluids?",
      options: [
        "It produces blood plasma for tissues",
        "It stores extracellular fluid permanently",
        "It returns extracellular fluids to the bloodstream from tissues",
        "It prevents fluid from leaving capillaries",
      ],
      correct: "C"
    },
    {
      id: 11403,
      question: "What is extracellular fluid in the context of the lymphatic system?",
      options: [
        "Fluid inside cells",
        "A filtrate from blood plasma that flows into surrounding tissues",
        "Blood that has clotted outside vessels",
        "Saliva in the oral cavity",
      ],
      correct: "B"
    },
    {
      id: 11404,
      question: "What is the fluid called when it is circulating within the lymphatic system?",
      options: [
        "Plasma",
        "Serum",
        "Lymph",
        "Interstitial fluid only",
      ],
      correct: "C"
    },
    {
      id: 11405,
      question: "What condition results when lymph vessels are blocked or unable to carry fluid away from tissues?",
      options: [
        "Lymphoma",
        "Lymphedema",
        "Lymphangitis",
        "Lymphadenitis",
      ],
      correct: "B"
    },
    {
      id: 11406,
      question: "What is the primary function of lymph nodes?",
      options: [
        "Produce red blood cells",
        "Store vitamins and minerals",
        "Act as filters and produce lymphocytes to combat infections",
        "Generate hormones for immune response",
      ],
      correct: "C"
    },
    {
      id: 11407,
      question: "Which tissues contain lymph vessels according to the document?",
      options: [
        "Only skin and mucosa",
        "Only major organs",
        "Most tissues, including the pulp of teeth",
        "Only superficial tissues",
      ],
      correct: "C"
    },
    {
      id: 11408,
      question: "How are lymph nodes organized in the body?",
      options: [
        "Randomly scattered throughout tissues",
        "Grouped together in small clusters",
        "Located only in the abdomen",
        "Found exclusively in bone marrow",
      ],
      correct: "B"
    },
    {
      id: 11409,
      question: "What happens when lymph nodes are affected by infection?",
      options: [
        "They shrink and harden",
        "They become tender and enlarged",
        "They disappear temporarily",
        "They change color to blue",
      ],
      correct: "B"
    },
    {
      id: 11410,
      question: "Which anatomical landmark is important for determining the spread of mandibular infections?",
      options: [
        "Hyoid bone",
        "Thyroid cartilage",
        "Mylohyoid muscle",
        "Sternocleidomastoid muscle",
      ],
      correct: "C"
    },
    {
      id: 11411,
      question: "Where are retropharyngeal lymph nodes located?",
      options: [
        "In front of the throat wall",
        "Behind the throat wall",
        "Under the chin",
        "Near the ear",
      ],
      correct: "B"
    },
    {
      id: 11412,
      question: "What type of infections primarily involve the retropharyngeal nodes?",
      options: [
        "Dental infections",
        "Throat infections",
        "Skin infections",
        "Eye infections",
      ],
      correct: "B"
    },
    {
      id: 11413,
      question: "Into which lymph node group do retropharyngeal nodes drain?",
      options: [
        "Submental nodes",
        "Lower deep cervical nodes",
        "Upper deep cervical nodes",
        "Submandibular nodes",
      ],
      correct: "C"
    },
    {
      id: 11414,
      question: "Where are submental lymph nodes located?",
      options: [
        "Behind the ear",
        "Beneath the chin",
        "Above the clavicle",
        "Near the angle of the mandible",
      ],
      correct: "B"
    },
    {
      id: 11415,
      question: "Which structures drain into the submental lymph nodes?",
      options: [
        "Maxillary molars",
        "Mandibular incisors and tip of tongue",
        "Parotid gland",
        "Maxillary sinus",
      ],
      correct: "B"
    },
    {
      id: 11416,
      question: "Where do submental nodes drain their lymph?",
      options: [
        "Directly into the bloodstream",
        "Into retropharyngeal nodes",
        "Into submandibular nodes or lower deep cervical nodes",
        "Into parotid nodes",
      ],
      correct: "C"
    },
    {
      id: 11417,
      question: "Where are submandibular lymph nodes located?",
      options: [
        "Under the chin",
        "Behind the ear",
        "Around the submandibular gland, near the angle of mandible",
        "In the floor of the mouth",
      ],
      correct: "C"
    },
    {
      id: 11418,
      question: "What is the medical term for enlargement and tenderness of submandibular nodes?",
      options: [
        "Lymphedema",
        "Lymphadenopathy",
        "Lymphangitis",
        "Lymphoma",
      ],
      correct: "B"
    },
    {
      id: 11419,
      question: "Which maxillary teeth drain into the submandibular nodes?",
      options: [
        "Only incisors",
        "All maxillary teeth except third molars",
        "Only molars",
        "Only canines",
      ],
      correct: "B"
    },
    {
      id: 11420,
      question: "Which mandibular teeth drain into submandibular lymph nodes?",
      options: [
        "All mandibular teeth",
        "Only anterior teeth",
        "All mandibular posterior teeth except third molars",
        "Only third molars",
      ],
      correct: "C"
    },
    {
      id: 11421,
      question: "Which of the following structures does NOT drain into submandibular nodes?",
      options: [
        "Floor of mouth",
        "Hard palate",
        "Soft palate",
        "Cheek area",
      ],
      correct: "C"
    },
    {
      id: 11422,
      question: "How many areas in the head and neck drain into submandibular nodes according to the document?",
      options: [
        "Five areas",
        "Seven areas",
        "Nine areas",
        "Eleven areas",
      ],
      correct: "C"
    },
    {
      id: 11423,
      question: "Where are upper deep cervical lymph nodes located?",
      options: [
        "Below the clavicle",
        "Under the chin",
        "On the lateral surface of internal jugular vein, beneath sternocleidomastoid muscle",
        "Behind the ear",
      ],
      correct: "C"
    },
    {
      id: 11424,
      question: "Approximately how far below the ear are upper deep cervical nodes located?",
      options: [
        "1 inch",
        "2 inches",
        "3 inches",
        "4 inches",
      ],
      correct: "B"
    },
    {
      id: 11425,
      question: "Which area does NOT drain into the upper deep cervical nodes?",
      options: [
        "Third molar region",
        "Base of tongue",
        "Tip of tongue",
        "Tonsillar area",
      ],
      correct: "C"
    },
    {
      id: 11426,
      question: "Which structures drain into upper deep cervical nodes?",
      options: [
        "Anterior teeth only",
        "Submandibular, retropharyngeal, and parotid nodes",
        "Only facial tissues",
        "Only the scalp",
      ],
      correct: "B"
    },
    {
      id: 11427,
      question: "Where are lower deep cervical lymph nodes located?",
      options: [
        "Above the ear",
        "Under the chin",
        "On lateral surface of internal jugular vein, beneath sternocleidomastoid muscle",
        "Behind the parotid gland",
      ],
      correct: "C"
    },
    {
      id: 11428,
      question: "How far above the clavicle are lower deep cervical nodes located?",
      options: [
        "1 inch",
        "2 inches",
        "3 inches",
        "4 inches",
      ],
      correct: "B"
    },
    {
      id: 11429,
      question: "Which node group drains into the lower deep cervical nodes?",
      options: [
        "Submental nodes only",
        "Upper deep cervical nodes",
        "Retropharyngeal nodes only",
        "Parotid nodes only",
      ],
      correct: "B"
    },
    {
      id: 11430,
      question: "Where do the lower deep cervical nodes ultimately drain?",
      options: [
        "Into the thoracic duct",
        "Into the junction of subclavian and internal jugular veins",
        "Directly into the heart",
        "Into the retropharyngeal space",
      ],
      correct: "B"
    },
    {
      id: 11431,
      question: "What are the three descriptive terms used for lymph node hierarchy in disease spread?",
      options: [
        "Superior, middle, inferior nodes",
        "Anterior, posterior, lateral nodes",
        "Primary, secondary, tertiary nodes",
        "Proximal, medial, distal nodes",
      ],
      correct: "C"
    },
    {
      id: 11432,
      question: "Why is understanding the node hierarchy important?",
      options: [
        "It determines blood type compatibility",
        "It affects the progression of infections and cancers",
        "It controls hormone production",
        "It regulates body temperature",
      ],
      correct: "B"
    },
    {
      id: 11433,
      question: "Can disease processes skip node groups in their progression?",
      options: [
        "No, they must pass through all groups sequentially",
        "Yes, disease can be stopped before reaching tertiary nodes",
        "Only in viral infections",
        "Only in bacterial infections",
      ],
      correct: "B"
    },
    {
      id: 11434,
      question: "What happens when infection or cancer reaches the lower deep cervical nodes and passes through them?",
      options: [
        "It stops spreading",
        "It returns to the primary site",
        "It enters the bloodstream and spreads throughout the body",
        "It becomes dormant",
      ],
      correct: "C"
    },
    {
      id: 11435,
      question: "What are fascial spaces?",
      options: [
        "Spaces within bones",
        "Spaces between fascia, located between muscle and tissue",
        "Spaces within lymph nodes",
        "Spaces in the bloodstream",
      ],
      correct: "B"
    },
    {
      id: 11436,
      question: "How common is the fascial space route of infection compared to lymphatic spread?",
      options: [
        "More common",
        "Equally common",
        "Less common",
        "Never occurs",
      ],
      correct: "C"
    },
    {
      id: 11437,
      question: "What clinical appearance is typical of fascial space infections?",
      options: [
        "Small red spots",
        "Dramatic swelling like a swollen jaw",
        "No visible changes",
        "Purple discoloration only",
      ],
      correct: "B"
    },
    {
      id: 11438,
      question: "Where do dental infections typically begin?",
      options: [
        "In the lymph nodes",
        "In the salivary glands",
        "At the apex of a tooth or in periodontal space",
        "In the fascial planes",
      ],
      correct: "C"
    },
    {
      id: 11439,
      question: "When a mandibular periodontal infection spreads lingually, where can it go?",
      options: [
        "Only to the vestibule",
        "Above mylohyoid muscle or beneath it",
        "Directly to the throat",
        "Into the maxillary sinus",
      ],
      correct: "B"
    },
    {
      id: 11440,
      question: "What is the most common outcome of buccal swelling from dental infection?",
      options: [
        "Spreads to the eye",
        "Breaks through mucosa and drains into oral cavity",
        "Enters the bloodstream immediately",
        "Forms a permanent abscess",
      ],
      correct: "B"
    },
    {
      id: 11441,
      question: "What is Ludwig's angina?",
      options: [
        "A type of heart condition",
        "A throat infection from streptococcus",
        "Cellulitis involving the sublingual space under the tongue",
        "An ear infection",
      ],
      correct: "C"
    },
    {
      id: 11442,
      question: "What commonly causes Ludwig's angina?",
      options: [
        "Viral throat infection",
        "Infection of tooth roots or mouth injury",
        "Allergic reaction",
        "Autoimmune disease",
      ],
      correct: "B"
    },
    {
      id: 11443,
      question: "Why is Ludwig's angina potentially life-threatening?",
      options: [
        "It causes severe pain only",
        "Tissue swelling can block the airway or prevent swallowing",
        "It spreads to the brain",
        "It causes permanent tooth loss",
      ],
      correct: "B"
    },
    {
      id: 11444,
      question: "Can Ludwig's angina be cured?",
      options: [
        "No, it is always fatal",
        "Yes, with proper airway protection and antibiotics",
        "Only with surgical removal of lymph nodes",
        "Only if caught within 24 hours",
      ],
      correct: "B"
    },
    {
      id: 11445,
      question: "If a sublingual space infection continues posteriorly beyond the mylohyoid muscle, where does it spread?",
      options: [
        "To the maxillary sinus",
        "To the lateral pharyngeal space",
        "To the parotid gland",
        "To the orbit of the eye",
      ],
      correct: "B"
    },
    {
      id: 11446,
      question: "If untreated, where does infection spread after reaching the lateral pharyngeal space?",
      options: [
        "To the ear canal",
        "To the retropharyngeal space, then posterior mediastinum",
        "To the frontal sinus",
        "To the brain",
      ],
      correct: "B"
    },
    {
      id: 11447,
      question: "What is the consequence if infection reaches the posterior mediastinum?",
      options: [
        "Mild discomfort only",
        "Chronic bad breath",
        "The person may die very quickly",
        "Temporary speech difficulty",
      ],
      correct: "C"
    },
    {
      id: 11448,
      question: "Which tooth infection is most likely to cause swelling below the eye?",
      options: [
        "Mandibular molar",
        "Maxillary canine",
        "Mandibular incisor",
        "Maxillary third molar",
      ],
      correct: "B"
    },
    {
      id: 11449,
      question: "Which tooth infection typically causes cheek swelling?",
      options: [
        "Mandibular incisor",
        "Maxillary incisor",
        "Maxillary posterior tooth",
        "Any mandibular tooth",
      ],
      correct: "C"
    },
    {
      id: 11450,
      question: "Where can maxillary tooth infections rarely spread?",
      options: [
        "To the ear",
        "To the nasal cavity or maxillary sinus",
        "To the lower jaw",
        "To the neck",
      ],
      correct: "B"
    },
    {
      id: 11451,
      question: "Where do most anterior and premolar mandibular tooth infections spread?",
      options: [
        "Below the mylohyoid muscle in submental space",
        "Above the mylohyoid muscle in sublingual space",
        "To the parotid space",
        "To the retropharyngeal space",
      ],
      correct: "B"
    },
    {
      id: 11452,
      question: "Where can some mandibular molar infections spread?",
      options: [
        "Above the mylohyoid muscle",
        "To the maxillary sinus",
        "Below the mylohyoid muscle in submental space",
        "To the orbit",
      ],
      correct: "C"
    },
    {
      id: 11453,
      question: "In the spread of infections, if an infection occurs near a primary node, how many chances are there to combat it?",
      options: [
        "One chance",
        "Two chances",
        "Three chances",
        "Four chances",
      ],
      correct: "C"
    },
    {
      id: 11454,
      question: "If an infection occurs near a tertiary node, how many chances are there to combat it?",
      options: [
        "One chance",
        "Two chances",
        "Three chances",
        "Four chances",
      ],
      correct: "A"
    },
    {
      id: 11455,
      question: "For an infection in the frontal lower lip, which node group is the primary barrier?",
      options: [
        "Upper deep cervical nodes",
        "Submandibular nodes",
        "Submental nodes",
        "Retropharyngeal nodes",
      ],
      correct: "C"
    },
    {
      id: 11456,
      question: "What is the secondary node group for a frontal lower lip infection?",
      options: [
        "Submental nodes",
        "Submandibular nodes",
        "Upper deep cervical nodes",
        "Lower deep cervical nodes",
      ],
      correct: "B"
    },
    {
      id: 11457,
      question: "What is the tertiary node group for frontal lower lip infection?",
      options: [
        "Submental nodes",
        "Submandibular nodes",
        "Upper deep cervical nodes",
        "Lower deep cervical nodes",
      ],
      correct: "C"
    },
    {
      id: 11458,
      question: "How do lymph node groups act in relation to cancer spread?",
      options: [
        "They accelerate cancer spread",
        "They have no effect on cancer",
        "They act as barriers and slow the spread",
        "They only affect viral infections",
      ],
      correct: "C"
    },
    {
      id: 11459,
      question: "Why does cancer on the tip of the tongue have a lower mortality rate than cancer on the back of the tongue?",
      options: [
        "It is easier to see and diagnose",
        "It must pass through more node groups before entering bloodstream",
        "It grows more slowly",
        "It responds better to treatment",
      ],
      correct: "B"
    },
    {
      id: 11460,
      question: "How many node groups must cancer on the tip of the tongue pass through before entering the bloodstream?",
      options: [
        "Two groups",
        "Three groups",
        "Four groups",
        "Five groups",
      ],
      correct: "C"
    },
    {
      id: 11461,
      question: "Which of the following is NOT mentioned as draining into submandibular nodes?",
      options: [
        "Maxillary sinus",
        "Most of the tongue",
        "Posterior nasal cavity",
        "Anterior nasal cavity",
      ],
      correct: "C"
    },
    {
      id: 11462,
      question: "What structure contains lymph vessels according to the document?",
      options: [
        "Tooth enamel",
        "Tooth pulp",
        "Cementum only",
        "Dentin only",
      ],
      correct: "B"
    },
    {
      id: 11463,
      question: "The lymphatic system collaborates with which other body areas beyond the head and neck?",
      options: [
        "Only the chest",
        "Only the abdomen",
        "Many other areas of the body",
        "Only the extremities",
      ],
      correct: "C"
    },
    {
      id: 11464,
      question: "Which lymphatic component includes the thymus, spleen, and Peyer's patches?",
      options: [
        "Local lymph nodes only",
        "The broader collaborative lymphatic system throughout the body",
        "The cervical lymph nodes exclusively",
        "The oral lymphatic ring",
      ],
      correct: "B"
    },
    {
      id: 11465,
      question: "What prevents lymph from flowing in the wrong direction within lymph nodes?",
      options: [
        "Muscle contractions",
        "Valves",
        "Blood pressure",
        "Gravity",
      ],
      correct: "B"
    },
    {
      id: 11466,
      question: "What cells are densely packed in lymph nodes to fight infection?",
      options: [
        "Red blood cells only",
        "Platelets",
        "B and T cells, macrophages, and plasma cells",
        "Neutrophils only",
      ],
      correct: "C"
    },
    {
      id: 11467,
      question: "How do lymph vessels enter and exit lymph nodes?",
      options: [
        "Lymph flows in through wide vessels and out through narrow vessels",
        "Lymph flows in through narrow vessels and out through wide vessels",
        "All vessels are the same size",
        "Lymph doesn't actually flow through nodes",
      ],
      correct: "B"
    },
    {
      id: 11468,
      question: "According to the document, what determines the pathway of fascial space infection spread?",
      options: [
        "The patient's age",
        "The location of the infection",
        "The time of day",
        "The type of bacteria",
      ],
      correct: "B"
    },
    {
      id: 11469,
      question: "What is the relationship between lymph nodes and the immune system?",
      options: [
        "Lymph nodes are separate from the immune system",
        "Lymph nodes are part of the immune system",
        "Lymph nodes suppress the immune system",
        "Lymph nodes replace the immune system",
      ],
      correct: "B"
    },
    {
      id: 11470,
      question: "Which space is involved in Ludwig's angina?",
      options: [
        "Buccal space",
        "Sublingual space",
        "Masseteric space",
        "Parotid space",
      ],
      correct: "B"
    },
    {
      id: 11471,
      question: "In dental infections, where does infection typically spread from the mandibular incisors?",
      options: [
        "To the buccal vestibule only",
        "To the submental nodes",
        "Directly to the throat",
        "To the maxillary sinus",
      ],
      correct: "B"
    },
    {
      id: 11472,
      question: "Which maxillary teeth are exceptions to the submandibular node drainage pattern?",
      options: [
        "Central incisors",
        "First molars",
        "Third molars",
        "Canines",
      ],
      correct: "C"
    },
    {
      id: 11473,
      question: "The document mentions that enlarged lymph nodes appear as what in clinical photographs?",
      options: [
        "Blue discoloration",
        "Black spots",
        "\"Swollen glands\" in the neck",
        "White patches",
      ],
      correct: "C"
    },
    {
      id: 11474,
      question: "What is lymphedema characterized by?",
      options: [
        "Increased blood flow to the area",
        "Localized swelling from blocked lymph vessels",
        "Decreased tissue temperature",
        "Rapid weight loss",
      ],
      correct: "B"
    },
    {
      id: 11475,
      question: "Which major lymphatic organs are part of the collaborative system?",
      options: [
        "Pancreas and gallbladder",
        "Tonsils, adenoids, thymus, spleen, appendix, Peyer's patches",
        "Kidneys and adrenal glands",
        "Liver and stomach",
      ],
      correct: "B"
    },
    {
      id: 11476,
      question: "What is the significance of the mylohyoid line in dental infections?",
      options: [
        "It has no clinical significance",
        "It determines whether infection spreads above or below the muscle",
        "It marks the location of salivary glands",
        "It indicates tooth eruption patterns",
      ],
      correct: "B"
    },
    {
      id: 11477,
      question: "When examining lymph nodes clinically, what indicates active infection?",
      options: [
        "Nodes are soft and mobile",
        "Nodes are tender and enlarged",
        "Nodes are undetectable",
        "Nodes are cold to touch",
      ],
      correct: "B"
    },
    {
      id: 11478,
      question: "Which fascial space is considered most dangerous for rapid infection spread?",
      options: [
        "Buccal space",
        "Sublingual space",
        "Retropharyngeal space",
        "Canine space",
      ],
      correct: "C"
    },
    {
      id: 11479,
      question: "What happens to lymph after it passes through the lower deep cervical nodes?",
      options: [
        "It is eliminated from the body",
        "It returns to tissues",
        "It enters the bloodstream via junction of subclavian and internal jugular veins",
        "It travels to the brain",
      ],
      correct: "C"
    },
    {
      id: 11480,
      question: "Where do most maxillary tooth infections initially spread?",
      options: [
        "To the palate only",
        "To the buccal vestibule or palate",
        "Directly to lymph nodes",
        "To the sinus only",
      ],
      correct: "B"
    },
    {
      id: 11481,
      question: "What is the primary route of cancer spread in oral malignancies?",
      options: [
        "Through blood vessels only",
        "Through fascial spaces",
        "Through lymphatic channels",
        "Through nerve pathways",
      ],
      correct: "C"
    },
    {
      id: 11482,
      question: "How does infection from mandibular first molar most commonly spread?",
      options: [
        "To submental space",
        "To submandibular nodes or fascial spaces",
        "Directly to bloodstream",
        "To maxillary sinus",
      ],
      correct: "B"
    },
    {
      id: 11483,
      question: "What clinical sign suggests that lymph nodes are functioning to combat infection?",
      options: [
        "They disappear",
        "They become enlarged and tender",
        "They turn blue",
        "They become mobile",
      ],
      correct: "B"
    },
    {
      id: 11484,
      question: "According to the document, the lymphatic system acts as which line of defense?",
      options: [
        "Primary line",
        "Secondary line",
        "Tertiary line",
        "Final line",
      ],
      correct: "B"
    },
    {
      id: 11485,
      question: "What type of fluid circulates in lymphatic vessels?",
      options: [
        "Blood plasma",
        "Cerebrospinal fluid",
        "Lymph",
        "Synovial fluid",
      ],
      correct: "C"
    },
    {
      id: 11486,
      question: "Where do infections from the base of the tongue typically drain?",
      options: [
        "To submental nodes",
        "To submandibular nodes",
        "To upper deep cervical nodes",
        "Directly to bloodstream",
      ],
      correct: "C"
    },
    {
      id: 11487,
      question: "What is the clinical importance of understanding fascial space anatomy?",
      options: [
        "It has no importance",
        "It predicts the pathway and spread of dental infections",
        "It only matters for orthodontics",
        "It determines tooth color",
      ],
      correct: "B"
    },
    {
      id: 11488,
      question: "Which mandibular teeth are exceptions to submandibular node drainage?",
      options: [
        "Incisors",
        "First molars",
        "Third molars",
        "Second premolars",
      ],
      correct: "C"
    },
    {
      id: 11489,
      question: "What happens when the lymphatic system is functioning properly?",
      options: [
        "Lymph is stored permanently in nodes",
        "Lymph is eventually returned to the bloodstream",
        "Lymph is excreted through sweat",
        "Lymph remains in tissues",
      ],
      correct: "B"
    },
    {
      id: 11490,
      question: "The posterior mediastinum is located in which region?",
      options: [
        "Behind the heart and between the lungs",
        "In the abdomen",
        "In the neck",
        "Behind the eye",
      ],
      correct: "A"
    },
    {
      id: 11491,
      question: "Why is the retropharyngeal space referred to as the \"danger space\"?",
      options: [
        "It is difficult to examine",
        "Infections here can spread quickly to the mediastinum",
        "It contains major blood vessels",
        "It is prone to cancer only",
      ],
      correct: "B"
    },
    {
      id: 11492,
      question: "Which muscle serves as an anatomical boundary for infection spread in the mandible?",
      options: [
        "Masseter muscle",
        "Temporalis muscle",
        "Mylohyoid muscle",
        "Buccinator muscle",
      ],
      correct: "C"
    },
    {
      id: 11493,
      question: "What can help visualize the location of fascial spaces?",
      options: [
        "Blood tests",
        "Anatomical cross-sections showing muscle and tissue planes",
        "Urine analysis",
        "Genetic testing",
      ],
      correct: "B"
    },
    {
      id: 11494,
      question: "What is the clinical significance of knowing lymphatic drainage patterns for oral cancer?",
      options: [
        "It has no significance",
        "It helps predict metastatic spread and prognosis",
        "It only matters for benign tumors",
        "It determines tooth color",
      ],
      correct: "B"
    },
    {
      id: 11495,
      question: "In the extraoral evaluation, what structures should be examined?",
      options: [
        "Only the teeth",
        "Head and neck structures including lymph nodes",
        "Only the eyes",
        "Only the ears",
      ],
      correct: "B"
    },
    {
      id: 11496,
      question: "Comprehensive study of this material should help you understand what?",
      options: [
        "Only basic anatomy",
        "Only infection patterns",
        "All content about lymphatics and spread of dental infections",
        "Only surgical procedures",
      ],
      correct: "C"
    },
    {
      id: 11497,
      question: "What determines whether a mandibular anterior tooth infection spreads above or below the mylohyoid muscle?",
      options: [
        "The age of the patient",
        "The position of the root apex relative to the mylohyoid line",
        "The time of day",
        "The patient's diet",
      ],
      correct: "B"
    },
    {
      id: 11498,
      question: "Which best describes the collaborative nature of the lymphatic system?",
      options: [
        "It works independently of other body systems",
        "It only involves the head and neck",
        "It involves many organs throughout the entire body",
        "It only functions during infections",
      ],
      correct: "C"
    },
    {
      id: 11499,
      question: "What is the recommended treatment for lymphedema?",
      options: [
        "Antibiotics only",
        "Surgery is the only option",
        "Compression devices and management techniques",
        "No treatment is available",
      ],
      correct: "C"
    },
    {
      id: 11500,
      question: "Which organ in the lymphatic system filters blood?",
      options: [
        "Liver",
        "Kidneys",
        "Spleen",
        "Pancreas",
      ],
      correct: "C"
    },
    {
      id: 11501,
      question: "Where is bone marrow located as part of the lymphatic system?",
      options: [
        "Only in the skull",
        "In long bones as part of the lymphatic network",
        "Only in the ribs",
        "Bone marrow is not part of the lymphatic system",
      ],
      correct: "B"
    },
    {
      id: 11502,
      question: "What happens to extracellular fluid in normal lymphatic circulation?",
      options: [
        "It remains in tissues permanently",
        "It is absorbed by bones",
        "It is picked up by lymphatic vessels, passed through nodes, returned to bloodstream",
        "It evaporates through skin",
      ],
      correct: "C"
    },
    {
      id: 11503,
      question: "How frequently does fluid exchange between capillaries and tissues occur?",
      options: [
        "Once per day",
        "Only during exercise",
        "Constantly repeating throughout life",
        "Only during sleep",
      ],
      correct: "C"
    },
    {
      id: 11504,
      question: "What can clinical palpation of submandibular nodes reveal?",
      options: [
        "Blood sugar levels",
        "Infection presence through tenderness and enlargement",
        "Vitamin deficiency",
        "Hormone levels",
      ],
      correct: "B"
    },
    {
      id: 11505,
      question: "The rapid tissue swelling that can block the airway is characteristic of which infection?",
      options: [
        "Cellulitis of the arm",
        "Pharyngitis",
        "Ludwig's angina",
        "Tonsillitis",
      ],
      correct: "C"
    },
    {
      id: 11506,
      question: "Which tissue space becomes involved when mandibular molar infections spread below the mylohyoid muscle?",
      options: [
        "Buccal space",
        "Temporal space",
        "Submental space",
        "Pterygoid space",
      ],
      correct: "C"
    },
    {
      id: 11507,
      question: "What is the typical progression pathway for a dental infection starting at the tooth apex?",
      options: [
        "Directly to the brain",
        "Through bone to lymph nodes or fascial spaces",
        "Only to adjacent teeth",
        "Through blood vessels immediately",
      ],
      correct: "B"
    },
    {
      id: 11508,
      question: "Which is true about oral cancer spread through lymph nodes?",
      options: [
        "Cancers bypass lymph nodes completely",
        "Each lymph node group acts as a barrier",
        "Lymph nodes accelerate cancer spread",
        "Lymph nodes have no effect on cancer",
      ],
      correct: "B"
    },
    {
      id: 11509,
      question: "Where are the tonsils and adenoids in relation to the lymphatic system?",
      options: [
        "They are not part of the lymphatic system",
        "In the oral cavity and nasopharynx as part of lymphatic defense",
        "Only in the chest",
        "In the abdomen",
      ],
      correct: "B"
    },
    {
      id: 11510,
      question: "If an infection breaks through the buccal mucosa in the vestibule, what is the most likely outcome?",
      options: [
        "It spreads to the brain",
        "It drains into the oral cavity",
        "It immediately enters the bloodstream",
        "It becomes permanently walled off",
      ],
      correct: "B"
    },
    {
      id: 11511,
      question: "What prevents lymph from flowing backward in the lymphatic system?",
      options: [
        "Muscle contractions only",
        "Valves in the lymphatic vessels",
        "Blood pressure",
        "Gravity alone",
      ],
      correct: "B"
    },
    {
      id: 11512,
      question: "What type of cells accumulate in lymph nodes to fight infection?",
      options: [
        "Only red blood cells",
        "Only platelets",
        "B and T lymphocytes, macrophages, and plasma cells",
        "Only neutrophils",
      ],
      correct: "C"
    },
    {
      id: 11513,
      question: "According to the document, comprehensive study should enable you to do what?",
      options: [
        "Perform surgery",
        "Prescribe medications",
        "Understand all content about lymphatics and dental infection spread",
        "Diagnose all diseases",
      ],
      correct: "C"
    },
    {
      id: 11514,
      question: "Which anatomical structure is NOT mentioned as draining to submandibular nodes?",
      options: [
        "Cheek area",
        "Hard palate",
        "Soft palate",
        "Floor of mouth",
      ],
      correct: "C"
    },
    {
      id: 11515,
      question: "What is the first group of lymph nodes that cervical infections typically encounter?",
      options: [
        "Primary nodes in the affected drainage area",
        "Secondary nodes",
        "Tertiary nodes",
        "Lower deep cervical nodes",
      ],
      correct: "A"
    },
    {
      id: 11516,
      question: "When does lymph fluid officially become \"lymph\"?",
      options: [
        "When it leaves the capillaries",
        "When it enters tissue spaces",
        "When it is in the lymphatic system",
        "When it reaches lymph nodes",
      ],
      correct: "C"
    },
    {
      id: 11517,
      question: "What is the process called when tissue fluid is picked up by lymphatic vessels?",
      options: [
        "Filtration",
        "Osmosis",
        "Lymphatic drainage",
        "Diffusion",
      ],
      correct: "C"
    },
    {
      id: 11518,
      question: "Which structure marks approximately 2 inches below the ear for upper deep cervical nodes?",
      options: [
        "Hyoid bone",
        "Sternocleidomastoid muscle border",
        "Thyroid cartilage",
        "Clavicle",
      ],
      correct: "B"
    },
    {
      id: 11519,
      question: "What happens if Ludwig's angina is left untreated?",
      options: [
        "It resolves spontaneously",
        "It causes minor discomfort",
        "It can block the airway leading to death",
        "It only affects speech",
      ],
      correct: "C"
    },
    {
      id: 11520,
      question: "The junction of subclavian and internal jugular veins is the final drainage point for which nodes?",
      options: [
        "Submental nodes",
        "Submandibular nodes",
        "Upper deep cervical nodes",
        "Lower deep cervical nodes",
      ],
      correct: "D"
    },
    {
      id: 11521,
      question: "Which infection route is less common but more dramatic clinically?",
      options: [
        "Lymphatic channel spread",
        "Blood vessel spread",
        "Fascial space spread",
        "Neural pathway spread",
      ],
      correct: "C"
    },
    {
      id: 11522,
      question: "How many areas drain into the submandibular nodes?",
      options: [
        "Three",
        "Five",
        "Nine",
        "Twelve",
      ],
      correct: "C"
    },
    {
      id: 11523,
      question: "What component of blood plasma flows out of capillaries to become extracellular fluid?",
      options: [
        "Red blood cells",
        "White blood cells",
        "Filtrate",
        "Platelets",
      ],
      correct: "C"
    },
    {
      id: 11524,
      question: "Which nodes are located approximately 2 inches above the clavicle?",
      options: [
        "Submental nodes",
        "Submandibular nodes",
        "Upper deep cervical nodes",
        "Lower deep cervical nodes",
      ],
      correct: "D"
    },
    {
      id: 11525,
      question: "What is the consequence of infection reaching the lower deep cervical nodes and passing through?",
      options: [
        "The infection stops",
        "The infection reverses",
        "Entry into the bloodstream occurs",
        "The infection becomes dormant",
      ],
      correct: "C"
    },
    {
      id: 11526,
      question: "According to the document, which provides the most barriers against tongue tip cancer?",
      options: [
        "Immediate entry to bloodstream",
        "Two node groups",
        "Three node groups",
        "Four node groups",
      ],
      correct: "D"
    },
    {
      id: 11527,
      question: "What part of the tooth contains lymph vessels?",
      options: [
        "Enamel",
        "Pulp",
        "Dentin",
        "Cementum",
      ],
      correct: "B"
    },
    {
      id: 11528,
      question: "Where would you palpate to examine submandibular lymph nodes?",
      options: [
        "Under the chin",
        "Behind the ear",
        "Near the angle of mandible",
        "Above the clavicle",
      ],
      correct: "C"
    },
    {
      id: 11529,
      question: "Which maxillary teeth do NOT typically drain to submandibular nodes?",
      options: [
        "Incisors",
        "Canines",
        "Third molars",
        "First molars",
      ],
      correct: "C"
    },
    {
      id: 11530,
      question: "What is the significance of identifying which lymph nodes are enlarged during examination?",
      options: [
        "No clinical significance",
        "Helps locate the source of infection",
        "Only important for cancer",
        "Only matters in children",
      ],
      correct: "B"
    },
    {
      id: 11531,
      question: "The retropharyngeal space can lead infection to which dangerous area?",
      options: [
        "The brain",
        "The eye",
        "The posterior mediastinum",
        "The ear",
      ],
      correct: "C"
    },
    {
      id: 11532,
      question: "Which best describes the function of the mylohyoid muscle in infection spread?",
      options: [
        "It has no role",
        "It acts as an anatomical divider determining spread direction",
        "It prevents all infection spread",
        "It only affects maxillary teeth",
      ],
      correct: "B"
    },
    {
      id: 11533,
      question: "What does the document indicate about comprehensively studying these questions?",
      options: [
        "It covers only basic concepts",
        "It covers only advanced topics",
        "It covers all document content on lymphatics and dental infection spread",
        "It covers only surgical techniques",
      ],
      correct: "C"
    },
  ],
  "4. Lymphatics (Part 2)": [
    {
      id: 11900,
      question: "What role does the lymphatic system play in the body\'s immune response?",
      options: [
        "It serves as the first line of defense against pathogens",
        "It functions as the second line of defense in immunity",
        "It provides the third line of defense through antibody production",
        "It creates physical barriers to prevent infection entry"
      ],
      correct: "B"
    },
    {
      id: 11901,
      question: "The lymphatic system functions primarily by performing which action?",
      options: [
        "Producing red blood cells for oxygen transport",
        "Filtering toxins through the liver and kidneys",
        "Returning extracellular fluids from tissues to the bloodstream",
        "Regulating body temperature through sweat production"
      ],
      correct: "C"
    },
    {
      id: 11902,
      question: "What is the fluid called when it circulates within the lymphatic system?",
      options: [
        "Plasma",
        "Serum",
        "Interstitial fluid",
        "Lymph"
      ],
      correct: "D"
    },
    {
      id: 11903,
      question: "Extracellular fluid originates from which source?",
      options: [
        "Direct secretion from lymph nodes into surrounding tissues",
        "Filtrate of blood plasma that flows from capillaries into tissues",
        "Fluid produced by the spleen and distributed systemically",
        "Cerebrospinal fluid that leaks into peripheral tissues"
      ],
      correct: "B"
    },
    {
      id: 11904,
      question: "What medical condition results when lymph vessels become blocked or unable to carry fluid away from tissues?",
      options: [
        "Thrombophlebitis",
        "Lymphedema",
        "Cellulitis",
        "Angioedema"
      ],
      correct: "B"
    },
    {
      id: 11905,
      question: "Lymph nodes contain which type of cells that combat infections?",
      options: [
        "Erythrocytes",
        "Thrombocytes",
        "Lymphocytes",
        "Hepatocytes"
      ],
      correct: "C"
    },
    {
      id: 11906,
      question: "Which tissues in the oral cavity contain lymph vessels?",
      options: [
        "Only the gingival tissues and oral mucosa",
        "The tooth enamel and dentin structures",
        "Most tissues, including the dental pulp",
        "Exclusively the periodontal ligament fibers"
      ],
      correct: "C"
    },
    {
      id: 11907,
      question: "The submandibular lymph nodes are located near which anatomical landmark?",
      options: [
        "Behind the pharyngeal wall",
        "Beneath the chin in the midline",
        "Around the submandibular gland near the mandibular angle",
        "Along the lateral surface of the sternocleidomastoid muscle"
      ],
      correct: "C"
    },
    {
      id: 11908,
      question: "What is the medical term for enlargement and tenderness of submandibular nodes?",
      options: [
        "Lymphangitis",
        "Lymphadenopathy",
        "Lymphocytosis",
        "Lymphangioma"
      ],
      correct: "B"
    },
    {
      id: 11909,
      question: "Which teeth drain into the submental lymph nodes?",
      options: [
        "All maxillary teeth except third molars",
        "Mandibular incisors and tip of tongue",
        "Mandibular molars and premolars exclusively",
        "Maxillary canines and lateral incisors"
      ],
      correct: "B"
    },
    {
      id: 11910,
      question: "The submandibular nodes receive drainage from which maxillary teeth?",
      options: [
        "Only the maxillary incisors and canines",
        "All maxillary teeth except the third molars",
        "Exclusively the maxillary molars and premolars",
        "The maxillary third molars only"
      ],
      correct: "B"
    },
    {
      id: 11911,
      question: "Which structures drain into the upper deep cervical nodes?",
      options: [
        "Mandibular incisors and anterior tongue",
        "Third molar region, tongue base, tonsils, and soft palate",
        "Maxillary incisors and hard palate exclusively",
        "Buccal mucosa and anterior floor of mouth"
      ],
      correct: "B"
    },
    {
      id: 11912,
      question: "Where are the upper deep cervical nodes located?",
      options: [
        "Beneath the chin between the anterior digastric muscles",
        "Behind the posterior pharyngeal wall",
        "On the lateral surface of internal jugular vein beneath sternocleidomastoid",
        "Along the anterior border of the trapezius muscle"
      ],
      correct: "C"
    },
    {
      id: 11913,
      question: "The lower deep cervical nodes are positioned approximately how far above the clavicle?",
      options: [
        "One inch",
        "Two inches",
        "Four inches",
        "Six inches"
      ],
      correct: "B"
    },
    {
      id: 11914,
      question: "Into what structure do the lower deep cervical nodes ultimately drain?",
      options: [
        "The thoracic duct exclusively",
        "The superior vena cava directly",
        "The junction of subclavian and internal jugular veins",
        "The axillary lymph node chain"
      ],
      correct: "C"
    },
    {
      id: 11915,
      question: "What critical event occurs when infection reaches the lower deep cervical nodes and passes through them?",
      options: [
        "The infection becomes localized and contained",
        "It spreads to the contralateral lymph nodes",
        "It enters the bloodstream and moves to the heart",
        "It triggers immediate systemic antibody production"
      ],
      correct: "C"
    },
    {
      id: 11916,
      question: "In the context of lymph node drainage, what does \"primary nodes\" refer to?",
      options: [
        "The largest lymph nodes in the chain",
        "The first group of nodes to receive drainage from an area",
        "Nodes that only drain lymphatic fluid, not infections",
        "The nodes closest to the heart"
      ],
      correct: "B"
    },
    {
      id: 11917,
      question: "Why does cancer on the tip of the tongue have a lower mortality rate than cancer on the back of the tongue?",
      options: [
        "Tip cancers grow more slowly than base cancers",
        "The tongue tip has fewer blood vessels for metastasis",
        "Tip cancer must pass through four node groups before entering bloodstream",
        "Back of tongue cancers are always more aggressive histologically"
      ],
      correct: "C"
    },
    {
      id: 11918,
      question: "What are fascial spaces in relation to dental infections?",
      options: [
        "Spaces between teeth where food becomes trapped",
        "Hollow chambers within the maxillary and mandibular bones",
        "Spaces between fascial layers of muscle and tissue",
        "The pulp chambers of infected teeth"
      ],
      correct: "C"
    },
    {
      id: 11919,
      question: "Where do most dental infections typically originate?",
      options: [
        "In the gingival sulcus from plaque accumulation",
        "At the apex of a tooth or in the periodontal space",
        "Within the maxillary sinus from chronic sinusitis",
        "In the temporomandibular joint from trauma"
      ],
      correct: "B"
    },
    {
      id: 11920,
      question: "When a periodontal space infection occurs, where does swelling typically appear?",
      options: [
        "Always in the submandibular space beneath the jaw",
        "Exclusively in the retropharyngeal space",
        "Either buccally or lingually depending on location",
        "Only in the maxillary sinus region"
      ],
      correct: "C"
    },
    {
      id: 11921,
      question: "What is the most common outcome for buccal swelling from dental infection?",
      options: [
        "It spreads systemically through the bloodstream",
        "It drains into the oral cavity through the mucosa",
        "It becomes encapsulated and requires surgical removal",
        "It resolves spontaneously without intervention"
      ],
      correct: "B"
    },
    {
      id: 11922,
      question: "The mylohyoid muscle is an important anatomical landmark because it determines what?",
      options: [
        "Whether infection spreads above or below it in the mandible",
        "The maximum size an abscess can reach",
        "Which teeth are more susceptible to infection",
        "The rate at which infection spreads through bone"
      ],
      correct: "A"
    },
    {
      id: 11923,
      question: "Mandibular anterior teeth and premolar infections typically spread to which space?",
      options: [
        "Submental space below the mylohyoid muscle",
        "Sublingual space above the mylohyoid muscle",
        "Lateral pharyngeal space posterior to mandible",
        "Buccal space lateral to the masseter muscle"
      ],
      correct: "B"
    },
    {
      id: 11924,
      question: "Some mandibular molar infections can spread below the mylohyoid muscle into which space?",
      options: [
        "Submandibular space",
        "Masseteric space",
        "Submental space",
        "Pterygomandibular space"
      ],
      correct: "C"
    },
    {
      id: 11925,
      question: "Where do maxillary tooth infections usually spread first?",
      options: [
        "Directly to cervical lymph nodes",
        "To the buccal vestibule or palate",
        "Into the lateral pharyngeal space",
        "Through the floor of the orbit"
      ],
      correct: "B"
    },
    {
      id: 11926,
      question: "Ludwig\'s angina is a type of cellulitis that involves which anatomical space?",
      options: [
        "The retropharyngeal space",
        "The masseteric space",
        "The sublingual space under the tongue",
        "The parotid space"
      ],
      correct: "C"
    },
    {
      id: 11927,
      question: "What is the most serious concern with Ludwig\'s angina?",
      options: [
        "Permanent damage to the tongue muscles",
        "Blockage of the airway or inability to swallow",
        "Spread to the brain through venous channels",
        "Destruction of the mandibular bone"
      ],
      correct: "B"
    },
    {
      id: 11928,
      question: "If a sublingual infection continues posteriorly past the mylohyoid muscle, which space will it reach?",
      options: [
        "The retropharyngeal space",
        "The carotid sheath",
        "The lateral pharyngeal space",
        "The danger space"
      ],
      correct: "C"
    },
    {
      id: 11929,
      question: "If an infection spreads from the lateral pharyngeal space to the retropharyngeal space and then to the posterior mediastinum, what is the likely outcome?",
      options: [
        "The infection will be contained by mediastinal fascia",
        "It will drain externally through the chest wall",
        "The person may die very quickly",
        "Antibiotics will easily resolve the infection"
      ],
      correct: "C"
    },
    {
      id: 11930,
      question: "Swelling in the cheek area is usually related to infection of which teeth?",
      options: [
        "Maxillary anterior teeth",
        "Mandibular incisors",
        "Maxillary posterior teeth",
        "Mandibular canines"
      ],
      correct: "C"
    },
    {
      id: 11931,
      question: "Swelling below the eye is characteristically associated with infection of which tooth?",
      options: [
        "Maxillary first premolar",
        "Maxillary canine",
        "Maxillary central incisor",
        "Maxillary first molar"
      ],
      correct: "B"
    },
    {
      id: 11932,
      question: "The retropharyngeal lymph nodes are primarily involved in what type of infection?",
      options: [
        "Dental infections from mandibular molars",
        "Infections of the external ear",
        "Throat infections",
        "Scalp and facial skin infections"
      ],
      correct: "C"
    },
    {
      id: 11933,
      question: "Where do the retropharyngeal nodes drain?",
      options: [
        "Directly into the thoracic duct",
        "Into the submental nodes",
        "To the upper deep cervical lymph nodes",
        "Into the submandibular nodes first"
      ],
      correct: "C"
    },
    {
      id: 11934,
      question: "Which of the following areas does NOT drain into the submandibular lymph nodes?",
      options: [
        "Maxillary sinus",
        "Floor of mouth",
        "Posterior nasal cavity",
        "Hard palate"
      ],
      correct: "C"
    },
    {
      id: 11935,
      question: "How many groups of lymph nodes must an infection from the frontal lower lip pass through in sequence?",
      options: [
        "Two groups: submental then upper deep cervical",
        "Three groups: submental, submandibular, then upper deep cervical",
        "Four groups including the lower deep cervical nodes",
        "Five groups before reaching the bloodstream"
      ],
      correct: "B"
    },
    {
      id: 11936,
      question: "The lymphatic system can be described as having what type of structural organization?",
      options: [
        "A series of isolated nodes with no interconnections",
        "Random distribution with unpredictable drainage patterns",
        "Tiny channels connecting nodular structures called lymph nodes",
        "Large vessels similar in structure to major arteries"
      ],
      correct: "C"
    },
    {
      id: 11937,
      question: "Why is the distribution pattern of lymph vessels useful as a diagnostic tool?",
      options: [
        "It helps identify vitamin deficiencies in patients",
        "It aids in studying oral infections and slowing cancer spread",
        "It determines tooth eruption patterns in children",
        "It predicts the likelihood of dental caries formation"
      ],
      correct: "B"
    },
    {
      id: 11938,
      question: "What happens to lymph when the lymphatic system functions properly?",
      options: [
        "It accumulates in tissues causing permanent swelling",
        "It is filtered through the kidneys and excreted",
        "It is eventually returned to the bloodstream",
        "It is stored in lymph nodes indefinitely"
      ],
      correct: "C"
    },
    {
      id: 11939,
      question: "Lymph nodes grouped into clusters perform what function?",
      options: [
        "Each group drains fluid from certain structures or tissue areas",
        "They all drain the same anatomical regions redundantly",
        "They produce hormones for tissue growth",
        "They store excess nutrients for cellular metabolism"
      ],
      correct: "A"
    },
    {
      id: 11940,
      question: "What clinical sign would indicate that lymph nodes are responding to infection?",
      options: [
        "The nodes become smaller and harder",
        "The nodes become tender and enlarged",
        "The nodes become mobile and painless",
        "The nodes disappear completely"
      ],
      correct: "B"
    },
    {
      id: 11941,
      question: "Which body structure is also part of the lymphatic system beyond the head and neck?",
      options: [
        "The liver and gallbladder",
        "Tonsils, thymus, spleen, and bone marrow",
        "The kidneys and adrenal glands",
        "The pancreas and small intestine"
      ],
      correct: "B"
    },
    {
      id: 11942,
      question: "The concept of primary, secondary, and tertiary nodes is important for understanding what?",
      options: [
        "The size classification of lymph nodes",
        "The age at which lymph nodes develop",
        "How infections and cancers spread through lymphatic channels",
        "Which nodes produce the most lymphocytes"
      ],
      correct: "C"
    },
    {
      id: 11943,
      question: "Each barrier of lymph nodes in a drainage sequence does what to cancer spread?",
      options: [
        "Completely blocks any further spread permanently",
        "Slows the spread of cancer progression",
        "Accelerates metastasis to distant sites",
        "Has no effect on cancer cell movement"
      ],
      correct: "B"
    },
    {
      id: 11944,
      question: "Why don\'t disease processes always have to pass through all node groups?",
      options: [
        "Some infections are too weak to continue spreading",
        "The immune system destroys all pathogens at the first node",
        "Disease can be stopped before reaching tertiary nodes",
        "Only bacterial infections follow the node pathway"
      ],
      correct: "C"
    },
    {
      id: 11945,
      question: "What describes the pathway of most common buccal vestibule infections?",
      options: [
        "They spread deep into fascial spaces requiring surgery",
        "The infection comes to a head and breaks through the mucosa",
        "They always require systemic antibiotics to resolve",
        "They spread to the brain through venous channels"
      ],
      correct: "B"
    }
  
  ],
  "5. Cranial Nerves (Part 1)": [    {
      id: 11600,
      question: "What is a neuron responsible for?",
      options: [
        "Transmitting messages or impulses",
        "Storing energy in muscles",
        "Producing hormones",
        "Filtering blood",
      ],
      correct: "A"
    },
    {
      id: 11601,
      question: "What is a sensory (afferent) neuron?",
      options: [
        "Carries messages from brain to body parts",
        "Carries messages from outer parts of body towards the brain",
        "Stores messages for later use",
        "Destroys harmful messages",
      ],
      correct: "B"
    },
    {
      id: 11602,
      question: "What is a motor (efferent) neuron?",
      options: [
        "Carries messages from body to brain",
        "Stops all nerve transmission",
        "Carries messages from brain towards parts of the body",
        "Only functions during sleep",
      ],
      correct: "C"
    },
    {
      id: 11603,
      question: "In which direction do neurons transmit messages?",
      options: [
        "In both directions simultaneously",
        "In random directions",
        "In circular patterns",
        "In only one direction",
      ],
      correct: "D"
    },
    {
      id: 11604,
      question: "What does the Central Nervous System (CNS) consist of?",
      options: [
        "Brain and spinal column",
        "Only the spinal column",
        "Peripheral nerves only",
        "Only the brain",
      ],
      correct: "A"
    },
    {
      id: 11605,
      question: "What makes up the Peripheral Nervous System (PNS)?",
      options: [
        "Only cranial nerves",
        "Nerves extending from brain and spinal cord, and the ANS",
        "Brain and spinal cord only",
        "Only the autonomic nervous system",
      ],
      correct: "B"
    },
    {
      id: 11606,
      question: "What is a reflex arc?",
      options: [
        "A long pathway through the entire nervous system",
        "A muscle contraction",
        "A shortcut in the CNS that bypasses the brain",
        "A sensory organ",
      ],
      correct: "C"
    },
    {
      id: 11607,
      question: "Where are the cranial nerves located?",
      options: [
        "Only in the brain stem",
        "In the spinal cord",
        "In the autonomic nervous system",
        "In the peripheral nervous system",
      ],
      correct: "D"
    },
    {
      id: 11608,
      question: "What is the function of a reflex arc in relation to pain?",
      options: [
        "Reflex action occurs before pain is interpreted by the brain",
        "It delays the response to pain",
        "It makes pain more intense",
        "It prevents all pain sensation",
      ],
      correct: "A"
    },
    {
      id: 11609,
      question: "In the pain response pathway, what happens at step 2?",
      options: [
        "Message travels down spinal cord",
        "Pain receptor nerve ending senses pain and carries message to spinal cord",
        "Brain recognizes pain",
        "Muscle pulls finger away",
      ],
      correct: "B"
    },
    {
      id: 11610,
      question: "The Somatic Nervous System is part of which major nervous system division?",
      options: [
        "Autonomic Nervous System only",
        "Central Nervous System",
        "Peripheral Nervous System",
        "Reflex Nervous System",
      ],
      correct: "C"
    },
    {
      id: 11611,
      question: "What does the Somatic Nervous System control?",
      options: [
        "Only glands",
        "Only internal organs",
        "Only heart rate",
        "Skeletal muscles and sends sensory information to CNS",
      ],
      correct: "D"
    },
    {
      id: 11612,
      question: "The Autonomic Nervous System controls which type of muscle?",
      options: [
        "Smooth muscle and glands",
        "Skeletal muscle only",
        "Voluntary muscles only",
        "Cardiac muscle only",
      ],
      correct: "A"
    },
    {
      id: 11613,
      question: "What are the three divisions of the Autonomic Nervous System?",
      options: [
        "Motor, sensory, and mixed",
        "Sympathetic, parasympathetic, and enteric",
        "Cranial, spinal, and peripheral",
        "Somatic, reflex, and central",
      ],
      correct: "B"
    },
    {
      id: 11614,
      question: "How many pairs of cranial nerves are there?",
      options: [
        "10 pairs",
        "11 pairs",
        "12 pairs",
        "13 pairs",
      ],
      correct: "C"
    },
    {
      id: 11615,
      question: "Where do cranial nerves attach?",
      options: [
        "To peripheral nerves",
        "To the spinal cord only",
        "To muscles only",
        "Directly to the brain",
      ],
      correct: "D"
    },
    {
      id: 11616,
      question: "What numbering system is used for cranial nerves?",
      options: [
        "Roman numerals",
        "Arabic numerals",
        "Alphabetical letters",
        "Greek letters",
      ],
      correct: "A"
    },
    {
      id: 11617,
      question: "Which mnemonic can help remember the cranial nerves?",
      options: [
        "\"All Good Children Do Fine\"",
        "\"On Old Olympus' Towering Top, A Friendly Viking Grew Vines And Hops\"",
        "\"Never Eat Soggy Waffles\"",
        "\"King Philip Came Over For Good Soup\"",
      ],
      correct: "B"
    },
    {
      id: 11618,
      question: "What is the function of Cranial Nerve I (Olfactory)?",
      options: [
        "Vision",
        "Hearing",
        "Sense of smell",
        "Taste",
      ],
      correct: "C"
    },
    {
      id: 11619,
      question: "What type of nerve is the Olfactory Nerve (I)?",
      options: [
        "Neither motor nor sensory",
        "Motor only",
        "Both motor and sensory",
        "Sensory only",
      ],
      correct: "D"
    },
    {
      id: 11620,
      question: "What happens if the Olfactory Nerve is damaged?",
      options: [
        "Impaired sense of smell",
        "Loss of hearing",
        "Paralysis of facial muscles",
        "Loss of vision",
      ],
      correct: "A"
    },
    {
      id: 11621,
      question: "What is the function of Cranial Nerve II (Optic)?",
      options: [
        "Smell",
        "Provides vision",
        "Hearing",
        "Eye movement",
      ],
      correct: "B"
    },
    {
      id: 11622,
      question: "What type of nerve is the Optic Nerve (II)?",
      options: [
        "Autonomic only",
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
      ],
      correct: "C"
    },
    {
      id: 11623,
      question: "Damage to the Optic Nerve causes what?",
      options: [
        "Loss of smell",
        "Hearing loss",
        "Double vision",
        "Blindness in visual field",
      ],
      correct: "D"
    },
    {
      id: 11624,
      question: "What is the function of Cranial Nerve III (Oculomotor)?",
      options: [
        "Eye movement and pupil constriction",
        "Hearing",
        "Facial sensation",
        "Sense of smell",
      ],
      correct: "A"
    },
    {
      id: 11625,
      question: "What type of nerve is the Oculomotor Nerve (III)?",
      options: [
        "Autonomic only",
        "Motor only",
        "Mixed sensory and motor",
        "Sensory only",
      ],
      correct: "B"
    },
    {
      id: 11626,
      question: "Which muscles does the Oculomotor Nerve control?",
      options: [
        "All extraocular muscles",
        "Lateral rectus muscle only",
        "Superior, inferior, medial rectus muscles and inferior oblique muscle",
        "Superior oblique muscle only",
      ],
      correct: "C"
    },
    {
      id: 11627,
      question: "Damage to the Oculomotor Nerve causes which symptom?",
      options: [
        "Loss of taste",
        "Deafness",
        "Blindness",
        "Drooping eyelid, dilated pupil, double vision",
      ],
      correct: "D"
    },
    {
      id: 11628,
      question: "What is the function of Cranial Nerve IV (Trochlear)?",
      options: [
        "Eye movement via superior oblique muscle",
        "Pupil constriction",
        "Eyelid opening",
        "Vision",
      ],
      correct: "A"
    },
    {
      id: 11629,
      question: "What type of nerve is the Trochlear Nerve (IV)?",
      options: [
        "Autonomic only",
        "Motor only",
        "Both motor and sensory",
        "Sensory only",
      ],
      correct: "B"
    },
    {
      id: 11630,
      question: "Damage to the Trochlear Nerve causes what?",
      options: [
        "Complete eye paralysis",
        "Drooping eyelid",
        "Double vision and inability to rotate eye inferolaterally",
        "Blindness",
      ],
      correct: "C"
    },
    {
      id: 11631,
      question: "How many divisions does the Trigeminal Nerve (V) have?",
      options: [
        "5 divisions",
        "2 divisions",
        "4 divisions",
        "3 divisions",
      ],
      correct: "D"
    },
    {
      id: 11632,
      question: "What type of nerve is the Trigeminal Nerve (V)?",
      options: [
        "Both motor and sensory",
        "Motor only",
        "Autonomic only",
        "Sensory only",
      ],
      correct: "A"
    },
    {
      id: 11633,
      question: "Damage to the Trigeminal Nerve produces what?",
      options: [
        "Loss of smell",
        "Loss of sensation and impaired chewing",
        "Blindness",
        "Deafness",
      ],
      correct: "B"
    },
    {
      id: 11634,
      question: "Which branch of the Trigeminal Nerve is V1?",
      options: [
        "Facial branch",
        "Maxillary branch",
        "Ophthalmic branch",
        "Mandibular branch",
      ],
      correct: "C"
    },
    {
      id: 11635,
      question: "What does the Ophthalmic branch (V1) provide sensation from?",
      options: [
        "Lower jaw",
        "Teeth",
        "Tongue",
        "Nasal cavity, forehead, upper eyelid, eyebrow, nose",
      ],
      correct: "D"
    },
    {
      id: 11636,
      question: "Through which opening does the Ophthalmic branch (V1) enter the skull?",
      options: [
        "Superior orbital fissure",
        "Foramen rotundum",
        "Inferior orbital fissure",
        "Foramen ovale",
      ],
      correct: "A"
    },
    {
      id: 11637,
      question: "How many subdivisions does the Ophthalmic branch (V1) have?",
      options: [
        "5 subdivisions",
        "3 subdivisions",
        "2 subdivisions",
        "4 subdivisions",
      ],
      correct: "B"
    },
    {
      id: 11638,
      question: "What are the three branches of V1 (Ophthalmic)?",
      options: [
        "Superior, middle, inferior alveolar",
        "Mental, incisive, buccal",
        "Lacrimal, frontal, nasociliary",
        "Temporal, zygomatic, mandibular",
      ],
      correct: "C"
    },
    {
      id: 11639,
      question: "Which branch of the Trigeminal Nerve is V2?",
      options: [
        "Cervical branch",
        "Ophthalmic branch",
        "Mandibular branch",
        "Maxillary branch",
      ],
      correct: "D"
    },
    {
      id: 11640,
      question: "What does the Maxillary branch (V2) provide sensation from?",
      options: [
        "Lower eyelid, upper lips and gums, maxillary teeth, cheek, nose, palate",
        "Forehead and scalp",
        "Tongue only",
        "Lower teeth and jaw",
      ],
      correct: "A"
    },
    {
      id: 11641,
      question: "Through which opening does the Maxillary branch (V2) enter the skull?",
      options: [
        "Jugular foramen",
        "Foramen rotundum",
        "Superior orbital fissure",
        "Foramen ovale",
      ],
      correct: "B"
    },
    {
      id: 11642,
      question: "How many branches does the Maxillary division (V2) divide into?",
      options: [
        "3 branches",
        "4 branches",
        "6 branches",
        "8 branches",
      ],
      correct: "C"
    },
    {
      id: 11643,
      question: "Which is NOT a branch of the Maxillary division (V2)?",
      options: [
        "Zygomatic Nerve",
        "Infraorbital Nerve",
        "Posterior Superior Alveolar Nerve",
        "Lingual Nerve",
      ],
      correct: "D"
    },
    {
      id: 11644,
      question: "Which branch of the Trigeminal Nerve is V3?",
      options: [
        "Mandibular branch",
        "Facial branch",
        "Maxillary branch",
        "Ophthalmic branch",
      ],
      correct: "A"
    },
    {
      id: 11645,
      question: "What makes the Mandibular division (V3) unique?",
      options: [
        "It has no subdivisions",
        "It is both sensory and motor",
        "It is motor only",
        "It is sensory only",
      ],
      correct: "B"
    },
    {
      id: 11646,
      question: "Through which opening does the Mandibular branch (V3) enter the skull?",
      options: [
        "Foramen magnum",
        "Superior orbital fissure",
        "Foramen ovale",
        "Foramen rotundum",
      ],
      correct: "C"
    },
    {
      id: 11647,
      question: "How many main divisions does the Mandibular branch (V3) have?",
      options: [
        "3 divisions",
        "1 division",
        "4 divisions",
        "2 divisions - anterior and posterior",
      ],
      correct: "D"
    },
    {
      id: 11648,
      question: "Which nerve is part of the posterior division of V3?",
      options: [
        "Lingual nerve",
        "Frontal nerve",
        "Lacrimal nerve",
        "Zygomatic nerve",
      ],
      correct: "A"
    },
    {
      id: 11649,
      question: "What does the Mandibular division (V3) provide motor function to?",
      options: [
        "Neck muscles only",
        "Temporalis and masseter muscles (muscles of mastication)",
        "Eye muscles",
        "Facial expression muscles",
      ],
      correct: "B"
    },
    {
      id: 11650,
      question: "The Trigeminal Nerve provides sensory innervation from which structure?",
      options: [
        "Scalp only",
        "Eyes only",
        "All teeth",
        "Ears only",
      ],
      correct: "C"
    },
    {
      id: 11651,
      question: "What portion of the tongue receives sensation from the Trigeminal Nerve?",
      options: [
        "Base of tongue only",
        "Posterior third",
        "Entire tongue",
        "Anterior two-thirds",
      ],
      correct: "D"
    },
    {
      id: 11652,
      question: "Which nerve provides motor function to the tensor veli palatini?",
      options: [
        "Trigeminal nerve",
        "Glossopharyngeal nerve",
        "Vagus nerve",
        "Facial nerve",
      ],
      correct: "A"
    },
    {
      id: 11653,
      question: "What is the function of Cranial Nerve VI (Abducens)?",
      options: [
        "Provides vision",
        "Eye movement via lateral rectus muscle",
        "Opens eyelid",
        "Constricts pupil",
      ],
      correct: "B"
    },
    {
      id: 11654,
      question: "What type of nerve is the Abducens Nerve (VI)?",
      options: [
        "Both motor and sensory",
        "Sensory only",
        "Motor only",
        "Autonomic only",
      ],
      correct: "C"
    },
    {
      id: 11655,
      question: "Damage to the Abducens Nerve results in what?",
      options: [
        "Drooping eyelid",
        "Dilated pupil",
        "Blindness",
        "Inability to rotate eye laterally",
      ],
      correct: "D"
    },
    {
      id: 11656,
      question: "What is a major function of Cranial Nerve VII (Facial)?",
      options: [
        "Facial expressions",
        "Chewing",
        "Hearing",
        "Eye movement",
      ],
      correct: "A"
    },
    {
      id: 11657,
      question: "What type of nerve is the Facial Nerve (VII)?",
      options: [
        "Autonomic only",
        "Both motor and sensory",
        "Sensory only",
        "Motor only",
      ],
      correct: "B"
    },
    {
      id: 11658,
      question: "The Facial Nerve provides taste sensation to which part of the tongue?",
      options: [
        "Base of tongue",
        "Entire tongue",
        "Anterior two-thirds",
        "Posterior third",
      ],
      correct: "C"
    },
    {
      id: 11659,
      question: "What autonomic function does the Facial Nerve control?",
      options: [
        "Pupil size",
        "Bronchi diameter",
        "Heart rate only",
        "Salivary and lacrimal glands",
      ],
      correct: "D"
    },
    {
      id: 11660,
      question: "Damage to the Facial Nerve produces what?",
      options: [
        "Sagging facial muscles and disturbed taste (no sweet and salty)",
        "Deafness",
        "Inability to chew",
        "Blindness",
      ],
      correct: "A"
    },
    {
      id: 11661,
      question: "How does the Facial Nerve compare to the Trigeminal Nerve in terms of depth?",
      options: [
        "They don't overlap in location",
        "The Facial Nerve is more superficial",
        "They are at the same depth",
        "The Facial Nerve is deeper",
      ],
      correct: "B"
    },
    {
      id: 11662,
      question: "Which clinical test can assess Facial Nerve function?",
      options: [
        "Hearing test",
        "Smell test",
        "Asking patient to smile, whistle, frown, raise eyebrows",
        "Eye movement test",
      ],
      correct: "C"
    },
    {
      id: 11663,
      question: "What is the function of Cranial Nerve VIII (Vestibulocochlear)?",
      options: [
        "Eye movement",
        "Taste",
        "Facial expression",
        "Hearing and balance",
      ],
      correct: "D"
    },
    {
      id: 11664,
      question: "What type of nerve is the Vestibulocochlear Nerve (VIII)?",
      options: [
        "Sensory only",
        "Motor only",
        "Autonomic only",
        "Both motor and sensory",
      ],
      correct: "A"
    },
    {
      id: 11665,
      question: "Which branch of the Vestibulocochlear Nerve provides hearing?",
      options: [
        "Balance branch",
        "Cochlear branch",
        "Vestibular branch",
        "Auditory branch",
      ],
      correct: "B"
    },
    {
      id: 11666,
      question: "Damage to the Vestibulocochlear Nerve can cause what?",
      options: [
        "Facial paralysis",
        "Loss of taste",
        "Deafness, dizziness, nausea, loss of balance, nystagmus",
        "Blindness",
      ],
      correct: "C"
    },
    {
      id: 11667,
      question: "What is nystagmus?",
      options: [
        "Loss of balance",
        "Loss of hearing",
        "Paralyzed vocal cords",
        "Involuntary eye movement",
      ],
      correct: "D"
    },
    {
      id: 11668,
      question: "What is the function of Cranial Nerve IX (Glossopharyngeal)?",
      options: [
        "Swallowing, voice production, taste from posterior 1/3 of tongue",
        "Hearing",
        "Eye movement",
        "Facial expression",
      ],
      correct: "A"
    },
    {
      id: 11669,
      question: "What type of nerve is the Glossopharyngeal Nerve (IX)?",
      options: [
        "Autonomic only",
        "Both motor and sensory",
        "Motor only",
        "Sensory only",
      ],
      correct: "B"
    },
    {
      id: 11670,
      question: "Which part of the tongue does the Glossopharyngeal Nerve provide taste from?",
      options: [
        "Entire tongue",
        "Tip of tongue",
        "Posterior one-third",
        "Anterior two-thirds",
      ],
      correct: "C"
    },
    {
      id: 11671,
      question: "What taste sensations are lost if the Glossopharyngeal Nerve is damaged?",
      options: [
        "Sweet only",
        "All tastes",
        "Sweet and salty",
        "Bitter and sour",
      ],
      correct: "D"
    },
    {
      id: 11672,
      question: "The Glossopharyngeal Nerve helps control what autonomic functions?",
      options: [
        "Blood pressure and respiration",
        "Facial expression",
        "Digestion only",
        "Eye movement",
      ],
      correct: "A"
    },
    {
      id: 11673,
      question: "What is the function of Cranial Nerve X (Vagus)?",
      options: [
        "Vision",
        "Swallowing, voice production, autonomic control of thoracic and abdominal viscera",
        "Hearing",
        "Smell",
      ],
      correct: "B"
    },
    {
      id: 11674,
      question: "What type of nerve is the Vagus Nerve (X)?",
      options: [
        "Reflex only",
        "Motor only",
        "Both motor and sensory",
        "Sensory only",
      ],
      correct: "C"
    },
    {
      id: 11675,
      question: "Where does the Vagus Nerve provide taste sensation from?",
      options: [
        "Lips",
        "Anterior tongue",
        "Posterior tongue",
        "Epiglottis and pharynx",
      ],
      correct: "D"
    },
    {
      id: 11676,
      question: "What happens if both Vagus Nerves are cut?",
      options: [
        "Fatal",
        "Blindness",
        "Minor speech difficulty",
        "Loss of smell",
      ],
      correct: "A"
    },
    {
      id: 11677,
      question: "Damage to the Vagus Nerve can cause what?",
      options: [
        "Deafness",
        "Hoarseness or loss of voice, impaired swallowing, GI dysfunction",
        "Loss of smell",
        "Blindness",
      ],
      correct: "B"
    },
    {
      id: 11678,
      question: "What autonomic function does the Vagus Nerve affect?",
      options: [
        "Body temperature only",
        "Salivation only",
        "Heart rate and airway relaxation",
        "Pupil size only",
      ],
      correct: "C"
    },
    {
      id: 11679,
      question: "What is the function of Cranial Nerve XI (Accessory)?",
      options: [
        "Hearing",
        "Vision",
        "Taste",
        "Swallowing, head, neck, and shoulder movement",
      ],
      correct: "D"
    },
    {
      id: 11680,
      question: "What type of nerve is the Accessory Nerve (XI)?",
      options: [
        "Motor only",
        "Sensory only",
        "Autonomic only",
        "Both motor and sensory",
      ],
      correct: "A"
    },
    {
      id: 11681,
      question: "Which muscles does the Accessory Nerve control?",
      options: [
        "Eye muscles",
        "Trapezius and sternocleidomastoid muscles",
        "Facial muscles",
        "Tongue muscles",
      ],
      correct: "B"
    },
    {
      id: 11682,
      question: "Damage to the Accessory Nerve causes what?",
      options: [
        "Deafness",
        "Loss of vision",
        "Impaired head, neck, and shoulder movement",
        "Loss of taste",
      ],
      correct: "C"
    },
    {
      id: 11683,
      question: "What is the function of Cranial Nerve XII (Hypoglossal)?",
      options: [
        "Facial expression",
        "Taste",
        "Swallowing only",
        "Tongue movements for speech, food manipulation, and swallowing",
      ],
      correct: "D"
    },
    {
      id: 11684,
      question: "What type of nerve is the Hypoglossal Nerve (XII)?",
      options: [
        "Motor only",
        "Sensory only",
        "Autonomic only",
        "Both motor and sensory",
      ],
      correct: "A"
    },
    {
      id: 11685,
      question: "If both Hypoglossal Nerves are damaged, what happens?",
      options: [
        "Tongue deviates to one side",
        "Cannot protrude tongue",
        "Loss of taste",
        "Tongue becomes paralyzed on one side",
      ],
      correct: "B"
    },
    {
      id: 11686,
      question: "If one Hypoglossal Nerve is damaged, what happens?",
      options: [
        "Tongue deviates away from injured side",
        "Cannot move tongue at all",
        "Tongue deviates towards injured side",
        "Loss of taste",
      ],
      correct: "C"
    },
    {
      id: 11687,
      question: "What is Trigeminal neuralgia also called?",
      options: [
        "Facial paralysis",
        "Glossopharyngeal neuralgia",
        "Bell's palsy",
        "Tic douloureux",
      ],
      correct: "D"
    },
    {
      id: 11688,
      question: "What characterizes Trigeminal neuralgia?",
      options: [
        "Recurring episodes of intense stabbing pain in trigeminal nerve area",
        "Inability to move tongue",
        "Facial paralysis",
        "Loss of taste",
      ],
      correct: "A"
    },
    {
      id: 11689,
      question: "What can trigger pain in Trigeminal neuralgia?",
      options: [
        "Lying down",
        "Touch, drinking, washing face",
        "Loud noises",
        "Bright lights",
      ],
      correct: "B"
    },
    {
      id: 11690,
      question: "What is Bell's palsy?",
      options: [
        "Disorder of vagus nerve",
        "Disorder of trigeminal nerve",
        "Disorder of facial nerve causing paralysis of facial muscles on one side",
        "Disorder of optic nerve",
      ],
      correct: "C"
    },
    {
      id: 11691,
      question: "How does Bell's palsy typically appear?",
      options: [
        "Permanently without recovery",
        "Only during sleep",
        "Gradually over months",
        "Abruptly with full recovery in 3-5 weeks",
      ],
      correct: "D"
    },
    {
      id: 11692,
      question: "Which branches of the Facial Nerve supply muscles of facial expression?",
      options: [
        "Temporal, zygomatic, buccal, mandibular, and cervical branches",
        "Only temporal branch",
        "Only mandibular branch",
        "Only buccal branch",
      ],
      correct: "A"
    },
    {
      id: 11693,
      question: "Which nerve division supplies the muscles of mastication?",
      options: [
        "Cranial Nerve VII",
        "V3 - Mandibular division of Trigeminal Nerve",
        "V1 - Ophthalmic",
        "V2 - Maxillary",
      ],
      correct: "B"
    },
    {
      id: 11694,
      question: "Which muscles of mastication are supplied by V3?",
      options: [
        "Only pterygoid muscles",
        "Only masseter",
        "Temporalis, lateral pterygoid, medial pterygoid, masseter, and digastric",
        "Only temporalis",
      ],
      correct: "C"
    },
    {
      id: 11695,
      question: "Which nerve supplies the maxillary molars?",
      options: [
        "Mental Nerve",
        "Infraorbital Nerve",
        "Lingual Nerve",
        "Posterior Superior Alveolar Nerve",
      ],
      correct: "D"
    },
    {
      id: 11696,
      question: "Which nerve supplies the maxillary premolars?",
      options: [
        "Middle Superior Alveolar Nerve",
        "Anterior Superior Alveolar Nerve",
        "Posterior Superior Alveolar Nerve",
        "Infraorbital Nerve alone",
      ],
      correct: "A"
    },
    {
      id: 11697,
      question: "Which nerve supplies the maxillary anterior teeth?",
      options: [
        "Posterior Superior Alveolar Nerve",
        "Anterior Superior Alveolar Nerve",
        "Mental Nerve",
        "Middle Superior Alveolar Nerve",
      ],
      correct: "B"
    },
    {
      id: 11698,
      question: "All maxillary teeth are supplied by which cranial nerve division?",
      options: [
        "Cranial Nerve VII",
        "V1 - Ophthalmic",
        "V2 - Maxillary division of Trigeminal Nerve",
        "V3 - Mandibular",
      ],
      correct: "C"
    },
    {
      id: 11699,
      question: "Which nerve supplies all mandibular teeth?",
      options: [
        "Lingual Nerve",
        "Mental Nerve only",
        "Superior Alveolar Nerve",
        "Inferior Alveolar Nerve",
      ],
      correct: "D"
    },
    {
      id: 11700,
      question: "The Mental Nerve is a branch of which nerve?",
      options: [
        "Inferior Alveolar Nerve",
        "Facial Nerve",
        "Lingual Nerve",
        "Maxillary division",
      ],
      correct: "A"
    },
    {
      id: 11701,
      question: "The Incisive Nerve is a continuation of which nerve?",
      options: [
        "Lingual Nerve",
        "Inferior Alveolar Nerve",
        "Mental Nerve",
        "Buccal Nerve",
      ],
      correct: "B"
    },
    {
      id: 11702,
      question: "Which nerve provides sensation to the buccal gingiva of mandibular molars?",
      options: [
        "Mental Nerve",
        "Inferior Alveolar Nerve",
        "Buccal Nerve",
        "Lingual Nerve",
      ],
      correct: "C"
    },
    {
      id: 11703,
      question: "What does the reflex arc allow?",
      options: [
        "Complete elimination of pain",
        "More intense pain",
        "Slower pain response",
        "Faster response to stimuli by bypassing the brain",
      ],
      correct: "D"
    },
    {
      id: 11704,
      question: "In the normal pain pathway, which step occurs third?",
      options: [
        "Second neuron carries message up spinal cord towards brain",
        "Message travels to brain",
        "Pain receptor senses pain",
        "Muscle responds",
      ],
      correct: "A"
    },
    {
      id: 11705,
      question: "What is the main advantage of the reflex arc?",
      options: [
        "It requires conscious thought",
        "Action happens before person has time to interpret pain",
        "It makes pain more noticeable",
        "It involves more neurons",
      ],
      correct: "B"
    },
    {
      id: 11706,
      question: "The sympathetic nervous system is associated with which response?",
      options: [
        "Decreased heart rate",
        "Sleep",
        "Fight or flight",
        "Rest and digest",
      ],
      correct: "C"
    },
    {
      id: 11707,
      question: "The parasympathetic nervous system is associated with which response?",
      options: [
        "Stress response",
        "Increased heart rate",
        "Fight or flight",
        "Rest or digest",
      ],
      correct: "D"
    },
    {
      id: 11708,
      question: "Which division of the Trigeminal Nerve is entirely sensory?",
      options: [
        "V1 and V2",
        "All three divisions",
        "Only V3",
        "Only V2",
      ],
      correct: "A"
    },
    {
      id: 11709,
      question: "Which cranial nerves are purely sensory?",
      options: [
        "I, II, VII",
        "I, II, VIII",
        "All cranial nerves have motor function",
        "I, II, III",
      ],
      correct: "B"
    },
    {
      id: 11710,
      question: "Which cranial nerves are purely motor?",
      options: [
        "V, VII, IX, X",
        "I, II, VIII",
        "III, IV, VI, XI, XII",
        "All have sensory components",
      ],
      correct: "C"
    },
    {
      id: 11711,
      question: "Which cranial nerves are mixed (both motor and sensory)?",
      options: [
        "None are mixed",
        "I, II, VIII",
        "III, IV, VI, XI, XII",
        "V, VII, IX, X",
      ],
      correct: "D"
    },
    {
      id: 11712,
      question: "What structure does the Oculomotor Nerve pass through to reach the eye?",
      options: [
        "Superior orbital fissure",
        "Foramen rotundum",
        "Inferior orbital fissure",
        "Foramen ovale",
      ],
      correct: "A"
    },
    {
      id: 11713,
      question: "What structure does the Trochlear Nerve pass through?",
      options: [
        "Optic foramen",
        "Superior orbital fissure",
        "Foramen rotundum",
        "Foramen ovale",
      ],
      correct: "B"
    },
    {
      id: 11714,
      question: "What structure does the Abducens Nerve pass through?",
      options: [
        "Inferior orbital fissure",
        "Foramen rotundum",
        "Superior orbital fissure",
        "Foramen ovale",
      ],
      correct: "C"
    },
    {
      id: 11715,
      question: "Which cranial nerve has both a cranial root and a spinal root?",
      options: [
        "Hypoglossal",
        "Glossopharyngeal",
        "Vagus",
        "Accessory",
      ],
      correct: "D"
    },
    {
      id: 11716,
      question: "What is the primary function of the enteric nervous system?",
      options: [
        "Controls digestive system",
        "Controls breathing",
        "Eye movement",
        "Facial expression",
      ],
      correct: "A"
    },
    {
      id: 11717,
      question: "The levator palpebrae superioris muscle is innervated by which nerve?",
      options: [
        "Trigeminal Nerve",
        "Oculomotor Nerve",
        "Facial Nerve",
        "Trochlear Nerve",
      ],
      correct: "B"
    },
    {
      id: 11718,
      question: "Pupil constriction (circular muscle) is controlled by which nerve?",
      options: [
        "Abducens Nerve",
        "Optic Nerve",
        "Oculomotor Nerve",
        "Trochlear Nerve",
      ],
      correct: "C"
    },
    {
      id: 11719,
      question: "The ciliary muscle for accommodation is controlled by which nerve?",
      options: [
        "Facial Nerve",
        "Optic Nerve",
        "Abducens Nerve",
        "Oculomotor Nerve",
      ],
      correct: "D"
    },
    {
      id: 11720,
      question: "Which nerve controls the superior oblique muscle?",
      options: [
        "Trochlear Nerve",
        "Oculomotor Nerve",
        "Facial Nerve",
        "Abducens Nerve",
      ],
      correct: "A"
    },
    {
      id: 11721,
      question: "Which nerve controls the lateral rectus muscle?",
      options: [
        "Facial Nerve",
        "Oculomotor Nerve",
        "Abducens Nerve",
        "Trochlear Nerve",
      ],
      correct: "C"
    },
    {
      id: 11722,
      question: "The lacrimal gland is controlled by which nerve?",
      options: [
        "Vagus Nerve",
        "Trigeminal Nerve",
        "Facial Nerve",
        "Glossopharyngeal Nerve",
      ],
      correct: "C"
    },
    {
      id: 11723,
      question: "The parotid gland receives autonomic innervation from which nerve?",
      options: [
        "Trigeminal Nerve",
        "Facial Nerve",
        "Vagus Nerve",
        "Glossopharyngeal Nerve",
      ],
      correct: "D"
    },
    {
      id: 11724,
      question: "The submandibular gland is controlled by which nerve?",
      options: [
        "Facial Nerve",
        "Trigeminal Nerve",
        "Hypoglossal Nerve",
        "Glossopharyngeal Nerve",
      ],
      correct: "A"
    },
    {
      id: 11725,
      question: "Sweet and salty taste sensations are carried by which nerve?",
      options: [
        "Trigeminal Nerve",
        "Facial Nerve",
        "Glossopharyngeal Nerve",
        "Vagus Nerve",
      ],
      correct: "B"
    },
    {
      id: 11726,
      question: "Bitter and sour taste sensations are carried by which nerve?",
      options: [
        "Trigeminal Nerve",
        "Facial Nerve",
        "Glossopharyngeal Nerve",
        "Vagus Nerve",
      ],
      correct: "C"
    },
    {
      id: 11727,
      question: "Which cranial nerve has the most extensive distribution in the body?",
      options: [
        "Trigeminal Nerve",
        "Facial Nerve",
        "Accessory Nerve",
        "Vagus Nerve",
      ],
      correct: "D"
    },
    {
      id: 11728,
      question: "The pharyngeal muscles for swallowing are innervated by which nerves?",
      options: [
        "Glossopharyngeal, Vagus, and Accessory",
        "Only Glossopharyngeal",
        "Only Hypoglossal",
        "Only Vagus",
      ],
      correct: "A"
    },
    {
      id: 11729,
      question: "Loss of the gag reflex would indicate damage to which nerves?",
      options: [
        "Hypoglossal and Accessory",
        "Glossopharyngeal and Vagus",
        "Olfactory and Optic",
        "Facial and Trigeminal",
      ],
      correct: "B"
    },
    {
      id: 11730,
      question: "Which nerve provides general sensation to the anterior two-thirds of the tongue?",
      options: [
        "Hypoglossal Nerve",
        "Facial Nerve",
        "Trigeminal Nerve (Lingual branch of V3)",
        "Glossopharyngeal Nerve",
      ],
      correct: "C"
    },
    {
      id: 11731,
      question: "The intrinsic muscles of the tongue are innervated by which nerve?",
      options: [
        "Glossopharyngeal Nerve",
        "Facial Nerve",
        "Trigeminal Nerve",
        "Hypoglossal Nerve",
      ],
      correct: "D"
    },
    {
      id: 11732,
      question: "The extrinsic muscles of the tongue are innervated by which nerve?",
      options: [
        "Hypoglossal Nerve",
        "Facial Nerve",
        "Trigeminal Nerve",
        "Glossopharyngeal Nerve",
      ],
      correct: "A"
    },
    {
      id: 11733,
      question: "What provides motor innervation to the stapedius muscle in the middle ear?",
      options: [
        "Glossopharyngeal Nerve",
        "Facial Nerve",
        "Vestibulocochlear Nerve",
        "Trigeminal Nerve",
      ],
      correct: "B"
    },
    {
      id: 11734,
      question: "The tensor tympani muscle of the middle ear is innervated by which nerve?",
      options: [
        "Vestibulocochlear Nerve",
        "Facial Nerve",
        "Trigeminal Nerve",
        "Glossopharyngeal Nerve",
      ],
      correct: "C"
    },
    {
      id: 11735,
      question: "Which statement about cranial nerves is correct?",
      options: [
        "All cranial nerves are sensory",
        "All cranial nerves control muscles",
        "All cranial nerves are motor",
        "Each cranial nerve has a separate function",
      ],
      correct: "D"
    },
    {
      id: 11736,
      question: "What is the correct order of events in a reflex arc?",
      options: [
        "Stimulus → sensory neuron → spinal cord → motor neuron → response (bypassing brain)",
        "Stimulus → brain → response",
        "Stimulus → conscious thought → response",
        "Stimulus → spinal cord → brain → response",
      ],
      correct: "A"
    },
    {
      id: 11737,
      question: "Where does the Facial Nerve exit the skull?",
      options: [
        "Foramen rotundum",
        "Stylomastoid foramen",
        "Jugular foramen",
        "Superior orbital fissure",
      ],
      correct: "B"
    },
    {
      id: 11738,
      question: "Where do the Glossopharyngeal and Vagus nerves exit the skull?",
      options: [
        "Stylomastoid foramen",
        "Foramen ovale",
        "Jugular foramen",
        "Foramen magnum",
      ],
      correct: "C"
    },
    {
      id: 11739,
      question: "The Hypoglossal Nerve exits the skull through which opening?",
      options: [
        "Stylomastoid foramen",
        "Foramen magnum",
        "Jugular foramen",
        "Hypoglossal canal",
      ],
      correct: "D"
    },
    {
      id: 11740,
      question: "Which cranial nerve provides sensation to the maxillary sinus?",
      options: [
        "Maxillary division (V2)",
        "Facial Nerve",
        "Ophthalmic division (V1)",
        "Mandibular division (V3)",
      ],
      correct: "A"
    },
    {
      id: 11741,
      question: "Which cranial nerve provides sensation to the nasal cavity?",
      options: [
        "Facial Nerve only",
        "Trigeminal Nerve (V1 and V2 divisions)",
        "Olfactory Nerve only",
        "Optic Nerve",
      ],
      correct: "B"
    },
    {
      id: 11742,
      question: "The hard palate receives sensation from which nerve?",
      options: [
        "Mandibular division of Trigeminal (V3)",
        "Glossopharyngeal Nerve",
        "Maxillary division of Trigeminal (V2)",
        "Facial Nerve",
      ],
      correct: "C"
    },
    {
      id: 11743,
      question: "The soft palate receives sensation from which nerves?",
      options: [
        "Only Glossopharyngeal",
        "Only Trigeminal",
        "Only Facial",
        "Trigeminal (V2), Glossopharyngeal, and Vagus",
      ],
      correct: "D"
    },
    {
      id: 11744,
      question: "Movement of the soft palate (except tensor veli palatini) is controlled by which nerve?",
      options: [
        "Vagus Nerve",
        "Trigeminal Nerve",
        "Glossopharyngeal Nerve",
        "Facial Nerve",
      ],
      correct: "A"
    },
  ],
  "5. Cranial Nerves (Part 2)": [
    {
      id: 12000,
      question: "Neurons are responsible for transmitting messages or impulses in which characteristic manner?",
      options: [
        "They travel in only one direction through the nervous system",
        "They can reverse direction based on signal strength",
        "They travel bidirectionally to enhance communication efficiency",
        "They move randomly until reaching their target destination"
      ],
      correct: "A"
    },
    {
      id: 12001,
      question: "What term describes messages carried from outer parts of the body towards the brain?",
      options: [
        "Efferent or motor pathways",
        "Sensory or afferent pathways",
        "Autonomic or involuntary pathways",
        "Somatic or voluntary pathways"
      ],
      correct: "B"
    },
    {
      id: 12002,
      question: "Motor (efferent) nerves carry messages in which direction and typically cause what result?",
      options: [
        "From body to brain, usually triggering sensory awareness",
        "Between neurons only, causing synaptic transmission",
        "From brain to body parts, usually causing an action",
        "Within the spinal cord, causing reflex responses"
      ],
      correct: "C"
    },
    {
      id: 12003,
      question: "The Central Nervous System (CNS) consists of which two main components?",
      options: [
        "The brain and spinal column",
        "The cranial and spinal nerves",
        "The sympathetic and parasympathetic systems",
        "The somatic and autonomic divisions"
      ],
      correct: "A"
    },
    {
      id: 12004,
      question: "The Peripheral Nervous System (PNS) is composed of which structures?",
      options: [
        "Only the twelve pairs of cranial nerves",
        "The brain, spinal cord, and autonomic system",
        "Nerves extending from brain and spinal cord, and the ANS",
        "The sensory receptors and motor effectors exclusively"
      ],
      correct: "C"
    },
    {
      id: 12005,
      question: "Cranial nerves are classified as part of which nervous system division?",
      options: [
        "The Central Nervous System exclusively",
        "The Autonomic Nervous System",
        "The Peripheral Nervous System",
        "The Enteric Nervous System"
      ],
      correct: "C"
    },
    {
      id: 12006,
      question: "What is a reflex arc within the Central Nervous System?",
      options: [
        "A complex pathway requiring conscious brain interpretation",
        "A built-in shortcut that bypasses the brain",
        "A pathway that only processes sensory information",
        "A system that requires multiple synaptic connections"
      ],
      correct: "B"
    },
    {
      id: 12007,
      question: "In a reflex arc, what allows the reflex action to occur before conscious pain recognition?",
      options: [
        "The brain processes information at accelerated speed",
        "Pain receptors are temporarily blocked during reflexes",
        "A shorter neural pathway runs between sensory and motor neurons",
        "Motor neurons fire before receiving complete sensory input"
      ],
      correct: "C"
    },
    {
      id: 12008,
      question: "The Somatic Nervous System is responsible for which primary functions?",
      options: [
        "Controlling heart rate and digestion exclusively",
        "Sending sensory info to CNS and motor signals to skeletal muscles",
        "Regulating smooth muscle contractions throughout the body",
        "Managing involuntary gland secretions and visceral responses"
      ],
      correct: "B"
    },
    {
      id: 12009,
      question: "Which division of the Peripheral Nervous System controls smooth muscle and glands?",
      options: [
        "The Somatic Nervous System",
        "The Central Nervous System",
        "The Autonomic Nervous System",
        "The Sensory Nervous System"
      ],
      correct: "C"
    },
    {
      id: 12010,
      question: "How many pairs of cranial nerves exist in the human nervous system?",
      options: [
        "Eight pairs numbered with Roman numerals",
        "Ten pairs numbered with Arabic numerals",
        "Twelve pairs numbered with Roman numerals",
        "Fourteen pairs numbered with Arabic numerals"
      ],
      correct: "C"
    },
    {
      id: 12011,
      question: "Cranial nerves attach directly to which structure in the nervous system?",
      options: [
        "The spinal cord at various levels",
        "The brain itself",
        "The peripheral ganglia exclusively",
        "The autonomic nerve plexuses"
      ],
      correct: "B"
    },
    {
      id: 12012,
      question: "Cranial Nerve I (Olfactory) is responsible for which sensory function?",
      options: [
        "Taste perception from the tongue",
        "Vision and light detection",
        "Sense of smell",
        "Hearing and sound processing"
      ],
      correct: "C"
    },
    {
      id: 12013,
      question: "What functional deficit results from damage to the Olfactory Nerve (CN I)?",
      options: [
        "Complete loss of taste sensation",
        "Impaired sense of smell",
        "Blindness in the affected visual field",
        "Loss of facial sensation"
      ],
      correct: "B"
    },
    {
      id: 12014,
      question: "Cranial Nerve II (Optic) provides which essential sensory function?",
      options: [
        "Hearing and auditory processing",
        "Balance and spatial orientation",
        "Vision and visual perception",
        "Smell and olfactory detection"
      ],
      correct: "C"
    },
    {
      id: 12015,
      question: "Damage to the Optic Nerve (CN II) results in which clinical finding?",
      options: [
        "Loss of eye movement coordination",
        "Blindness in the visual field",
        "Pupil dilation without light response",
        "Drooping of the upper eyelid"
      ],
      correct: "B"
    },
    {
      id: 12016,
      question: "The Oculomotor Nerve (CN III) controls which eye-related functions?",
      options: [
        "Only lateral eye movements and pupil dilation",
        "Eye movement, eyelid opening, pupil constriction, and focusing",
        "Exclusively downward and inward eye rotation",
        "Only the muscles controlling peripheral vision"
      ],
      correct: "B"
    },
    {
      id: 12017,
      question: "Which clinical signs indicate damage to the Oculomotor Nerve (CN III)?",
      options: [
        "Inability to close the eye and dilated pupil",
        "Drooping eyelid, dilated pupil, double vision, and impaired eye movement",
        "Complete blindness and loss of light perception",
        "Constricted pupil and excessive tearing"
      ],
      correct: "B"
    },
    {
      id: 12018,
      question: "The Trochlear Nerve (CN IV) innervates which specific eye muscle?",
      options: [
        "The lateral rectus muscle exclusively",
        "The inferior oblique muscle only",
        "The superior oblique muscle",
        "All six extraocular muscles equally"
      ],
      correct: "C"
    },
    {
      id: 12019,
      question: "What visual problem occurs with Trochlear Nerve (CN IV) damage?",
      options: [
        "Complete blindness in one eye",
        "Double vision and inability to rotate eye inferolaterally",
        "Loss of peripheral vision fields",
        "Inability to focus on near objects"
      ],
      correct: "B"
    },
    {
      id: 12020,
      question: "The Trigeminal Nerve (CN V) is unique because it has how many divisions?",
      options: [
        "Two divisions serving different facial regions",
        "Three divisions with distinct distribution patterns",
        "Four divisions covering the entire head",
        "Five divisions corresponding to facial segments"
      ],
      correct: "B"
    },
    {
      id: 12021,
      question: "Which functions are impaired when the Trigeminal Nerve (CN V) is damaged?",
      options: [
        "Facial expressions and tear production",
        "Eye movements and pupil constriction",
        "Loss of sensation and impaired chewing",
        "Hearing and balance disturbances"
      ],
      correct: "C"
    },
    {
      id: 12022,
      question: "The Ophthalmic branch (V1) of the Trigeminal Nerve provides sensation to which areas?",
      options: [
        "Lower eyelid, upper lip, and maxillary teeth",
        "Nasal cavity, forehead skin, upper eyelid, and eyebrow",
        "Mandibular teeth, lower lip, and chin region",
        "Tongue, palate, and pharyngeal structures"
      ],
      correct: "B"
    },
    {
      id: 12023,
      question: "Which structures receive sensory innervation from the Maxillary branch (V2)?",
      options: [
        "Forehead skin, upper eyelid, and nasal tip",
        "Mandibular teeth, tongue, and lower gums",
        "Lower eyelid, upper lips and gums, maxillary teeth, and palate",
        "Temporal region, external ear, and jaw joint"
      ],
      correct: "C"
    },
    {
      id: 12024,
      question: "The Mandibular branch (V3) is distinct from other Trigeminal divisions because it provides what?",
      options: [
        "Only sensory innervation to facial structures",
        "Both sensory and motor functions",
        "Exclusively motor control of eye muscles",
        "Only autonomic innervation to glands"
      ],
      correct: "B"
    },
    {
      id: 12025,
      question: "Which muscles receive motor innervation from the Mandibular division (V3)?",
      options: [
        "Muscles of facial expression exclusively",
        "Extraocular muscles controlling eye movement",
        "Temporalis and masseter muscles for mastication",
        "Pharyngeal muscles for swallowing"
      ],
      correct: "C"
    },
    {
      id: 12026,
      question: "The Maxillary branch (V2) enters the skull through which foramen?",
      options: [
        "The superior orbital fissure",
        "The foramen ovale",
        "The foramen rotundum",
        "The inferior orbital fissure"
      ],
      correct: "C"
    },
    {
      id: 12027,
      question: "How many branches does the Maxillary division (V2) divide into?",
      options: [
        "Three main branches",
        "Four main branches",
        "Six main branches",
        "Eight main branches"
      ],
      correct: "C"
    },
    {
      id: 12028,
      question: "The Mandibular branch (V3) enters the skull through which opening?",
      options: [
        "The foramen rotundum",
        "The foramen ovale",
        "The superior orbital fissure",
        "The jugular foramen"
      ],
      correct: "B"
    },
    {
      id: 12029,
      question: "The Abducens Nerve (CN VI) provides motor control to which eye muscle?",
      options: [
        "The medial rectus muscle for inward gaze",
        "The superior oblique muscle for downward rotation",
        "The lateral rectus muscle for outward movement",
        "The inferior rectus muscle for downward gaze"
      ],
      correct: "C"
    },
    {
      id: 12030,
      question: "What clinical finding indicates Abducens Nerve (CN VI) damage?",
      options: [
        "Drooping eyelid and dilated pupil",
        "Inability to rotate eye laterally; at rest eye rotates medially",
        "Complete loss of vision in affected eye",
        "Double vision only when looking upward"
      ],
      correct: "B"
    },
    {
      id: 12031,
      question: "The Facial Nerve (CN VII) provides motor control for which primary function?",
      options: [
        "Muscles of mastication and jaw movement",
        "Eye movements and pupillary responses",
        "Facial expressions and mimetic muscles",
        "Tongue movements for speech"
      ],
      correct: "C"
    },
    {
      id: 12032,
      question: "Which sensory function does the Facial Nerve (CN VII) provide?",
      options: [
        "Pain and temperature from the entire face",
        "Taste from anterior two-thirds of tongue",
        "Proprioception from jaw muscles",
        "Touch sensation from the scalp"
      ],
      correct: "B"
    },
    {
      id: 12033,
      question: "The Facial Nerve (CN VII) controls which glands through autonomic motor function?",
      options: [
        "Thyroid and parathyroid glands",
        "Salivary and lacrimal glands, plus nasal mucous membranes",
        "Sweat glands across the entire body",
        "Adrenal glands and pancreatic secretions"
      ],
      correct: "B"
    },
    {
      id: 12034,
      question: "What taste sensations are lost when the Facial Nerve (CN VII) is damaged?",
      options: [
        "Bitter and sour tastes exclusively",
        "Sweet and salty taste perception",
        "All taste sensations from entire tongue",
        "Only metallic and umami tastes"
      ],
      correct: "B"
    },
    {
      id: 12035,
      question: "How does the Facial Nerve (CN VII) differ anatomically from the Trigeminal Nerve (CN V)?",
      options: [
        "The Facial Nerve is deeper and more protected",
        "The Facial Nerve is more superficial than CN V",
        "Both nerves follow identical pathways",
        "The Facial Nerve travels only through bone canals"
      ],
      correct: "B"
    },
    {
      id: 12036,
      question: "The Vestibulocochlear Nerve (CN VIII) has two branches serving which functions?",
      options: [
        "Taste and smell sensation",
        "Hearing (cochlear) and balance (vestibular)",
        "Eye movement and pupil control",
        "Facial sensation and motor control"
      ],
      correct: "B"
    },
    {
      id: 12037,
      question: "What symptoms indicate damage to the Vestibulocochlear Nerve (CN VIII)?",
      options: [
        "Loss of facial expression and taste",
        "Deafness, dizziness, nausea, loss of balance, and nystagmus",
        "Blindness and impaired eye movements",
        "Difficulty swallowing and hoarseness"
      ],
      correct: "B"
    },
    {
      id: 12038,
      question: "The Glossopharyngeal Nerve (CN IX) provides taste sensation to which tongue region?",
      options: [
        "The anterior two-thirds of the tongue",
        "The entire tongue uniformly",
        "The posterior one-third of the tongue",
        "Only the tongue tip and margins"
      ],
      correct: "C"
    },
    {
      id: 12039,
      question: "Which motor functions are controlled by the Glossopharyngeal Nerve (CN IX)?",
      options: [
        "Facial expressions and eye movements",
        "Swallowing, voice production, and pharyngeal muscle control",
        "Tongue protrusion and lateral movement",
        "Jaw closing and mastication"
      ],
      correct: "B"
    },
    {
      id: 12040,
      question: "What taste sensations are lost with Glossopharyngeal Nerve (CN IX) damage?",
      options: [
        "Sweet and salty taste perception",
        "All taste sensations completely",
        "Bitter and sour taste detection",
        "Only umami taste recognition"
      ],
      correct: "C"
    },
    {
      id: 12041,
      question: "The Vagus Nerve (CN X) provides sensory innervation to which extensive areas?",
      options: [
        "Only the external ear and facial skin",
        "Skin at back of ear, larynx, trachea, esophagus, thoracic and abdominal viscera",
        "Exclusively the tongue and oral cavity",
        "Only the pharynx and nasal passages"
      ],
      correct: "B"
    },
    {
      id: 12042,
      question: "Which motor functions are controlled by the Vagus Nerve (CN X)?",
      options: [
        "Eye movements and facial expressions exclusively",
        "Tongue protrusion and speech articulation only",
        "Swallowing, voice production, visceral smooth muscle, and heart rate",
        "Mastication and jaw movements primarily"
      ],
      correct: "C"
    },
    {
      id: 12043,
      question: "What life-threatening situation occurs if both Vagus Nerves (CN X) are cut?",
      options: [
        "Complete paralysis of facial muscles bilaterally",
        "Fatal outcome due to loss of vital autonomic control",
        "Permanent blindness in both eyes",
        "Total loss of hearing and balance"
      ],
      correct: "B"
    },
    {
      id: 12044,
      question: "The Accessory Nerve (CN XI) provides motor control to which muscles?",
      options: [
        "Muscles of facial expression and mastication",
        "Extraocular muscles and eyelid elevators",
        "Trapezius, sternocleidomastoid, and pharyngeal muscles",
        "All intrinsic and extrinsic tongue muscles"
      ],
      correct: "C"
    },
    {
      id: 12045,
      question: "What functional impairments result from Accessory Nerve (CN XI) damage?",
      options: [
        "Loss of facial expressions and taste",
        "Impaired head, neck, and shoulder movement",
        "Difficulty with eye movements and focusing",
        "Complete loss of voice and speech"
      ],
      correct: "B"
    },
    {
      id: 12046,
      question: "The Hypoglossal Nerve (CN XII) controls which specific motor functions?",
      options: [
        "Jaw movements for chewing and grinding",
        "Pharyngeal muscles for swallowing",
        "Tongue movements for speech, food manipulation, and swallowing",
        "Facial muscles for expressions"
      ],
      correct: "C"
    },
    {
      id: 12047,
      question: "What occurs when both Hypoglossal Nerves (CN XII) are damaged?",
      options: [
        "The tongue deviates to one side consistently",
        "Cannot protrude tongue at all",
        "Tongue movements are excessively rapid",
        "Tongue becomes enlarged and swollen"
      ],
      correct: "B"
    },
    {
      id: 12048,
      question: "When only one Hypoglossal Nerve (CN XII) is damaged, how does the tongue deviate?",
      options: [
        "Towards the uninjured side",
        "Towards the injured side",
        "The tongue does not deviate",
        "Alternately to both sides"
      ],
      correct: "B"
    },
    {
      id: 12049,
      question: "Trigeminal neuralgia (tic douloureux) is characterized by which symptom pattern?",
      options: [
        "Constant dull aching pain throughout the face",
        "Recurring episodes of intense stabbing pain in trigeminal area",
        "Numbness and tingling without pain",
        "Burning sensation across the entire scalp"
      ],
      correct: "B"
    },
    {
      id: 12050,
      question: "What typically triggers pain episodes in trigeminal neuralgia?",
      options: [
        "Only severe head trauma or injury",
        "Touch, drinking, washing face, or eating",
        "Exclusively during sleep periods",
        "Changes in barometric pressure"
      ],
      correct: "B"
    },
    {
      id: 12051,
      question: "Bell\'s palsy affects which cranial nerve causing what primary symptom?",
      options: [
        "Trigeminal nerve causing loss of facial sensation",
        "Facial nerve causing paralysis of facial muscles on one side",
        "Hypoglossal nerve causing tongue deviation",
        "Vagus nerve causing voice loss"
      ],
      correct: "B"
    },
    {
      id: 12052,
      question: "What is the typical progression and recovery time for Bell\'s palsy?",
      options: [
        "Gradual onset over months with permanent deficits",
        "Abrupt appearance with full recovery in 3-5 weeks",
        "Slow development with no possibility of recovery",
        "Sudden onset followed by progressive worsening"
      ],
      correct: "B"
    },
    {
      id: 12053,
      question: "Which branches of the Facial Nerve (CN VII) supply the muscles of facial expression?",
      options: [
        "Only the buccal and mandibular branches",
        "Temporal, zygomatic, buccal, mandibular, and cervical branches",
        "Exclusively the ophthalmic and maxillary branches",
        "Only the superior and inferior divisions"
      ],
      correct: "B"
    },
    {
      id: 12054,
      question: "The muscles of mastication receive motor innervation from which nerve branch?",
      options: [
        "The Facial Nerve (CN VII) branches",
        "The Ophthalmic division (V1) of Trigeminal",
        "The Mandibular division (V3) of Trigeminal",
        "The Hypoglossal Nerve (CN XII)"
      ],
      correct: "C"
    },
    {
      id: 12055,
      question: "Which specific muscles of mastication are innervated by the Mandibular division (V3)?",
      options: [
        "Only the masseter and temporalis muscles",
        "Temporalis, lateral pterygoid, medial pterygoid, masseter, and digastric",
        "Exclusively the buccinator and orbicularis oris",
        "Only the superior and inferior pharyngeal constrictors"
      ],
      correct: "B"
    },
    {
      id: 12056,
      question: "The maxillary molar teeth receive sensory innervation from which nerve?",
      options: [
        "The Anterior Superior Alveolar Nerve",
        "The Middle Superior Alveolar Nerve",
        "The Posterior Superior Alveolar Nerve",
        "The Inferior Alveolar Nerve"
      ],
      correct: "C"
    },
    {
      id: 12057,
      question: "Which nerve provides sensory innervation to the maxillary premolar teeth?",
      options: [
        "The Posterior Superior Alveolar Nerve",
        "The Middle Superior Alveolar Nerve",
        "The Anterior Superior Alveolar Nerve",
        "The Nasopalatine Nerve"
      ],
      correct: "B"
    },
    {
      id: 12058,
      question: "The maxillary anterior teeth receive sensory innervation from which nerve branch?",
      options: [
        "The Posterior Superior Alveolar Nerve",
        "The Infraorbital Nerve via the Anterior Superior Alveolar Nerve",
        "The Middle Superior Alveolar Nerve",
        "The Greater Palatine Nerve"
      ],
      correct: "B"
    },
    {
      id: 12059,
      question: "All mandibular teeth receive sensory innervation from which primary nerve?",
      options: [
        "The Lingual Nerve exclusively",
        "The Buccal Nerve primarily",
        "The Inferior Alveolar Nerve",
        "The Mylohyoid Nerve"
      ],
      correct: "C"
    },
    {
      id: 12060,
      question: "Which nerve branches from the Inferior Alveolar Nerve to supply the anterior mandibular region?",
      options: [
        "The Mental Nerve for external sensation",
        "The Incisive Nerve for tooth innervation",
        "The Lingual Nerve for tongue sensation",
        "The Mylohyoid Nerve for muscle control"
      ],
      correct: "B"
    },
    {
      id: 12061,
      question: "The Mental Nerve is a terminal branch of which nerve providing sensation to what area?",
      options: [
        "Maxillary nerve; sensation to upper lip",
        "Inferior Alveolar Nerve; sensation to lower lip and chin",
        "Buccal nerve; sensation to cheek mucosa",
        "Lingual nerve; sensation to tongue"
      ],
      correct: "B"
    },
    {
      id: 12062,
      question: "The Trigeminal Nerve (CN V) provides sensory innervation to which portion of the tongue?",
      options: [
        "The posterior one-third for taste only",
        "The entire tongue for all sensations",
        "The anterior two-thirds for general sensation",
        "Only the tongue tip for touch"
      ],
      correct: "C"
    },
    {
      id: 12063,
      question: "Which nerve is responsible for general sensation from the oral cavity structures?",
      options: [
        "The Facial Nerve (CN VII)",
        "The Glossopharyngeal Nerve (CN IX)",
        "The Trigeminal Nerve (CN V)",
        "The Vagus Nerve (CN X)"
      ],
      correct: "C"
    },
    {
      id: 12064,
      question: "The Ophthalmic branch (V1) divides into how many branches just before entering the skull?",
      options: [
        "Two branches",
        "Three branches",
        "Four branches",
        "Five branches"
      ],
      correct: "B"
    },
    {
      id: 12065,
      question: "Which three branches form the subdivisions of the Ophthalmic division (V1)?",
      options: [
        "Superior, middle, and inferior branches",
        "Lacrimal, frontal, and nasociliary nerves",
        "Supraorbital, supratrochlear, and infratrochlear nerves",
        "Medial, lateral, and central branches"
      ],
      correct: "B"
    },
    {
      id: 12066,
      question: "The Maxillary branch (V2) includes which nerve that provides sensation below the eye?",
      options: [
        "The Supraorbital Nerve",
        "The Infraorbital Nerve",
        "The Mental Nerve",
        "The Buccal Nerve"
      ],
      correct: "B"
    },
    {
      id: 12067,
      question: "Which division of the Mandibular branch (V3) contains the Lingual Nerve?",
      options: [
        "The Anterior Division",
        "The Posterior Division",
        "The Superior Division",
        "The Medial Division"
      ],
      correct: "B"
    },
    {
      id: 12068,
      question: "The Inferior Alveolar Nerve is part of which division of the Mandibular branch (V3)?",
      options: [
        "The Anterior Division exclusively",
        "The Posterior Division",
        "The Superior Division",
        "The Lateral Division"
      ],
      correct: "B"
    },
    {
      id: 12069,
      question: "Which nerve from the Mandibular division provides sensation to the cheek mucosa?",
      options: [
        "The Lingual Nerve",
        "The Mental Nerve",
        "The Buccal Nerve",
        "The Auriculotemporal Nerve"
      ],
      correct: "C"
    },
    {
      id: 12070,
      question: "The Auriculotemporal Nerve is a branch of which division of CN V?",
      options: [
        "The Ophthalmic division (V1)",
        "The Maxillary division (V2)",
        "The Posterior division of Mandibular (V3)",
        "The Anterior division of Mandibular (V3)"
      ],
      correct: "C"
    },
    {
      id: 12071,
      question: "Which cranial nerves are purely sensory in function?",
      options: [
        "CN I, II, and VIII",
        "CN III, IV, and VI",
        "CN V, VII, and IX",
        "CN X, XI, and XII"
      ],
      correct: "A"
    },
    {
      id: 12072,
      question: "Which cranial nerves are purely motor in function?",
      options: [
        "CN I, II, and VIII",
        "CN III, IV, VI, XI, and XII",
        "CN V, VII, IX, and X",
        "CN I, VII, and IX"
      ],
      correct: "B"
    },
    {
      id: 12073,
      question: "Which cranial nerves have both sensory and motor functions?",
      options: [
        "CN I, II, and VIII only",
        "CN III, IV, and VI only",
        "CN V, VII, IX, and X",
        "CN XI and XII only"
      ],
      correct: "C"
    },
    {
      id: 12074,
      question: "What is the primary function of the sympathetic nervous system?",
      options: [
        "Promoting digestion and energy conservation",
        "Fight or flight response activation",
        "Regulating sleep and circadian rhythms",
        "Controlling voluntary muscle movements"
      ],
      correct: "B"
    },
    {
      id: 12075,
      question: "The parasympathetic nervous system is associated with which functional state?",
      options: [
        "Fight or flight stress responses",
        "Increased heart rate and alertness",
        "Rest or digest relaxation state",
        "Voluntary skeletal muscle control"
      ],
      correct: "C"
    }
  
  ],
  "6. Local Anaesthetic (Part 1)": [    {
      id: 11800,
      question: "What is the mechanism by which local anesthetics block pain signals?",
      options: [
        "They block sodium channels preventing nerve signal transmission",
        "They destroy nerve cells permanently",
        "They increase potassium influx into nerve cells",
        "They activate calcium channels",
      ],
      correct: "A"
    },
    {
      id: 11801,
      question: "Which type of local anesthetic is metabolized by the liver?",
      options: [
        "Esters",
        "Benzocaine",
        "Procaine",
        "Amides",
      ],
      correct: "D"
    },
    {
      id: 11802,
      question: "Where are ester-type local anesthetics primarily metabolized?",
      options: [
        "Kidneys",
        "Liver",
        "Blood/plasma",
        "Spleen",
      ],
      correct: "C"
    },
    {
      id: 11803,
      question: "Which local anesthetic is an example of an ester?",
      options: [
        "Lidocaine",
        "Mepivacaine",
        "Articaine",
        "Benzocaine",
      ],
      correct: "D"
    },
    {
      id: 11804,
      question: "Which local anesthetic is an example of an amide?",
      options: [
        "Lidocaine",
        "Benzocaine",
        "Dyclonine",
        "Procaine",
      ],
      correct: "A"
    },
    {
      id: 11805,
      question: "After which trimester can lidocaine and prilocaine be used on pregnant females?",
      options: [
        "They cannot be used at all during pregnancy",
        "First trimester",
        "Second trimester",
        "Third trimester",
      ],
      correct: "C"
    },
    {
      id: 11806,
      question: "In the epinephrine concentration ratio 1:50,000, what does this indicate compared to 1:100,000?",
      options: [
        "1:50,000 has less epinephrine",
        "They contain the same amount",
        "1:50,000 has more epinephrine",
        "1:50,000 has no epinephrine",
      ],
      correct: "C"
    },
    {
      id: 11807,
      question: "Why is epinephrine dose reduced in cardiac patients?",
      options: [
        "To reduce the cost of treatment",
        "To prevent allergic reactions",
        "Because it causes liver damage",
        "To avoid excessive vasoconstriction and cardiovascular stress",
      ],
      correct: "D"
    },
    {
      id: 11808,
      question: "What is one benefit of adding epinephrine to local anesthetic?",
      options: [
        "It prolongs the duration of anesthesia by causing vasoconstriction",
        "It makes the anesthetic work faster",
        "It increases bleeding at the injection site",
        "It reduces the risk of infection",
      ],
      correct: "A"
    },
    {
      id: 11809,
      question: "What is a clinical manifestation of epinephrine overdose?",
      options: [
        "Drowsiness and fatigue",
        "Tremor and palpitation",
        "Decreased heart rate",
        "Low blood pressure",
      ],
      correct: "B"
    },
    {
      id: 11810,
      question: "Which factor should be considered when selecting a local anesthetic agent?",
      options: [
        "The color of the cartridge",
        "The patient's favorite flavor",
        "The duration of the procedure and expected post-operative pain",
        "The time of day",
      ],
      correct: "C"
    },
    {
      id: 11811,
      question: "What medical condition can affect which local anesthetic drug is safe to use?",
      options: [
        "Patient's hair color",
        "Patient's height",
        "Patient's dietary preferences",
        "Heart problems, liver disease, or pregnancy",
      ],
      correct: "D"
    },
    {
      id: 11812,
      question: "Which type of syringe is recommended for dental local anesthetic administration?",
      options: [
        "Aspirating syringe",
        "Non-aspirating syringe",
        "Insulin syringe",
        "Tuberculin syringe",
      ],
      correct: "A"
    },
    {
      id: 11813,
      question: "What is a potential complication of needle breakage during injection?",
      options: [
        "Temporary numbness",
        "The needle fragment may remain embedded in tissue",
        "Increased effectiveness of anesthesia",
        "Faster onset of numbness",
      ],
      correct: "B"
    },
    {
      id: 11814,
      question: "What is trismus?",
      options: [
        "A type of local anesthetic",
        "Excessive salivation after injection",
        "Difficulty opening the mouth due to jaw muscle spasm",
        "A brand of dental syringe",
      ],
      correct: "C"
    },
    {
      id: 11815,
      question: "What causes facial nerve paralysis as a complication of local anesthesia?",
      options: [
        "Using too little anesthetic",
        "Patient anxiety",
        "Needle being too short",
        "Anesthetic hitting the wrong nerve",
      ],
      correct: "D"
    },
    {
      id: 11816,
      question: "What is paresthesia in the context of local anesthetic complications?",
      options: [
        "Persistent tingling or numbness that doesn't go away quickly",
        "Complete loss of sensation permanently",
        "Temporary increase in pain sensation",
        "Muscle weakness",
      ],
      correct: "A"
    },
    {
      id: 11817,
      question: "What causes a hematoma after local anesthetic injection?",
      options: [
        "Allergic reaction to the anesthetic",
        "Hitting a blood vessel during injection",
        "Using expired anesthetic",
        "Injecting too slowly",
      ],
      correct: "B"
    },
    {
      id: 11818,
      question: "What is the difference between relative overdose and absolute overdose?",
      options: [
        "Relative overdose occurs only in children, absolute in adults",
        "There is no difference between them",
        "Relative overdose causes strong effects even with normal doses in sensitive patients; absolute overdose is when a large or incorrect dose is given",
        "Relative overdose is more dangerous than absolute overdose",
      ],
      correct: "C"
    },
    {
      id: 11819,
      question: "Which type of local anesthetic (ester or amide) is more commonly associated with allergic reactions?",
      options: [
        "Amides",
        "Neither causes allergies",
        "Both cause allergies equally",
        "Esters",
      ],
      correct: "D"
    },
    {
      id: 11820,
      question: "What is anaphylaxis?",
      options: [
        "A severe, life-threatening allergic reaction requiring immediate emergency care",
        "A mild allergic reaction causing itching",
        "A common side effect of local anesthetics",
        "Temporary swelling at the injection site",
      ],
      correct: "A"
    },
    {
      id: 11821,
      question: "What is the difference between infiltration and supraperiosteal injection?",
      options: [
        "There is no difference",
        "Infiltration numbs only gingiva; supraperiosteal numbs tooth, gingiva, and ligaments",
        "Infiltration is deeper than supraperiosteal",
        "Supraperiosteal only numbs gingiva",
      ],
      correct: "B"
    },
    {
      id: 11822,
      question: "Where is an infiltration injection administered?",
      options: [
        "Deep into the bone",
        "Into the muscle",
        "Near the gums (shallow)",
        "Into a blood vessel",
      ],
      correct: "C"
    },
    {
      id: 11823,
      question: "What does a nerve block anesthetize?",
      options: [
        "Only a single tooth",
        "Only the gingiva",
        "Only soft tissues",
        "Multiple teeth, gingiva, and bone on one side",
      ],
      correct: "D"
    },
    {
      id: 11824,
      question: "Why are infiltration injections commonly used in the maxilla but not in the mandible?",
      options: [
        "The maxillary bone is porous and allows easy diffusion of anesthetic",
        "The mandibular nerve is larger",
        "The maxillary bone is dense",
        "The mandibular bone is too porous",
      ],
      correct: "A"
    },
    {
      id: 11825,
      question: "What nerve is anesthetized during an Anterior Superior Alveolar (ASA) nerve block?",
      options: [
        "Posterior Superior Alveolar Nerve",
        "Anterior Superior Alveolar Nerve",
        "Inferior Alveolar Nerve",
        "Mental Nerve",
      ],
      correct: "B"
    },
    {
      id: 11826,
      question: "Which teeth are anesthetized with an ASA nerve block?",
      options: [
        "All maxillary teeth",
        "Maxillary molars",
        "Maxillary central incisor, lateral incisor, and canine",
        "Mandibular anterior teeth",
      ],
      correct: "C"
    },
    {
      id: 11827,
      question: "Where is the penetration site for an ASA nerve block?",
      options: [
        "Height of mucobuccal fold above the first molar",
        "Directly into the palate",
        "Behind the third molar",
        "Height of mucobuccal fold just mesial to the canine eminence",
      ],
      correct: "D"
    },
    {
      id: 11828,
      question: "Which teeth are anesthetized with a Posterior Superior Alveolar (PSA) nerve block?",
      options: [
        "Maxillary first molar distal buccal root, second molar, and third molar",
        "All maxillary teeth",
        "Maxillary anterior teeth only",
        "All mandibular teeth",
      ],
      correct: "A"
    },
    {
      id: 11829,
      question: "What is the penetration site for a PSA nerve block?",
      options: [
        "Height of mucobuccal fold at the canine",
        "Height of mucobuccal fold posterior and superior to the second molar",
        "Middle of the hard palate",
        "Floor of the mouth",
      ],
      correct: "B"
    },
    {
      id: 11830,
      question: "What area does the Greater Palatine nerve block anesthetize?",
      options: [
        "All of the hard palate",
        "Only the soft palate",
        "Hard palate and soft tissue from maxillary third molar to first premolar unilaterally",
        "The tongue",
      ],
      correct: "C"
    },
    {
      id: 11831,
      question: "Where is the penetration site for a Greater Palatine nerve block?",
      options: [
        "Incisive papilla",
        "Behind the third molar",
        "Middle of the soft palate",
        "Just anterior to the greater palatine foramen",
      ],
      correct: "D"
    },
    {
      id: 11832,
      question: "What area does the Nasopalatine nerve block anesthetize?",
      options: [
        "Hard palate and soft tissue bilaterally from canine to canine",
        "Only one side of the palate",
        "All maxillary teeth",
        "The floor of the mouth",
      ],
      correct: "A"
    },
    {
      id: 11833,
      question: "Where is the penetration site for a Nasopalatine nerve block?",
      options: [
        "Greater palatine foramen",
        "Just lateral to the posterior portion of the incisive papilla",
        "Mucobuccal fold",
        "Behind the last molar",
      ],
      correct: "B"
    },
    {
      id: 11834,
      question: "Which nerves are anesthetized during an Inferior Alveolar (IA) nerve block?",
      options: [
        "Only the Inferior Alveolar nerve",
        "Superior Alveolar nerves",
        "Inferior Alveolar, Incisive, Mental, and Lingual nerves",
        "Buccal nerve only",
      ],
      correct: "C"
    },
    {
      id: 11835,
      question: "What teeth are anesthetized with an Inferior Alveolar nerve block?",
      options: [
        "Only mandibular molars",
        "All mandibular teeth bilaterally",
        "Only mandibular incisors",
        "Mandibular teeth unilaterally to midline",
      ],
      correct: "D"
    },
    {
      id: 11836,
      question: "Where is the penetration site for an Inferior Alveolar nerve block?",
      options: [
        "Middle of the pterygomandibular triangle at the height of the coronoid notch",
        "Directly over the mandibular foramen",
        "Floor of the mouth",
        "Buccal mucosa near the molars",
      ],
      correct: "A"
    },
    {
      id: 11837,
      question: "What needle length is typically used for an Inferior Alveolar nerve block?",
      options: [
        "Extra short (10mm)",
        "Short (20-25mm)",
        "Long (30-35mm)",
        "Any length works equally well",
      ],
      correct: "C"
    },
    {
      id: 11838,
      question: "What does a Long Buccal nerve block anesthetize?",
      options: [
        "All mandibular teeth",
        "The tongue",
        "Lower lip",
        "Soft tissues buccal to the mandibular molars",
      ],
      correct: "D"
    },
    {
      id: 11839,
      question: "Where is the penetration site for a Long Buccal nerve block?",
      options: [
        "Vestibule, distal and buccal to the most distal molar at the occlusal plane",
        "Pterygomandibular triangle",
        "Floor of the mouth",
        "Lingual side of the mandible",
      ],
      correct: "A"
    },
    {
      id: 11840,
      question: "What does a Mental nerve block anesthetize?",
      options: [
        "All mandibular teeth",
        "Facial soft tissues from mental foramen to midline and lower lip",
        "The tongue and floor of mouth",
        "Maxillary teeth",
      ],
      correct: "B"
    },
    {
      id: 11841,
      question: "What additional area does an Incisive nerve block anesthetize compared to a Mental nerve block?",
      options: [
        "The tongue",
        "Maxillary anterior teeth",
        "Mandibular teeth from second premolar to central incisor",
        "The hard palate",
      ],
      correct: "C"
    },
    {
      id: 11842,
      question: "Where is the mental foramen typically located?",
      options: [
        "Behind the third molar",
        "At the midline of the mandible",
        "On the lingual side of the mandible",
        "Near the mandibular second premolar",
      ],
      correct: "D"
    },
    {
      id: 11843,
      question: "In a needle gauge numbering system, what does a higher gauge number indicate?",
      options: [
        "A smaller lumen diameter",
        "A thicker needle",
        "A longer needle",
        "Better quality",
      ],
      correct: "A"
    },
    {
      id: 11844,
      question: "Which needle is thicker: 25-gauge or 30-gauge?",
      options: [
        "30-gauge",
        "25-gauge",
        "They are the same thickness",
        "Gauge doesn't indicate thickness",
      ],
      correct: "B"
    },
    {
      id: 11845,
      question: "What is the typical length of a \"short\" dental needle?",
      options: [
        "10-15 mm",
        "30-35 mm",
        "20-25 mm",
        "40-45 mm",
      ],
      correct: "C"
    },
    {
      id: 11846,
      question: "What is the typical length of a \"long\" dental needle?",
      options: [
        "20-25 mm",
        "25-30 mm",
        "35-40 mm",
        "30-35 mm",
      ],
      correct: "D"
    },
    {
      id: 11847,
      question: "How often should needles be changed during multiple injections on the same patient?",
      options: [
        "After approximately 3-4 injections",
        "Never, use the same needle for all injections",
        "After every single injection",
        "Only when visibly damaged",
      ],
      correct: "A"
    },
    {
      id: 11848,
      question: "Why should needles be changed regularly during treatment?",
      options: [
        "To save money",
        "The stainless steel becomes dull, causing trauma and soreness",
        "It's required by law",
        "To use different gauge needles",
      ],
      correct: "B"
    },
    {
      id: 11849,
      question: "What are the main parts of an anesthetic cartridge?",
      options: [
        "Only glass and metal",
        "Plastic tube and metal cap",
        "Rubber plunger, diaphragm, aluminum cap, and glass cylinder",
        "Single-piece construction",
      ],
      correct: "C"
    },
    {
      id: 11850,
      question: "What type of injection is a Periodontal Ligament (PDL) injection?",
      options: [
        "A nerve block",
        "A palatal injection",
        "An infiltration injection",
        "A local injection directly into the tooth's sulcus",
      ],
      correct: "D"
    },
    {
      id: 11851,
      question: "What area does a PDL injection anesthetize?",
      options: [
        "Pulp, soft tissue, and bone of the injected tooth only",
        "Multiple teeth in a quadrant",
        "The entire jaw",
        "Only the gingiva",
      ],
      correct: "A"
    },
    {
      id: 11852,
      question: "What must be documented when administering local anesthetic?",
      options: [
        "Only the date",
        "Date, amount, type, concentration, injection location, reactions, and administrator",
        "Only the type of anesthetic used",
        "Just the patient's name and date",
      ],
      correct: "B"
    },
    {
      id: 11853,
      question: "When documenting the amount of local anesthetic, what units should be used?",
      options: [
        "Only milliliters",
        "Only number of cartridges",
        "Number of cartridges or mL",
        "Grams",
      ],
      correct: "C"
    },
    {
      id: 11854,
      question: "What concentration information should be documented for local anesthetic?",
      options: [
        "Only the drug name",
        "Just the vasoconstrictor concentration",
        "None, concentration doesn't need documentation",
        "Concentration and type of anesthetic, plus concentration of vasoconstrictor",
      ],
      correct: "D"
    },
    {
      id: 11855,
      question: "Which step occurs first in the mechanism of local anesthetic action?",
      options: [
        "The anesthetic is given outside the nerve",
        "The channel is blocked",
        "It enters the sodium channel",
        "Sodium enters the nerve cell",
      ],
      correct: "A"
    },
    {
      id: 11856,
      question: "Which step occurs second in the mechanism of local anesthetic action?",
      options: [
        "The anesthetic blocks the sodium channel",
        "The anesthetic is injected",
        "Pain signals stop completely",
        "The anesthetic moves through the nerve membrane",
      ],
      correct: "D"
    },
    {
      id: 11857,
      question: "Which step occurs third in the mechanism of local anesthetic action?",
      options: [
        "The patient feels pain",
        "The nerve membrane becomes permeable",
        "The anesthetic goes inside the sodium channel",
        "Sodium flows freely",
      ],
      correct: "C"
    },
    {
      id: 11858,
      question: "What is the final result when local anesthetic blocks sodium channels?",
      options: [
        "Increased pain sensation",
        "Sodium can still enter freely",
        "The nerve dies permanently",
        "Sodium cannot enter the nerve cell and pain signals are blocked",
      ],
      correct: "D"
    },
    {
      id: 11859,
      question: "What happens to sodium (Na+) in blood versus nerves?",
      options: [
        "In blood, high Na+ increases water and BP; in nerves, Na+ entry sends pain signals",
        "Sodium has no effect in either location",
        "Sodium only affects blood pressure",
        "Sodium only affects nerve function",
      ],
      correct: "A"
    },
    {
      id: 11860,
      question: "How does blocking Na+ with local anesthetic affect pain perception?",
      options: [
        "It increases pain",
        "Na+ cannot send pain signals, resulting in reduced pain",
        "It has no effect on pain",
        "It only affects blood pressure",
      ],
      correct: "B"
    },
    {
      id: 11861,
      question: "What is the primary use of ester-type local anesthetics?",
      options: [
        "For deep nerve blocks",
        "Intravenous injection",
        "Topical application on surfaces",
        "Intramuscular injection",
      ],
      correct: "C"
    },
    {
      id: 11862,
      question: "What topical anesthetic product contains lidocaine and prilocaine?",
      options: [
        "Benzocaine gel",
        "Procaine solution",
        "Articaine cartridge",
        "Oraqix",
      ],
      correct: "D"
    },
    {
      id: 11863,
      question: "What is Oraqix specifically designed for?",
      options: [
        "Periodontal use (gum treatment)",
        "Tooth extraction",
        "Oral surgery",
        "Root canal therapy",
      ],
      correct: "A"
    },
    {
      id: 11864,
      question: "What components make up the delivery system for topical periodontal anesthetics like Oraqix?",
      options: [
        "Standard syringe only",
        "Applicator with blunt-tip, cartridge, and reset button",
        "Needle and cartridge",
        "Spray bottle",
      ],
      correct: "B"
    },
    {
      id: 11865,
      question: "When would you use a short needle in dental anesthesia?",
      options: [
        "For deep nerve blocks",
        "For inferior alveolar blocks",
        "For supraperiosteal (local infiltration) injections",
        "For intravenous sedation",
      ],
      correct: "C"
    },
    {
      id: 11866,
      question: "What are the three main types of dental local anesthetic injections?",
      options: [
        "Superficial, intermediate, deep",
        "Surface, internal, external",
        "Primary, secondary, tertiary",
        "Infiltration, supraperiosteal, nerve block",
      ],
      correct: "D"
    },
    {
      id: 11867,
      question: "What is the infraorbital foramen's significance in local anesthesia?",
      options: [
        "It's a landmark for maxillary nerve blocks",
        "It's where mandibular injections are given",
        "It has no relevance to anesthesia",
        "It's only important for oral surgery",
      ],
      correct: "A"
    },
    {
      id: 11868,
      question: "What anatomical structure forms the medial boundary of the pterygomandibular triangle?",
      options: [
        "Internal oblique ridge",
        "Pterygomandibular raphe",
        "Buccal mucosa",
        "Masseter muscle",
      ],
      correct: "B"
    },
    {
      id: 11869,
      question: "What anatomical structure forms the lateral boundary of the pterygomandibular triangle?",
      options: [
        "Pterygomandibular raphe",
        "Buccal mucosa",
        "Internal oblique ridge",
        "Tongue",
      ],
      correct: "C"
    },
    {
      id: 11870,
      question: "At what height relative to the occlusal plane should an inferior alveolar nerve block be administered?",
      options: [
        "At the occlusal plane level",
        "Below the occlusal plane",
        "Height doesn't matter",
        "6-10 mm above the mandibular occlusal plane",
      ],
      correct: "D"
    },
    {
      id: 11871,
      question: "What is the coronoid notch?",
      options: [
        "The concave area between the coronoid process and condyle of the mandible",
        "A depression on the maxilla",
        "A groove on the tongue",
        "The space between teeth",
      ],
      correct: "A"
    },
    {
      id: 11872,
      question: "How far should the needle typically be advanced for an inferior alveolar nerve block?",
      options: [
        "5-10 mm",
        "10-15 mm",
        "20-25 mm",
        "30-35 mm",
      ],
      correct: "C"
    },
    {
      id: 11873,
      question: "What should you do if bone is contacted during an inferior alveolar nerve block before reaching the expected depth?",
      options: [
        "Continue pushing the needle forward",
        "Remove completely and restart",
        "Inject immediately",
        "Withdraw 1mm and deposit anesthetic",
      ],
      correct: "D"
    },
    {
      id: 11874,
      question: "Why is aspiration important before injecting local anesthetic?",
      options: [
        "To ensure the needle isn't in a blood vessel",
        "To make the injection less painful",
        "To test if the anesthetic is still good",
        "It's not important",
      ],
      correct: "A"
    },
    {
      id: 11875,
      question: "What does a positive aspiration (blood in the cartridge) indicate?",
      options: [
        "The injection was successful",
        "The needle is in a blood vessel and should be repositioned",
        "The patient is bleeding excessively",
        "The anesthetic is contaminated",
      ],
      correct: "B"
    },
    {
      id: 11876,
      question: "What is the purpose of topical anesthetic before injection?",
      options: [
        "To sterilize the area",
        "To speed up the injection",
        "To reduce pain from needle penetration",
        "To identify the injection site",
      ],
      correct: "C"
    },
    {
      id: 11877,
      question: "How long should topical anesthetic be applied before injection?",
      options: [
        "A few seconds",
        "10-15 minutes",
        "It should be left on indefinitely",
        "1-2 minutes",
      ],
      correct: "D"
    },
    {
      id: 11878,
      question: "What should be used to dry the injection site before applying topical anesthetic?",
      options: [
        "Cotton gauze or applicator",
        "Paper towel",
        "Air syringe only",
        "Nothing, moisture helps",
      ],
      correct: "A"
    },
    {
      id: 11879,
      question: "Why should injection be performed slowly?",
      options: [
        "To use less anesthetic",
        "To make it last longer",
        "To reduce pain and tissue trauma",
        "It doesn't matter how fast you inject",
      ],
      correct: "C"
    },
    {
      id: 11880,
      question: "What should you do if a patient reports severe pain during injection?",
      options: [
        "Continue injecting quickly",
        "Ignore it and finish the injection",
        "Remove the needle completely immediately",
        "Stop, withdraw slightly, and assess needle position",
      ],
      correct: "D"
    },
    {
      id: 11881,
      question: "What is sloughing of tissues?",
      options: [
        "Peeling or death of skin/mucosa due to tissue damage",
        "Normal healing after injection",
        "Temporary whitening of tissue",
        "Increased blood flow to the area",
      ],
      correct: "A"
    },
    {
      id: 11882,
      question: "What can cause post-anesthetic intraoral lesions?",
      options: [
        "Normal reaction to anesthetic",
        "Trauma from injection or patient biting numb tissues",
        "Allergic reaction to cartridge material",
        "Bacterial infection from the needle",
      ],
      correct: "B"
    },
    {
      id: 11883,
      question: "What should patients be warned about after receiving local anesthetic?",
      options: [
        "Not to eat for 24 hours",
        "To keep the area wet",
        "To avoid biting lips or cheeks while numb",
        "To exercise the jaw immediately",
      ],
      correct: "C"
    },
    {
      id: 11884,
      question: "How long does numbness typically last after local anesthetic?",
      options: [
        "15-30 minutes",
        "12-24 hours",
        "Several days",
        "1-4 hours depending on the drug and technique",
      ],
      correct: "D"
    },
    {
      id: 11885,
      question: "Which has a longer duration: lidocaine or bupivacaine?",
      options: [
        "Bupivacaine",
        "Lidocaine",
        "They last the same time",
        "Duration depends only on dose",
      ],
      correct: "A"
    },
    {
      id: 11886,
      question: "Why might bupivacaine be chosen over lidocaine?",
      options: [
        "It's cheaper",
        "For longer procedures or when post-operative pain relief is needed",
        "It works faster",
        "It's safer in all patients",
      ],
      correct: "B"
    },
    {
      id: 11887,
      question: "What is articaine's unique property among amide local anesthetics?",
      options: [
        "It's the safest option",
        "It lasts the longest",
        "It has both ester and amide characteristics",
        "It has no vasoconstrictor",
      ],
      correct: "C"
    },
    {
      id: 11888,
      question: "What concentration of lidocaine is commonly used in dental cartridges?",
      options: [
        "1%",
        "5%",
        "10%",
        "2%",
      ],
      correct: "D"
    },
    {
      id: 11889,
      question: "What is the maximum recommended dose of lidocaine for a healthy adult?",
      options: [
        "500 mg",
        "100 mg",
        "300 mg",
        "1000 mg",
      ],
      correct: "A"
    },
    {
      id: 11890,
      question: "How much lidocaine is in one standard 1.8 mL cartridge of 2% lidocaine?",
      options: [
        "18 mg",
        "36 mg",
        "54 mg",
        "72 mg",
      ],
      correct: "B"
    },
    {
      id: 11891,
      question: "Why are vasoconstrictors added to local anesthetics?",
      options: [
        "To increase pain",
        "To speed up metabolism",
        "To decrease bleeding and prolong anesthetic duration",
        "To reduce cost",
      ],
      correct: "C"
    },
    {
      id: 11892,
      question: "What is the most common vasoconstrictor used in dental local anesthetics?",
      options: [
        "Norepinephrine",
        "Phenylephrine",
        "Dopamine",
        "Epinephrine",
      ],
      correct: "D"
    },
    {
      id: 11893,
      question: "What does levonordefrin do when added to local anesthetic?",
      options: [
        "Causes vasoconstriction similar to epinephrine",
        "Increases pain sensitivity",
        "Speeds up drug elimination",
        "Prevents allergic reactions",
      ],
      correct: "A"
    },
    {
      id: 11894,
      question: "What is the maximum recommended dose of epinephrine for healthy patients per appointment?",
      options: [
        "0.04 mg",
        "0.2 mg",
        "0.5 mg",
        "1.0 mg",
      ],
      correct: "B"
    },
    {
      id: 11895,
      question: "What is the maximum recommended dose of epinephrine for cardiac patients?",
      options: [
        "0.04 mg",
        "0.2 mg",
        "0.5 mg",
        "Same as healthy patients",
      ],
      correct: "A"
    },
    {
      id: 11896,
      question: "How many cartridges of 1:100,000 epinephrine can a healthy patient receive?",
      options: [
        "5.5 cartridges",
        "22.2 cartridges",
        "Unlimited",
        "11.1 cartridges",
      ],
      correct: "D"
    },
    {
      id: 11897,
      question: "How many cartridges of 1:100,000 epinephrine should cardiac patients be limited to?",
      options: [
        "1.1 cartridges",
        "2.2 cartridges",
        "5.5 cartridges",
        "11.1 cartridges",
      ],
      correct: "B"
    },
    {
      id: 11898,
      question: "What symptom is associated with epinephrine overdose?",
      options: [
        "Bradycardia (slow heart rate)",
        "Drowsiness",
        "Throbbing headache and palpitations",
        "Decreased blood pressure",
      ],
      correct: "C"
    },
    {
      id: 11899,
      question: "What respiratory symptom can occur with epinephrine overdose?",
      options: [
        "Improved breathing",
        "Decreased respiratory rate",
        "No respiratory effects",
        "Respiratory difficulty",
      ],
      correct: "D"
    },
    {
      id: 11900,
      question: "What psychological symptom is associated with epinephrine overdose?",
      options: [
        "Increased fear and anxiety",
        "Euphoria",
        "Sedation",
        "Confusion",
      ],
      correct: "A"
    },
    {
      id: 11901,
      question: "What physical appearance change occurs with epinephrine overdose?",
      options: [
        "Flushed skin",
        "Pallor (pale appearance)",
        "Cyanosis (blue color)",
        "No visible changes",
      ],
      correct: "B"
    },
    {
      id: 11902,
      question: "What medications can interact with epinephrine in local anesthetics?",
      options: [
        "Antibiotics only",
        "Pain relievers only",
        "Antidepressants, beta-blockers, and herbal supplements",
        "Vitamins",
      ],
      correct: "C"
    },
    {
      id: 11903,
      question: "Why is it important to ask about herbal supplements before giving local anesthetic?",
      options: [
        "They're always dangerous",
        "They make anesthetics work better",
        "It's not important",
        "Some can interact with local anesthetics or epinephrine",
      ],
      correct: "D"
    },
    {
      id: 11904,
      question: "What medical condition requires special consideration when selecting local anesthetics?",
      options: [
        "Liver disease",
        "Common cold",
        "Seasonal allergies",
        "Athlete's foot",
      ],
      correct: "A"
    },
    {
      id: 11905,
      question: "Why is liver disease relevant to local anesthetic selection?",
      options: [
        "The liver stores anesthetics",
        "Amide local anesthetics are metabolized in the liver",
        "Liver disease prevents pain sensation",
        "It's not actually relevant",
      ],
      correct: "B"
    },
    {
      id: 11906,
      question: "What should be done if a patient has an allergy to ester local anesthetics?",
      options: [
        "Use esters anyway",
        "Don't use any anesthetic",
        "Use amide local anesthetics instead",
        "Use general anesthesia",
      ],
      correct: "C"
    },
    {
      id: 11907,
      question: "Are cross-allergies common between esters and amides?",
      options: [
        "Yes, very common",
        "Only in children",
        "Only in elderly patients",
        "No, they're chemically different",
      ],
      correct: "D"
    },
    {
      id: 11908,
      question: "What is the difference between an aspirating and self-aspirating syringe?",
      options: [
        "Aspirating requires manual technique; self-aspirating has automatic mechanism",
        "There is no difference",
        "Self-aspirating is always disposable",
        "Aspirating syringes can't be reused",
      ],
      correct: "A"
    },
    {
      id: 11909,
      question: "What is a pressure syringe used for?",
      options: [
        "Routine infiltrations",
        "PDL (periodontal ligament) injections",
        "Topical anesthetic application",
        "Mixing anesthetic solutions",
      ],
      correct: "B"
    },
    {
      id: 11910,
      question: "What is the purpose of computer-controlled local anesthetic delivery systems?",
      options: [
        "To make injections more painful",
        "To reduce the amount of anesthetic needed to zero",
        "To control flow rate and pressure for more comfortable injections",
        "To eliminate the need for topical anesthetic",
      ],
      correct: "C"
    },
    {
      id: 11911,
      question: "What safety feature is found on modern dental syringes?",
      options: [
        "Automatic cartridge loading",
        "Built-in timers",
        "Temperature control",
        "Safety mechanisms to prevent needlestick injuries",
      ],
      correct: "D"
    },
    {
      id: 11912,
      question: "What should be done with used needles?",
      options: [
        "Dispose in sharps container without recapping",
        "Recap and throw in regular trash",
        "Reuse after cleaning",
        "Save for later use",
      ],
      correct: "A"
    },
    {
      id: 11913,
      question: "Why should needles not be recapped after use?",
      options: [
        "It wastes time",
        "It increases risk of needlestick injury",
        "It damages the needle",
        "It's more expensive",
      ],
      correct: "B"
    },
    {
      id: 11914,
      question: "What is the bevel of a needle?",
      options: [
        "The hub where it attaches to the syringe",
        "The middle section of the needle",
        "The angled tip of the needle",
        "The length of the needle",
      ],
      correct: "C"
    },
    {
      id: 11915,
      question: "How should the bevel be oriented during injection?",
      options: [
        "Randomly, orientation doesn't matter",
        "Always away from tissue",
        "Downward only",
        "Toward the bone for most injections",
      ],
      correct: "D"
    },
    {
      id: 11916,
      question: "What is the hub of the needle?",
      options: [
        "The pointed tip",
        "The part that attaches to the syringe",
        "The middle shaft",
        "The bevel",
      ],
      correct: "B"
    },
    {
      id: 11917,
      question: "What is the shaft of the needle?",
      options: [
        "The attachment point",
        "The bevel",
        "The long, thin body of the needle between hub and tip",
        "The internal channel",
      ],
      correct: "C"
    },
    {
      id: 11918,
      question: "What is in the cartridge besides the local anesthetic drug?",
      options: [
        "Only the anesthetic",
        "Just saline solution",
        "Only epinephrine",
        "Anesthetic, vasoconstrictor, preservatives, and sometimes sodium bisulfite",
      ],
      correct: "D"
    },
    {
      id: 11919,
      question: "Why is sodium bisulfite added to some local anesthetic cartridges?",
      options: [
        "To prevent oxidation of epinephrine",
        "To increase pH",
        "As the main anesthetic agent",
        "To add flavor",
      ],
      correct: "A"
    },
    {
      id: 11920,
      question: "Can patients be allergic to components other than the anesthetic drug itself?",
      options: [
        "No, only the anesthetic causes allergies",
        "Yes, to preservatives like methylparaben or sodium bisulfite",
        "Allergies never occur with local anesthetics",
        "Only children have these allergies",
      ],
      correct: "B"
    },
    {
      id: 11921,
      question: "What is methylparaben?",
      options: [
        "A type of local anesthetic",
        "A vasoconstrictor",
        "A preservative that can cause allergic reactions",
        "A topical anesthetic",
      ],
      correct: "C"
    },
    {
      id: 11922,
      question: "What should be checked before using a local anesthetic cartridge?",
      options: [
        "Only the expiration date",
        "Only the color",
        "Just the manufacturer",
        "Expiration date, clarity of solution, integrity of cartridge, and presence of bubbles",
      ],
      correct: "D"
    },
    {
      id: 11923,
      question: "What does a large bubble in an anesthetic cartridge indicate?",
      options: [
        "Possible contamination or damage; cartridge should not be used",
        "The cartridge is fine to use",
        "Higher potency",
        "Lower cost",
      ],
      correct: "A"
    },
    {
      id: 11924,
      question: "What should the anesthetic solution look like in the cartridge?",
      options: [
        "Cloudy or discolored",
        "Clear and colorless (or slightly colored if with vasoconstrictor)",
        "Dark brown",
        "Thick and gel-like",
      ],
      correct: "B"
    },
    {
      id: 11925,
      question: "What could a cracked or damaged cartridge lead to?",
      options: [
        "Better anesthetic effect",
        "Faster onset",
        "Contamination and infection risk",
        "Longer duration",
      ],
      correct: "C"
    },
    {
      id: 11926,
      question: "What is the color-coding system on cartridges used for?",
      options: [
        "Decoration",
        "Indicating expiration date",
        "Showing manufacturer preference",
        "Identifying the type and concentration of anesthetic",
      ],
      correct: "D"
    },
    {
      id: 11927,
      question: "What does a red band on a cartridge typically indicate?",
      options: [
        "No vasoconstrictor",
        "Contains vasoconstrictor",
        "Expired",
        "For topical use only",
      ],
      correct: "B"
    },
    {
      id: 11928,
      question: "Where should local anesthetic cartridges be stored?",
      options: [
        "In direct sunlight",
        "In the freezer",
        "At room temperature, away from light and heat",
        "In the sterilizer",
      ],
      correct: "C"
    },
    {
      id: 11929,
      question: "Why should cartridges not be stored in disinfectant solution?",
      options: [
        "It's actually recommended",
        "It makes them expire faster",
        "It changes the color",
        "Disinfectant can penetrate the cartridge and contaminate the solution",
      ],
      correct: "D"
    },
    {
      id: 11930,
      question: "What is the standard volume of a dental local anesthetic cartridge?",
      options: [
        "1.8 mL",
        "1.0 mL",
        "2.5 mL",
        "5.0 mL",
      ],
      correct: "A"
    },
  ],
  "6. Local Anaesthetic (Part 2)": [
    {
      id: 12100,
      question: "Local anesthetic works by blocking which ion channel in nerve cells?",
      options: [
        "Calcium channels",
        "Potassium channels",
        "Sodium channels",
        "Chloride channels"
      ],
      correct: "C"
    },
    {
      id: 12101,
      question: "Which type of local anesthetic is typically used only for topical application?",
      options: [
        "Amides",
        "Esters",
        "Lidocaine",
        "Mepivacaine"
      ],
      correct: "B"
    },
    {
      id: 12102,
      question: "How are ester-type local anesthetics metabolized in the body?",
      options: [
        "By the liver",
        "By the kidneys",
        "By blood/plasma",
        "By muscle tissue"
      ],
      correct: "C"
    },
    {
      id: 12103,
      question: "How are amide-type local anesthetics metabolized in the body?",
      options: [
        "By blood/plasma",
        "By the liver",
        "By the kidneys",
        "By the spleen"
      ],
      correct: "B"
    },
    {
      id: 12104,
      question: "Which of the following is an example of an ester local anesthetic?",
      options: [
        "Lidocaine",
        "Mepivacaine",
        "Benzocaine",
        "Articaine"
      ],
      correct: "C"
    },
    {
      id: 12105,
      question: "Which of the following is an example of an amide local anesthetic?",
      options: [
        "Benzocaine",
        "Procaine",
        "Dyclonine",
        "Lidocaine"
      ],
      correct: "D"
    },
    {
      id: 12106,
      question: "After which trimester can lidocaine and prilocaine be safely used in pregnant females?",
      options: [
        "First trimester",
        "Second trimester",
        "Third trimester",
        "They cannot be used during pregnancy"
      ],
      correct: "B"
    },
    {
      id: 12107,
      question: "What does a concentration of 1:50,000 epinephrine mean compared to 1:100,000?",
      options: [
        "Less epinephrine",
        "More epinephrine",
        "The same amount",
        "No epinephrine"
      ],
      correct: "B"
    },
    {
      id: 12108,
      question: "Why is the epinephrine dose reduced in cardiac patients?",
      options: [
        "To prevent allergic reactions",
        "To reduce cost",
        "To prevent cardiovascular strain and complications",
        "To speed up anesthesia onset"
      ],
      correct: "C"
    },
    {
      id: 12109,
      question: "What are the main benefits of adding epinephrine to local anesthetic?",
      options: [
        "Prolongs duration and reduces bleeding",
        "Reduces pain on injection",
        "Speeds up metabolism",
        "Prevents allergic reactions"
      ],
      correct: "A"
    },
    {
      id: 12110,
      question: "What is the maximum recommended dose of epinephrine for healthy patients per appointment?",
      options: [
        "0.04 mg",
        "0.1 mg",
        "0.2 mg",
        "0.5 mg"
      ],
      correct: "C"
    },
    {
      id: 12111,
      question: "What is the maximum recommended dose of epinephrine for cardiac patients per appointment?",
      options: [
        "0.2 mg",
        "0.1 mg",
        "0.04 mg",
        "0.01 mg"
      ],
      correct: "C"
    },
    {
      id: 12112,
      question: "Which symptom is NOT typically associated with epinephrine overdose?",
      options: [
        "Fear and anxiety",
        "Tremor",
        "Bradycardia",
        "Throbbing headache"
      ],
      correct: "C"
    },
    {
      id: 12113,
      question: "When selecting a local anesthetic, which factor is LEAST important?",
      options: [
        "Duration needed",
        "Patient\'s medical conditions",
        "Brand name preference",
        "Drug interactions"
      ],
      correct: "C"
    },
    {
      id: 12114,
      question: "What type of syringe allows for aspiration to check for blood vessel penetration?",
      options: [
        "Disposable syringe",
        "Pressure syringe",
        "Aspirating syringe",
        "Computer-controlled syringe"
      ],
      correct: "C"
    },
    {
      id: 12115,
      question: "What is the typical gauge range for dental local anesthetic needles?",
      options: [
        "18-22 gauge",
        "25-27 gauge",
        "30-32 gauge",
        "35-40 gauge"
      ],
      correct: "B"
    },
    {
      id: 12116,
      question: "Which needle length is typically used for inferior alveolar nerve blocks?",
      options: [
        "Extra short",
        "Short (20-25 mm)",
        "Long (30-35 mm)",
        "Extra long"
      ],
      correct: "C"
    },
    {
      id: 12117,
      question: "How often should needles be changed during multiple injections on the same patient?",
      options: [
        "After every injection",
        "After 2 injections",
        "After 3-4 injections",
        "Never, use the same needle"
      ],
      correct: "C"
    },
    {
      id: 12118,
      question: "Which structure is NOT a standard part of a local anesthetic cartridge?",
      options: [
        "Rubber diaphragm",
        "Aluminum cap",
        "Steel reinforcement ring",
        "Glass cylinder"
      ],
      correct: "C"
    },
    {
      id: 12119,
      question: "What should be applied to the injection site before administering local anesthetic?",
      options: [
        "Topical anesthetic",
        "Alcohol",
        "Iodine",
        "Nothing"
      ],
      correct: "A"
    },
    {
      id: 12120,
      question: "Which injection type numbs only the gingiva (gum tissue)?",
      options: [
        "Supraperiosteal",
        "Infiltration",
        "Nerve block",
        "Intraligamentary"
      ],
      correct: "B"
    },
    {
      id: 12121,
      question: "Which injection type numbs the tooth, gingiva, and nearby ligaments?",
      options: [
        "Infiltration",
        "Supraperiosteal",
        "Nerve block",
        "Intrapulpal"
      ],
      correct: "B"
    },
    {
      id: 12122,
      question: "Which injection technique numbs multiple teeth on one side?",
      options: [
        "Infiltration",
        "Supraperiosteal",
        "Nerve block",
        "Topical"
      ],
      correct: "C"
    },
    {
      id: 12123,
      question: "Why are infiltration injections commonly used in the maxilla but not in the mandible?",
      options: [
        "The mandibular nerve is larger",
        "The maxillary bone is dense",
        "The mandibular bone is too porous",
        "The maxillary bone is porous and allows easy diffusion"
      ],
      correct: "D"
    },
    {
      id: 12124,
      question: "Which gauge needle is thicker?",
      options: [
        "25-gauge",
        "30-gauge",
        "Both are the same",
        "Gauge doesn\'t indicate thickness"
      ],
      correct: "A"
    },
    {
      id: 12125,
      question: "When would you typically use a short needle?",
      options: [
        "For deep nerve blocks",
        "For supraperiosteal injections",
        "For tongue anesthesia",
        "For IV sedation"
      ],
      correct: "B"
    },
    {
      id: 12126,
      question: "The Anterior Superior Alveolar (ASA) nerve block anesthetizes which teeth?",
      options: [
        "All maxillary teeth",
        "Maxillary molars",
        "Maxillary central incisor, lateral incisor, and canine",
        "Mandibular anterior teeth"
      ],
      correct: "C"
    },
    {
      id: 12127,
      question: "For an ASA nerve block, where is the penetration site?",
      options: [
        "At the apex of the canine",
        "Just mesial to the canine eminence",
        "Distal to the second molar",
        "At the incisive papilla"
      ],
      correct: "B"
    },
    {
      id: 12128,
      question: "The Posterior Superior Alveolar (PSA) nerve block anesthetizes which teeth?",
      options: [
        "All maxillary teeth",
        "Maxillary first molar distal buccal root, second molar, and third molar",
        "Maxillary anterior teeth",
        "Mandibular molars"
      ],
      correct: "B"
    },
    {
      id: 12129,
      question: "Where is the penetration site for a PSA nerve block?",
      options: [
        "At the canine eminence",
        "At the incisive papilla",
        "Posterior and superior to the maxillary second molar",
        "At the mental foramen"
      ],
      correct: "C"
    },
    {
      id: 12130,
      question: "The Greater Palatine nerve block anesthetizes which area?",
      options: [
        "All of the hard palate",
        "Hard palate from the third molar to the first premolar unilaterally",
        "Soft palate only",
        "Anterior hard palate bilaterally"
      ],
      correct: "B"
    },
    {
      id: 12131,
      question: "Where is the penetration site for the Greater Palatine nerve block?",
      options: [
        "At the incisive papilla",
        "Just anterior to the greater palatine foramen",
        "At the canine eminence",
        "Posterior to the third molar"
      ],
      correct: "B"
    },
    {
      id: 12132,
      question: "The Nasopalatine nerve block anesthetizes which area?",
      options: [
        "Unilateral hard palate",
        "Soft palate",
        "Hard palate bilaterally from canine to canine",
        "Posterior hard palate only"
      ],
      correct: "C"
    },
    {
      id: 12133,
      question: "Where is the penetration site for the Nasopalatine nerve block?",
      options: [
        "At the greater palatine foramen",
        "Just lateral to the posterior portion of the incisive papilla",
        "At the canine eminence",
        "Distal to the second molar"
      ],
      correct: "B"
    },
    {
      id: 12134,
      question: "Which nerves are anesthetized with an Inferior Alveolar nerve block?",
      options: [
        "Only the inferior alveolar nerve",
        "Inferior alveolar, mental, and buccal nerves",
        "Inferior alveolar, incisive, mental, and lingual nerves",
        "All mandibular nerves"
      ],
      correct: "C"
    },
    {
      id: 12135,
      question: "How deep should the needle be inserted for an inferior alveolar nerve block?",
      options: [
        "5-10 mm",
        "10-15 mm",
        "20-25 mm",
        "30-35 mm"
      ],
      correct: "C"
    },
    {
      id: 12136,
      question: "The Long Buccal nerve block anesthetizes which area?",
      options: [
        "All buccal tissue",
        "Buccal tissue of mandibular molars unilaterally",
        "Lingual tissue",
        "Palatal tissue"
      ],
      correct: "B"
    },
    {
      id: 12137,
      question: "Where is the penetration site for the Long Buccal nerve block?",
      options: [
        "At the mental foramen",
        "At the pterygomandibular triangle",
        "Distal and buccal to the most distal molar at occlusal plane height",
        "At the coronoid notch"
      ],
      correct: "C"
    },
    {
      id: 12138,
      question: "The Mental nerve block anesthetizes which area?",
      options: [
        "All mandibular teeth",
        "Facial soft tissues from mental foramen to midline and lower lip",
        "Lingual tissues",
        "All facial tissues"
      ],
      correct: "B"
    },
    {
      id: 12139,
      question: "The Incisive nerve block anesthetizes which teeth in addition to soft tissues?",
      options: [
        "All mandibular teeth",
        "Mandibular molars",
        "Mandibular second premolar to central incisor unilaterally",
        "Maxillary anterior teeth"
      ],
      correct: "C"
    },
    {
      id: 12140,
      question: "Where is the mental foramen typically located?",
      options: [
        "Near the first molar",
        "Near the first or second premolar",
        "Near the canine",
        "Near the third molar"
      ],
      correct: "B"
    },
    {
      id: 12141,
      question: "What is the recommended needle gauge and length for a mental nerve block?",
      options: [
        "25 or 27 gauge, long",
        "30 gauge, short",
        "25 or 27 gauge, short",
        "23 gauge, extra long"
      ],
      correct: "C"
    },
    {
      id: 12142,
      question: "Which complication involves difficulty opening the mouth after injection?",
      options: [
        "Hematoma",
        "Trismus",
        "Paresthesia",
        "Edema"
      ],
      correct: "B"
    },
    {
      id: 12143,
      question: "Which complication causes temporary facial drooping?",
      options: [
        "Needle breakage",
        "Hematoma",
        "Facial nerve paralysis",
        "Trismus"
      ],
      correct: "C"
    },
    {
      id: 12144,
      question: "What is paresthesia in the context of local anesthesia?",
      options: [
        "Temporary numbness during anesthesia",
        "Persistent numbness or tingling that doesn\'t go away quickly",
        "Pain during injection",
        "Allergic reaction"
      ],
      correct: "B"
    },
    {
      id: 12145,
      question: "What causes a hematoma after local anesthetic injection?",
      options: [
        "Allergic reaction",
        "Hitting a blood vessel",
        "Using expired anesthetic",
        "Injecting too quickly"
      ],
      correct: "B"
    },
    {
      id: 12146,
      question: "What is the difference between relative and absolute overdose?",
      options: [
        "There is no difference",
        "Relative is a normal dose causing strong effects in sensitive patients; absolute is too large a dose",
        "Relative is mild; absolute is always fatal",
        "Relative affects children; absolute affects adults"
      ],
      correct: "B"
    },
    {
      id: 12147,
      question: "Which type of local anesthetic is more commonly associated with allergies?",
      options: [
        "Amides",
        "Esters",
        "Both equally",
        "Neither causes allergies"
      ],
      correct: "B"
    },
    {
      id: 12148,
      question: "What is anaphylaxis?",
      options: [
        "Mild allergic reaction",
        "Delayed allergic response",
        "Severe, life-threatening allergic reaction",
        "Local tissue reaction"
      ],
      correct: "C"
    },
    {
      id: 12149,
      question: "What is the immediate treatment for anaphylaxis?",
      options: [
        "Antihistamine pill",
        "Epinephrine injection",
        "Ice pack",
        "Rest and observation"
      ],
      correct: "B"
    },
    {
      id: 12150,
      question: "What causes tissue sloughing after local anesthetic injection?",
      options: [
        "Normal reaction",
        "Allergic response",
        "Tissue damage from chemical irritation or ischemia",
        "Bacterial infection"
      ],
      correct: "C"
    },
    {
      id: 12151,
      question: "What is a Periodontal Ligament (PDL) injection?",
      options: [
        "Injection into the palate",
        "Injection directly into the periodontal ligament space of a tooth",
        "Injection into the mental foramen",
        "Topical application"
      ],
      correct: "B"
    },
    {
      id: 12152,
      question: "What areas are anesthetized with a PDL injection?",
      options: [
        "Multiple teeth",
        "Entire quadrant",
        "Only the pulp, soft tissue, and bone of the injected tooth",
        "All surrounding teeth"
      ],
      correct: "C"
    },
    {
      id: 12153,
      question: "What should be documented after administering local anesthetic?",
      options: [
        "Only the type of anesthetic",
        "Only the amount used",
        "Date, amount, type, concentration, injection site, reaction, and administrator",
        "Nothing needs to be documented"
      ],
      correct: "C"
    },
    {
      id: 12154,
      question: "What does \"25-gauge short\" refer to?",
      options: [
        "Needle diameter and length",
        "Cartridge size",
        "Syringe type",
        "Anesthetic concentration"
      ],
      correct: "A"
    },
    {
      id: 12155,
      question: "What is the purpose of aspirating before injecting local anesthetic?",
      options: [
        "To remove air bubbles",
        "To check if the needle is in a blood vessel",
        "To test the anesthetic",
        "To reduce pressure"
      ],
      correct: "B"
    },
    {
      id: 12156,
      question: "What is the bevel of a needle?",
      options: [
        "The hub attachment",
        "The angled tip",
        "The length measurement",
        "The gauge size"
      ],
      correct: "B"
    },
    {
      id: 12157,
      question: "What is ischemia in relation to local anesthetic with vasoconstrictor?",
      options: [
        "Allergic reaction",
        "Reduced blood flow to the area",
        "Increased sensation",
        "Nerve damage"
      ],
      correct: "B"
    },
    {
      id: 12158,
      question: "Why should the injection be administered slowly?",
      options: [
        "To conserve anesthetic",
        "To reduce pain and tissue trauma",
        "To speed up onset",
        "To prevent waste"
      ],
      correct: "B"
    },
    {
      id: 12159,
      question: "What is the purpose of topical anesthetic before injection?",
      options: [
        "To sterilize the area",
        "To numb the surface and reduce injection pain",
        "To prevent bleeding",
        "To speed up the main anesthetic"
      ],
      correct: "B"
    },
    {
      id: 12160,
      question: "How long should topical anesthetic be applied before injection?",
      options: [
        "5-10 seconds",
        "30 seconds to 2 minutes",
        "5-10 minutes",
        "Not specified in the material"
      ],
      correct: "B"
    },
    {
      id: 12161,
      question: "What does \"unilateral\" mean in anesthesia documentation?",
      options: [
        "Both sides",
        "One side only",
        "Upper and lower",
        "Front and back"
      ],
      correct: "B"
    },
    {
      id: 12162,
      question: "In a nerve block, where is the anesthetic deposited?",
      options: [
        "At the tooth apex",
        "In the gingival tissue",
        "Near a main nerve trunk",
        "On the surface only"
      ],
      correct: "C"
    },
    {
      id: 12163,
      question: "What landmark is used for the inferior alveolar nerve block?",
      options: [
        "Mental foramen",
        "Coronoid notch and pterygomandibular triangle",
        "Greater palatine foramen",
        "Incisive papilla"
      ],
      correct: "B"
    },
    {
      id: 12164,
      question: "What is the coronoid notch?",
      options: [
        "A depression on the maxilla",
        "The depression between the coronoid process and mandibular ramus",
        "The mental foramen opening",
        "The palatal tissue landmark"
      ],
      correct: "B"
    },
    {
      id: 12165,
      question: "What does ASA classification refer to in the context of patient assessment?",
      options: [
        "American Society of Anesthesiologists physical status classification",
        "Anterior Superior Alveolar nerve",
        "Aspiration Safety Assessment",
        "Anesthetic Solution Application"
      ],
      correct: "A"
    },
    {
      id: 12166,
      question: "Why is it important to know if a patient has liver disease?",
      options: [
        "It affects ester metabolism",
        "It affects amide metabolism",
        "It has no effect on anesthesia",
        "It only affects general anesthesia"
      ],
      correct: "B"
    },
    {
      id: 12167,
      question: "What does the pterygomandibular raphe indicate?",
      options: [
        "Location of blood vessels",
        "Landmark for inferior alveolar nerve block",
        "Site of muscle attachment only",
        "Area to avoid for injections"
      ],
      correct: "B"
    },
    {
      id: 12168,
      question: "What is the internal oblique ridge?",
      options: [
        "A maxillary landmark",
        "A mandibular bony landmark used for injection guidance",
        "A soft tissue structure",
        "A nerve pathway"
      ],
      correct: "B"
    },
    {
      id: 12169,
      question: "What is the purpose of the color-coded bands on anesthetic cartridges?",
      options: [
        "To indicate expiration date",
        "To identify the drug and vasoconstrictor concentration",
        "To show the manufacturer",
        "Purely decorative"
      ],
      correct: "B"
    },
    {
      id: 12170,
      question: "How many milliliters are in a standard dental anesthetic cartridge?",
      options: [
        "1.0 mL",
        "1.8 mL",
        "2.5 mL",
        "3.0 mL"
      ],
      correct: "B"
    },
    {
      id: 12171,
      question: "What is the mucobuccal fold?",
      options: [
        "A bone structure",
        "The junction where mucosa transitions from alveolar mucosa to buccal mucosa",
        "A nerve pathway",
        "A muscle attachment"
      ],
      correct: "B"
    },
    {
      id: 12172,
      question: "Where should used anesthetic needles be disposed?",
      options: [
        "Regular trash",
        "Sharps container",
        "Recycle bin",
        "Any medical waste container"
      ],
      correct: "B"
    },
    {
      id: 12173,
      question: "What does \"bilateral\" anesthesia mean?",
      options: [
        "Top and bottom",
        "Both left and right sides",
        "Front and back",
        "Inside and outside"
      ],
      correct: "B"
    }
  
  ],
  "7. Muscles of Mastication (Part 1)": [    {
      id: 12000,
      question: "What are muscle fibers?",
      options: [
        "Long cylindrical cells that make up muscles",
        "Short cells that connect bones together",
        "Small proteins within muscle tissue",
        "Nerve pathways that control muscles",
      ],
      correct: "A"
    },
    {
      id: 12001,
      question: "What is the typical diameter range of a muscle fiber cell?",
      options: [
        "100-200 microns",
        "10-100 microns",
        "1-10 microns",
        "5-50 microns",
      ],
      correct: "B"
    },
    {
      id: 12002,
      question: "What is the only active movement that muscles can perform?",
      options: [
        "Extension",
        "Relaxation",
        "Contraction",
        "Stretching",
      ],
      correct: "C"
    },
    {
      id: 12003,
      question: "How do muscles move bones in opposite directions?",
      options: [
        "By pushing instead of pulling",
        "By stretching and contracting simultaneously",
        "By rotating around the bone",
        "By pairs of muscles working together, one contracting while the other relaxes",
      ],
      correct: "D"
    },
    {
      id: 12004,
      question: "Which type of muscle is found in the digestive system and bladder?",
      options: [
        "Smooth muscle",
        "Cardiac muscle",
        "Skeletal muscle",
        "Voluntary muscle",
      ],
      correct: "A"
    },
    {
      id: 12005,
      question: "Which characteristic is unique to smooth muscle?",
      options: [
        "Only found in the heart",
        "Can stretch and maintain tension for long periods",
        "Short twitch movements only",
        "Always voluntary",
      ],
      correct: "B"
    },
    {
      id: 12006,
      question: "Where is cardiac muscle exclusively found?",
      options: [
        "In major blood vessels",
        "In the digestive system",
        "Only in the heart",
        "Throughout the circulatory system",
      ],
      correct: "C"
    },
    {
      id: 12007,
      question: "Which type of muscle is primarily studied in relation to mastication?",
      options: [
        "Involuntary muscle",
        "Cardiac muscle",
        "Smooth muscle",
        "Skeletal muscle",
      ],
      correct: "D"
    },
    {
      id: 12008,
      question: "What is the definition of a muscle's \"origin\"?",
      options: [
        "The end attached to the least movable structure",
        "The end attached to the more movable structure",
        "The middle point of the muscle",
        "The point where the muscle receives nerve signals",
      ],
      correct: "A"
    },
    {
      id: 12009,
      question: "What is the definition of a muscle's \"insertion\"?",
      options: [
        "The nerve attachment point",
        "The end attached to the more movable structure",
        "The end attached to the immovable bone",
        "The center of the muscle belly",
      ],
      correct: "B"
    },
    {
      id: 12010,
      question: "What does \"elevation\" of the mandible mean?",
      options: [
        "Pushing the jaw forward",
        "Lowering the jaw",
        "Lifting the jaw upward",
        "Moving the jaw sideways",
      ],
      correct: "C"
    },
    {
      id: 12011,
      question: "What does \"depression\" of the mandible refer to?",
      options: [
        "Grinding motion",
        "Moving the jaw backward",
        "Lifting the jaw",
        "Lowering the jaw",
      ],
      correct: "D"
    },
    {
      id: 12012,
      question: "What is \"retraction\" of the mandible?",
      options: [
        "Pulling the jaw backward",
        "Pushing the jaw forward",
        "Moving the jaw sideways",
        "Opening the mouth",
      ],
      correct: "A"
    },
    {
      id: 12013,
      question: "What is \"protraction\" of the mandible?",
      options: [
        "Side-to-side movement",
        "Pushing the jaw forward",
        "Pulling the jaw backward",
        "Closing the mouth",
      ],
      correct: "B"
    },
    {
      id: 12014,
      question: "What does \"medial/lateral excursion\" of the mandible describe?",
      options: [
        "Pushing the jaw forward",
        "Lifting the jaw upward",
        "Moving the jaw from side to side",
        "Opening and closing the mouth",
      ],
      correct: "C"
    },
    {
      id: 12015,
      question: "What does the term \"mastication\" mean?",
      options: [
        "Speaking",
        "Swallowing",
        "Breathing",
        "Chewing",
      ],
      correct: "D"
    },
    {
      id: 12016,
      question: "How many pairs of muscles are responsible for mastication?",
      options: [
        "Four pairs",
        "Two pairs",
        "Three pairs",
        "Five pairs",
      ],
      correct: "A"
    },
    {
      id: 12017,
      question: "What are the four muscles of mastication?",
      options: [
        "Lateral pterygoid, Buccinator, Masseter, Digastric",
        "Masseter, Temporalis, Medial pterygoid, Lateral pterygoid",
        "Masseter, Temporalis, Buccinator, Digastric",
        "Temporalis, Masseter, Mylohyoid, Geniohyoid",
      ],
      correct: "B"
    },
    {
      id: 12018,
      question: "Which nerve innervates all the muscles of mastication?",
      options: [
        "Glossopharyngeal nerve (CN IX)",
        "Facial nerve (CN VII)",
        "Mandibular division of the trigeminal nerve (V3)",
        "Hypoglossal nerve (CN XII)",
      ],
      correct: "C"
    },
    {
      id: 12019,
      question: "What provides the blood supply to the muscles of mastication?",
      options: [
        "External carotid artery directly",
        "Lingual artery",
        "Facial artery",
        "Maxillary artery",
      ],
      correct: "D"
    },
    {
      id: 12020,
      question: "Where does the masseter muscle insert?",
      options: [
        "Angle of the mandible on the lateral side",
        "Coronoid process of the mandible",
        "Neck of the mandibular condyle",
        "Ramus of the mandible on the medial side",
      ],
      correct: "A"
    },
    {
      id: 12021,
      question: "How many heads does the masseter muscle have?",
      options: [
        "Four",
        "Two",
        "One",
        "Three",
      ],
      correct: "B"
    },
    {
      id: 12022,
      question: "What is the primary action of the masseter muscle?",
      options: [
        "Retraction of the mandible",
        "Depression of the mandible",
        "Elevation of the mandible",
        "Lateral movement of the jaw",
      ],
      correct: "C"
    },
    {
      id: 12023,
      question: "Where does the temporalis muscle originate?",
      options: [
        "Maxilla",
        "Zygomatic arch",
        "Sphenoid bone",
        "Temporal fossa of the temporal bone",
      ],
      correct: "D"
    },
    {
      id: 12024,
      question: "Where does the temporalis muscle insert?",
      options: [
        "Coronoid process of the mandible and anterior border of ramus",
        "Angle of the mandible",
        "Neck of the condyle",
        "Body of the mandible",
      ],
      correct: "A"
    },
    {
      id: 12025,
      question: "What are the two actions of the temporalis muscle?",
      options: [
        "Depression and protraction",
        "Elevation and retraction",
        "Protraction and lateral movement",
        "Elevation and depression",
      ],
      correct: "B"
    },
    {
      id: 12026,
      question: "Why does the temporalis muscle have two different actions?",
      options: [
        "It has superior and inferior heads",
        "It has two separate nerve supplies",
        "Its anterior fibers are vertical and posterior fibers are horizontal",
        "It attaches to two different bones",
      ],
      correct: "C"
    },
    {
      id: 12027,
      question: "Where is the major origin of the medial pterygoid muscle?",
      options: [
        "Greater wing of the sphenoid",
        "Lateral surface of the lateral pterygoid plate",
        "Maxillary tuberosity",
        "Medial side of the lateral pterygoid plate",
      ],
      correct: "D"
    },
    {
      id: 12028,
      question: "Where does the medial pterygoid muscle insert?",
      options: [
        "Angle of the mandible on the medial side",
        "Angle of the mandible on the lateral side",
        "Coronoid process",
        "Neck of the condyle",
      ],
      correct: "A"
    },
    {
      id: 12029,
      question: "What are the two actions of the medial pterygoid muscle?",
      options: [
        "Protraction and elevation",
        "Elevation and lateral movement",
        "Depression and protraction",
        "Retraction and depression",
      ],
      correct: "B"
    },
    {
      id: 12030,
      question: "The medial pterygoid muscle is opposite to which other muscle?",
      options: [
        "Buccinator",
        "Temporalis",
        "Masseter",
        "Lateral pterygoid",
      ],
      correct: "C"
    },
    {
      id: 12031,
      question: "How many heads does the lateral pterygoid muscle have?",
      options: [
        "Four",
        "One",
        "Three",
        "Two",
      ],
      correct: "D"
    },
    {
      id: 12032,
      question: "Where does the superior head of the lateral pterygoid originate?",
      options: [
        "Lateral surface of the greater wing of the sphenoid",
        "Lateral surface of the lateral pterygoid plate",
        "Medial surface of the lateral pterygoid plate",
        "Maxillary tuberosity",
      ],
      correct: "A"
    },
    {
      id: 12033,
      question: "Where does the inferior head of the lateral pterygoid originate?",
      options: [
        "Temporal fossa",
        "Lateral surface of the lateral pterygoid plate",
        "Greater wing of the sphenoid",
        "Medial pterygoid plate",
      ],
      correct: "B"
    },
    {
      id: 12034,
      question: "Where does the inferior head of the lateral pterygoid insert?",
      options: [
        "Angle of the mandible",
        "Articular disk of the TMJ",
        "Neck of the mandibular condyle",
        "Coronoid process",
      ],
      correct: "C"
    },
    {
      id: 12035,
      question: "Where does the superior head of the lateral pterygoid insert?",
      options: [
        "Ramus of the mandible",
        "Neck of the condyle",
        "Coronoid process",
        "Articular disk of the TMJ",
      ],
      correct: "D"
    },
    {
      id: 12036,
      question: "What is unique about the lateral pterygoid compared to other muscles of mastication?",
      options: [
        "It is the only muscle responsible for depression of the mandible",
        "It is the strongest muscle",
        "It is innervated by a different nerve",
        "It has three heads",
      ],
      correct: "A"
    },
    {
      id: 12037,
      question: "What are the actions of the lateral pterygoid muscle?",
      options: [
        "Retraction and elevation",
        "Protrusion, depression, and lateral movement",
        "Only elevation",
        "Elevation and retraction",
      ],
      correct: "B"
    },
    {
      id: 12038,
      question: "Which muscle action is described as the \"power stroke\" in mastication?",
      options: [
        "Retraction by the temporalis",
        "Elevation by the masseter",
        "The superior head of lateral pterygoid guiding the disc and condyle back",
        "Depression by the lateral pterygoid",
      ],
      correct: "C"
    },
    {
      id: 12039,
      question: "Which muscle elevates the jaw but does NOT move it side to side?",
      options: [
        "All muscles of mastication move the jaw side to side",
        "Lateral pterygoid",
        "Medial pterygoid",
        "Masseter",
      ],
      correct: "D"
    },
    {
      id: 12040,
      question: "Which muscle can both protrude the jaw and move it laterally?",
      options: [
        "Lateral pterygoid",
        "Masseter",
        "Temporalis",
        "Medial pterygoid",
      ],
      correct: "A"
    },
    {
      id: 12041,
      question: "Which muscle can both elevate and retract the mandible?",
      options: [
        "Lateral pterygoid",
        "Temporalis",
        "Medial pterygoid",
        "Masseter",
      ],
      correct: "B"
    },
    {
      id: 12042,
      question: "How many muscles of mastication can elevate the mandible?",
      options: [
        "Four",
        "Two",
        "Three",
        "One",
      ],
      correct: "C"
    },
    {
      id: 12043,
      question: "Where does the sternocleidomastoid muscle originate?",
      options: [
        "Occipital bone",
        "Mastoid process",
        "Clavicle only",
        "Upper border of the sternum and medial 1/3 of the clavicle",
      ],
      correct: "D"
    },
    {
      id: 12044,
      question: "Where does the sternocleidomastoid muscle insert?",
      options: [
        "Mastoid process of the temporal bone",
        "Clavicle",
        "Sternum",
        "Mandible",
      ],
      correct: "A"
    },
    {
      id: 12045,
      question: "What is the primary action of the sternocleidomastoid muscle?",
      options: [
        "Flexing the neck forward only",
        "Tilting and rotating the head",
        "Opening the jaw",
        "Elevating the shoulder",
      ],
      correct: "B"
    },
    {
      id: 12046,
      question: "Why is the sternocleidomastoid muscle important during extraoral examinations?",
      options: [
        "To evaluate jaw movement",
        "To check for TMJ disorders",
        "To palpate the posterior border for large lymph nodes",
        "To assess muscle strength",
      ],
      correct: "C"
    },
    {
      id: 12047,
      question: "What can strain in the sternocleidomastoid muscle cause?",
      options: [
        "Hearing loss",
        "Difficulty swallowing",
        "Vision problems",
        "Referred pain in the head and neck, especially the temporomandibular region",
      ],
      correct: "D"
    },
    {
      id: 12048,
      question: "Where does the trapezius muscle originate?",
      options: [
        "Humerus and radius",
        "External occipital protuberance, superior nuchal lines, and spinous processes of cervical and thoracic vertebrae",
        "Scapula and clavicle",
        "Sternum and ribs",
      ],
      correct: "B"
    },
    {
      id: 12049,
      question: "Where does the trapezius muscle insert?",
      options: [
        "Sternum",
        "Vertebrae",
        "Spine of scapula, acromion process, and lateral 1/3 of clavicle",
        "Humerus",
      ],
      correct: "C"
    },
    {
      id: 12050,
      question: "What is the primary action of the trapezius muscle?",
      options: [
        "Flexing the spine",
        "Rotating the head",
        "Elevating the ribs",
        "Adducting, elevating, and rotating the scapula",
      ],
      correct: "D"
    },
    {
      id: 12051,
      question: "What common movement demonstrates the action of the trapezius muscle?",
      options: [
        "Shrugging the shoulders",
        "Nodding the head",
        "Turning the head side to side",
        "Bending forward",
      ],
      correct: "A"
    },
    {
      id: 12052,
      question: "What type of muscle tissue makes up the muscles of mastication?",
      options: [
        "Mixed muscle types",
        "Skeletal muscle",
        "Smooth muscle",
        "Cardiac muscle",
      ],
      correct: "B"
    },
    {
      id: 12053,
      question: "What is the approximate length range of muscle fiber cells?",
      options: [
        "50-100 millimeters",
        "10-40 microns",
        "1-40 millimeters",
        "1-10 microns",
      ],
      correct: "C"
    },
    {
      id: 12054,
      question: "How does the brain control muscle contraction?",
      options: [
        "Via the lymphatic system",
        "Through hormones in the bloodstream",
        "Through direct contact with muscle fibers",
        "By sending electrical impulses via nerve pathways",
      ],
      correct: "D"
    },
    {
      id: 12055,
      question: "What allows muscles to contract with different levels of force?",
      options: [
        "The signal strength that the nerve sends",
        "The number of muscle fibers",
        "The length of the muscle",
        "The temperature of the muscle",
      ],
      correct: "A"
    },
    {
      id: 12056,
      question: "What are the characteristics of involuntary muscles?",
      options: [
        "They are stronger than voluntary muscles",
        "They work without conscious control",
        "They can be consciously controlled",
        "They are only found in the limbs",
      ],
      correct: "B"
    },
    {
      id: 12057,
      question: "Which type of muscle movement is described as a \"tetanus\"?",
      options: [
        "Relaxation phase",
        "Rapid twitching",
        "Longer sustained contraction",
        "Short contraction",
      ],
      correct: "C"
    },
    {
      id: 12058,
      question: "Which muscles are typically paired to move bones in opposite directions?",
      options: [
        "All muscle types",
        "Cardiac muscles",
        "Skeletal muscles",
        "Smooth muscles",
      ],
      correct: "C"
    },
    {
      id: 12059,
      question: "What is the main feature of cardiac muscle?",
      options: [
        "Short, powerful contractions only",
        "Endurance and consistency",
        "Voluntary control",
        "Ability to stretch extensively",
      ],
      correct: "B"
    },
    {
      id: 12060,
      question: "What determines whether a muscle action is voluntary or involuntary?",
      options: [
        "The strength of the muscle",
        "The type of muscle tissue",
        "The size of the muscle",
        "The location of the muscle",
      ],
      correct: "B"
    },
    {
      id: 12061,
      question: "In the mnemonic \"Mouth, Top, Mouth, lower\" for muscles of mastication, what does \"Top\" refer to?",
      options: [
        "Lateral pterygoid",
        "Medial pterygoid",
        "Temporalis",
        "Masseter",
      ],
      correct: "C"
    },
    {
      id: 12062,
      question: "What does the mnemonic \"MMLT\" stand for in muscles of mastication?",
      options: [
        "Masseter, Mandible, Lateral movement, Temporalis",
        "Medial pterygoid, Masseter, Lateral pterygoid, Trapezius",
        "Masseter, Mylohyoid, Lateral pterygoid, Temporalis",
        "Masseter, Medial pterygoid, Lateral pterygoid, Temporalis",
      ],
      correct: "D"
    },
    {
      id: 12063,
      question: "What structural feature allows the temporalis muscle to both elevate and retract?",
      options: [
        "Different fiber orientations (vertical anterior, horizontal posterior)",
        "Two separate muscle bellies",
        "Dual nerve supply",
        "Two insertion points",
      ],
      correct: "A"
    },
    {
      id: 12064,
      question: "Which muscle has insertion points that are opposite to the masseter muscle?",
      options: [
        "Buccinator",
        "Temporalis",
        "Medial pterygoid",
        "Lateral pterygoid",
      ],
      correct: "C"
    },
    {
      id: 12065,
      question: "What is the relationship between the medial and lateral pterygoid muscles in terms of origin?",
      options: [
        "They both originate from the maxilla",
        "They originate from opposite sides of the lateral pterygoid plate",
        "One originates from bone, the other from cartilage",
        "They have identical origins",
      ],
      correct: "B"
    },
    {
      id: 12066,
      question: "Which muscle of mastication has the most complex insertion pattern?",
      options: [
        "Temporalis",
        "Medial pterygoid",
        "Masseter",
        "Lateral pterygoid",
      ],
      correct: "D"
    },
    {
      id: 12067,
      question: "What happens when only one lateral pterygoid muscle contracts?",
      options: [
        "Lateral movement occurs",
        "The jaw elevates",
        "The jaw depresses",
        "The jaw retracts",
      ],
      correct: "A"
    },
    {
      id: 12068,
      question: "During the chewing process, which muscle is primarily responsible for the grinding motion?",
      options: [
        "Lateral pterygoid",
        "Medial pterygoid",
        "Masseter",
        "Temporalis",
      ],
      correct: "B"
    },
    {
      id: 12069,
      question: "What is the significance of muscle fiber diameter compared to typical cell size?",
      options: [
        "There is no significant difference",
        "Muscle fibers are about the same size as typical cells",
        "Muscle fibers are significantly larger than typical cells",
        "Muscle fibers are smaller than typical cells",
      ],
      correct: "C"
    },
    {
      id: 12070,
      question: "How does a strand of hair compare in size to a typical cell?",
      options: [
        "1000 times larger",
        "100 times larger",
        "About the same size",
        "10 times larger",
      ],
      correct: "D"
    },
    {
      id: 12071,
      question: "What layer is found between skin and muscle tissue?",
      options: [
        "Fat (subcutaneous tissue)",
        "Bone",
        "Cartilage",
        "Nerve tissue",
      ],
      correct: "A"
    },
    {
      id: 12072,
      question: "During jaw movement, what allows smooth articulation at the TMJ?",
      options: [
        "Ligaments exclusively",
        "Muscle strength alone",
        "The articular disk and superior head of lateral pterygoid",
        "Bone structure only",
      ],
      correct: "C"
    },
    {
      id: 12073,
      question: "What clinical significance does the posterior border of the sternocleidomastoid have?",
      options: [
        "It shows the boundary of the parotid gland",
        "It marks the location of the carotid artery",
        "It indicates the position of the thyroid gland",
        "It's a landmark for palpating lymph nodes along the internal jugular vein",
      ],
      correct: "D"
    },
    {
      id: 12074,
      question: "Which structure lies against the internal jugular vein near the sternocleidomastoid?",
      options: [
        "Large lymph nodes",
        "Parotid gland",
        "Thyroid gland",
        "Salivary glands",
      ],
      correct: "A"
    },
    {
      id: 12075,
      question: "What is scapular adduction?",
      options: [
        "Rotating the shoulder blades",
        "Moving the shoulder blades together",
        "Moving the shoulder blades apart",
        "Lifting the shoulder blades",
      ],
      correct: "B"
    },
    {
      id: 12076,
      question: "What is scapular elevation?",
      options: [
        "Rotating shoulders",
        "Moving shoulders forward",
        "Lifting shoulders upward",
        "Moving shoulders backward",
      ],
      correct: "C"
    },
    {
      id: 12077,
      question: "How many major attachment points does the trapezius have at its origin?",
      options: [
        "Four",
        "Two",
        "Three (occipital bone, nuchal lines, and vertebral spinous processes)",
        "One",
      ],
      correct: "C"
    },
    {
      id: 12078,
      question: "What bone feature serves as part of the trapezius origin on the skull?",
      options: [
        "Temporal line",
        "Zygomatic arch",
        "Mastoid process",
        "External occipital protuberance",
      ],
      correct: "D"
    },
    {
      id: 12079,
      question: "What is the functional relationship between the sternocleidomastoid and trapezius?",
      options: [
        "They both work on neck and shoulder movement",
        "They are antagonists",
        "They have no relationship",
        "One is voluntary, the other involuntary",
      ],
      correct: "A"
    },
    {
      id: 12080,
      question: "Which vertebrae contribute to the origin of the trapezius?",
      options: [
        "Thoracic only",
        "Both cervical and thoracic",
        "Lumbar only",
        "Cervical only",
      ],
      correct: "B"
    },
    {
      id: 12081,
      question: "What is the acromion process?",
      options: [
        "Part of the sternum",
        "Part of the scapula",
        "Part of the clavicle",
        "Part of the humerus",
      ],
      correct: "B"
    },
    {
      id: 12082,
      question: "How does the trapezius contribute to shoulder movement?",
      options: [
        "By depressing the shoulder only",
        "Only by elevating the shoulder",
        "By adducting, elevating, and rotating the scapula",
        "Only by rotating the shoulder",
      ],
      correct: "C"
    }
  ],
  "7. Muscles of Mastication (Part 2)": [
    {
      id: 12200,
      question: "What are muscle fibers?",
      options: [
        "Short cells that connect bones together",
        "Long cylindrical cells that make up muscle bundles",
        "Nerve pathways that transmit signals",
        "Blood vessels that supply muscles with oxygen"
      ],
      correct: "B"
    },
    {
      id: 12201,
      question: "What is the primary active movement that muscles can perform?",
      options: [
        "Expansion",
        "Rotation",
        "Contraction",
        "Elongation"
      ],
      correct: "C"
    },
    {
      id: 12202,
      question: "How does the brain communicate with muscles to produce movement?",
      options: [
        "Through hormonal signals via the bloodstream",
        "By direct physical connection through cartilage",
        "Via electrical impulses through nerve pathways",
        "Through chemical reactions in muscle tissue"
      ],
      correct: "C"
    },
    {
      id: 12203,
      question: "What is the typical diameter range of muscle fiber cells?",
      options: [
        "1-10 microns",
        "10-100 microns",
        "100-200 microns",
        "200-500 microns"
      ],
      correct: "B"
    },
    {
      id: 12204,
      question: "Which type of muscle is found in the digestive system and bladder?",
      options: [
        "Cardiac muscle",
        "Skeletal muscle",
        "Voluntary muscle",
        "Smooth muscle"
      ],
      correct: "D"
    },
    {
      id: 12205,
      question: "What is a characteristic feature of cardiac muscle?",
      options: [
        "Can stretch and maintain tension for long periods",
        "Short twitch movements only",
        "Voluntary control by conscious thought",
        "Attaches directly to the skeleton"
      ],
      correct: "B"
    },
    {
      id: 12206,
      question: "Which type of muscle attaches to the skeleton and typically comes in pairs?",
      options: [
        "Smooth muscle",
        "Cardiac muscle",
        "Skeletal muscle",
        "Involuntary muscle"
      ],
      correct: "C"
    },
    {
      id: 12207,
      question: "What are the two types of skeletal muscle contractions?",
      options: [
        "Rapid and slow",
        "Strong and weak",
        "Twitch and tetanus",
        "Voluntary and involuntary"
      ],
      correct: "C"
    },
    {
      id: 12208,
      question: "What is the origin of a muscle?",
      options: [
        "The end attached to the more movable structure",
        "The end attached to the least movable structure",
        "The middle portion of the muscle belly",
        "The nerve supply entering the muscle"
      ],
      correct: "B"
    },
    {
      id: 12209,
      question: "What is the insertion of a muscle?",
      options: [
        "The point where nerves enter the muscle",
        "The end attached to the immovable bone",
        "The end attached to the more movable structure",
        "The center of the muscle fiber bundle"
      ],
      correct: "C"
    },
    {
      id: 12210,
      question: "Which term describes lifting the mandible and bringing teeth together?",
      options: [
        "Depression",
        "Retraction",
        "Elevation",
        "Protraction"
      ],
      correct: "C"
    },
    {
      id: 12211,
      question: "What does retraction of the mandible mean?",
      options: [
        "Moving the jaw from side to side",
        "Pulling the mandible posteriorly",
        "Lowering the mandible",
        "Pushing the mandible forward"
      ],
      correct: "B"
    },
    {
      id: 12212,
      question: "What is protraction of the mandible?",
      options: [
        "Lifting the jaw upward",
        "Moving the jaw backward",
        "Pushing the mandible anteriorly",
        "Moving the jaw laterally"
      ],
      correct: "C"
    },
    {
      id: 12213,
      question: "What does medial/lateral excursion refer to?",
      options: [
        "Opening and closing the mouth",
        "Moving the mandible from side to side",
        "Lifting and lowering the jaw",
        "Forward and backward jaw movement"
      ],
      correct: "B"
    },
    {
      id: 12214,
      question: "How many pairs of muscles are responsible for mastication?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five"
      ],
      correct: "C"
    },
    {
      id: 12215,
      question: "What is mastication?",
      options: [
        "The process of swallowing food",
        "The process of breathing",
        "The process of breaking food down with teeth",
        "The process of digesting food"
      ],
      correct: "C"
    },
    {
      id: 12216,
      question: "Which nerve innervates all muscles of mastication?",
      options: [
        "Facial nerve",
        "Hypoglossal nerve",
        "Mandibular division of trigeminal nerve (V3)",
        "Glossopharyngeal nerve"
      ],
      correct: "C"
    },
    {
      id: 12217,
      question: "What provides the blood supply to the muscles of mastication?",
      options: [
        "Facial artery",
        "Lingual artery",
        "Maxillary artery",
        "External carotid artery"
      ],
      correct: "C"
    },
    {
      id: 12218,
      question: "What is the primary action of the masseter muscle?",
      options: [
        "Opens the mouth",
        "Moves jaw side to side",
        "Pulls jaw backward",
        "Elevates the jaw"
      ],
      correct: "D"
    },
    {
      id: 12219,
      question: "Where does the masseter muscle insert?",
      options: [
        "Coronoid process of mandible",
        "Angle of the mandible on the lateral side",
        "Condyle of the mandible",
        "Medial surface of the ramus"
      ],
      correct: "B"
    },
    {
      id: 12220,
      question: "How many heads does the masseter muscle have?",
      options: [
        "One",
        "Two",
        "Three",
        "Four"
      ],
      correct: "B"
    },
    {
      id: 12221,
      question: "What is the shape of the temporalis muscle?",
      options: [
        "Rectangular",
        "Circular",
        "Fan-shaped",
        "Triangular"
      ],
      correct: "C"
    },
    {
      id: 12222,
      question: "Where does the temporalis muscle originate?",
      options: [
        "Zygomatic arch",
        "Maxillary bone",
        "Temporal fossa of the temporal bone",
        "Sphenoid bone"
      ],
      correct: "C"
    },
    {
      id: 12223,
      question: "Where does the temporalis muscle insert?",
      options: [
        "Angle of the mandible",
        "Coronoid process and anterior border of ramus",
        "Condyle of the mandible",
        "Mental protuberance"
      ],
      correct: "B"
    },
    {
      id: 12224,
      question: "What action do the posterior fibers of the temporalis produce?",
      options: [
        "Elevation only",
        "Depression of mandible",
        "Retraction of mandible",
        "Lateral movement"
      ],
      correct: "C"
    },
    {
      id: 12225,
      question: "What are the two primary actions of the temporalis muscle?",
      options: [
        "Elevation and depression",
        "Elevation and retraction",
        "Protraction and retraction",
        "Protraction and depression"
      ],
      correct: "B"
    },
    {
      id: 12226,
      question: "Where is the major origin of the medial pterygoid muscle?",
      options: [
        "Lateral surface of lateral pterygoid plate",
        "Medial side of the lateral pterygoid plate",
        "Greater wing of sphenoid",
        "Temporal fossa"
      ],
      correct: "B"
    },
    {
      id: 12227,
      question: "What is the smaller origin point of the medial pterygoid muscle?",
      options: [
        "Palatine bone",
        "Zygomatic bone",
        "Maxillary tuberosity",
        "Coronoid process"
      ],
      correct: "C"
    },
    {
      id: 12228,
      question: "Where does the medial pterygoid muscle insert?",
      options: [
        "Lateral side of mandibular angle",
        "Coronoid process",
        "Condyle of mandible",
        "Medial side of mandibular angle"
      ],
      correct: "D"
    },
    {
      id: 12229,
      question: "What are the two main actions of the medial pterygoid muscle?",
      options: [
        "Depression and protraction",
        "Elevation and lateral movement",
        "Retraction and elevation",
        "Depression and retraction"
      ],
      correct: "B"
    },
    {
      id: 12230,
      question: "How many heads does the lateral pterygoid muscle have?",
      options: [
        "One",
        "Two",
        "Three",
        "Four"
      ],
      correct: "B"
    },
    {
      id: 12231,
      question: "Where does the superior head of the lateral pterygoid originate?",
      options: [
        "Medial surface of lateral pterygoid plate",
        "Maxillary tuberosity",
        "Lateral surface of greater wing of sphenoid",
        "Temporal fossa"
      ],
      correct: "C"
    },
    {
      id: 12232,
      question: "Where does the inferior head of the lateral pterygoid originate?",
      options: [
        "Greater wing of sphenoid",
        "Lateral surface of the lateral pterygoid plate",
        "Medial surface of lateral pterygoid plate",
        "Zygomatic arch"
      ],
      correct: "B"
    },
    {
      id: 12233,
      question: "Where does the inferior head of the lateral pterygoid insert?",
      options: [
        "Coronoid process",
        "Articular disk of TMJ",
        "Neck of mandibular condyle",
        "Angle of mandible"
      ],
      correct: "C"
    },
    {
      id: 12234,
      question: "Where does the superior head of the lateral pterygoid insert?",
      options: [
        "Neck of condyle",
        "Coronoid process",
        "Articular disk of the TMJ",
        "Angle of mandible"
      ],
      correct: "C"
    },
    {
      id: 12235,
      question: "What is unique about the lateral pterygoid among the muscles of mastication?",
      options: [
        "It is the largest muscle",
        "It is the only one that depresses the mandible",
        "It has three heads",
        "It causes only elevation"
      ],
      correct: "B"
    },
    {
      id: 12236,
      question: "What are the primary actions of the lateral pterygoid muscle?",
      options: [
        "Elevation and retraction",
        "Protrusion and lateral movement",
        "Depression and retraction",
        "Elevation and lateral movement"
      ],
      correct: "B"
    },
    {
      id: 12237,
      question: "What special role does the superior head of the lateral pterygoid play?",
      options: [
        "Opens the mouth widely",
        "Guides the disc and condyle back after biting",
        "Closes the mouth forcefully",
        "Moves jaw backward"
      ],
      correct: "B"
    },
    {
      id: 12238,
      question: "Where does the sternocleidomastoid muscle originate?",
      options: [
        "Mastoid process and clavicle",
        "Upper border of sternum and medial 1/3 of clavicle",
        "Scapula and sternum",
        "Temporal bone and sternum"
      ],
      correct: "B"
    },
    {
      id: 12239,
      question: "Where does the sternocleidomastoid muscle insert?",
      options: [
        "Occipital bone",
        "Clavicle",
        "Mastoid process of temporal bone",
        "Acromion process"
      ],
      correct: "C"
    },
    {
      id: 12240,
      question: "What is the primary action of the sternocleidomastoid muscle?",
      options: [
        "Elevating the shoulders",
        "Rotating the scapula",
        "Tilting and rotating the head",
        "Protruding the mandible"
      ],
      correct: "C"
    },
    {
      id: 12241,
      question: "Why do we palpate the posterior border of the sternocleidomastoid?",
      options: [
        "To assess muscle strength",
        "To check for large lymph nodes",
        "To measure blood pressure",
        "To locate the carotid pulse"
      ],
      correct: "B"
    },
    {
      id: 12242,
      question: "Where does the trapezius muscle originate?",
      options: [
        "Only from the scapula",
        "Clavicle and sternum",
        "External occipital protuberance and spinous processes",
        "Mastoid process and clavicle"
      ],
      correct: "C"
    },
    {
      id: 12243,
      question: "Where does the trapezius muscle insert?",
      options: [
        "Mastoid process only",
        "Spine of scapula, acromion, and lateral 1/3 of clavicle",
        "Medial border of scapula only",
        "Humerus and radius"
      ],
      correct: "B"
    },
    {
      id: 12244,
      question: "What is the primary action of the trapezius muscle?",
      options: [
        "Rotating the head",
        "Elevating the mandible",
        "Adducting and elevating the scapula",
        "Depressing the shoulders"
      ],
      correct: "C"
    },
    {
      id: 12245,
      question: "What common movement demonstrates trapezius action?",
      options: [
        "Nodding the head",
        "Chewing food",
        "Shrugging the shoulders",
        "Opening the mouth"
      ],
      correct: "C"
    },
    {
      id: 12246,
      question: "Which muscle forms the most superficial layer of the back?",
      options: [
        "Sternocleidomastoid",
        "Latissimus dorsi",
        "Masseter",
        "Trapezius"
      ],
      correct: "D"
    },
    {
      id: 12247,
      question: "What can be compared to understand the size of a muscle fiber?",
      options: [
        "Red blood cell (smaller than fiber)",
        "Strand of hair (similar to fiber diameter)",
        "Nerve cell (same size as fiber)",
        "White blood cell (larger than fiber)"
      ],
      correct: "B"
    },
    {
      id: 12248,
      question: "What allows muscles to contract with different levels of force?",
      options: [
        "The amount of blood flow to the muscle",
        "The temperature of the muscle tissue",
        "The signal strength from the nerve",
        "The length of the muscle fibers"
      ],
      correct: "C"
    },
    {
      id: 12249,
      question: "How do most bones achieve movement in opposite directions?",
      options: [
        "By rotating at the joint",
        "Through pairs of muscles that move them",
        "By lengthening and shortening",
        "Through ligament tension"
      ],
      correct: "B"
    },
    {
      id: 12250,
      question: "What type of muscle tissue has endurance and consistency as main features?",
      options: [
        "Smooth muscle",
        "Skeletal muscle",
        "Cardiac muscle",
        "Voluntary muscle"
      ],
      correct: "C"
    },
    {
      id: 12251,
      question: "Which muscles are primarily studied in dental anatomy?",
      options: [
        "Cardiac muscles",
        "Smooth muscles",
        "Skeletal muscles",
        "Involuntary muscles"
      ],
      correct: "C"
    },
    {
      id: 12252,
      question: "What term describes the work accomplished when muscle fibers contract?",
      options: [
        "Origin",
        "Insertion",
        "Action",
        "Innervation"
      ],
      correct: "C"
    },
    {
      id: 12253,
      question: "What may muscle names provide information about?",
      options: [
        "Their color",
        "Their origin",
        "Their temperature",
        "Their age"
      ],
      correct: "B"
    },
    {
      id: 12254,
      question: "Which movement would you use to create a \"double chin\"?",
      options: [
        "Elevation",
        "Depression",
        "Protraction",
        "Retraction"
      ],
      correct: "D"
    },
    {
      id: 12255,
      question: "What movement occurs when you stick your lower jaw forward?",
      options: [
        "Elevation",
        "Retraction",
        "Protraction",
        "Lateral excursion"
      ],
      correct: "C"
    },
    {
      id: 12256,
      question: "What type of jaw movement is used for grinding food?",
      options: [
        "Elevation only",
        "Depression only",
        "Protraction only",
        "Lateral excursion"
      ],
      correct: "D"
    },
    {
      id: 12257,
      question: "Which muscles work together as a functional pair on opposite sides of the mandible?",
      options: [
        "Temporalis and trapezius",
        "Masseter and medial pterygoid",
        "Sternocleidomastoid and trapezius",
        "Lateral pterygoid and masseter"
      ],
      correct: "B"
    },
    {
      id: 12258,
      question: "What structure runs along the posterior border of the sternocleidomastoid?",
      options: [
        "External jugular vein",
        "Facial artery",
        "Internal jugular vein",
        "Common carotid artery"
      ],
      correct: "C"
    },
    {
      id: 12259,
      question: "What type of pain might be associated with the sternocleidomastoid?",
      options: [
        "Tooth pain",
        "Referred pain to head and neck",
        "Shoulder pain only",
        "Back pain only"
      ],
      correct: "B"
    },
    {
      id: 12260,
      question: "What bony landmark helps identify the origin of the trapezius?",
      options: [
        "Mastoid process",
        "External occipital protuberance",
        "Zygomatic arch",
        "Mental foramen"
      ],
      correct: "B"
    },
    {
      id: 12261,
      question: "Which structure is NOT a part of the trapezius insertion?",
      options: [
        "Spine of scapula",
        "Acromion process",
        "Lateral 1/3 of clavicle",
        "Mastoid process"
      ],
      correct: "D"
    },
    {
      id: 12262,
      question: "What type of muscle fibers are described as \"long cylindrical cells\"?",
      options: [
        "Cardiac fibers",
        "Smooth muscle cells",
        "Muscle fibers in skeletal muscle",
        "Nerve fibers"
      ],
      correct: "C"
    },
    {
      id: 12263,
      question: "Approximately how long can muscle fiber cells be?",
      options: [
        "1-10 microns",
        "10-40 microns",
        "1-40 millimeters",
        "100-400 millimeters"
      ],
      correct: "C"
    },
    {
      id: 12264,
      question: "Which characteristic is true of smooth muscle?",
      options: [
        "Voluntary control",
        "Short twitch movements only",
        "Can maintain tension for long periods",
        "Always attached to skeleton"
      ],
      correct: "C"
    },
    {
      id: 12265,
      question: "What distinguishes skeletal muscle from other types?",
      options: [
        "Located in digestive system",
        "Involuntary control only",
        "Found only in the heart",
        "Usually has voluntary control"
      ],
      correct: "D"
    },
    {
      id: 12266,
      question: "What is a \"tetanus\" in muscle physiology?",
      options: [
        "A disease caused by bacteria",
        "A longer sustained contraction",
        "A short quick contraction",
        "Complete muscle relaxation"
      ],
      correct: "B"
    },
    {
      id: 12267,
      question: "What does the direction of muscle fibers in the temporalis indicate?",
      options: [
        "It has only one action",
        "It has two different actions",
        "It cannot elevate the mandible",
        "It only moves the jaw sideways"
      ],
      correct: "B"
    },
    {
      id: 12268,
      question: "What anatomical feature makes the temporalis muscle fan-shaped?",
      options: [
        "Its insertion point",
        "Its blood supply",
        "Its origin from the temporal fossa",
        "Its nerve innervation"
      ],
      correct: "C"
    },
    {
      id: 12269,
      question: "Which muscle\'s insertion is opposite to the masseter\'s insertion?",
      options: [
        "Temporalis",
        "Lateral pterygoid",
        "Medial pterygoid",
        "Sternocleidomastoid"
      ],
      correct: "C"
    },
    {
      id: 12270,
      question: "What structure is located at the pyramidal process of the palatine bone?",
      options: [
        "Masseter origin",
        "Part of medial pterygoid origin",
        "Temporalis insertion",
        "Lateral pterygoid insertion"
      ],
      correct: "B"
    },
    {
      id: 12271,
      question: "Which muscle attaches to the articular disk of the TMJ?",
      options: [
        "Masseter",
        "Temporalis",
        "Medial pterygoid",
        "Lateral pterygoid"
      ],
      correct: "D"
    },
    {
      id: 12272,
      question: "What is the \"power stroke\" in mastication?",
      options: [
        "Opening the mouth widely",
        "The action guided by superior head of lateral pterygoid",
        "Closing the mouth forcefully",
        "Moving the jaw side to side"
      ],
      correct: "B"
    },
    {
      id: 12273,
      question: "Which muscle action is assisted by the lateral pterygoid?",
      options: [
        "Elevation",
        "Retraction",
        "Depression",
        "Adduction"
      ],
      correct: "C"
    },
    {
      id: 12274,
      question: "What happens when only one lateral pterygoid contracts?",
      options: [
        "The jaw elevates",
        "The jaw retracts",
        "Lateral movement occurs",
        "The jaw depresses equally"
      ],
      correct: "C"
    },
    {
      id: 12275,
      question: "Which two muscles work together to elevate the mandible?",
      options: [
        "Lateral pterygoid and temporalis",
        "Masseter and medial pterygoid",
        "Sternocleidomastoid and trapezius",
        "Masseter and lateral pterygoid"
      ],
      correct: "B"
    }
  
  ],
  "5-10. Head and Neck Summary (Part 1)": [
    {
      id: 12276,
      question: "What is the definition of a suture in anatomical terminology?",
      options: [
        "A short tube-like opening or hole through bone",
        "The line of junction between bones that is generally immovable",
        "A shallow depression or hollow space in bone",
        "A rounded protuberance forming an articulation",
      ],
      correct: "B"
    },
    {
      id: 12277,
      question: "Which anatomical term describes a long tube-like opening through bone?",
      options: [
        "Foramen",
        "Fissure",
        "Canal",
        "Process",
      ],
      correct: "C"
    },
    {
      id: 12278,
      question: "A foramen is best described as which of the following?",
      options: [
        "A long tube-like passage or channel through bone",
        "A shallow depression or hollow area in bone",
        "A short tube-like opening or passage through bone",
        "A groove or natural division between structures",
      ],
      correct: "C"
    },
    {
      id: 12279,
      question: "What anatomical structure is defined as an area raised above the surrounding bone surface?",
      options: [
        "Fossa",
        "Condyle",
        "Eminence",
        "Process",
      ],
      correct: "C"
    },
    {
      id: 12280,
      question: "Which term describes a groove, natural division, or cleft between two structures?",
      options: [
        "Fissure",
        "Canal",
        "Foramen",
        "Suture",
      ],
      correct: "A"
    },
    {
      id: 12281,
      question: "A rounded protuberance of bone that forms articulation with another bone is called a:",
      options: [
        "Process",
        "Condyle",
        "Eminence",
        "Protuberance",
      ],
      correct: "B"
    },
    {
      id: 12282,
      question: "What is the definition of a fossa?",
      options: [
        "A blunt projection similar to an eminence",
        "A projection or outgrowth of bone tissue",
        "A shallow depression or hollow in bone",
        "A rounded protuberance forming articulation",
      ],
      correct: "C"
    },
    {
      id: 12283,
      question: "Which term describes a projection or outgrowth of bone tissue?",
      options: [
        "Eminence",
        "Fossa",
        "Process",
        "Condyle",
      ],
      correct: "C"
    },
    {
      id: 12284,
      question: "How many bones comprise the neurocranium?",
      options: [
        "6 bones",
        "8 bones",
        "14 bones",
        "22 bones",
      ],
      correct: "B"
    },
    {
      id: 12285,
      question: "What does the neurocranium consist of?",
      options: [
        "The bones of the face",
        "The bones surrounding the brain",
        "The bones of the jaw",
        "The bones of the inner ear",
      ],
      correct: "B"
    },
    {
      id: 12286,
      question: "How many bones make up the viscerocranium?",
      options: [
        "8 bones",
        "10 bones",
        "14 bones",
        "22 bones",
      ],
      correct: "C"
    },
    {
      id: 12287,
      question: "The viscerocranium consists of which type of bones?",
      options: [
        "Bones surrounding the brain",
        "Bones of the face",
        "Bones of the cranial vault",
        "Bones of the skull base",
      ],
      correct: "B"
    },
    {
      id: 12288,
      question: "The three small ossicles in each ear that aid in hearing are:",
      options: [
        "Frontal, parietal, and temporal",
        "Malleus, incus, and stapes",
        "Lacrimal, nasal, and vomer",
        "Maxilla, palatine, and zygomatic",
      ],
      correct: "B"
    },
    {
      id: 12289,
      question: "Which mnemonic helps remember the 8 neurocranium bones?",
      options: [
        "LIMP",
        "F. PESTO",
        "N.V.M.Z",
        "S.I.M",
      ],
      correct: "B"
    },
    {
      id: 12290,
      question: "Which of the following is NOT a bone of the neurocranium?",
      options: [
        "Frontal bone",
        "Ethmoid bone",
        "Mandible bone",
        "Occipital bone",
      ],
      correct: "C"
    },
    {
      id: 12291,
      question: "How many temporal bones are part of the neurocranium?",
      options: [
        "1 temporal bone",
        "2 temporal bones",
        "3 temporal bones",
        "4 temporal bones",
      ],
      correct: "B"
    },
    {
      id: 12292,
      question: "Which mnemonic represents lacrimal, inferior nasal conchae, maxilla, and palatine bones?",
      options: [
        "F. PESTO",
        "N.V.M.Z",
        "LIMP",
        "S.I.M",
      ],
      correct: "C"
    },
    {
      id: 12293,
      question: "The mandible, vomer, nasal, and zygomatic bones can be remembered using which mnemonic?",
      options: [
        "LIMP",
        "F. PESTO",
        "N.V.M.Z",
        "MMLT",
      ],
      correct: "C"
    },
    {
      id: 12294,
      question: "How many lacrimal bones are present in the viscerocranium?",
      options: [
        "1 lacrimal bone",
        "2 lacrimal bones",
        "3 lacrimal bones",
        "4 lacrimal bones",
      ],
      correct: "B"
    },
    {
      id: 12295,
      question: "What is the primary function of a neuron?",
      options: [
        "Store nutrients for the brain",
        "Transmit messages or impulses in one direction",
        "Produce cerebrospinal fluid for protection",
        "Filter toxins from the bloodstream",
      ],
      correct: "B"
    },
    {
      id: 12296,
      question: "Sensory or afferent nerves carry messages in which direction?",
      options: [
        "From brain to body parts (brain-to-body)",
        "Between neurons within the spinal cord",
        "From body parts towards the brain (body-to-brain)",
        "Between the left and right hemispheres",
      ],
      correct: "C"
    },
    {
      id: 12297,
      question: "Motor or efferent nerves carry messages in which direction?",
      options: [
        "From body parts towards the brain",
        "From the brain towards body parts causing action",
        "Between sensory neurons within the cord",
        "Between hemispheres for coordination",
      ],
      correct: "B"
    },
    {
      id: 12298,
      question: "The Central Nervous System consists of which structures?",
      options: [
        "Brain and spinal column",
        "Cranial and spinal nerves",
        "Autonomic and somatic systems",
        "Sympathetic and parasympathetic divisions",
      ],
      correct: "A"
    },
    {
      id: 12299,
      question: "What makes up the Peripheral Nervous System?",
      options: [
        "Only the brain and spinal cord",
        "The brain, spinal cord, and cranial nerves",
        "Nerves extending from brain and spinal cord, including ANS",
        "Only the autonomic nervous system",
      ],
      correct: "C"
    },
    {
      id: 12300,
      question: "The cranial nerves are part of which nervous system?",
      options: [
        "Central Nervous System only",
        "Peripheral Nervous System",
        "Autonomic Nervous System only",
        "Somatic Nervous System only",
      ],
      correct: "B"
    },
    {
      id: 12301,
      question: "What is a reflex arc?",
      options: [
        "A complex pathway requiring conscious thought",
        "A shortcut that can occur in the CNS",
        "A pathway only in the peripheral nerves",
        "A long-distance signal requiring multiple neurons",
      ],
      correct: "B"
    },
    {
      id: 12302,
      question: "The Somatic Nervous System is responsible for:",
      options: [
        "Controlling smooth muscle and glands",
        "Regulating heart rate and blood pressure",
        "Sending sensory info to CNS and motor signals to skeletal muscles",
        "Managing unconscious breathing patterns",
      ],
      correct: "C"
    },
    {
      id: 12303,
      question: "Which system controls smooth muscle and glands?",
      options: [
        "Somatic Nervous System",
        "Central Nervous System",
        "Autonomic Nervous System",
        "Peripheral Nervous System",
      ],
      correct: "C"
    },
    {
      id: 12304,
      question: "The sympathetic nervous system is also known as:",
      options: [
        "Rest or digest system",
        "Fight or flight system",
        "Voluntary control system",
        "Skeletal muscle system",
      ],
      correct: "B"
    },
    {
      id: 12305,
      question: "The parasympathetic nervous system is also known as:",
      options: [
        "Fight or flight system",
        "Rest or digest system",
        "Stress response system",
        "Emergency response system",
      ],
      correct: "B"
    },
    {
      id: 12306,
      question: "During sympathetic nervous system activation, what happens?",
      options: [
        "Heart rate decreases and salivary flow increases",
        "Blood pressure decreases and digestion increases",
        "Heart rate increases and salivary flow decreases",
        "Breathing slows and muscle tension decreases",
      ],
      correct: "C"
    },
    {
      id: 12307,
      question: "During parasympathetic nervous system activation, what happens?",
      options: [
        "Heart rate increases and salivary flow decreases",
        "Heart rate decreases and salivary flow increases",
        "Blood pressure increases and digestion decreases",
        "Pupils dilate and breathing accelerates",
      ],
      correct: "B"
    },
    {
      id: 12308,
      question: "What is the function of Cranial Nerve I (Olfactory)?",
      options: [
        "Provides vision to the eyes",
        "Controls sense of smell",
        "Regulates eye movement",
        "Manages facial expressions",
      ],
      correct: "B"
    },
    {
      id: 12309,
      question: "What type of nerve is the Olfactory Nerve (CN I)?",
      options: [
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "B"
    },
    {
      id: 12310,
      question: "Damage to the Olfactory Nerve causes:",
      options: [
        "Blindness in the visual field",
        "Impaired sense of smell",
        "Drooping eyelid and dilated pupil",
        "Loss of taste sensation",
      ],
      correct: "B"
    },
    {
      id: 12311,
      question: "The Optic Nerve (CN II) is responsible for:",
      options: [
        "Sense of smell",
        "Providing vision",
        "Eye movement",
        "Pupil constriction",
      ],
      correct: "B"
    },
    {
      id: 12312,
      question: "What type of nerve is the Optic Nerve (CN II)?",
      options: [
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "B"
    },
    {
      id: 12313,
      question: "Damage to the Optic Nerve results in:",
      options: [
        "Impaired sense of smell",
        "Blindness in visual field",
        "Double vision",
        "Loss of taste",
      ],
      correct: "B"
    },
    {
      id: 12314,
      question: "The Oculomotor Nerve (CN III) provides which functions?",
      options: [
        "Vision and smell sensation",
        "Eye movement, eyelid opening, and pupil constriction",
        "Facial expression and taste sensation",
        "Hearing and balance",
      ],
      correct: "B"
    },
    {
      id: 12315,
      question: "What type of nerve is the Oculomotor Nerve (CN III)?",
      options: [
        "Sensory only",
        "Motor only",
        "Both motor and sensory",
        "Neither motor nor sensory",
      ],
      correct: "B"
    },
    {
      id: 12316,
      question: "Which muscles are controlled by the Oculomotor Nerve?",
      options: [
        "Lateral rectus and superior oblique muscles",
        "Superior, inferior, medial rectus and inferior oblique muscles",
        "Muscles of facial expression",
        "Muscles of mastication",
      ],
      correct: "B"
    },
    {
      id: 12317,
      question: "Damage to the Oculomotor Nerve causes:",
      options: [
        "Blindness and loss of smell",
        "Drooping eyelid, dilated pupil, and double vision",
        "Hearing loss and vertigo",
        "Loss of facial expression",
      ],
      correct: "B"
    },
    {
      id: 12318,
      question: "The Trochlear Nerve (CN IV) controls which muscle?",
      options: [
        "Lateral rectus muscle",
        "Medial rectus muscle",
        "Superior oblique muscle",
        "Inferior rectus muscle",
      ],
      correct: "C"
    },
    {
      id: 12319,
      question: "What type of nerve is the Trochlear Nerve (CN IV)?",
      options: [
        "Sensory only",
        "Motor only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "B"
    },
    {
      id: 12320,
      question: "Damage to the Trochlear Nerve results in:",
      options: [
        "Blindness and dilated pupils",
        "Double vision and inability to rotate eye inferolaterally",
        "Loss of smell sensation",
        "Paralysis of facial muscles",
      ],
      correct: "B"
    },
    {
      id: 12321,
      question: "The Trigeminal Nerve (CN V) is composed of how many divisions?",
      options: [
        "2 divisions",
        "3 divisions",
        "4 divisions",
        "5 divisions",
      ],
      correct: "B"
    },
    {
      id: 12322,
      question: "What type of nerve is the Trigeminal Nerve (CN V)?",
      options: [
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "C"
    },
    {
      id: 12323,
      question: "Which statement about the Trigeminal Nerve divisions is correct?",
      options: [
        "All three divisions are motor only",
        "V1 and V2 are sensory; V3 is motor and sensory",
        "All three divisions are sensory only",
        "V1 is motor; V2 and V3 are sensory",
      ],
      correct: "B"
    },
    {
      id: 12324,
      question: "The Ophthalmic branch (V1) provides sensations from which areas?",
      options: [
        "Lower eyelid, upper lips, and maxillary teeth",
        "Mandibular teeth, lower lips, and tongue",
        "Upper eyelid, forehead, and frontal sinus",
        "Cheeks, nose, and upper gums",
      ],
      correct: "C"
    },
    {
      id: 12325,
      question: "The Maxillary branch (V2) is responsible for sensation from:",
      options: [
        "Upper eyelid and forehead",
        "Lower eyelid, upper lips, maxillary teeth, and maxillary sinus",
        "Mandibular teeth and lower lips",
        "Tongue and floor of mouth",
      ],
      correct: "B"
    },
    {
      id: 12326,
      question: "The Mandibular branch (V3) provides sensation and motor function to:",
      options: [
        "Upper jaw and forehead",
        "Lower eyelid and cheeks",
        "Mandibular teeth, lower lips, tongue, and muscles of mastication",
        "Maxillary teeth and upper lips",
      ],
      correct: "C"
    },
    {
      id: 12327,
      question: "Which muscles are innervated by the Mandibular branch (V3)?",
      options: [
        "Muscles of facial expression",
        "Muscles of mastication",
        "Extraocular muscles",
        "Muscles of the pharynx",
      ],
      correct: "B"
    },
    {
      id: 12328,
      question: "The Abducens Nerve (CN VI) controls which muscle?",
      options: [
        "Medial rectus muscle",
        "Superior oblique muscle",
        "Lateral rectus muscle",
        "Inferior rectus muscle",
      ],
      correct: "C"
    },
    {
      id: 12329,
      question: "What type of nerve is the Abducens Nerve (CN VI)?",
      options: [
        "Sensory only",
        "Motor only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "B"
    },
    {
      id: 12330,
      question: "Damage to the Abducens Nerve results in:",
      options: [
        "Inability to look upward",
        "Inability to look laterally (outward) with affected eye",
        "Drooping eyelid",
        "Double vision when looking down",
      ],
      correct: "B"
    },
    {
      id: 12331,
      question: "The Facial Nerve (CN VII) provides motor function to:",
      options: [
        "Muscles of mastication",
        "Muscles of facial expression",
        "Extraocular muscles",
        "Tongue muscles",
      ],
      correct: "B"
    },
    {
      id: 12332,
      question: "What type of nerve is the Facial Nerve (CN VII)?",
      options: [
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "C"
    },
    {
      id: 12333,
      question: "The Facial Nerve provides taste sensation to which part of the tongue?",
      options: [
        "Posterior 1/3",
        "Anterior 2/3",
        "Entire tongue",
        "Only the tip",
      ],
      correct: "B"
    },
    {
      id: 12334,
      question: "Damage to the Facial Nerve causes:",
      options: [
        "Loss of smell",
        "Inability to close eye and drooping of face",
        "Loss of hearing",
        "Difficulty swallowing",
      ],
      correct: "B"
    },
    {
      id: 12335,
      question: "The Vestibulocochlear Nerve (CN VIII) is responsible for:",
      options: [
        "Facial expression",
        "Hearing and balance",
        "Taste sensation",
        "Eye movement",
      ],
      correct: "B"
    },
    {
      id: 12336,
      question: "What type of nerve is the Vestibulocochlear Nerve (CN VIII)?",
      options: [
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "B"
    },
    {
      id: 12337,
      question: "Damage to the Vestibulocochlear Nerve results in:",
      options: [
        "Facial paralysis",
        "Hearing loss and balance problems",
        "Loss of taste",
        "Double vision",
      ],
      correct: "B"
    },
    {
      id: 12338,
      question: "The Glossopharyngeal Nerve (CN IX) provides taste to which part of the tongue?",
      options: [
        "Anterior 2/3",
        "Posterior 1/3",
        "Entire tongue",
        "Only the tip",
      ],
      correct: "B"
    },
    {
      id: 12339,
      question: "What type of nerve is the Glossopharyngeal Nerve (CN IX)?",
      options: [
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "C"
    },
    {
      id: 12340,
      question: "The Glossopharyngeal Nerve provides motor function to:",
      options: [
        "Muscles of facial expression",
        "Muscles of mastication",
        "Stylopharyngeus muscle for swallowing",
        "Tongue muscles",
      ],
      correct: "C"
    },
    {
      id: 12341,
      question: "The Vagus Nerve (CN X) is the only cranial nerve that:",
      options: [
        "Exits the head and neck region",
        "Is purely motor",
        "Is purely sensory",
        "Controls eye movement",
      ],
      correct: "A"
    },
    {
      id: 12342,
      question: "What type of nerve is the Vagus Nerve (CN X)?",
      options: [
        "Motor only",
        "Sensory only",
        "Both motor and sensory",
        "Neither motor nor sensory",
      ],
      correct: "C"
    },
    {
      id: 12343,
      question: "The Vagus Nerve innervates which structures?",
      options: [
        "Only the heart and lungs",
        "Pharynx, larynx, heart, lungs, and abdominal organs",
        "Only facial muscles",
        "Only the tongue",
      ],
      correct: "B"
    },
    {
      id: 12344,
      question: "Damage to the Vagus Nerve affects:",
      options: [
        "Only speech",
        "Swallowing, speech, heart rate, and digestion",
        "Only hearing",
        "Only facial expression",
      ],
      correct: "B"
    },
    {
      id: 12345,
      question: "The Accessory Nerve (CN XI) provides motor function to which muscles?",
      options: [
        "Facial muscles",
        "Eye muscles",
        "Sternocleidomastoid and trapezius muscles",
        "Tongue muscles",
      ],
      correct: "C"
    },
    {
      id: 12346,
      question: "What type of nerve is the Accessory Nerve (CN XI)?",
      options: [
        "Sensory only",
        "Motor only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "B"
    },
    {
      id: 12347,
      question: "Damage to the Accessory Nerve results in:",
      options: [
        "Loss of taste",
        "Difficulty turning head and shrugging shoulders",
        "Hearing loss",
        "Facial paralysis",
      ],
      correct: "B"
    },
    {
      id: 12348,
      question: "The Hypoglossal Nerve (CN XII) controls:",
      options: [
        "Facial muscles",
        "Tongue movements",
        "Eye movements",
        "Swallowing muscles",
      ],
      correct: "B"
    },
    {
      id: 12349,
      question: "What type of nerve is the Hypoglossal Nerve (CN XII)?",
      options: [
        "Sensory only",
        "Motor only",
        "Both motor and sensory",
        "Autonomic only",
      ],
      correct: "B"
    },
    {
      id: 12350,
      question: "Damage to the Hypoglossal Nerve causes:",
      options: [
        "Loss of taste",
        "Tongue deviation and difficulty with speech/swallowing",
        "Facial paralysis",
        "Hearing loss",
      ],
      correct: "B"
    },
    {
      id: 12351,
      question: "The mnemonic to remember cranial nerves in order is:",
      options: [
        "On Old Olympus Towering Top",
        "Some Say Marry Money But My Brother Says Big Brains Matter More",
        "LIMP",
        "F. PESTO",
      ],
      correct: "A"
    },
    {
      id: 12352,
      question: "The mnemonic for cranial nerve functions (Sensory, Motor, Both) is:",
      options: [
        "On Old Olympus Towering Top",
        "Some Say Marry Money But My Brother Says Big Brains Matter More",
        "LIMP",
        "N.V.M.Z",
      ],
      correct: "B"
    },
    {
      id: 12353,
      question: "Which cranial nerves are purely sensory?",
      options: [
        "I, II, III",
        "I, II, VIII",
        "III, IV, VI",
        "V, VII, IX",
      ],
      correct: "B"
    },
    {
      id: 12354,
      question: "Which cranial nerves are purely motor?",
      options: [
        "I, II, VIII",
        "III, IV, VI, XI, XII",
        "V, VII, IX, X",
        "All cranial nerves",
      ],
      correct: "B"
    },
    {
      id: 12355,
      question: "Which cranial nerves are both motor and sensory?",
      options: [
        "I, II, VIII",
        "III, IV, VI",
        "V, VII, IX, X",
        "XI, XII",
      ],
      correct: "C"
    },
    {
      id: 12356,
      question: "The four muscles of mastication can be remembered by which mnemonic?",
      options: [
        "TLMPP (Temporalis, Lateral pterygoid, Medial pterygoid, Pterygoid)",
        "MMLT (Masseter, Medial pterygoid, Lateral pterygoid, Temporalis)",
        "My Gut Seems Damaged",
        "T.O.S.S",
      ],
      correct: "B"
    },
    {
      id: 12357,
      question: "All muscles of mastication are innervated by:",
      options: [
        "Facial nerve (CN VII)",
        "V3 of Trigeminal nerve (CN V)",
        "Glossopharyngeal nerve (CN IX)",
        "Hypoglossal nerve (CN XII)",
      ],
      correct: "B"
    },
    {
      id: 12358,
      question: "The Masseter muscle originates from:",
      options: [
        "Temporal fossa",
        "Zygomatic arch",
        "Mandibular condyle",
        "Coronoid process",
      ],
      correct: "B"
    },
    {
      id: 12359,
      question: "The Masseter muscle inserts at:",
      options: [
        "Coronoid process",
        "Mandibular condyle",
        "Angle of mandible and ramus",
        "Mental protuberance",
      ],
      correct: "C"
    },
    {
      id: 12360,
      question: "The primary action of the Masseter muscle is:",
      options: [
        "Depression (opening) of the mandible",
        "Elevation (closing) of the mandible",
        "Lateral movement of the mandible",
        "Protrusion of the mandible",
      ],
      correct: "B"
    },
    {
      id: 12361,
      question: "The Temporalis muscle originates from:",
      options: [
        "Zygomatic arch",
        "Temporal fossa on side of skull",
        "Sphenoid bone",
        "Occipital bone",
      ],
      correct: "B"
    },
    {
      id: 12362,
      question: "The Temporalis muscle inserts at:",
      options: [
        "Angle of mandible",
        "Mandibular condyle",
        "Coronoid process of mandible",
        "Mental protuberance",
      ],
      correct: "C"
    },
    {
      id: 12363,
      question: "The primary action of the Temporalis muscle is:",
      options: [
        "Depression of mandible",
        "Elevation and retraction (pulling back) of mandible",
        "Protrusion of mandible",
        "Lateral movement only",
      ],
      correct: "B"
    },
    {
      id: 12364,
      question: "The Medial Pterygoid muscle originates from:",
      options: [
        "Temporal fossa",
        "Lateral pterygoid plate of sphenoid bone",
        "Zygomatic arch",
        "Maxilla",
      ],
      correct: "B"
    },
    {
      id: 12365,
      question: "The Medial Pterygoid muscle inserts at:",
      options: [
        "Coronoid process",
        "Mandibular condyle",
        "Angle and ramus of mandible (medial/inside surface)",
        "Mental protuberance",
      ],
      correct: "C"
    },
    {
      id: 12366,
      question: "The primary action of the Medial Pterygoid muscle is:",
      options: [
        "Depression of mandible",
        "Elevation and lateral movement (side-to-side) of mandible",
        "Retraction of mandible",
        "Protrusion only",
      ],
      correct: "B"
    },
    {
      id: 12367,
      question: "The Lateral Pterygoid muscle has how many heads?",
      options: [
        "One head",
        "Two heads (superior and inferior)",
        "Three heads",
        "Four heads",
      ],
      correct: "B"
    },
    {
      id: 12368,
      question: "The superior head of the Lateral Pterygoid originates from:",
      options: [
        "Lateral pterygoid plate",
        "Greater wing of sphenoid bone",
        "Temporal fossa",
        "Zygomatic arch",
      ],
      correct: "B"
    },
    {
      id: 12369,
      question: "The inferior head of the Lateral Pterygoid originates from:",
      options: [
        "Greater wing of sphenoid",
        "Lateral pterygoid plate of sphenoid bone",
        "Temporal bone",
        "Maxilla",
      ],
      correct: "B"
    },
    {
      id: 12370,
      question: "The Lateral Pterygoid muscle inserts at:",
      options: [
        "Angle of mandible",
        "Coronoid process",
        "Neck of mandibular condyle and TMJ disc",
        "Mental protuberance",
      ],
      correct: "C"
    },
    {
      id: 12371,
      question: "The primary action of the Lateral Pterygoid muscle is:",
      options: [
        "Elevation of mandible",
        "Depression (opening), protrusion, and lateral movement of mandible",
        "Retraction of mandible",
        "Elevation only",
      ],
      correct: "B"
    },
    {
      id: 12372,
      question: "Which muscle is the only muscle of mastication that opens the jaw?",
      options: [
        "Masseter",
        "Temporalis",
        "Medial Pterygoid",
        "Lateral Pterygoid",
      ],
      correct: "D"
    },
    {
      id: 12373,
      question: "The four suprahyoid muscles can be remembered by which mnemonic?",
      options: [
        "MMLT",
        "T.O.S.S",
        "My Gut Seems Damaged (Mylohyoid, Geniohyoid, Stylohyoid, Digastric)",
        "TLMPP",
      ],
      correct: "C"
    },
    {
      id: 12374,
      question: "The Digastric muscle has how many bellies?",
      options: [
        "One belly",
        "Two bellies (anterior and posterior)",
        "Three bellies",
        "Four bellies",
      ],
      correct: "B"
    },
    {
      id: 12375,
      question: "The anterior belly of the Digastric originates from:",
      options: [
        "Hyoid bone",
        "Mastoid notch of temporal bone",
        "Digastric fossa on lingual surface of mandible near symphysis",
        "Styloid process",
      ],
      correct: "C"
    },
    {
      id: 12376,
      question: "The posterior belly of the Digastric originates from:",
      options: [
        "Mandible",
        "Hyoid bone",
        "Mastoid notch (groove) of temporal bone",
        "Styloid process",
      ],
      correct: "C"
    },
    {
      id: 12377,
      question: "Both bellies of the Digastric insert at:",
      options: [
        "Mandible",
        "Mastoid process",
        "Body of hyoid bone",
        "Temporal bone",
      ],
      correct: "C"
    },
    {
      id: 12378,
      question: "The action of the Digastric muscle is:",
      options: [
        "Elevation of mandible only",
        "Depression (opening) of mandible and elevation of hyoid bone",
        "Lateral movement of mandible",
        "Retraction of mandible",
      ],
      correct: "B"
    },
    {
      id: 12379,
      question: "The anterior belly of the Digastric is innervated by:",
      options: [
        "Facial nerve (CN VII)",
        "V3 of Trigeminal nerve (mylohyoid branch)",
        "Glossopharyngeal nerve (CN IX)",
        "Hypoglossal nerve (CN XII)",
      ],
      correct: "B"
    },
    {
      id: 12380,
      question: "The posterior belly of the Digastric is innervated by:",
      options: [
        "Trigeminal nerve (CN V)",
        "Facial nerve (CN VII)",
        "Glossopharyngeal nerve (CN IX)",
        "Vagus nerve (CN X)",
      ],
      correct: "B"
    },
    {
      id: 12381,
      question: "The Mylohyoid muscle forms which structure?",
      options: [
        "Roof of the mouth",
        "Floor of the mouth",
        "Side of the neck",
        "Back of the throat",
      ],
      correct: "B"
    },
    {
      id: 12382,
      question: "The Mylohyoid muscle originates from:",
      options: [
        "Mandibular condyle",
        "Mylohyoid line on medial surface of mandible",
        "Mental protuberance",
        "Coronoid process",
      ],
      correct: "B"
    },
    {
      id: 12383,
      question: "The left and right Mylohyoid muscles fuse in the midline forming a:",
      options: [
        "Foramen",
        "Fossa",
        "Raphe",
        "Condyle",
      ],
      correct: "C"
    },
    {
      id: 12384,
      question: "The action of the Mylohyoid muscle is:",
      options: [
        "Elevation of mandible only",
        "Depression (opening) of mandible and elevation of hyoid bone",
        "Lateral movement of mandible",
        "Retraction of mandible",
      ],
      correct: "B"
    },
    {
      id: 12385,
      question: "The Mylohyoid muscle is innervated by:",
      options: [
        "Facial nerve (CN VII)",
        "V3 of Trigeminal nerve (mylohyoid branch)",
        "Glossopharyngeal nerve (CN IX)",
        "Hypoglossal nerve (CN XII)",
      ],
      correct: "B"
    },
    {
      id: 12386,
      question: "The Geniohyoid muscle originates from:",
      options: [
        "Mylohyoid line",
        "Inferior genial tubercle or mental spine on lingual surface of mandible",
        "Mandibular angle",
        "Coronoid process",
      ],
      correct: "B"
    },
    {
      id: 12387,
      question: "The action of the Geniohyoid muscle is:",
      options: [
        "Elevation of mandible only",
        "Depression of mandible and elevation of hyoid",
        "Lateral movement of jaw",
        "Retraction of mandible",
      ],
      correct: "B"
    },
    {
      id: 12388,
      question: "The Geniohyoid muscle is innervated by:",
      options: [
        "Trigeminal nerve (CN V)",
        "Facial nerve (CN VII)",
        "First cervical nerve of the neck",
        "Glossopharyngeal nerve (CN IX)",
      ],
      correct: "C"
    },
    {
      id: 12389,
      question: "The Stylohyoid muscle originates from:",
      options: [
        "Mastoid process",
        "Styloid process of the temporal bone",
        "Hyoid bone",
        "Mandible",
      ],
      correct: "A"
    },
    {
      id: 12390,
      question: "On insertion, the Stylohyoid muscle:",
      options: [
        "Remains intact",
        "Splits and digastric posterior belly passes through it",
        "Fuses with the mylohyoid",
        "Attaches to the mandible",
      ],
      correct: "B"
    },
    {
      id: 12391,
      question: "The action of the Stylohyoid muscle is:",
      options: [
        "Pulls hyoid forward and down",
        "Pulls hyoid back and up",
        "Depresses the mandible",
        "Elevates the mandible",
      ],
      correct: "B"
    },
    {
      id: 12392,
      question: "The Stylohyoid muscle is innervated by:",
      options: [
        "Trigeminal nerve (CN V)",
        "Facial nerve (CN VII) (same as digastric posterior belly)",
        "Glossopharyngeal nerve (CN IX)",
        "Hypoglossal nerve (CN XII)",
      ],
      correct: "B"
    },
    {
      id: 12393,
      question: "The four infrahyoid muscles can be remembered by which mnemonic?",
      options: [
        "My Gut Seems Damaged",
        "TLMPP",
        "T.O.S.S (Thyrohyoid, Omohyoid, Sternohyoid, Sternothyroid)",
        "MMLT",
      ],
      correct: "C"
    },
    {
      id: 12394,
      question: "The Omohyoid muscle consists of how many bellies?",
      options: [
        "One belly",
        "Two bellies separated by intermediate tendon",
        "Three bellies",
        "Four bellies",
      ],
      correct: "B"
    },
    {
      id: 12395,
      question: "The inferior belly of the Omohyoid originates from:",
      options: [
        "Hyoid bone",
        "Sternum",
        "Upper border of the scapula (shoulder blade)",
        "Clavicle",
      ],
      correct: "C"
    },
    {
      id: 12396,
      question: "The action of the Omohyoid muscle is:",
      options: [
        "Elevates hyoid bone",
        "Pulls hyoid bone down",
        "Retracts the mandible",
        "Elevates the scapula",
      ],
      correct: "B"
    },
    {
      id: 12397,
      question: "The Omohyoid muscle is innervated by:",
      options: [
        "1st cervical nerve",
        "2nd and 3rd cervical nerves",
        "Trigeminal nerve (CN V)",
        "Facial nerve (CN VII)",
      ],
      correct: "B"
    },
    {
      id: 12398,
      question: "The Sternohyoid muscle originates from:",
      options: [
        "Hyoid bone",
        "Scapula",
        "Upper border of the manubrium of the sternum",
        "Clavicle",
      ],
      correct: "C"
    },
    {
      id: 12399,
      question: "The action of the Sternohyoid muscle is:",
      options: [
        "Elevates hyoid bone",
        "Pulls hyoid down",
        "Retracts the mandible",
        "Elevates the sternum",
      ],
      correct: "B"
    },
    {
      id: 12400,
      question: "The Sternohyoid muscle is innervated by:",
      options: [
        "1st cervical nerve",
        "2nd and 3rd cervical nerves (same as omohyoid)",
        "Facial nerve (CN VII)",
        "Trigeminal nerve (CN V)",
      ],
      correct: "A"
    },
    {
      id: 12401,
      question: "The Sternothyroid muscle originates from:",
      options: [
        "Hyoid bone",
        "Upper part of the sternum",
        "Scapula",
        "Clavicle",
      ],
      correct: "B"
    },
    {
      id: 12402,
      question: "The Sternothyroid muscle inserts at:",
      options: [
        "Hyoid bone",
        "Oblique line on side of thyroid cartilage of larynx",
        "Mandible",
        "Scapula",
      ],
      correct: "B"
    },
    {
      id: 12403,
      question: "The action of the Sternothyroid muscle is:",
      options: [
        "Elevates the larynx",
        "Pulls the larynx down",
        "Depresses the hyoid bone",
        "Elevates the sternum",
      ],
      correct: "B"
    },
    {
      id: 12404,
      question: "The Sternothyroid muscle is innervated by:",
      options: [
        "1st cervical nerve",
        "2nd and 3rd cervical nerves",
        "Facial nerve (CN VII)",
        "Hypoglossal nerve (CN XII)",
      ],
      correct: "B"
    },
    {
      id: 12405,
      question: "The Thyrohyoid muscle originates from:",
      options: [
        "Sternum",
        "Oblique line on lateral side of thyroid cartilage",
        "Scapula",
        "Hyoid bone",
      ],
      correct: "B"
    },
    {
      id: 12406,
      question: "The action of the Thyrohyoid muscle is:",
      options: [
        "Depresses the larynx only",
        "Raises the larynx or depresses the hyoid bone",
        "Elevates the thyroid gland",
        "Retracts the mandible",
      ],
      correct: "B"
    },
    {
      id: 12407,
      question: "The Thyrohyoid muscle is innervated by:",
      options: [
        "2nd and 3rd cervical nerves",
        "1st cervical nerve",
        "Facial nerve (CN VII)",
        "Trigeminal nerve (CN V)",
      ],
      correct: "B"
    },
    {
      id: 12408,
      question: "A suture is a long tube-like passage through bone.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12409,
      question: "A foramen is a short tube-like opening through bone.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12410,
      question: "The neurocranium consists of the bones of the face.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12411,
      question: "The viscerocranium consists of 14 bones.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12412,
      question: "The ossicles (malleus, incus, stapes) are part of the neurocranium count.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12413,
      question: "There are 2 parietal bones in the neurocranium.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12414,
      question: "The mandible is part of the neurocranium.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12415,
      question: "Neurons transmit messages in only one direction.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12416,
      question: "Sensory nerves carry messages from the brain to body parts.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12417,
      question: "Motor nerves carry messages from the brain to body parts causing action.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12418,
      question: "The Central Nervous System consists of the brain and spinal column.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12419,
      question: "The cranial nerves are part of the Central Nervous System.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12420,
      question: "The sympathetic nervous system is known as \"rest or digest.\"",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12421,
      question: "The parasympathetic nervous system increases heart rate and blood pressure.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12422,
      question: "The Olfactory Nerve (CN I) is a sensory nerve.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12423,
      question: "The Optic Nerve (CN II) is a motor nerve.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12424,
      question: "The Oculomotor Nerve (CN III) is a motor nerve.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12425,
      question: "The Trigeminal Nerve (CN V) is the largest cranial nerve.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12426,
      question: "The Ophthalmic branch (V1) of the Trigeminal nerve has motor function.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12427,
      question: "The Mandibular branch (V3) is both sensory and motor.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12428,
      question: "The Facial Nerve (CN VII) is more superficial than Cranial Nerve V.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12429,
      question: "The Facial Nerve provides taste to the anterior 2/3 of the tongue.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12430,
      question: "The Vestibulocochlear Nerve (CN VIII) is responsible for hearing and balance.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12431,
      question: "The Glossopharyngeal Nerve (CN IX) provides taste to the anterior 2/3 of tongue.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12432,
      question: "The Vagus Nerve (CN X) is both motor and sensory.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12433,
      question: "Cutting both Vagus nerves is fatal.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12434,
      question: "The Accessory Nerve (CN XI) is a motor nerve only.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12435,
      question: "The Hypoglossal Nerve (CN XII) controls tongue movements.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    }
  ],
  "5-10. Head and Neck Summary (Part 2)": [
    {
      id: 12500,
      question: "Which anatomical term describes a short tube-like opening or hole through bone?",
      options: [
        "Foramen",
        "Suture",
        "Fossa",
        "Eminence",
      ],
      correct: "A"
    },
    {
      id: 12501,
      question: "Which anatomical term refers to a long tube-like channel or passage through bone?",
      options: [
        "Canal",
        "Process",
        "Condyle",
        "Fissure",
      ],
      correct: "A"
    },
    {
      id: 12502,
      question: "Which of the following best describes the anatomical term \"fossa\"?",
      options: [
        "A shallow depression or hollow in bone",
        "A rounded protuberance forming joint articulation",
        "A groove or natural division between two structures",
        "A blunt projection similar to an eminence",
      ],
      correct: "A"
    },
    {
      id: 12503,
      question: "How many bones make up the neurocranium (bones surrounding the brain)?",
      options: [
        "8 bones",
        "6 bones",
        "10 bones",
        "14 bones",
      ],
      correct: "A"
    },
    {
      id: 12504,
      question: "Which mnemonic is used to remember the 8 neurocranial bones?",
      options: [
        "F. PESTO (Frontal, Parietal, Ethmoid, Sphenoid, Temporal, Occipital)",
        "LIMP (Lacrimal, Inferior nasal conchae, Maxilla, Palatine)",
        "T.O.S.S (Thyrohyoid, Omohyoid, Sternohyoid, Sternothyroid)",
        "MMLT (Masseter, Medial pterygoid, Lateral pterygoid, Temporalis)",
      ],
      correct: "A"
    },
    {
      id: 12505,
      question: "How many bones make up the viscerocranium (bones of the face)?",
      options: [
        "14 bones",
        "8 bones",
        "12 bones",
        "10 bones",
      ],
      correct: "A"
    },
    {
      id: 12506,
      question: "Which of the following is NOT one of the three ossicles found in the ear?",
      options: [
        "Vomer",
        "Stapes",
        "Incus",
        "Malleus",
      ],
      correct: "A"
    },
    {
      id: 12507,
      question: "In the nervous system, \"afferent\" (sensory) neurons carry signals in which direction?",
      options: [
        "From the outer body toward the brain",
        "From the brainstem to the cranial nerve nuclei",
        "From brain to body to cause muscle action",
        "From the spinal cord to glands and smooth muscle",
      ],
      correct: "A"
    },
    {
      id: 12508,
      question: "Which two structures make up the Central Nervous System (CNS)?",
      options: [
        "Brain and spinal column",
        "Somatic and autonomic nervous systems",
        "Cranial nerves and spinal nerves",
        "Sympathetic and parasympathetic systems",
      ],
      correct: "A"
    },
    {
      id: 12509,
      question: "What effect does the sympathetic nervous system (SNS) have on the body?",
      options: [
        "Increased heart rate, blood pressure, and decreased salivary flow",
        "Relaxation response with normal or decreased heart rate",
        "Increased salivary flow and decreased heart rate",
        "Decreased blood pressure and slowed digestion",
      ],
      correct: "A"
    },
    {
      id: 12510,
      question: "Which cranial nerve is responsible for the sense of smell?",
      options: [
        "Olfactory Nerve (I)",
        "Optic Nerve (II)",
        "Oculomotor Nerve (III)",
        "Facial Nerve (VII)",
      ],
      correct: "A"
    },
    {
      id: 12511,
      question: "Damage to which cranial nerve results in blindness in the visual field?",
      options: [
        "Optic Nerve (II)",
        "Abducens Nerve (VI)",
        "Trochlear Nerve (IV)",
        "Olfactory Nerve (I)",
      ],
      correct: "A"
    },
    {
      id: 12512,
      question: "Which cranial nerve controls eye movement, eyelid opening, pupil constriction, and focusing?",
      options: [
        "Oculomotor Nerve (III)",
        "Abducens Nerve (VI)",
        "Optic Nerve (II)",
        "Trochlear Nerve (IV)",
      ],
      correct: "A"
    },
    {
      id: 12513,
      question: "The Trochlear Nerve (IV) controls which specific eye muscle?",
      options: [
        "Superior oblique muscle",
        "Lateral rectus muscle",
        "Inferior oblique muscle",
        "Medial rectus muscle",
      ],
      correct: "A"
    },
    {
      id: 12514,
      question: "Which cranial nerve is the largest, composed of three divisions, and whose damage causes loss of sensation and impaired chewing?",
      options: [
        "Trigeminal Nerve (V)",
        "Vagus Nerve (X)",
        "Facial Nerve (VII)",
        "Vestibulocochlear Nerve (VIII)",
      ],
      correct: "A"
    },
    {
      id: 12515,
      question: "Which branch of the Trigeminal Nerve provides sensations from the lower eyelid, upper lips and gums, teeth of the maxilla, and palate?",
      options: [
        "Maxillary branch (V2)",
        "Mandibular branch (V3)",
        "Ophthalmic branch (V1)",
        "Buccal branch (V4)",
      ],
      correct: "A"
    },
    {
      id: 12516,
      question: "Which division of the Trigeminal Nerve has BOTH sensory AND motor functions?",
      options: [
        "Mandibular branch (V3)",
        "Ophthalmic branch (V1)",
        "Maxillary branch (V2)",
        "All three branches are both sensory and motor",
      ],
      correct: "A"
    },
    {
      id: 12517,
      question: "The Abducens Nerve (VI) serves which eye muscle, and what clinical finding results from its damage?",
      options: [
        "Serves lateral rectus; eye cannot rotate laterally and rotates medially at rest",
        "Serves inferior oblique; eye deviates upward at rest",
        "Serves medial rectus; eye rotates laterally at rest",
        "Serves superior oblique; eye cannot rotate downward",
      ],
      correct: "A"
    },
    {
      id: 12518,
      question: "Which of the following is a function of the Facial Nerve (VII)?",
      options: [
        "Facial expressions, salivary/lacrimal glands, and taste on anterior 2/3 of tongue",
        "Swallowing and voice production via pharyngeal muscles",
        "Controls tongue movements for speech and swallowing",
        "Provides hearing and sense of balance",
      ],
      correct: "A"
    },
    {
      id: 12519,
      question: "The Vestibulocochlear Nerve (VIII) provides which two special sensory functions?",
      options: [
        "Hearing (cochlear branch) and balance (vestibular branch)",
        "Smell and vision",
        "Taste and smell",
        "Facial expression and tear production",
      ],
      correct: "A"
    },
    {
      id: 12520,
      question: "Which cranial nerve provides taste from the posterior 1/3 of the tongue and controls salivation, gagging, and blood pressure?",
      options: [
        "Hypoglossal Nerve (XII)",
        "Glossopharyngeal Nerve (IX)",
        "Vagus Nerve (X)",
        "Facial Nerve (VII)",
      ],
      correct: "B"
    },
    {
      id: 12521,
      question: "What is the consequence if BOTH Vagus Nerves (X) are severed?",
      options: [
        "Permanent deafness and complete loss of balance",
        "Fatal outcome due to loss of vital autonomic functions",
        "Inability to move the tongue and impaired speech",
        "Complete paralysis of facial muscles and loss of taste",
      ],
      correct: "B"
    },
    {
      id: 12522,
      question: "Which cranial nerve is responsible for tongue movements for speech, food manipulation, and swallowing?",
      options: [
        "Accessory Nerve (XI)",
        "Hypoglossal Nerve (XII)",
        "Glossopharyngeal Nerve (IX)",
        "Facial Nerve (VII)",
      ],
      correct: "B"
    },
    {
      id: 12523,
      question: "If one Hypoglossal Nerve (XII) is damaged, what is the expected clinical finding?",
      options: [
        "Inability to swallow on the affected side",
        "Tongue deviation toward the injured side",
        "Loss of taste on the anterior tongue",
        "Drooping eyelid on the affected side",
      ],
      correct: "B"
    },
    {
      id: 12524,
      question: "Which of the following are clinical signs of epinephrine overdose?",
      options: [
        "Muscle weakness, facial droop, and slurred speech",
        "Anxiety, tremor, throbbing headache, dizziness, pallor, and palpitations",
        "Decreased heart rate, increased salivation, and drowsiness",
        "Nausea, loss of balance, and temporary blindness",
      ],
      correct: "B"
    },
    {
      id: 12525,
      question: "Which type of dental injection affects only the gingiva, NOT the tooth or surrounding structures?",
      options: [
        "Inferior alveolar nerve block",
        "Infiltration injection",
        "Posterior superior alveolar nerve block",
        "Supraperiosteal injection",
      ],
      correct: "B"
    },
    {
      id: 12526,
      question: "Which type of dental injection targets a nerve trunk, covering the largest area including periodontium, gingiva, and teeth?",
      options: [
        "Infiltration injection",
        "Nerve block injection",
        "Supraperiosteal injection",
        "Middle superior alveolar nerve block",
      ],
      correct: "B"
    },
    {
      id: 12527,
      question: "Which muscle type is found ONLY in the heart and is characterized by short twitch movements with endurance and consistency?",
      options: [
        "Voluntary striated skeletal muscle",
        "Cardiac muscle",
        "Somatic peripheral muscle",
        "Smooth muscle",
      ],
      correct: "B"
    },
    {
      id: 12528,
      question: "In muscle terminology, what is the \"origin\" of a muscle?",
      options: [
        "The direction in which muscle fibers pull during contraction",
        "The end of the muscle attached to the least movable (immovable) structure",
        "The work accomplished when muscle fibers contract",
        "The end attached to the more movable structure",
      ],
      correct: "B"
    },
    {
      id: 12529,
      question: "Which mandibular movement pushes the mandible anteriorly?",
      options: [
        "Elevation",
        "Protraction",
        "Retraction",
        "Depression",
      ],
      correct: "B"
    },
    {
      id: 12530,
      question: "Which nerve innervates all four muscles of mastication?",
      options: [
        "Maxillary division of the Trigeminal Nerve (V2)",
        "Mandibular division of the Trigeminal Nerve (V3)",
        "Facial Nerve (VII)",
        "Glossopharyngeal Nerve (IX)",
      ],
      correct: "B"
    },
    {
      id: 12531,
      question: "Which artery provides the blood supply to the muscles of mastication?",
      options: [
        "Ascending pharyngeal artery",
        "Maxillary artery",
        "Facial artery",
        "External carotid artery",
      ],
      correct: "B"
    },
    {
      id: 12532,
      question: "What is the primary action of the Masseter muscle?",
      options: [
        "Moves the mandible laterally from side to side",
        "Elevates the mandible, causing the teeth to clench together",
        "Depresses and opens the mouth",
        "Retrudes the mandible posteriorly",
      ],
      correct: "B"
    },
    {
      id: 12533,
      question: "The Temporalis muscle's posterior fibers are responsible for which specific mandibular movement?",
      options: [
        "Lateral excursion of the mandible",
        "Retruding or pulling the mandible backward",
        "Depression and opening of the mouth",
        "Elevation and closing of the mouth",
      ],
      correct: "B"
    },
    {
      id: 12534,
      question: "Which muscle of mastication is the ONLY one responsible for depression of the mandible?",
      options: [
        "Temporalis",
        "Lateral Pterygoid",
        "Masseter",
        "Medial Pterygoid",
      ],
      correct: "B"
    },
    {
      id: 12535,
      question: "What is the action of the Medial Pterygoid muscle?",
      options: [
        "Retrudes the mandible posteriorly",
        "Elevates the mandible, closing the mouth",
        "Protrudes the mandible anteriorly",
        "Depresses the mandible and opens the mouth",
      ],
      correct: "B"
    },
    {
      id: 12536,
      question: "The pharynx is composed of how many constrictor muscles and how many smaller muscles?",
      options: [
        "3 constrictors and 2 smaller muscles",
        "3 constrictors and 3 smaller muscles",
        "4 constrictors and 2 smaller muscles",
        "2 constrictors and 4 smaller muscles",
      ],
      correct: "B"
    },
    {
      id: 12537,
      question: "All three pharyngeal constrictor muscles insert into which structure?",
      options: [
        "Thyroid cartilage of the larynx",
        "Median raphe (midline tendon in the posterior throat wall)",
        "Styloid process of the temporal bone",
        "Hyoid bone",
      ],
      correct: "B"
    },
    {
      id: 12538,
      question: "Which nerve supplies all three pharyngeal constrictor muscles?",
      options: [
        "Trigeminal Nerve (V3)",
        "Pharyngeal plexus",
        "Vagus Nerve (X)",
        "Glossopharyngeal Nerve (IX)",
      ],
      correct: "B"
    },
    {
      id: 12539,
      question: "What is the origin of the Middle Pharyngeal Constrictor?",
      options: [
        "Base of the styloid process on the medial side",
        "Lower part of the medial pterygoid plate",
        "Posterior, superior part of the hyoid bone and stylohyoid ligament",
        "Posterior part of the thyroid cartilage of the larynx",
      ],
      correct: "C"
    },
    {
      id: 12540,
      question: "The Inferior Pharyngeal Constrictor originates from which structure?",
      options: [
        "Hyoid bone and stylohyoid ligament",
        "Styloid process of the temporal bone",
        "Posterior part of the thyroid cartilage of the larynx",
        "Median raphe and posterior pharyngeal wall",
      ],
      correct: "C"
    },
    {
      id: 12541,
      question: "Which pharyngeal elevator and dilator is the PRIMARY dilator of the pharynx?",
      options: [
        "Salpingopharyngeal muscle",
        "Inferior pharyngeal constrictor",
        "Stylopharyngeal muscle",
        "Palatopharyngeal muscle",
      ],
      correct: "C"
    },
    {
      id: 12542,
      question: "Which cranial nerve supplies the Stylopharyngeal muscle?",
      options: [
        "Vagus Nerve (X)",
        "Facial Nerve (VII)",
        "Glossopharyngeal Nerve (IX)",
        "Accessory Nerve (XI)",
      ],
      correct: "C"
    },
    {
      id: 12543,
      question: "Which nerves supply the Salpingopharyngeal muscle?",
      options: [
        "Trigeminal (V3) and Glossopharyngeal (IX) nerves",
        "Glossopharyngeal (IX) and Facial (VII) nerves",
        "Vagus (X) and Accessory (XI) cranial nerves",
        "Facial (VII) and Accessory (XI) cranial nerves",
      ],
      correct: "C"
    },
    {
      id: 12544,
      question: "Which soft palate muscle receives its nerve supply from the Mandibular Division of the Trigeminal Nerve (V3)?",
      options: [
        "Palatoglossal",
        "Musculus uvulae",
        "Tensor veli palatini",
        "Levator veli palatini",
      ],
      correct: "C"
    },
    {
      id: 12545,
      question: "What is the primary action of the Levator Veli Palatini?",
      options: [
        "Opens the auditory tube and tenses the anterior soft palate",
        "Narrows the posterior pillar and elevates the larynx",
        "Pulls the posterior soft palate up and back to contact the posterior pharyngeal wall",
        "Shortens and broadens the uvula and changes soft palate contour",
      ],
      correct: "C"
    },
    {
      id: 12546,
      question: "What is the action of the Musculus Uvulae?",
      options: [
        "Tenses the anterior portion of the soft palate",
        "Pulls the soft palate up and back to seal the nasopharynx",
        "Shortens and broadens the uvula and changes the posterior soft palate contour",
        "Opens the auditory tube when it is closed",
      ],
      correct: "C"
    },
    {
      id: 12547,
      question: "Where does the Tensor Veli Palatini originate?",
      options: [
        "Two small bands from the posterior end of the hard palate",
        "Petrous part of the temporal bone near the carotid canal",
        "Near the base of the medial pterygoid plate and lateral wall of the auditory tube cartilage",
        "Posterolateral part of the soft palate",
      ],
      correct: "C"
    },
    {
      id: 12548,
      question: "Which unique feature distinguishes the hyoid bone from all other bones in the body?",
      options: [
        "It is the only bone found entirely within the floor of the mouth",
        "It has no marrow and relies on surrounding tissues for nutrition",
        "It does not articulate with any other bone; it is connected only by muscles and ligaments",
        "It is the smallest bone in the human body",
      ],
      correct: "C"
    },
    {
      id: 12549,
      question: "The suprahyoid muscles are remembered by which mnemonic?",
      options: [
        "MMLT (Masseter, Medial pterygoid, Lateral pterygoid, Temporalis)",
        "F. PESTO (Frontal, Parietal, Ethmoid, Sphenoid, Temporal, Occipital)",
        "My Gut Seems Damaged (Mylohyoid, Geniohyoid, Stylohyoid, Digastric)",
        "T.O.S.S (Thyrohyoid, Omohyoid, Sternohyoid, Sternothyroid)",
      ],
      correct: "C"
    },
    {
      id: 12550,
      question: "What happens when the Digastric muscle contracts?",
      options: [
        "It protrudes and depresses the mandible anteriorly",
        "It elevates the mandible and clenches the teeth together",
        "It causes backward pull (retrusion) on the mandible and elevates the hyoid during jaw clenching",
        "It depresses the hyoid bone and pulls the larynx downward",
      ],
      correct: "C"
    },
    {
      id: 12551,
      question: "Which nerve supplies the anterior belly of the Digastric muscle?",
      options: [
        "First cervical nerve",
        "Glossopharyngeal Nerve (IX)",
        "V3 of the Trigeminal Nerve (5th cranial nerve)",
        "Facial Nerve (VII)",
      ],
      correct: "C"
    },
    {
      id: 12552,
      question: "Which nerve supplies the posterior belly of the Digastric muscle?",
      options: [
        "Vagus Nerve (X)",
        "Accessory Nerve (XI)",
        "Facial Nerve (VII)",
        "V3 of the Trigeminal Nerve",
      ],
      correct: "C"
    },
    {
      id: 12553,
      question: "The Mylohyoid muscle forms which anatomical structure?",
      options: [
        "The lateral wall of the nasal cavity",
        "The roof of the oral cavity",
        "The floor of the mouth",
        "The posterior wall of the pharynx",
      ],
      correct: "C"
    },
    {
      id: 12554,
      question: "What is the nerve supply to the Mylohyoid muscle?",
      options: [
        "Glossopharyngeal Nerve (IX)",
        "First cervical nerve",
        "V3 of the Trigeminal Nerve (mylohyoid branch)",
        "Facial Nerve (VII)",
      ],
      correct: "C"
    },
    {
      id: 12555,
      question: "What is the nerve supply to the Geniohyoid muscle?",
      options: [
        "Facial Nerve (VII)",
        "Hypoglossal Nerve (XII)",
        "First cervical nerve of the neck",
        "V3 of the Trigeminal Nerve",
      ],
      correct: "C"
    },
    {
      id: 12556,
      question: "What is the primary action of the Stylohyoid muscle?",
      options: [
        "Protrudes the mandible and opens the mouth",
        "Depresses the mandible and elevates the hyoid bone",
        "Pulls the hyoid back and upward",
        "Forms the floor of the mouth and opens the jaw",
      ],
      correct: "C"
    },
    {
      id: 12557,
      question: "The infrahyoid muscles are remembered by which mnemonic?",
      options: [
        "My Gut Seems Damaged",
        "F. PESTO",
        "T.O.S.S (Thyrohyoid, Omohyoid, Sternohyoid, Sternothyroid)",
        "MMLT",
      ],
      correct: "C"
    },
    {
      id: 12558,
      question: "The inferior belly of the Omohyoid muscle originates from which structure?",
      options: [
        "Styloid process of the temporal bone",
        "Upper border of the manubrium of the sternum",
        "Oblique line on the lateral side of the thyroid cartilage",
        "Upper border of the scapula (shoulder blade)",
      ],
      correct: "D"
    },
    {
      id: 12559,
      question: "Which nerve supplies both the Omohyoid and Sternohyoid muscles?",
      options: [
        "1st cervical nerve",
        "V3 of the Trigeminal Nerve",
        "Facial Nerve (VII)",
        "2nd and 3rd cervical nerves",
      ],
      correct: "D"
    },
    {
      id: 12560,
      question: "What is the action of the Sternothyroid muscle?",
      options: [
        "Raises the larynx or depresses the hyoid bone",
        "Elevates and retracts the mandible",
        "Pulls the hyoid bone down",
        "Pulls the larynx down",
      ],
      correct: "D"
    },
    {
      id: 12561,
      question: "What is the action of the Thyrohyoid muscle?",
      options: [
        "Protrudes the mandible anteriorly",
        "Depresses the mandible and opens the mouth",
        "Pulls the larynx down toward the sternum",
        "Raises the larynx or depresses the hyoid bone",
      ],
      correct: "D"
    },
    {
      id: 12562,
      question: "Which nerve supplies the Thyrohyoid muscle?",
      options: [
        "2nd and 3rd cervical nerves",
        "V3 of the Trigeminal Nerve",
        "Hypoglossal Nerve (XII)",
        "1st cervical nerve",
      ],
      correct: "D"
    },
    {
      id: 12563,
      question: "What is the action of the Palatopharyngeal muscle?",
      options: [
        "Shortens and broadens the uvula and changes the soft palate contour",
        "Opens the auditory tube and tenses the anterior soft palate",
        "Pulls the posterior soft palate up and back against the pharyngeal wall",
        "Narrows the posterior pillar and elevates the pharynx and larynx",
      ],
      correct: "D"
    },
    {
      id: 12564,
      question: "Where does the Salpingopharyngeal muscle originate?",
      options: [
        "Posterolateral part of the soft palate",
        "Base of the styloid process on the medial side",
        "Posterior, superior part of the hyoid bone",
        "End of the auditory tube in the lateral wall of the nasal pharynx",
      ],
      correct: "D"
    },
    {
      id: 12565,
      question: "Which of the following correctly lists the three regions of the pharynx from top to bottom?",
      options: [
        "Laryngopharynx, Nasopharynx, Oropharynx",
        "Oropharynx, Nasopharynx, Laryngopharynx",
        "Nasopharynx, Laryngopharynx, Oropharynx",
        "Nasopharynx, Oropharynx, Laryngopharynx",
      ],
      correct: "D"
    },
    {
      id: 12566,
      question: "Which region of the pharynx is located where the digestive and respiratory systems branch into the esophagus and larynx?",
      options: [
        "Oropharynx (middle part)",
        "Hypopharynx (base part)",
        "Nasopharynx (upper part)",
        "Laryngopharynx (lower part)",
      ],
      correct: "D"
    },
    {
      id: 12567,
      question: "Damage to the Accessory Nerve (XI) results in which clinical finding?",
      options: [
        "Drooping eyelid and dilated pupil",
        "Impaired swallowing and loss of voice",
        "Loss of taste and sagging facial muscles",
        "Impaired head, neck, and shoulder movement",
      ],
      correct: "D"
    },
    {
      id: 12568,
      question: "What does activation of the parasympathetic nervous system (PNS) cause?",
      options: [
        "Increased adrenal hormone release and heightened alertness",
        "Increased heart rate, elevated blood pressure, and decreased salivation",
        "Fight-or-flight response with dilated pupils and muscle tension",
        "Decreased heart rate, lower blood pressure, and increased salivary flow",
      ],
      correct: "D"
    },
    {
      id: 12569,
      question: "A \"condyle\" is best described as which of the following?",
      options: [
        "A long tube-like channel or passage through bone",
        "A groove or natural division between two structures",
        "A shallow depression or hollow in bone",
        "A rounded protuberance of a bone forming articulation with another bone",
      ],
      correct: "D"
    },
    {
      id: 12570,
      question: "What is the role of the Superior Pharyngeal Constrictor?",
      options: [
        "Forces food down toward the esophagus from the middle pharynx",
        "Constricts the lower pharynx and pushes food into the esophagus",
        "Elevates and dilates the pharynx during swallowing",
        "Constricts the upper pharynx and forces its contents downward",
      ],
      correct: "D"
    },
    {
      id: 12571,
      question: "Sensory neurons are also known by what alternate term?",
      options: [
        "Efferent neurons",
        "Motor neurons",
        "Autonomic neurons",
        "Afferent neurons",
      ],
      correct: "D"
    },
    {
      id: 12572,
      question: "Which of the following bones is part of the viscerocranium (facial bones)?",
      options: [
        "Frontal bone",
        "Occipital bone",
        "Parietal bone",
        "Zygomatic bone",
      ],
      correct: "D"
    },
    {
      id: 12573,
      question: "Which of the following is a characteristic of skeletal muscle?",
      options: [
        "Controls glands and smooth structures throughout the body autonomously",
        "Found only in the heart; functions involuntarily with endurance",
        "Located in the digestive system; can maintain tension for long periods",
        "Attaches to the skeleton, comes in pairs, and movements are usually voluntary",
      ],
      correct: "D"
    },
    {
      id: 12574,
      question: "What is the action of the Sternohyoid muscle?",
      options: [
        "Pulls the larynx down toward the chest",
        "Raises the larynx or depresses the hyoid bone",
        "Elevates and retracts the mandible posteriorly",
        "Pulls the hyoid bone down",
      ],
      correct: "D"
    },
    {
      id: 12575,
      question: "Which of the following is a mandibular injection technique used in dental local anesthesia?",
      options: [
        "Anterior superior alveolar nerve block",
        "Greater palatine nerve block",
        "Naso-palatine nerve block",
        "Inferior alveolar nerve block",
      ],
      correct: "D"
    },
    {
      id: 12576,
      question: "Which group of muscles consists of the Masseter, Temporalis, Medial Pterygoid, and Lateral Pterygoid?",
      options: [
        "Pharyngeal constrictors",
        "Hyoid muscles",
        "Soft palate muscles",
        "Muscles of mastication",
      ],
      correct: "D"
    },
    {
      id: 12577,
      question: "The neurocranium consists of 14 bones, while the viscerocranium consists of 8 bones.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12578,
      question: "The Mandibular branch (V3) of the Trigeminal Nerve is the only branch that has both sensory and motor functions.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12579,
      question: "The Lateral Pterygoid is the only muscle of mastication responsible for depression of the mandible.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12580,
      question: "The hyoid bone articulates directly with the mandible and the temporal bone.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12581,
      question: "All three pharyngeal constrictor muscles are innervated by the pharyngeal plexus.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12582,
      question: "The Facial Nerve (VII) provides taste sensation from the posterior 1/3 of the tongue.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12583,
      question: "Damage to both Vagus Nerves (X) simultaneously can be fatal.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12584,
      question: "The Tensor Veli Palatini is the only soft palate muscle supplied by V3 of the Trigeminal Nerve.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12585,
      question: "The Mylohyoid muscle is innervated by the Facial Nerve (VII).",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12586,
      question: "Smooth muscle is typically voluntary and is found primarily in the skeletal system.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    }
  ],
  "5-10. Head and Neck Summary (Part 3)": [
    {
      id: 12600,
      question: "Which type of dental sealant requires mixing a base and catalyst before application?",
      options: [
        "Self-cured sealant material",
        "Light-cured sealant material",
        "Fluoride-releasing sealant",
        "Glass ionomer sealant type",
      ],
      correct: "A"
    },
    {
      id: 12601,
      question: "What is the primary purpose of the acid etching step in sealant application?",
      options: [
        "To sterilize the tooth surface",
        "To create micropores for retention",
        "To remineralize the enamel layer",
        "To reduce tooth sensitivity level",
      ],
      correct: "B"
    },
    {
      id: 12602,
      question: "Which teeth are most commonly indicated for dental sealant placement?",
      options: [
        "Anterior teeth with smooth surfaces",
        "Teeth with existing restorations",
        "Molars and premolars with pits and fissures",
        "Primary teeth only regardless of anatomy",
      ],
      correct: "C"
    },
    {
      id: 12603,
      question: "What is the recommended concentration of phosphoric acid used for etching before sealant placement?",
      options: [
        "10-15% phosphoric acid solution",
        "20-25% phosphoric acid solution",
        "50-55% phosphoric acid solution",
        "35-37% phosphoric acid solution",
      ],
      correct: "D"
    },
    {
      id: 12604,
      question: "How long should the acid etchant typically remain on permanent teeth during sealant application?",
      options: [
        "15-30 seconds of contact time",
        "5-10 seconds of contact time",
        "45-60 seconds of contact time",
        "90-120 seconds of contact time",
      ],
      correct: "A"
    },
    {
      id: 12605,
      question: "What appearance should properly etched enamel have after rinsing and drying?",
      options: [
        "Shiny and wet appearance present",
        "Chalky, frosty white appearance",
        "Yellowish discoloration present",
        "Transparent and glossy surface",
      ],
      correct: "B"
    },
    {
      id: 12606,
      question: "If saliva contaminates the etched enamel surface before sealant application, what should be done?",
      options: [
        "Apply the sealant immediately anyway",
        "Use a bonding agent instead only",
        "Re-etch the tooth surface again",
        "Cancel the sealant procedure now",
      ],
      correct: "C"
    },
    {
      id: 12607,
      question: "Which type of fluoride is most commonly used in professional topical fluoride applications?",
      options: [
        "Calcium fluoride compound type",
        "Stannous fluoride solution only",
        "Sodium fluoride at neutral pH",
        "Acidulated phosphate fluoride",
      ],
      correct: "D"
    },
    {
      id: 12608,
      question: "What is the recommended fluoride concentration in community water fluoridation?",
      options: [
        "0.7 parts per million optimal",
        "0.1-0.3 parts per million range",
        "1.5-2.0 parts per million range",
        "3.0-4.0 parts per million range",
      ],
      correct: "A"
    },
    {
      id: 12609,
      question: "Which condition is a contraindication for acidulated phosphate fluoride (APF) treatment?",
      options: [
        "History of dental caries present",
        "Porcelain or composite restorations",
        "Patients over the age of twelve",
        "Presence of dental calculus buildup",
      ],
      correct: "B"
    },
    {
      id: 12610,
      question: "What is the primary mechanism of action of topical fluoride in preventing dental caries?",
      options: [
        "Killing all oral bacteria present",
        "Increasing saliva production rate",
        "Enhancing enamel remineralization",
        "Preventing plaque accumulation only",
      ],
      correct: "C"
    },
    {
      id: 12611,
      question: "How long should patients refrain from eating or drinking after a professional fluoride treatment?",
      options: [
        "10-15 minutes waiting period",
        "60 minutes waiting period only",
        "120 minutes waiting period",
        "30 minutes waiting period",
      ],
      correct: "D"
    },
    {
      id: 12612,
      question: "Which test uses cold temperature stimulus to assess pulp vitality in teeth?",
      options: [
        "Thermal pulp test procedure",
        "Electric pulp test procedure",
        "Percussion test procedure only",
        "Transillumination test method",
      ],
      correct: "A"
    },
    {
      id: 12613,
      question: "What does a negative response to pulp vitality testing typically indicate?",
      options: [
        "Healthy vital pulp tissue present",
        "Necrotic or non-vital pulp tissue",
        "Reversible pulpitis condition exists",
        "Hypersensitive pulp tissue present",
      ],
      correct: "B"
    },
    {
      id: 12614,
      question: "Which pulp test applies a small electrical current to determine tooth vitality status?",
      options: [
        "Thermal testing with cold spray",
        "Percussion testing on crown",
        "Electric pulp testing device",
        "Bite testing with cotton roll",
      ],
      correct: "C"
    },
    {
      id: 12615,
      question: "What is the purpose of isolating a tooth with cotton rolls during pulp testing?",
      options: [
        "To keep the area sterile only",
        "To improve patient comfort level",
        "To enhance visual examination view",
        "To prevent current from spreading",
      ],
      correct: "D"
    },
    {
      id: 12616,
      question: "Which Universal tooth numbering system number represents the maxillary right third molar?",
      options: [
        "Tooth number 1 in system",
        "Tooth number 16 in system",
        "Tooth number 17 in system",
        "Tooth number 32 in system",
      ],
      correct: "A"
    },
    {
      id: 12617,
      question: "In the Universal numbering system, which tooth is number 19?",
      options: [
        "Maxillary right first molar tooth",
        "Mandibular left first molar tooth",
        "Maxillary left third molar tooth",
        "Mandibular right canine tooth only",
      ],
      correct: "B"
    },
    {
      id: 12618,
      question: "What tooth numbering system uses letters A through T for primary teeth?",
      options: [
        "Palmer notation system only",
        "FDI two-digit system only",
        "Universal numbering system",
        "International ISO system only",
      ],
      correct: "C"
    },
    {
      id: 12619,
      question: "In the FDI (International) numbering system, what does the first digit represent?",
      options: [
        "The specific tooth type present",
        "The patient's age category used",
        "The surface being treated now",
        "The quadrant of the mouth",
      ],
      correct: "D"
    },
    {
      id: 12620,
      question: "What is the main concern regarding mercury exposure in dental settings?",
      options: [
        "Mercury vapor inhalation toxicity",
        "Mercury causes tooth discoloration",
        "Mercury increases cavity rates",
        "Mercury causes gingival growth",
      ],
      correct: "A"
    },
    {
      id: 12621,
      question: "Which of the following is a recommended mercury hygiene practice in dental offices?",
      options: [
        "Store mercury in open containers",
        "Use high-volume evacuation suction",
        "Heat amalgam before placement",
        "Dispose of mercury in regular trash",
      ],
      correct: "B"
    },
    {
      id: 12622,
      question: "What type of flooring is recommended in areas where amalgam is handled?",
      options: [
        "Carpeted flooring for comfort",
        "Wooden flooring materials only",
        "Seamless non-absorbent flooring",
        "Tiled flooring with wide grout",
      ],
      correct: "C"
    },
    {
      id: 12623,
      question: "How should amalgam scrap be stored in the dental office properly?",
      options: [
        "In open containers at room temp",
        "In paper bags inside cabinets only",
        "In plastic wrap on countertops",
        "In sealed containers under water",
      ],
      correct: "D"
    },
    {
      id: 12624,
      question: "What is the purpose of using rubber dam isolation during amalgam removal?",
      options: [
        "To reduce mercury vapor inhalation",
        "To improve visibility of the area",
        "To speed up the removal process",
        "To prevent tooth fracture occurring",
      ],
      correct: "A"
    },
    {
      id: 12625,
      question: "Which restorative material requires acid etching of enamel before placement?",
      options: [
        "Amalgam restoration material only",
        "Composite resin material used",
        "Gold crown restoration type only",
        "Stainless steel crown type only",
      ],
      correct: "B"
    },
    {
      id: 12626,
      question: "What is the primary advantage of composite resin restorations over amalgam?",
      options: [
        "Lower cost of the material used",
        "Greater durability over time",
        "Esthetics matching tooth color",
        "Faster placement procedure time",
      ],
      correct: "C"
    },
    {
      id: 12627,
      question: "Which bonding agent component penetrates into etched enamel micropores?",
      options: [
        "The phosphoric acid etchant",
        "The composite filling material",
        "The curing light wavelength used",
        "The primer and adhesive resin",
      ],
      correct: "D"
    },
    {
      id: 12628,
      question: "What type of light is used to cure light-activated composite resins?",
      options: [
        "Blue visible light wavelength",
        "Ultraviolet light wavelength used",
        "Infrared light wavelength used",
        "White light wavelength spectrum",
      ],
      correct: "A"
    },
    {
      id: 12629,
      question: "What is the purpose of using a matrix band during amalgam restoration placement?",
      options: [
        "To prevent pulp exposure risk",
        "To provide a wall for condensation",
        "To increase the setting time rate",
        "To reduce mercury content used",
      ],
      correct: "B"
    },
    {
      id: 12630,
      question: "Which instrument is used to carve the anatomy of an amalgam restoration?",
      options: [
        "Amalgam carrier instrument used",
        "Condensers of various sizes only",
        "Discoid-cleoid carver instrument",
        "Burnisher instrument type only",
      ],
      correct: "C"
    },
    {
      id: 12631,
      question: "What is the function of an amalgam condenser during restoration placement?",
      options: [
        "To carry amalgam to the tooth",
        "To carve the occlusal anatomy",
        "To polish the final restoration",
        "To pack and adapt the amalgam",
      ],
      correct: "D"
    },
    {
      id: 12632,
      question: "How long should a patient wait before chewing on a new amalgam restoration?",
      options: [
        "Wait at least 24 hours minimum",
        "The patient can chew immediately",
        "Wait at least one week total",
        "Wait at least one month total",
      ],
      correct: "A"
    },
    {
      id: 12633,
      question: "Which material is used for temporary restorations between dental appointments?",
      options: [
        "Permanent amalgam filling material",
        "Intermediate restorative material",
        "Porcelain crown material only",
        "Gold inlay material type used",
      ],
      correct: "B"
    },
    {
      id: 12634,
      question: "What is the primary purpose of using a base under a deep restoration?",
      options: [
        "To improve esthetics of restoration",
        "To increase restoration strength",
        "To provide thermal insulation",
        "To reduce procedure time needed",
      ],
      correct: "C"
    },
    {
      id: 12635,
      question: "Which dental cement is commonly used as a base under amalgam restorations?",
      options: [
        "Zinc phosphate cement material",
        "Composite resin cement only",
        "Calcium hydroxide cement type",
        "Glass ionomer cement material",
      ],
      correct: "D"
    },
    {
      id: 12636,
      question: "What is the function of a liner in restorative dentistry procedures?",
      options: [
        "To protect the pulp from irritation",
        "To fill the entire cavity preparation",
        "To increase restoration retention",
        "To improve the esthetics present",
      ],
      correct: "A"
    },
    {
      id: 12637,
      question: "Which instrument is used to place calcium hydroxide liner in a cavity preparation?",
      options: [
        "Amalgam carrier instrument only",
        "Ball-ended applicator instrument",
        "Plastic filling instrument only",
        "Condenser instrument type used",
      ],
      correct: "B"
    },
    {
      id: 12638,
      question: "What is the setting reaction of glass ionomer cement based on?",
      options: [
        "Light-curing polymerization only",
        "Heat-curing process activated",
        "Acid-base chemical reaction type",
        "Self-curing chemical reaction",
      ],
      correct: "C"
    },
    {
      id: 12639,
      question: "Which property makes glass ionomer cement beneficial for root surface restorations?",
      options: [
        "High compressive strength value",
        "Rapid setting time present",
        "Superior esthetics achieved",
        "Fluoride release capability",
      ],
      correct: "D"
    },
    {
      id: 12640,
      question: "What is the purpose of using a dental dam during restorative procedures?",
      options: [
        "To provide moisture control",
        "To increase the setting time",
        "To reduce material needed",
        "To eliminate curing time",
      ],
      correct: "A"
    },
    {
      id: 12641,
      question: "Which clamp design is used for anterior teeth during rubber dam isolation?",
      options: [
        "Winged clamps with flat jaws",
        "Butterfly clamps with curved jaws",
        "Wingless clamps with four prongs",
        "Universal clamps with serrations",
      ],
      correct: "B"
    },
    {
      id: 12642,
      question: "What is the correct sequence for rubber dam placement procedures?",
      options: [
        "Frame, dam, clamp placement order",
        "Dam, clamp, frame placement order",
        "Clamp, dam, frame placement order",
        "Dam, frame, clamp placement order",
      ],
      correct: "C"
    },
    {
      id: 12643,
      question: "Which tooth surface is the mesial surface located on?",
      options: [
        "Surface toward the cheek area",
        "Surface toward the tongue area",
        "Surface toward the back teeth",
        "Surface toward the midline",
      ],
      correct: "D"
    },
    {
      id: 12644,
      question: "What does the term \"distal\" refer to in dental terminology?",
      options: [
        "Surface away from the midline",
        "Surface closest to the midline",
        "Surface toward the tongue area",
        "Surface toward the cheek area",
      ],
      correct: "A"
    },
    {
      id: 12645,
      question: "Which tooth surface is in contact with the cheek tissue?",
      options: [
        "The lingual surface area only",
        "The buccal surface area only",
        "The mesial surface area only",
        "The distal surface area only",
      ],
      correct: "B"
    },
    {
      id: 12646,
      question: "What is the incisal edge of anterior teeth?",
      options: [
        "The root portion of the tooth",
        "The side surface of the tooth",
        "The cutting edge of the tooth",
        "The back surface of the tooth",
      ],
      correct: "C"
    },
    {
      id: 12647,
      question: "Which classification describes a cavity on the occlusal surface of molars?",
      options: [
        "Class II cavity classification",
        "Class III cavity classification",
        "Class IV cavity classification",
        "Class I cavity classification",
      ],
      correct: "D"
    },
    {
      id: 12648,
      question: "What type of cavity involves the proximal surfaces of posterior teeth?",
      options: [
        "Class II cavity classification",
        "Class I cavity classification",
        "Class III cavity classification",
        "Class V cavity classification",
      ],
      correct: "A"
    },
    {
      id: 12649,
      question: "Which cavity classification involves the proximal surfaces of anterior teeth without the incisal angle?",
      options: [
        "Class I cavity classification",
        "Class III cavity classification",
        "Class II cavity classification",
        "Class IV cavity classification",
      ],
      correct: "B"
    },
    {
      id: 12650,
      question: "A cavity involving the incisal angle of an anterior tooth is classified as which class?",
      options: [
        "Class II cavity classification",
        "Class III cavity classification",
        "Class IV cavity classification",
        "Class V cavity classification",
      ],
      correct: "C"
    },
    {
      id: 12651,
      question: "Class V cavities are located on which tooth surface area?",
      options: [
        "Occlusal surfaces of molars",
        "Proximal surfaces of anteriors",
        "Incisal edges of anteriors only",
        "Gingival third of all teeth",
      ],
      correct: "D"
    },
    {
      id: 12652,
      question: "What instrument is used to measure periodontal pocket depth?",
      options: [
        "Periodontal probe instrument",
        "Explorer instrument type used",
        "Scaler instrument type only",
        "Curette instrument type used",
      ],
      correct: "A"
    },
    {
      id: 12653,
      question: "Which type of periodontal probe has markings at specific millimeter intervals?",
      options: [
        "Nabors probe instrument type",
        "Cowhorn probe type only",
        "Williams probe instrument type",
        "Universal probe type only",
      ],
      correct: "C"
    },
    {
      id: 12654,
      question: "What is the normal sulcus depth in healthy periodontal tissue?",
      options: [
        "1-3 millimeters depth range",
        "4-5 millimeters depth range",
        "0-1 millimeters depth range",
        "6-7 millimeters depth range",
      ],
      correct: "A"
    },
    {
      id: 12655,
      question: "Which condition is characterized by inflammation of the gingiva without bone loss?",
      options: [
        "Periodontitis condition present",
        "Pericoronitis condition only",
        "Periapical abscess present",
        "Gingivitis condition present",
      ],
      correct: "D"
    },
    {
      id: 12656,
      question: "What is the primary cause of gingivitis in most patients?",
      options: [
        "Bacterial plaque accumulation",
        "Viral infection of tissues only",
        "Genetic predisposition only",
        "Nutritional deficiency present",
      ],
      correct: "A"
    },
    {
      id: 12657,
      question: "Which sign is characteristic of healthy gingival tissue?",
      options: [
        "Red and swollen appearance",
        "Pink and stippled appearance",
        "Bleeding upon probing present",
        "Purulent exudate present",
      ],
      correct: "B"
    },
    {
      id: 12658,
      question: "What does bleeding on probing indicate about gingival health?",
      options: [
        "Healthy tissue is present now",
        "Tissue is well-attached present",
        "Inflammation is present now",
        "No treatment is needed now",
      ],
      correct: "C"
    },
    {
      id: 12659,
      question: "Which type of calculus forms above the gingival margin?",
      options: [
        "Subgingival calculus type only",
        "Serumal calculus type only",
        "Salivary calculus type only",
        "Supragingival calculus type",
      ],
      correct: "D"
    },
    {
      id: 12660,
      question: "What is the primary source of minerals for supragingival calculus formation?",
      options: [
        "Saliva from salivary glands",
        "Blood serum from tissues only",
        "Crevicular fluid from sulcus",
        "Food particles consumed daily",
      ],
      correct: "A"
    },
    {
      id: 12661,
      question: "Which instrument is designed for removing supragingival calculus deposits?",
      options: [
        "Curette instrument type only",
        "Sickle scaler instrument type",
        "File instrument type only",
        "Chisel instrument type only",
      ],
      correct: "B"
    },
    {
      id: 12662,
      question: "What is the working end design of a universal curette instrument?",
      options: [
        "Single cutting edge present",
        "Three cutting edges present",
        "Two cutting edges present",
        "Four cutting edges present",
      ],
      correct: "C"
    },
    {
      id: 12663,
      question: "Which gracey curette is designed for use on anterior teeth?",
      options: [
        "Gracey 7/8 curette type only",
        "Gracey 11/12 curette type",
        "Gracey 13/14 curette type",
        "Gracey 1/2 curette type",
      ],
      correct: "D"
    },
    {
      id: 12664,
      question: "What is the correct working angulation for a curette during scaling?",
      options: [
        "0-40 degrees to the surface",
        "100-120 degrees to surface",
        "45-90 degrees to the surface",
        "130-180 degrees to surface",
      ],
      correct: "C"
    },
    {
      id: 12665,
      question: "Which stroke is used when adapting a curette for calculus removal?",
      options: [
        "Horizontal stroke pattern only",
        "Vertical or oblique strokes",
        "Circular stroke pattern only",
        "Random stroke pattern used",
      ],
      correct: "B"
    },
    {
      id: 12666,
      question: "What is the purpose of using an explorer during instrumentation?",
      options: [
        "To remove calculus deposits",
        "To polish the tooth surface",
        "To detect remaining deposits",
        "To apply fluoride treatment",
      ],
      correct: "C"
    },
    {
      id: 12667,
      question: "Which type of explorer has a long, thin working end for detecting subgingival calculus?",
      options: [
        "Shepherd's hook explorer type",
        "Pigtail explorer type only",
        "Orban explorer type only",
        "11/12 explorer type used",
      ],
      correct: "D"
    },
    {
      id: 12668,
      question: "What is the recommended maintenance interval for patients with healthy periodontium?",
      options: [
        "Every 1-2 months interval",
        "Every 12 months interval",
        "Every 6 months interval",
        "Every 24 months interval",
      ],
      correct: "C"
    },
    {
      id: 12669,
      question: "Which ultrasonic scaler tip design is used for subgingival instrumentation?",
      options: [
        "Universal tip with broad design",
        "Straight, thick tip design",
        "Flat, wide tip for coverage",
        "Thin, curved tip for access",
      ],
      correct: "D"
    },
    {
      id: 12670,
      question: "What is the primary mechanism of action of ultrasonic scalers?",
      options: [
        "Heat generation for removal",
        "Chemical dissolution process",
        "Mechanical vibration action",
        "Laser ablation technique used",
      ],
      correct: "C"
    },
    {
      id: 12671,
      question: "Which cooling mechanism is essential during ultrasonic scaling procedures?",
      options: [
        "Air cooling system present",
        "No cooling is required here",
        "Chemical coolant solution",
        "Water lavage irrigation",
      ],
      correct: "D"
    },
    {
      id: 12672,
      question: "What precaution should be taken when using ultrasonic scalers on patients with pacemakers?",
      options: [
        "Consult with patient's physician",
        "No precautions are required",
        "Never use ultrasonics at all",
        "Use only at low power setting",
      ],
      correct: "A"
    },
    {
      id: 12673,
      question: "Which polishing paste grit is recommended for removing heavy stain?",
      options: [
        "Fine grit polishing paste",
        "Extra-fine grit paste only",
        "No grit paste required here",
        "Coarse grit polishing paste",
      ],
      correct: "D"
    },
    {
      id: 12674,
      question: "What is the purpose of using a rubber cup for polishing?",
      options: [
        "To remove calculus deposits",
        "To apply local anesthesia now",
        "To polish coronal surfaces",
        "To place dental sealants now",
      ],
      correct: "C"
    },
    {
      id: 12675,
      question: "Which motion should be used when polishing with a rubber cup?",
      options: [
        "Continuous circular motion",
        "Back and forth motion only",
        "Up and down motion only",
        "Intermittent wiping strokes",
      ],
      correct: "D"
    },
    {
      id: 12676,
      question: "What is the recommended speed for rubber cup polishing?",
      options: [
        "Low speed rotary motion",
        "High speed rotary motion",
        "Variable speed motion only",
        "No speed limit applies here",
      ],
      correct: "A"
    },
    {
      id: 12677,
      question: "Which agent is commonly added to polishing paste for desensitization?",
      options: [
        "Chlorhexidine compound added",
        "Fluoride compound added",
        "Hydrogen peroxide added",
        "Sodium hypochlorite used",
      ],
      correct: "B"
    },
    {
      id: 12678,
      question: "What is selective polishing in dental hygiene practice?",
      options: [
        "Polishing all tooth surfaces",
        "Polishing only anterior teeth",
        "Polishing only stained areas",
        "Polishing only posterior teeth",
      ],
      correct: "C"
    },
    {
      id: 12679,
      question: "Which condition is a contraindication for air polishing procedures?",
      options: [
        "Presence of dental sealants",
        "Presence of amalgam fillings",
        "Presence of gold restorations",
        "Respiratory conditions present",
      ],
      correct: "D"
    },
    {
      id: 12680,
      question: "What type of particles are used in air polishing devices?",
      options: [
        "Sodium bicarbonate particles",
        "Diamond particles for abrasion",
        "Glass particles for polishing",
        "Metal particles for cleaning",
      ],
      correct: "A"
    },
    {
      id: 12681,
      question: "Which area should be avoided when using air polishing devices?",
      options: [
        "Enamel surfaces of teeth only",
        "Exposed root surfaces present",
        "Occlusal surfaces present now",
        "Interproximal surfaces only",
      ],
      correct: "B"
    },
    {
      id: 12682,
      question: "What is the purpose of applying disclosing solution before polishing?",
      options: [
        "To desensitize the teeth now",
        "To strengthen the enamel",
        "To visualize plaque deposits",
        "To reduce tooth sensitivity",
      ],
      correct: "C"
    },
    {
      id: 12683,
      question: "Dental sealants are only recommended for permanent teeth and should never be placed on primary teeth.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12684,
      question: "The etched enamel surface should appear shiny and wet before sealant application.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12685,
      question: "Fluoride varnish can be applied to wet tooth surfaces without prior drying.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12686,
      question: "Acidulated phosphate fluoride is safe to use on all types of dental restorations.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12687,
      question: "A positive response to electric pulp testing indicates that the pulp is vital.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12688,
      question: "In the Universal numbering system, tooth number 1 is the mandibular left third molar.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12689,
      question: "Mercury vapor is released when amalgam restorations are placed or removed.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12690,
      question: "Composite resin restorations require acid etching of enamel before placement.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12691,
      question: "Glass ionomer cement releases fluoride over time after placement.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12692,
      question: "The mesial surface of a tooth faces away from the midline of the dental arch.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12693,
      question: "Class II cavities involve the proximal surfaces of anterior teeth.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12694,
      question: "Normal healthy sulcus depth ranges from 1-3 millimeters.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12695,
      question: "Supragingival calculus forms primarily from minerals in blood serum.",
      options: [
        "True",
        "False",
      ],
      correct: "B"
    },
    {
      id: 12696,
      question: "Universal curettes have two cutting edges on each working end.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    },
    {
      id: 12697,
      question: "Ultrasonic scalers require water lavage during use to prevent overheating.",
      options: [
        "True",
        "False",
      ],
      correct: "A"
    }
  ],
  "0. TMJ (Disorder)": [
    {
      id: 12698,
      question: "What are the two types of movement that make up normal TMJ movement?",
      options: [
        "Flexion and extension",
        "Rotation and gliding",
        "Gliding and compression",
        "Rotation and translation",
      ],
      correct: "B"
    },
    {
      id: 12699,
      question: "During the initial phase of mouth opening, what lubricates the rotation of the condyle against the articular disc?",
      options: [
        "The inferior synovial cavity",
        "The superior synovial cavity",
        "The collagenous lamina fluid",
        "The elastic lamina secretion",
      ],
      correct: "A"
    },
    {
      id: 12700,
      question: "During jaw opening, what is the role of the elastic lamina?",
      options: [
        "It contracts to assist the lateral pterygoid muscle during gliding",
        "It prevents the articular disc from being pulled too far forward",
        "It holds the disc more posteriorly so the condyle can rotate on top of it",
        "It pulls the condyle forward along the articular eminence",
      ],
      correct: "C"
    },
    {
      id: 12701,
      question: "Which muscle is responsible for pulling the condyle and disc forward during the gliding phase of mouth opening?",
      options: [
        "The superior head of the lateral pterygoid muscle",
        "The masseter muscle",
        "The inferior head of the medial pterygoid muscle",
        "The temporalis muscle",
      ],
      correct: "A"
    },
    {
      id: 12702,
      question: "During jaw closing, what structure prevents the articular disc from being pulled too far forward?",
      options: [
        "The inferior synovial membrane",
        "The posterior ligament",
        "The collagenous lamina",
        "The elastic lamina",
      ],
      correct: "C"
    },
    {
      id: 12703,
      question: "During mastication, which side does the condyle maintain contact with the mandibular fossa?",
      options: [
        "Alternating sides with each chewing cycle",
        "The same side as the food being chewed",
        "The side closest to the hyoid bone",
        "The side opposite to the food",
      ],
      correct: "B"
    },
    {
      id: 12704,
      question: "During mastication, what happens on the side of the mouth without food?",
      options: [
        "The inferior pterygoid relaxes to widen the joint space",
        "The elastic lamina contracts to fill the space",
        "The temporalis muscle pulls the condyle anteriorly to fill the space",
        "The superior head of the lateral pterygoid pulls the thicker part of the disc forward",
      ],
      correct: "D"
    },
    {
      id: 12705,
      question: "Which muscle contracts to pull the condyle posteriorly and bring the mandible back to centric occlusion during mastication?",
      options: [
        "The temporalis muscle",
        "The masseter muscle",
        "The buccinator muscle",
        "The medial pterygoid muscle",
      ],
      correct: "A"
    },
    {
      id: 12706,
      question: "What is the most likely cause of popping and clicking in the TMJ?",
      options: [
        "Spasm of the temporalis muscle during jaw opening",
        "The articular disc being pulled too far forward, deranging over the articular eminence",
        "Arthritis eroding the surface of the articular disc",
        "Perforation of the inferior synovial cavity membrane",
      ],
      correct: "B"
    },
    {
      id: 12707,
      question: "Which of the following are listed as causes of TMJ popping and clicking?",
      options: [
        "Malocclusion, fibromyalgia, and referred muscle pain",
        "Bruxism, trismus, and subluxation of the condyle",
        "Arthritis, disc perforations, and synovial membrane adhesions",
        "Ankylosis, disc derangement, and bony fusion",
      ],
      correct: "C"
    },
    {
      id: 12708,
      question: "Which of the following is a sign of popping and clicking during clinical assessment?",
      options: [
        "Radiographs show normal results with no bony changes",
        "Complaints of diffuse pain in the neck and auricular region",
        "A mandibular midline shift to one side observed during opening",
        "The client is unable to close the mouth after wide opening",
      ],
      correct: "C"
    },
    {
      id: 12709,
      question: "Which treatment option is NOT listed for popping and clicking of the TMJ?",
      options: [
        "Use of a nightguard splint",
        "Ultrasound therapy",
        "Physical therapy",
        "Surgical recontouring of the articular eminence",
      ],
      correct: "D"
    },
    {
      id: 12710,
      question: "Why is disc derangement typically more painful than simple popping and clicking?",
      options: [
        "Because the structures posterior to the disc have full nerve supply, unlike the disc itself",
        "Because the lateral pterygoid muscle goes into permanent spasm during derangement",
        "Because disc derangement always involves tearing of the temporal bone periosteum",
        "Because the articular disc has a very high nerve supply throughout its body",
      ],
      correct: "A"
    },
    {
      id: 12711,
      question: "What structures may be damaged if the articular disc is permanently displaced forward?",
      options: [
        "The inferior synovial cavity and the articular eminence cartilage surface",
        "The posterior laminae, disc-to-condyle attachments, and the disc itself",
        "The collagenous lamina and the mandibular fossa cartilage",
        "The lateral pterygoid insertion and the condylar neck periosteum",
      ],
      correct: "B"
    },
    {
      id: 12712,
      question: "What defines subluxation of the TMJ?",
      options: [
        "Habitual grinding of the teeth causing muscle fatigue and joint pain",
        "Fibrous fusion of the mandible to the temporal bone limiting jaw movement",
        "The articular disc permanently displaced anterior to the condyle position",
        "The condyle sliding too far forward, passing over the height of the articular eminence",
      ],
      correct: "D"
    },
    {
      id: 12713,
      question: "After subluxation, why is it difficult for the condyle to return over the articular eminence during closing?",
      options: [
        "The lateral pterygoid muscle locks the condyle in an anterior position",
        "Muscles pull the condyle both upward and backward simultaneously",
        "The elastic lamina becomes too rigid to allow posterior condylar movement",
        "The collagenous lamina tears, removing posterior guidance of the articular disc",
      ],
      correct: "B"
    },
    {
      id: 12714,
      question: "What is the manual reduction technique used for TMJ subluxation?",
      options: [
        "Apply upward pressure on the chin and guide the mandible in a forward direction",
        "Press firmly on the TMJ externally while the patient attempts to close forcefully",
        "Grasp the mandible from below and rotate it superiorly in one smooth motion",
        "Place thumbs on the posterior occlusal surfaces and apply downward, then posterior pressure",
      ],
      correct: "D"
    },
    {
      id: 12715,
      question: "Which of the following is a correct post-operative instruction given after subluxation treatment?",
      options: [
        "Do not open wide and avoid stretching the jaw when yawning",
        "Apply heat to the TMJ and massage the condylar area daily",
        "Perform jaw-stretching exercises three times per day",
        "Chew gum regularly to strengthen the lateral pterygoid muscle",
      ],
      correct: "A"
    },
    {
      id: 12716,
      question: "What is bruxism?",
      options: [
        "Referred muscle pain experienced in the TMJ from surrounding neck muscles",
        "A condition where the condyle permanently displaces anterior to the articular eminence",
        "The habitual grinding of teeth outside of normal function, often during sleep",
        "Fibrous fusion of the mandibular condyle to the articular fossa over time",
      ],
      correct: "C"
    },
    {
      id: 12717,
      question: "Where does most of the pain associated with bruxism originate?",
      options: [
        "From tiring of the muscles of mastication, with referred tenderness in the TMJ",
        "From the perforation of the articular disc under repeated grinding forces",
        "From damage to the inferior synovial cavity from excessive clenching forces",
        "From tearing of the posterior laminae caused by habitual forward disc displacement",
      ],
      correct: "A"
    },
    {
      id: 12718,
      question: "Which of the following is a clinical sign associated with bruxism?",
      options: [
        "The mandible becomes progressively immobile due to fibrosis of masticatory muscles",
        "A visible shift of the mandibular midline during wide mouth opening",
        "Audible joint noises detected with a stethoscope during condylar movement",
        "Signs of abfraction and excessive wear on the occlusal surfaces of teeth",
      ],
      correct: "D"
    },
    {
      id: 12719,
      question: "What is referred pain in the context of TMJ disorders?",
      options: [
        "Pain caused by direct nerve compression within the mandibular fossa",
        "Pain interpreted as coming from the TMJ but actually originating from another area",
        "Pain that originates in the TMJ and radiates to distant muscles of mastication",
        "Pain resulting from disc perforation that radiates to the auricular region",
      ],
      correct: "B"
    },
    {
      id: 12720,
      question: "Which clinical finding would suggest referred pain rather than an intrinsic TMJ disorder?",
      options: [
        "Audible clicking with a stethoscope and midline shift observed during opening",
        "Inability to close the mouth following wide opening of the jaw",
        "No pain on palpation and normal results on radiographic examination",
        "Visible occlusal wear and partner reports of nighttime grinding sounds",
      ],
      correct: "C"
    },
    {
      id: 12721,
      question: "How does malocclusion contribute to TMJ pain?",
      options: [
        "Improper tooth occlusion places masticatory muscles out of position, making them prone to fatigue",
        "It leads to subluxation by reducing the height of the articular eminence over time",
        "It causes direct disc derangement by altering condylar rotation angles",
        "It compresses the inferior synovial cavity, causing adhesion of the synovial membranes",
      ],
      correct: "A"
    },
    {
      id: 12722,
      question: "What distinguishes trismus from ankylosis?",
      options: [
        "Trismus is treated surgically while ankylosis resolves with physical therapy alone",
        "Trismus only affects the articular disc while ankylosis affects the entire joint capsule",
        "Trismus involves bony fusion while ankylosis involves muscle spasm of the jaw",
        "Trismus involves muscle spasm or fibrosis while ankylosis involves bony or fibrous fusion",
      ],
      correct: "D"
    },
    {
      id: 12723,
      question: "How does arthritis affect the TMJ specifically?",
      options: [
        "It causes the articular disc to permanently displace forward during all jaw movements",
        "It may cause excessive wear of the articular disc and synovial cavities, reducing smooth movement",
        "It results in fibrosis of the masticatory muscles, locking the jaw in a closed position",
        "It increases the height of the articular eminence, predisposing the condyle to subluxation",
      ],
      correct: "B"
    },
    {
      id: 12724,
      question: "What is fibromyalgia as it relates to TMJ disorders?",
      options: [
        "A localized condition causing disc perforation due to repetitive grinding forces",
        "A specific TMJ disorder involving bony fusion between the condyle and articular fossa",
        "An idiopathic syndrome causing generalized heightened nerve sensitivity that can extend to the TMJ",
        "A condition involving synovial membrane adhesions that progressively restrict joint movement",
      ],
      correct: "C"
    },
    {
      id: 12725,
      question: "Why is the TMJ particularly susceptible to conditions like arthritis and fibromyalgia?",
      options: [
        "Because the elastic lamina weakens over time, reducing overall joint stability",
        "Because it is the only joint in the body with a biconcave articular disc structure",
        "Because it relies entirely on synovial fluid without any fibrocartilage protection",
        "Because the TMJ is a high-stress joint used frequently for essential daily functions",
      ],
      correct: "D"
    },
    {
      id: 12726,
      question: "The first millimeters of mouth opening occur through a gliding movement of the condyle.",
      options: [
        "True",
        "False",
        "Only during wide opening",
        "Only during chewing",
      ],
      correct: "B"
    },
    {
      id: 12727,
      question: "During the closing phase of jaw movement, the elastic lamina applies a controlled posterior pull to guide the condyle back into the mandibular fossa.",
      options: [
        "True",
        "False",
        "Only during wide opening",
        "Only during chewing",
      ],
      correct: "A"
    },
    {
      id: 12728,
      question: "Disc derangement may resolve on its own over time without surgical intervention.",
      options: [
        "True",
        "False",
        "Only with physical therapy",
        "Only with splint therapy",
      ],
      correct: "A"
    },
    {
      id: 12729,
      question: "Subluxation occurs when the condyle slides too far forward and passes over the height of the articular eminence.",
      options: [
        "True",
        "False",
        "Only during extreme mouth opening",
        "Only in patients with prior TMJ surgery",
      ],
      correct: "A"
    },
    {
      id: 12730,
      question: "Bruxism is more commonly experienced while the patient is awake rather than during sleep.",
      options: [
        "True",
        "False",
        "It occurs equally during waking and sleep",
        "It only occurs during sleep",
      ],
      correct: "B"
    },
    {
      id: 12731,
      question: "Ankylosis can be treated conservatively with muscle relaxants and physical therapy alone.",
      options: [
        "True",
        "False",
        "Only in mild cases",
        "Only in pediatric patients",
      ],
      correct: "B"
    },
  ]
};
